import { makeStyles, withStyles } from '@material-ui/core/styles';
import React, { useState, useEffect, useRef } from 'react';
import {useHistory, useParams, useLocation} from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import Popover from "@material-ui/core/Popover";
import Tooltip from "@material-ui/core/Tooltip";
import { toast } from 'react-toastify';
import _ from "lodash";
import {FaInfoCircle, FaRegPlusSquare, FaStar, FaTrash, FaShareAlt, FaPencilAlt} from "react-icons/fa";
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import ResultTable from './ResultTable';
import { buildFullSubjectAlignment } from './ResultTableRecord';
import CustomPagination from '../../shared/CustomPagination';
import DisplayColumnModal from '../../shared/Modal/DisplayColumnModal';
import ShareViewModal from '../../shared/Modal/ShareViewModal';
import sharedViews from '../../services/sharedViews';
import alertViews from '../../services/alertViews';
import fieldConfig from "./FieldConfig";
import filter from "./ResultFilter";
import DiscoverService from "../../services/discoverService";
import UIlog from "./UILog"
import ReactHtmlParser from "react-html-parser";
import ResultStatsBar from "./ResultStatsBar";
import ChartService from "./ChartService";
import TabUnderTool from "./TabUnderTool";
import '../../assets/css/flag-icon.css';
import DedupPrefModal from '../../shared/Modal/DedupPrefModal';
import DiscoverContinueModal from "../../shared/Modal/DiscoverContinueModal";
import DiscoverExportAllModal from "../../shared/Modal/DiscoverExportAllModal";
import DiscoverExportChoicesModal from "../../shared/Modal/DiscoverExportChoicesModal";
import DiscoverPatbaseModal from "../../shared/Modal/DiscoverPatbaseModal";
import DiscoverExportVmModal from "../../shared/Modal/DiscoverExportVmModal";
import DiscoverSaveResultsModal from "../../shared/Modal/DiscoverSaveResultsModal";
import DiscoverSaveResultsSucModal from "../../shared/Modal/DiscoverSaveResultsSucModal";
import DiscoverMoreItemsModal from "../../shared/Modal/DiscoverMoreItemsModal";
import DiscoverFilterModal from "../../shared/Modal/DiscoverFilterModal";
import DiscoverMessageModal from "../../shared/Modal/DiscoverMessageModal";
import Authorities from '../../helpers/authorities';
import GQPowerTools from './GQPowerTools/GQPowerTools';
import SortingWidgetModal from '../../shared/Modal/SortingWidgetModal';
import {useSelector, useDispatch} from "react-redux";
import { startExportProgress, updateExportProgress, completeExportProgress, failExportProgress, cancelExportProgress } from '../../reducers/slice/exportProgressSlice';
import { registerExportRetry, registerExportAbort } from '../../services/exportJobRegistry';
import DiscoverFilterDeleteModal from "../../shared/Modal/DiscoverFilterDeleteModal";
import DiscoverViewDeleteModal from "../../shared/Modal/DiscoverViewDeleteModal";
import ftAccess from '../../services/ftAccess';
import { Link } from '@material-ui/core';
import FTSearchModal from '../../shared/Modal/FTSearchModal';
import PfmFilterModal from '../../shared/Modal/PfmFilterModal';
import QuerySequencePatterns from '../../shared/Modal/QuerySequencePatterns';
import langflowService from '../../services/langflowService';
import { setDiscoverChatContext, clearDiscoverChatContext } from '../../shared/discoverChatContext';
import DownloadsIndicator from '../../shared/DownloadsIndicator/DownloadsIndicator';
import HoverPopout from './HoverPopout';
import { highlightColors, getQueryIdColor } from './highlightColors';

const useStyles = makeStyles((theme) => ({
    grow: {
        //flexGrow: 1,
        //width: '96%',
        //maxWidth: '1200px',
        margin: '0 auto',
        minHeight: '260px',
        padding: '23px 0 5px'
    },
     sideMenuContainer: (props) => ({
        height: 'calc(100vh - 180px)',
        overflowY: 'auto',
        overflowX: 'auto',
          position: 'relative',
        paddingRight: '2px', 
        maxWidth: '300px',
          zIndex: '1001',
        scrollbarColor: props.toggle ? 'auto': '#777 #292929',
        scrollbarWidth: props.toggle ? 'thin' : 'auto',
    }),
    projectTitle: {
        margin: '0px 4px',
        position: 'relative',
        top: '2px',
        fontSize: '14px',
        padding: '0'
    },
    displayTitle: {
        margin: '0px 4px',
        position: 'relative',
        top: '2px',
        fontSize: '18px',
        padding: '0'
    },
    projectListItem: {
        padding: '0.2rem 0.25rem !important',
        border: 'none !important'
    },
    projTitleActive: {
        backgroundColor: '#008EC5',
        color: '#fff',
        padding: '3px',
        borderRadius: '3px'
    },
    txtwrp: {
        overflow: 'hidden',
        //whiteSpace: 'nowrap',
        display: 'block',
        textOverflow: 'ellipsis'
    },
    folderIcon: {
        width: '8%'
    },
    modalHeader: {
        borderBottom: 'none !important',
    },
    modalBody: {
        paddingBottom: '20px'
    },
    modal_body: {
        padding: '10px 0 0 0'
    },
    footerDiv: {
        padding: '0 10px'
    },
    checkBox: {
        transform: "scale(0.9)",
    },
    addNewLabel: {
        marginTop: '-20px',
        marginLeft: '31px'
    },
    addNewText: {
        marginTop: '-6px',
        marginLeft: '30px',
        height: '65px'
    },
    selectedTitle: {
        backgroundColor: '#337ab7',
        color: '#fff',
        padding: '3px',
        borderRadius: '3px'
    },
    buttonStyle: {
        backgroundColor: '#EEEEEE !important',
        border: '1px solid #CCCCCC !important',
        float: 'right',
        textTransform: 'none !important',
        marginTop: '4px !important',
        color: '#777777!important',
        boxShadow: 'none !important'
    },
    disabledButtonStyle: {
        float: 'right',
        textTransform: 'none !important',
        marginTop: '4px !important',
        backgroundColor: '#db862c!important',
        border: '1px solid #ca751b!important',
        color: 'white !important'
    },
    loader :{
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height:' 100%',
        zIndex: '999999',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'block',
 
    },
    loaderPosition:{
        marginLeft: '602px',
        marginTop: '300px',
    },
    hoverChanges: {
        zIndex: '350',
        position: 'relative',
   
        '&:hover': {
            padding: '5px',
            border: '0.5px solid grey',
            // background: 'white',
        }
    },
    scrollStyleChangeDark: {
    overflowY: 'auto',          // vertical scrolling
    overflowX: 'scroll',        // horizontal scrollbar

    msOverflowStyle: 'none',    // IE 10+

    /* Chrome, Safari, Edge */
    '&::-webkit-scrollbar': {
      width: 0,                 // hide vertical scrollbar
      height: '8px',            // horizontal scrollbar height
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#777', 
      width: 'thin', 
    },
    '&::-webkit-scrollbar-track': {
      background: '#292929',    // horizontal scrollbar track
    },
  },
    
    
}));

const Accordion = withStyles({
    root: {
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        minHeight: 3,
        width: '102%',
        margin: 0,
        '&$expanded': {
            minHeight: 3,
            margin: 0,
        },
    },
    content: {
        margin: '0',
        padding: '0',
        '&$expanded': {
            margin: '0',
        },
    },
    expanded: {},
    // '@media (max-width: 780px)': {
    //     root: {
    //         width: '100%',
    //     }
    // }
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: '0 0 0 5px',
        margin: '0',
        display: 'block'
    },
}))(MuiAccordionDetails);

const CmAccordionDetails = withStyles((theme) => ({
    root: {
        padding: '0 0 0 5px',
        margin: '0',
        display: 'inline-block'
    },
}))(MuiAccordionDetails);

const toolTipStyles = {
    tooltip: {
        width: "auto",
        //height: "40px",
        fontSize: '12px',
        textAlign: 'justify',
        padding: "8px 14px 8px 14px",
        boxShadow: "0px 1px 7px #888",
        backgroundColor: '#777',
        color: '#FFF'
    }
};
const CustomTooltip = withStyles(toolTipStyles)(Tooltip);

const colors = ['White', 'Red', 'Orange', 'Yellow', 'Green', 'Blue', 'Purple',
     'Gray', 'Tan', 'Light Orange', 'Light Yellow', 'Light Green', 'Light Blue', 'Violet'];

// The Advanced Group Options dialog's Group size rows: the legacy groupSize/groupSizeOper pair or a groupSize row.
// The statistics follow these, not the Query Sequence ID rows.
const sizeRowsOf = (fieldConfig) => (fieldConfig.groupFilters || []).filter(groupFilter => groupFilter.type === 'groupSize');
const hasGroupSizeFilter = (fieldConfig) => (!!fieldConfig.groupSize && !!fieldConfig.groupSizeOper)
    || sizeRowsOf(fieldConfig).length > 0;
// The groupCriteria the summary request sends for a table display mode
const groupCriteriaFor = (mode) => ({family: 'fam', document: 'patent', flat: 'alignment'}[mode] || mode);
// The dialog's filters, for the requests that have to see the groups the table shows
const groupFilterFields = (fieldConfig) => ({
    groupSize: fieldConfig.groupSize,
    groupSizeOper: fieldConfig.groupSizeOper,
    groupFilters: fieldConfig.groupFilters,
    // Read path for states saved before groupFilters existed
    groupFilterType: fieldConfig.groupFilterType,
    groupFilterMatchType: fieldConfig.groupFilterMatchType,
    groupFilterValue: fieldConfig.groupFilterValue,
});

const famViewOptions = {
    '1': '1 Patent Number per Family',
    '3': '3 Patent Numbers per Family',
    '5': '5 Patent Numbers per Family',
    'All': 'All'
};
const pnViewOptions = {
    '1': '1 Alignment per Patent Number',
    '3': '3 Alignments per Patent Number',
    '5': '5 Alignments per Patent Number',
    '10': '10 Alignments per Patent Number',
    'All': 'All'
};
const ssvOptions = {
    '1': '1 Alignment per Subject Sequence',
    '3': '3 Alignments per Subject Sequence',
    '5': '5 Alignments per Subject Sequence',
    '10': '10 Alignments per Subject Sequence',
    'All': 'All'
};
const ufsOptions = {
    '1': '1 Alignment per UFS',
    '3': '3 Alignments per UFS',
    '5': '5 Alignments per UFS',
    '10': '10 Alignments per UFS',
    'All': 'All'
};
const qsOptions = {
    '1': '1 Alignment per Query Sequence',
    '3': '3 Alignments per Query Sequence',
    '5': '5 Alignments per Query Sequence',
    '10': '10 Alignments per Query Sequence',
    'All': 'All'
};
const hspOptions = {
    '1': '1 Alignment per Blast HSPs',
    '3': '3 Alignments per Blast HSPs',
    '5': '5 Alignments per Blast HSPs',
    '10': '10 Alignments per Blast HSPs',
    'All': 'All'
};

const _NOT_SEARCHING = 0;
const defaultCustomFiltersHelpMessage = {
    '0': 'Sample custom filter most appropriate for >20 residue sequences',
    '1': 'Finds subjects comprised by the query',
    '2': 'GenePast only; best for short queries.  Use as a foundation for additional filters.',
    '3': 'Antibody workflow only; Sample custom filter for Diff. Count <= 1 or %Id Query >=90. ',
};

const abFiltersMap = {
    querySeqDbs: "Query Sequence ID",
    subjSeqFrag: "Subject Sequence Fragment",
    matchingDocuments: "Matching Documents For",
    matchingSequences: "Matching Sequences For",
    cdrCombinationsOrder: "CDR Mismatches Order",
    cdrCombinations: "CDR Mismatches For"
};

function Discover(props) {
    const toggle = useSelector(state => state.setToggle.toggle);
    const classes = useStyles({toggle});
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const userInfo = useSelector((state) => state.setUserInfo);
    const pageCount = useState('50');
    const resultTableRef = useRef(null);
    const autoOpenedRef = useRef(false); // Track if we've already auto-opened
    const [currentPage, setCurrentPage] = useState(1);
    const [includeSubjectSeq, setIncludeSubjectSeq] = useState(false); // Full Subject Sequence toggle
    const [totalPage, setTotalPage] = useState(1);
    const [showLoader, setShowLoader] = useState(false);
    const [addDisplayColumnShow, setAddDisplayColumnShow] = useState(false);
    const [tempTemplate, setTempTemplate] = useState({});

    const [ftWindowsToOpen, setFtWindowsToOpen] = useState(null);

    // Prepare the GenomeQuest Alignments
    let [gqAlignments, setGqAlignments] = useState([]);
    let [gqAlignmentsNoSumm, setGqAlignmentsNoSumm] = useState([]);
    let [gqAlignmentsStrNoSumm, setGqAlignmentsStrNoSumm] = useState([]);
    let [gqAlignmentsSumm, setGqAlignmentsSumm] = useState([]);
    let [gqAlignmentsVariation, setGqAlignmentsVariation] = useState([]);

    let [facetInfo, setFacetInfo] = useState({});
    let [resInfo, setResInfo] = useState({});
    const [aiPatentData, setAiPatentData] = useState(null);
    const [aiDataLoading, setAiDataLoading] = useState(false);

    const addAiCustomFilterRef = useRef(null);
    addAiCustomFilterRef.current = ({ name, rows }) => {
        if (!filter || !filter.widgetState) return { ok: false, error: 'Discover filter not ready' };
        const widgetContent = (rows || []).map(r => ({
            field: r.field,
            field_type: r.dataType || r.field_type || 'string',
            operator: r.operator,
            value: r.value,
            second_value: r.second_value || '',
        }));
        if (widgetContent.length === 0) return { ok: false, error: 'No filter rows provided' };
        const existingFilters = filter.widgetState.customFilters || [];
        let nameUsed = -1;
        for (let i = 0; i < existingFilters.length; i++) {
            if (existingFilters[i].customFilterName === name) { nameUsed = i; break; }
        }
        filter.widgetState.widgetContent = widgetContent;
        filter.widgetState.widgetMode = 'AND';
        filter.widgetState.widgetCustomQuery = '';
        filter.widgetState.customFilterName = name;
        filter.widgetState.filterNameUsed = nameUsed;
        try {
            saveFilter(filter, fieldConfig, sideMenuDetail || {});
            applyAllFilters(filter);
            loadResultsFromBackend(true);
            return { ok: true, overwritten: nameUsed !== -1 };
        } catch (err) {
            console.error('[addAiCustomFilter] failed:', err);
            return { ok: false, error: err.message };
        }
    };

    useEffect(() => {
        setDiscoverChatContext({
            resInfo,
            aiPatentData,
            aiDataLoading,
            addAiCustomFilter: (payload) => addAiCustomFilterRef.current?.(payload),
        });
    }, [resInfo, aiPatentData, aiDataLoading]);
    useEffect(() => () => clearDiscoverChatContext(), []);
    let [sideMenuCollapse ,setSideMenuCollapse] = useState(false);
    let [chartMenu ,setChartMenu] = useState(false);
    let [multiQuerySeqMenu, setMultiQuerySeqMenu] = useState(false);
    let [state, setState] = useState({
        claimCollapse: {},          // whether the claims for a specific PN are shown fully, or only the first three claims
        sideMenuCollapse: false,    // which of the side-bar menus are open / collapsed
        currentPage: 1,   // which page of the results we're on
        itemsCurrentPage: 1,
        maxed_out_exceptions: {},   // which PNs to show all SEQ ID NOs for, regardless of the amount (normally it gets cut off)
        showAll: false,             // render 3 results per PN first, then render the rest when this variable is set to true
        tableGetsKeyPress: true,    // when set to true, the key presses are used by the table (for navigation and annotation)
        showHighlightColorBox: false,
        //showCommentIcon: false,
        //showCommentBox: false,
        toolbarTab: false,
    });
    const [originalState, setOriginalState] = useState({
        // facet filters
        SUBJECT_PN: {},
        SUBJECT_PG: {},
        SUBJECT_PS: {},

        // default sort
        sort: 'high_percid_query',

        // list of PNs "Publication Number" list / text area in the UI
        publicationNumberList: '',

        smartTextFilter: {},
        smartText: '',
        smartTextPopup: false,
        smartTextOptions: [],

        smartHighlightPopup: false,
        smartHighlight: '',
        smartHighlightOptions: [],
        smartHighlightFilter: {},
        smartFiltersHover: [],

        // state of the "Alignment Annotation" filter
        annot: {
            checkboxes: {
                checked: false,
                unchecked: false
            },
            colors: [
                false, false, false, false, false, false, false,
                false, false, false, false, false, false, false
            ],
            stars: [
                false, false, false, false
            ],
            notes: [],
            notesCheckboxes: {
                empty: false,
                notEmpty: false
            }
        },

        // state of the "Alignment Quality" filter
        align: {
            len: false,
            percidq: false,
            percids: false,
            percida: false,
            vallen: 100,
            valpercidq: 70,
            valpercids: 70,
            valpercida: 70
        },

        // SUBJECT_GNAME
        databaseNames: {},

        querySeqDbs: {},
        queryCmCodes: {},

        // switch for apply button enabled / disabled
        applyEnabled: false,

        // which checkboxes are checked in the UI (UI state)
        customFilterCheckboxes: [],

        cmFilterCheckboxes: [],

        customPfmFilterCheckboxes: [],

        // which LVA checkboxes are checked in the UI (UI state)
        lvaFilterCheckboxes: [],

        // which global filter checkboxes are checked in the UI (UI state)
        globalLvaFiltersCheckboxes: []
    });


    //antibody
    const [abFilterDesc, setAbFiltersDesc] = useState([])


    //powerTools
    const [abFilters, setAbFilters] = useState({});
    const [gqApiKey, setGqApiKey] = useState("");
    const [resultReportFilters, setResultReportFilters] = useState({});

    //states
    //let [isloaded, setIsloaded] = useState(false);
    let [isFtWorkflow, setIsFtWorkflow] = useState(false);
    let [isAbWorkflow, setIsAbWorkflow] = useState(false);
    let [isCmWorkflow, setIsCmWorkflow] = useState(false);
    let [isCasCm, setIsCasCm] = useState(false);
    let [isCmNoSeq, setIsCmNoSeq] = useState(false);
    const [accessDeniedMsg, setAccessDeniedMsg] = useState(null);
    let [hasLvaAccess, setHasLvaAccess] = useState(false);
    let [hasftAccess, setHasftAccess] = useState(false);
    let [hasRegAccess, setHasRegAccess] = useState(false);
    let [hasRegNp, setHasRegNp] = useState(false);
    const [lqAuthKey, setLqAuthKey] = useState('');
    const [lqBaseUrl, setLqBaseUrl] = useState('');
    const [loginName, setLoginName] = useState('');
    let [userdir, setUserdir] = useState('');
    let [infoMsg, setInfoMsg] = useState('');
    //let [appErrorMsg, setAppErrorMsg] = useState('');
    let [showInfoMsg, setShowInfoMsg] = useState(false);

    //let [lvaQueries, setLvaQueries] = useState({});
    const [vmIds, setVmIds] = useState({});
    //let [defaultLvaQuery, setDefaultLvaQuery] = useState();
    const [lvaLoadingReady, setLvaLoadingReady] = useState(false);
    let [loadingLvaTables, setLoadingLvaTables] = useState(false);
    //let [seqReports, setSeqReports] = useState([]);
    //const [abReportNames, setAbReportNames] = useState([]);
    let [cmCodes, setCmCodes] = useState([]); // All CM codes in the result set
    const [resultSetModCodes, setResultSetModCodes] = useState([]); // Flat numeric Mod_IDs present in the result set
    // Sequence type implied by those Mod_IDs. Kept so later query-info inference cannot
    // put the protein default back over a nucleotide result.
    const qspModSeqTypeRef = useRef(null);
    let [cmPos, setCmPos] = useState(''); // CM Subject Search Positions
    let [cmQueryPos, setCmQueryPos] = useState(''); // CM Query Search Positions
    const [queryCmCodes, setQueryCmCodes] = useState([]); // CM Codes to be searched
    let [cmMap, setCmMap] = useState(new Map()); // All CM Mapping
    let [cmColorMap, setCmColorMap] = useState(new Map()); // CM Types color Mapping
    let [highlightHits, setHighlightHits] = useState(true); // Highlight hits only flag, default as true
    let [cmColorLevel, setCmColorLevel] = useState(2); // Color mode, 1/2/3/4, default as 2
    const flipCmAlign = true; // In-page switch: true flips CM marker layers vertically.
    const appliedCmPatternStateRef = useRef({
        cmFilters: [],
        cmFilterCheckboxes: []
    });

    let [data, setData] = useState({});
    const [searchResultData, setSearchResultData] = useState({});
    const [annotState, setAnnotState] = useState({});
    const [itemsAnnotState, setItemsAnnotState] = useState({});

    let [querydb, setQuerydb] = useState([]);
    const [querySeqIds, setQuerySeqIds] = useState([]);
    // The whole result's query sequence IDs for the Advanced Group Options dropdown, and the result they belong to
    const [queryIdOptions, setQueryIdOptions] = useState([]);
    const queryIdOptionsResid = useRef(undefined);
    let [querySeqIdsCount, setQuerySeqIdsCount] = useState(1);
    let [stats, setStats] = useState([]);
    let [docItems, setDocItems] = useState({});
    let [docItemsSelected, setDocItemsSelected] = useState({});
    const [databases, setDatabases] = useState({});
    const [dataBasesForDed, setDataBasesForDed] = useState({});  //database pref for dedup
    let databasesForDed = {};
    const [dedupModal, setDedupModal] = useState(false);
    const [dedDataBasePrefsForUI, setDedDataBasePrefsForUI] = useState([]);
    let [queryDbStats, setQueryDbStats] = useState({});
    let [supportedDisplayModes, setSupportedDisplayModes] = useState({});
    // Whether to clear all filters/groupings
    const [showContinueAlert, setShowContinueAlert] = useState(false);
    const [continueMsg, setContinueMsg] = useState('');
    const [showReportAlert, setShowReportAlert] = useState(false);
    const [editable, setEditable] = useState(true);

    const [manageSortModal, setManageSortModal] = useState(false);

    // Highlight Text variables
    const [smartHighlightText, setSmartHighlightText] = useState('');
    const [smartHighlightPopup, setSmartHighlightPopup] = useState(false);
    const [smartHighlightFilterHover, setSmartHighlightFilterHover] = useState([]);
    const [highlightColorBox, setHighlightColorBox] = useState([]);
    let [smartHighlightFilter, setSmartHighlightFilter] = useState({});
    const [smartHighlightOptions, setSmartHighlightOptions] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [hlFilterSearching, setHlFilterSearching] = React.useState('');
    const minSmartTextLen = 2;

    const [applyEnabled, setApplyEnabled] = useState(false);

    // Filter Text variables
    const [smartText, setSmartText] = useState('');
    const [smartTextPopup, setSmartTextPopup] = useState(false);
    const [smartTextHover, setSmartTextHover] = useState([]);
    let [smartTextFilter, setSmartTextFilter] = useState({});
    const [smartTextOptions, setSmartTextOptions] = useState([]);
    const [filterAnchorEl, setFilterAnchorEl] = React.useState(null);
    const [filterSearching, setFilterSearching] = React.useState('');
    const [filterState, setFilterState] = useState({});
    // For Advanced Filter
    const [addFilterPopup, setAddFilterPopup] = useState(false);
    const [deleteFilterPopup, setDeleteFilterPopup] = useState(false);
    const [deleteViewPopup, setDeleteViewPopup] = useState(false);
    const [deleteViewName, setDeleteViewName] = useState('');
    // The alert-usage check behind del is asynchronous, so two quick clicks can have an
    // earlier check resolve last. This holds the view the user actually asked about, and
    // a check that comes back for anything else is dropped.
    const pendingDeleteView = useRef(null);
    const [deleteIdx,setDeleteIdx] = useState(false);
    const [widgetState, setWidgetState] = useState({});
    //full text search 
    const [showFTModal,setShowFTModal] = useState(false);
    const [ftsInline, setFtsInline] = useState({ field: 'SUBJECT_FTS', value: '', fieldDisplayValue: '', tempFieldDisplayValue: '' });
    const [ftsResetCounter, setFtsResetCounter] = useState(0);

    // PN list variable
    const [pnListErr, setPnListErr] = useState('');

    // Export variables
    const [totalAlignmentNumber, setTotalAlignmentNumber] = useState(0);
    const [totalPatentNumber, setTotalPatentNumber] = useState(0);
    const [customTtlCount, setCustomTtlCount] = useState(0);
    const [downloadType, setDownloadType] = useState('');
    const [downloadTypeDesc, setDownloadTypeDesc] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [customAlertMessage, setCustomAlertMessage] = useState('');
    const [showExportAllModal, setShowExportAllModal] = useState(false);
    const [exportFileName, setExportFileName] = useState('');
    const [showExportChoicesModal, setShowExportChoicesModal] = useState(false);
    const [displayCustomSelection, setDisplayCustomSelection] = useState(false);
    const [customSelectionLabel, setCustomSelectionLabel] = useState('');
    const [selectedAlertMessage, setSelectedAlertMessage] = useState('');
    const [selectedAlignmentsCount, setSelectedAlignmentsCount] = useState(0);
    const [selectedAlignmentsIds, setSelectedAlignmentsIds] = useState([]);
    const [showExportVmModal, setShowExportVmModal] = useState(false);
    const [showSaveResultsModal, setShowSaveResultsModal] = useState(false);
    const [showSaveResultsSucModal, setShowSaveResultsSucModal] = useState(false);
    const [saveAsName, setSaveAsName] = useState('');
    const [saveFiltedResultMsg, setSaveFiltedResultMsg] = useState('');
    const [includeResult, setIncludeResult] = useState(false);
    const [includeAnnotation, setIncludeAnnotation] = useState(false);
    const [includeSS, setIncludeSS] = useState(false);
    const [includeQS, setIncludeQS] = useState(false);
    const [includeFullSeq, setIncludeFullSeq] = useState(false);
    // For Patbase export
    const [showPatbaseModal, setShowPatbaseModal] = useState(false);
    const [pbCountdown, setPbCountdown] = useState(3);
    const [patbasePns, setPatbasePns] = useState([]);
    const [totalPatbasePns, setTotalPatbasePns] = useState(0);
    const [patbasePnsStr, setPatbasePnsStr] = useState('');
    let pbTimer;
    // queriesNoHits for "Extract Quries that did not hit"
    const [queriesNoHits, setQueriesNoHits] = useState(0);
    const [extractName, setExtractName] = useState('');
    const [workflowType, setWorkflowType] = useState(0);

    // More items page
    const [itemsCurrentPage, setItemsCurrentPage] = useState(1);
    const [itemsTotalPage, setItemsTotalPage] = useState(1);
    const [itemsData, setItemsData] = useState({});
    const [showItemsModal, setShowItemsModal] = useState(false);
    const [groupValue1, setGroupValue1] = useState('');
    const [groupValue2, setGroupValue2] = useState('');

    let [sideMenuDetail, setSideMenuDetail] = useState(null);
    let [alignmentsCollapseAll, setAlignmentsCollapseAll] = useState(true);
    let [alignmentsCollapse, setAlignmentsCollapse] = useState({});
    let [claimsCollapseAll, setClaimsCollapseAll] = useState(true);
    let [claimsCollapse, setClaimsCollapse] = useState({});

    let [detailPageCollapseAllLevelOne, setDetailPageCollapseAllLevelOne] = useState(false);
    let [detailPageCollapseAllLevelTwo, setDetailPageCollapseAllLevelTwo] = useState(false);
    let [detailPageCollapseAllLevelThree, setDetailPageCollapseAllLevelThree] = useState(false);

    const [deduplication, setDeduplication] = useState(false);
    const [dedDatabasePrefs, setDedDatabasePrefs] = useState([]);
    const [showDedAlert, setShowDedAlert] = useState(false);
    const [selectedDatabase, setSelectedDatabase] = useState('');

    const [updateKWs, setUpdateKWs ] = useState(false);

    const [viewKeys, setViewKeys] = useState([]);
    // Sharing a saved view with colleagues / the whole entity
    const [shareViewShow, setShareViewShow] = useState(false);
    const [shareViewName, setShareViewName] = useState('');
    const [shareViewUsers, setShareViewUsers] = useState([]);
    const [shareViewEntityShared, setShareViewEntityShared] = useState(false);
    // Views colleagues have shared with this user, listed under their own heading.
    const [sharedViewKeys, setSharedViewKeys] = useState([]);
    const [viewCount, setViewCount] = useState({});
    const [viewOptions, setViewOptions] = useState(null);
    const [groupOptions, setGroupOptions] = useState([
        'family', 'document', 'flat', 'ufs', 'ssv', 'qs', 'hsp', 'cas'
    ]);
    let [selectedGroupOption, setSelectedGroupOption] = useState('');

    let [groupQuery, setGroupQuery] = useState({});

    const {resid, alerts, singleAlignmentId, abExp, vmExp, vmQueryId, reportId} = useParams();
    const {abReportfilters} = useParams();
    const videoToggle = useSelector(state => state.setVideoToggle.videoToggle);

    const changePage = async (e, page) => {
        //let start, stop;
        if (page) {
            //start = ((page - 1) * pageCount) + 1;
            //stop = page * pageCount;
            // When changing page, close the side panel if it's open, reset the search results data, 
            // and fetch new results for the selected page
            if (resultTableRef.current && resultTableRef.current.closeSidePanel) {
                resultTableRef.current.closeSidePanel();
            }
            setCurrentPage(page);
            state.currentPage = page;
            setSearchResultData({});
            fetchResultsNow(true);
        }
    }

    // Re-fetch data when Full Subject Sequence toggle changes (after initial load)
    const includeSubjectSeqInitRef = useRef(true);
    useEffect(() => {
        if (includeSubjectSeqInitRef.current) {
            includeSubjectSeqInitRef.current = false;
            return;
        }
        fetchResultsNow(true);
    }, [includeSubjectSeq]);

    useEffect(() => {
        const handler = (event) => {
            if (event.origin !== window.location.origin) return;
            if (event.data?.type !== 'ANNOTATION_UPDATE') return;
            const { annotType, key, value } = event.data;
            setAnnotState(prev => {
                const next = { ...prev };
                if (annotType === 'star') next.stars = { ...prev.stars, [key]: value };
                else if (annotType === 'color') next.colors = { ...prev.colors, [key]: value };
                else if (annotType === 'notes') next.notes = { ...prev.notes, [key]: value };
                else if (annotType === 'checkbox') next.checkboxes = { ...prev.checkboxes, [key]: value };
                return next;
            });
        };
        window.addEventListener('message', handler);
        return () => window.removeEventListener('message', handler);
    }, []);

    useEffect(() => {
        const applyStyles = () => {
            // Find the container with our specific FullTextSearchBox
            const discoverFTBox = document.querySelector('[data-ft-discover="true"]');

            if (discoverFTBox) {
                // Only apply styles to elements INSIDE the discover container
                const ontologySpacers = discoverFTBox.querySelectorAll('.ftontologySpacer');
                const enhancements = discoverFTBox.querySelectorAll('.ftEnhancement');
                const ftPopup = discoverFTBox.querySelectorAll('.ftPopupBackground');

                ontologySpacers.forEach(el => {
                    el.style.setProperty('padding-right', '51px', 'important');
                });

                enhancements.forEach(el => {
                    el.style.cssText = `margin-left: -14px !important;`;
                    el.style.setProperty('width', '85%', 'important');
                    // el.style.setProperty('max-width', '85%', 'important');
                    el.style.setProperty('min-width', 'auto', 'important');
                });
                ftPopup.forEach(el => {
                    el.style.cssText = 'width: 222px !important; margin-left: -25px !important;';
                });
            }
        };

        setTimeout(applyStyles, 0);
        setTimeout(applyStyles, 100);
        setTimeout(applyStyles, 500);

    }, [ftsResetCounter]); // Removed showFTModal from dependencies

    useEffect(() => {

        if(abReportfilters !== undefined && abReportfilters !== null && abReportfilters !== ""){
            var localAbFilters = JSON.parse(decodeURIComponent(abReportfilters))
            if(!_.isEmpty(localAbFilters)){
                window.reportFilters = localAbFilters;
                if (reportId) {
                    history.push("/discover/"+resid+"/report/" + reportId);
                } else {
                    history.push("/discover/"+resid+"");
                }
            }
        }

        if (userInfo && userInfo.current_user && userInfo.current_user.gq_user_id) {
            if (singleAlignmentId === undefined) {
                fieldConfig.singleAlignment = false;
            } else {
                fieldConfig.singleAlignment = true;
            }
            if (abExp === undefined) {
                fieldConfig.forAb = false;
            } else {
                fieldConfig.forAb = true;
            }
            if (alerts === undefined) {
                fieldConfig.forAlert = false;
            } else {
                fieldConfig.forAlert = true;
                fieldConfig.alertType = alerts; // Store the type: alert, legal, extended, family
            }
            if (vmExp === undefined) {
                fieldConfig.forVm = false;
            } else {
                fieldConfig.forVm = true;
            }
            if (reportId === undefined) {
                fieldConfig.reportId = '';
            } else {
                fieldConfig.reportId = reportId;
            }
            setShowLoader(true);
            fieldConfig.combinedFields = fieldConfig.prepCombinedFields();
            // firstTimeInitial - 1
            fieldConfig.loadConfig('result_rb2', fieldConfig, filter, resid.match(/\d+/)[0]).then(views => {
                //filter = [...filter];
                setViewKeys(views);
                setSharedViewKeys([...fieldConfig.sharedViewKeys]);
            });
            getAuthInfo(); // firstTimeInitial - 2, will call loadResultState()
            // sameAsOriginalOrContinue(); // firstTimeInitial - 3
            //variationReportOperation('list', '', '');

            const timer = setInterval(() => {
                (async () => {
                    await callGQApi();
                })();
            }, 882000); // every 14.7 mins as the api token is valid for 15 mins

            return () => {
                clearInterval(timer);
            };
        }
    }, [userInfo]);

    async function getAuthInfo() {
        let response = await DiscoverService.getAuthInfo(resid, history);
        //let response = authy
        
        if (response && response.response_content) {
            if (response.response_content.type === 'GQEXCEPTION') {
                setAccessDeniedMsg(response.response_content.message);
                return;
            }

            setGqApiKey(response.response_content.gqApiKey);
            // Workflow path/title/algorithm
            let workflowDir = response.response_content.userdir;
            setUserdir(response.response_content.userdir);
            let workflowId = resid.match(/\d+/)[0];
            if (workflowId && workflowDir) {
                // e.g. /opt/genomequest/apache/data/GQdata/userdata/admin/workflow/1341/results.res, "workflow/1341/results.res" to be removed in frontend
                userdir = workflowDir.replace('workflow/' + workflowId + '/results.res', '');
                filter.userdir = userdir;
            }
            resInfo = {...resInfo};
            resInfo['title'] = response.response_content.title;
            document.title = 'GenomeQuest - '+response.response_content.title;
            resInfo['algorithm'] = response.response_content.algorithm;
            setResInfo(resInfo);
            setSaveAsName("copy of " + resInfo['title']);

            if (response.response_content.status && response.response_content.status === 'ARCHIVED') {
                alert("These search results have been archived. If you require access to the search results, " +
                    "please reach out to GQ-Support@aptean.com and request for the data to be restored. Note that this process can take up to 48 hours.");
                // setAppErrorMsg();
                //setShowAppError(true);
                return;
            }

            if (response.response_content.dbs) {
                filter.dbs = response.response_content.dbs;
                /*response.response_content.dbs.forEach(function (value) {
                    if (value.startsWith("CAS") || value.startsWith("REG")) {
                        setHasRegAccess(true);
                        //break;
                    }
                });*/
            }
            hasLvaAccess = Boolean(response.response_content.lvaAccess);
            setHasLvaAccess(hasLvaAccess);
            hasftAccess = Boolean(response.response_content.ftAccess);
            setHasftAccess(hasftAccess);
            let hasCasAccess = Boolean(response.response_content.casAccess);
            setHasRegAccess(hasCasAccess);
            isCmWorkflow = Boolean(response.response_content.isCmWorkflow);
            setIsCmWorkflow(isCmWorkflow);
            // Block access to CM results if user no longer has CM access
            if (isCmWorkflow && userInfo && userInfo.current_user && userInfo.current_user.cmAccess === false) {
                setAccessDeniedMsg('Access to this search result requires an active subscription to the Chemical Modification Module. Please contact your administrator or GQ sales at GQ-Sales@aptean.com.');
                return;
            }
            // Block access if user lost CAS access and ANY database is a CAS database
            if (!hasCasAccess && response.response_content.dbs && response.response_content.dbs.length > 0) {
                const dbs = response.response_content.dbs;
                const casDatabases = response.response_content.casDatabases || [];
                const casDbsInSearch = dbs.filter(db => casDatabases.includes(db));
                if (casDbsInSearch.length > 0) {
                    setAccessDeniedMsg('Access to these results requires an active CAS Biosequences subscription. This search was run against CAS databases.');
                    return;
                }
            }
            isCmNoSeq = Boolean(response.response_content.isCmNoSeq);
            setIsCmNoSeq(isCmNoSeq);
            isCasCm = Boolean(response.response_content.isCasCm);
            setIsCasCm(isCasCm);
            if (isCmWorkflow) {
                // Initialize the CM code map
                let tmpMap = new Map();
                // Fetch CAS dictionary from public folder
                const CmJson = await fetch(process.env.REACT_APP_FT_URL + '/modification_dictionary_full.json').then(res => res.json());
                for (let item of CmJson) {
                    tmpMap.set(parseInt(item.Mod_ID), item);
                }
                cmMap.clear();
                tmpMap.forEach((value, key) => {
                    cmMap.set(key, value);
                });

                qspModSeqTypeRef.current = null;
                if (response.response_content.cmCodes) {
                    let i = 0, colorIndex = 0;
                    cmCodes = [];
                    const numericModCodes = Object.values(response.response_content.cmCodes).filter(c => c !== "" && !isNaN(c)).map(c => parseInt(c, 10));
                    setResultSetModCodes(numericModCodes);
                    const modSeqType = inferQspSeqTypeFromModIds(numericModCodes, tmpMap);
                    qspModSeqTypeRef.current = modSeqType;
                    if (modSeqType) {
                        setQspResultSeqType(modSeqType);
                    }
                    let level1Label, level2Label, level3Label, level4Label;
                    for (let index in response.response_content.cmCodes) {
                        let code = response.response_content.cmCodes[index];
                        if (code !== "") { // Ignore empty ones
                            let color, label, abbr;
                            if (!isNaN(code)) {
                                let codeIntValue = parseInt(code);
                                level1Label = getCmDisplay(cmMap, codeIntValue, 1, true);
                                level2Label = getCmDisplay(cmMap, codeIntValue, 2, true);
                                level3Label = getCmDisplay(cmMap, codeIntValue, 3, true);
                                level4Label = getCmDisplay(cmMap, codeIntValue, 4, true);

                                if (cmColorMap.has(level2Label)) {
                                    color = cmColorMap.get(level2Label);
                                    if (!cmColorMap.has(level1Label)) {
                                        cmColorMap.set(level1Label, color);
                                        cmColorMap.set(level1Label + "/" + level2Label, color);
                                    }
                                    if (!cmColorMap.has(level4Label)) {
                                        cmColorMap.set(level4Label, color);
                                    }
                                    if (!cmColorMap.has(level1Label + "/" + level2Label + "/" + level3Label)) {
                                        let level3Color = color;
                                        if (level2Label === "Fluorination") {
                                            // Set Fluorination as green
                                            level3Color = "A5D6A7";
                                        } else if (level2Label === "2'-O-Methylation") {
                                            // Set 2'-O-Methylation as blue
                                            level3Color = "81D4FA";
                                        } else {
                                            level3Color = highlightColors[codeIntValue % 14];
                                        }
                                        if (cmColorLevel === 3) {
                                            // Uses its own color
                                            color = level3Color;
                                        }
                                        // cmColorMap.set(level3Label, highlightColors[codeIntValue % 14]);
                                        cmColorMap.set(level1Label + "/" + level2Label + "/" + level3Label, level3Color);
                                    }
                                } else {
                                    // For a new group
                                    if (level2Label === "Fluorination") {
                                        // Set Fluorination as green
                                        color = "A5D6A7";
                                    } else if (level2Label === "2'-O-Methylation") {
                                        // Set 2'-O-Methylation as blue
                                        color = "81D4FA";
                                    } else {
                                        color = highlightColors[codeIntValue % 14];
                                    }

                                    // No such level2 group yet, set the same color for its all levels
                                    cmColorMap.set(level1Label, color);
                                    cmColorMap.set(level2Label, color);
                                    cmColorMap.set(level1Label + "/" + level2Label, color);
                                    if (level3Label && level3Label !== "") {
                                        // cmColorMap.set(level3Label, color);
                                        cmColorMap.set(level1Label + "/" + level2Label + "/" + level3Label, color);
                                    }
                                    cmColorMap.set(level4Label, color);
                                }

                                abbr = level3Label && level3Label !== "" ? level3Label : level2Label;

                            } else {
                                color = highlightColors[colorIndex++ % 14];
                                //label = code;
                                abbr = code;
                                level1Label = code;
                                level2Label = code;
                                level3Label = "";

                                cmColorMap.set(code, color);
                            }

                            // Level 1
                            let obj = cmCodes.find(f => f.label === level1Label);
                            if (obj) {
                                // Level 2
                                let obj2 = obj.codes.find(f => f.label === level2Label);
                                if (obj2) {
                                    // Level 3
                                    if (level3Label && level3Label !== "") {
                                        let obj3 = obj2.codes.find(f => f.label === level3Label);
                                        if (obj3) {
                                            // Ignored, already there
                                        } else {
                                            // Add new level 3
                                            obj2.codes.push({
                                                code: code,
                                                label: level3Label,
                                                color: color,
                                            });
                                        }
                                    }

                                    if (obj2.codes.length > 1) {
                                        // Sort by label asc
                                        obj2.codes.sort((a, b) => a.label.localeCompare(b.label));
                                    }
                                } else {
                                    // Add new level 2
                                    obj2 = {};
                                    let codes = [];
                                    if (level3Label && level3Label !== "") {
                                        codes.push({
                                            code: code,
                                            label: level3Label,
                                            color: color,
                                        });
                                        obj2.code = "2-" + code;
                                    } else {
                                        obj2.code = code;
                                    }
                                    obj2.codes = codes;
                                    obj2.color = color;
                                    obj2.label = level2Label;
                                    obj.codes.push(obj2);

                                    if (obj.codes.length > 1) {
                                        // Sort by label asc
                                        obj.codes.sort((a, b) => a.label.localeCompare(b.label));
                                    }
                                }
                            } else {
                                // Add new level 1
                                obj = {};
                                obj.label = level1Label;
                                obj.code = "1-" + code;
                                obj.codes = [];

                                let obj2 = {};
                                let codes = [];
                                // Add its level 2 & level 3
                                if (level3Label && level3Label !== "") {
                                    codes.push({
                                        code: code,
                                        label: level3Label,
                                        color: color,
                                    });
                                    obj2.code = "2-" + code;
                                } else {
                                    obj2.code = code;
                                }

                                obj2.codes = codes;
                                obj2.label = level2Label;
                                obj2.color = color;
                                obj.codes.push(obj2);

                                cmCodes.push(obj);

                                if (cmCodes.length > 1) {
                                    // Sort by label asc
                                    cmCodes.sort((a, b) => a.label.localeCompare(b.label));
                                }
                            }

                        }
                    }

                    setCmCodes(cmCodes);
                    setCmColorMap(cmColorMap);
                }
            } else {
                qspModSeqTypeRef.current = null;
            }
            cmPos = response.response_content.cmPos;
            setCmPos(response.response_content.cmPos);
            cmQueryPos = response.response_content.cmQueryPos || '';
            setCmQueryPos(cmQueryPos);

            setLqAuthKey(response.response_content.lqAuthKey);
            setLqBaseUrl(response.response_content.lqBaseUrl);
            setLoginName(response.response_content.loginName);
            isAbWorkflow = response.response_content.isAbWorkflow;
            setIsAbWorkflow(isAbWorkflow);
            isFtWorkflow = response.response_content.isFtWorkflow;
            let algorithm = response.response_content.algorithm;
            if (isFtWorkflow) {
                setGroupOptions(['family', 'document', 'flat']);
            } else if (isCmWorkflow && isCmNoSeq) {
                // Remove query sequence group && hsp group since it is genepast algo & no query sequences
                setGroupOptions(['family', 'document', 'flat', 'ufs', 'ssv', 'cas']);
            } else if (algorithm && (algorithm.toLowerCase() === 'genepast' || algorithm.toLowerCase() === 'hash')) {
                setGroupOptions(['family', 'document', 'flat', 'ufs', 'ssv', 'qs', 'cas']);
            }
            setQueriesNoHits(response.response_content.queryNoHits);
            setWorkflowType(response.response_content.workflowType);

            let javaCall = {
                data: {
                    workflowId: resid.match(/\d+/)[0],
                    userId: userdir,
                    gqApiKey: response.response_content.gqApiKey
                }
            };
            window.$javaCall = javaCall;
            //warmAllHitsCache(javaCall.data);

            if (!window.$aiDataFetchStarted) {
                window.$aiDataFetchStarted = true;
                setAiDataLoading(true);
                langflowService.fetchAllResults(
                    javaCall.data.workflowId,
                    javaCall.data.userId
                ).then(patentData => {
                    setAiPatentData(patentData);
                    window.$aiPatentData = patentData;
                }).catch(err => {
                    console.error('[AiData] Background load failed:', err);
                }).finally(() => {
                    setAiDataLoading(false);
                });
            }

            updateLastAccess();
            loadResultState(resInfo); // clearAnnotation() method requires the above info
        }
    }

    async function saveResultState(filter, fieldConfig) {
        filter.lvaWidgetState = {...filter.lvaWidgetState};
        filter.widgetState    = {...filter.widgetState};
        filter.state          = {...filter.state};

        let saveLvaFilters = [];
        if (filter.lvaWidgetState && filter.lvaWidgetState.lvaFilters) {
            for (let idx in filter.lvaWidgetState.lvaFilters) {
                if (!filter.lvaWidgetState.lvaFilterDeleted || !filter.lvaWidgetState.lvaFilterDeleted[idx]) {
                    saveLvaFilters.push(filter.lvaWidgetState.lvaFilters[idx]);
                }
            }
        }
        let tmpAlignmentsCollapse = {};
        for (let col in alignmentsCollapse) {
            if (alignmentsCollapse[col] !== alignmentsCollapseAll) {
                tmpAlignmentsCollapse[col] = alignmentsCollapse[col];
            }
        }
        let tmpClaimsCollapse = {};
        for (let col in claimsCollapse) {
            if (claimsCollapse[col] !== claimsCollapseAll) {
                tmpClaimsCollapse[col] = claimsCollapse[col];
            }
        }
        if (singleAlignmentId === undefined && abExp === undefined && vmExp === undefined && reportId === undefined && alerts === undefined) {
            let data = {
                'do': 'gqresult2.save_state',
                'db': resid,
                'state': {
                    resbrowseCtrlState: state,
                    resultFilterState: filter.state,
                    sideMenuDetail: sideMenuDetail,
                    tableDisplayMode: fieldConfig.tableDisplayMode,
                    famViewOption: fieldConfig.famViewOption,
                    famViewAliOption: fieldConfig.famViewAliOption,
                    pnViewOption: fieldConfig.pnViewOption,
                    ssvOption: fieldConfig.ssvOption,
                    ufsOption: fieldConfig.ufsOption,
                    qsOption: fieldConfig.qsOption,
                    hspOption: fieldConfig.hspOption,
                    groupOption: fieldConfig.groupOption,
                    groupSize: fieldConfig.groupSize,
                    groupSizeOper: fieldConfig.groupSizeOper,
                    groupFilters: fieldConfig.groupFilters,
                    groupFilterType: fieldConfig.groupFilterType,
                    groupFilterMatchType: fieldConfig.groupFilterMatchType,
                    groupFilterValue: fieldConfig.groupFilterValue,
                    lvaFilters: saveLvaFilters, // This is saved by result, not with fieldConfig
                    alignmentsCollapseAll: alignmentsCollapseAll,
                    alignmentsCollapse: tmpAlignmentsCollapse,
                    claimsCollapseAll: claimsCollapseAll,
                    claimsCollapse: tmpClaimsCollapse,
                    detailPageCollapseAllLevelOne: detailPageCollapseAllLevelOne,
                    detailPageCollapseAllLevelTwo: detailPageCollapseAllLevelTwo,
                    detailPageCollapseAllLevelThree: detailPageCollapseAllLevelThree,
                    saved: true,
                    userTableTemplate: fieldConfig.userTableTemplate,
                    currentView: fieldConfig.currentView,
                    deduplication: filter.state.deduplication,
                    dedDatabasePrefs: filter.state.dedDatabasePrefs,
                    highlightHits: filter.state.highlightHits,
                    cmColorLevel: filter.state.cmColorLevel,
                    queryCmCodes: filter.state.queryCmCodes,
                },
                format: 'json',
                error_detection: true,
                parm_location: 'inner'
            };
            await DiscoverService.saveState(data);
        }
    }

    async function updateLastAccess() {
        let workflowId = resid.match(/\d+/)[0];
        let data = {workflowId: workflowId};
        await DiscoverService.updateLastAccess(data, window.$javaCall.data.gqApiKey);
    }

    async function loadResultState(resInfo) {
        //if (singleAlignmentId !== undefined || abExp !== undefined || vmExp !== undefined ) { // || window.notLoadSavedResFilters
            // fieldConfig outlives a result, so the last result's Advanced Group Options filters must not carry
            // over, even into a request sent while the state loads. This result's saved state, if it has one,
            // sets them again below.
            Object.assign(fieldConfig, {groupSize: undefined, groupSizeOper: undefined, groupFilters: undefined,
                groupFilterType: undefined, groupFilterMatchType: undefined, groupFilterValue: undefined});
            const response = await DiscoverService.loadResultState(resid, reportId === undefined ? '' : reportId);
            //filter.state = originalState;
            Object.assign(filter.state, originalState);
            setFilterState({...originalState});
            if (response && response.response_status === 0 && response.response_content) {

                if (response.response_content.resbrowseCtrlState) {
                    state = response.response_content.resbrowseCtrlState;
                }
                if (response.response_content.resultFilterState) {
                    filter.state = _.cloneDeep(response.response_content.resultFilterState);
                    if (!filter.state.customFilterCheckboxes) {
                        filter.state.customFilterCheckboxes = [];
                    }
                    if (!filter.state.lvaFilterCheckboxes) {
                        filter.state.lvaFilterCheckboxes = [];
                    }
                    if (!filter.state.annot) {
                        filter.state.annot = {};
                        filter.state.annot.checkboxes = {};
                        filter.state.annot.notesCheckboxes = {
                            empty: false,
                            notEmpty: false
                        };
                    } else if (!filter.state.annot.notesCheckboxes) {
                        filter.state.annot.notesCheckboxes = {
                            empty: false,
                            notEmpty: false
                        };
                    }
                    if (!filter.state['SUBJECT_PN']) {
                        filter.state['SUBJECT_PN'] = {};
                    }
                    if (!filter.state['SUBJECT_PG']) {
                        filter.state['SUBJECT_PG'] = {};
                    }
                    if (!filter.state['SUBJECT_PS']) {
                        filter.state['SUBJECT_PS'] = {};
                    }
                    if (!filter.state['querySeqDbs']) {
                        filter.state['querySeqDbs'] = {};
                    }
                    if (!filter.state['queryCmCodes']) {
                        filter.state['queryCmCodes'] = {};
                    }
                    if (!response.response_content.resultFilterState.sort) {
                        filter.state.sort = 'high_percid_query';
                    }
                    //Object.assign(filter.state, response.response_content.resultFilterState);

                    // Keep only the per-field highlight lists; older saves could hold stray non-list keys (state, widgetState, ...)
                    filter.state.smartHighlightFilter = _.pickBy(filter.state.smartHighlightFilter, Array.isArray);
                    // Apply limit to saved QUERY_ID entries in smartHighlightFilter
                    if (filter.state.smartHighlightFilter && filter.state.smartHighlightFilter['QUERY_ID']) {
                        filter.state.smartHighlightFilter['QUERY_ID'] = filter.state.smartHighlightFilter['QUERY_ID'].slice(0, 8);
                    }

                    setSmartHighlightFilter(_.cloneDeep(filter.state.smartHighlightFilter));
                    setSmartHighlightText(filter.state.smartHighlight);
                    setSmartText(filter.state.smartText);
                    if (filter.state.smartTextFilter) {
                        setSmartTextFilter(JSON.parse(JSON.stringify(filter.state.smartTextFilter)));
                    }
                    Object.assign(filterState, response.response_content.resultFilterState);
                }
                sideMenuDetail = {};
                if (response.response_content.sideMenuDetail) {
                    Object.assign(sideMenuDetail, response.response_content.sideMenuDetail);
                    //setDefaultViews(response.response_content.sideMenuDetail['saved-view']);
                } else {
                    //setDefaultViews(true);
                    sideMenuDetail['saved-view'] = false;
                    sideMenuDetail['shared-view'] = false;
                    sideMenuDetail['lvaModules'] = false;
                    sideMenuDetail['lvaFilters'] = false;
                    sideMenuDetail['globalLvaFilters'] = false;
                    sideMenuDetail['customfilter'] = false;
                    sideMenuDetail['mycustomfilter'] = false;
                    if (cmCodes.length > 0) {
                        Object.keys(cmCodes).forEach(function (key) {
                            sideMenuDetail[cmCodes[key].label] = true;
                        });
                    }
                }
                setSideMenuDetail({...sideMenuDetail});
                if (response.response_content.tableDisplayMode) {
                    fieldConfig.tableDisplayMode = response.response_content.tableDisplayMode;
                    selectedGroupOption = response.response_content.tableDisplayMode;
                    setSelectedGroupOption(response.response_content.tableDisplayMode);
                }
                let options = {};
                if (response.response_content.famViewOption) {
                    options.selectedFamViewOption = response.response_content.famViewOption;
                    fieldConfig.famViewOption = response.response_content.famViewOption;
                } else {
                    options.selectedFamViewOption = '3';
                    fieldConfig.famViewOption = '3';
                }
                if (response.response_content.famViewAliOption) {
                    options.selectedFamViewAliOption = response.response_content.famViewAliOption;
                    fieldConfig.famViewAliOption = response.response_content.famViewAliOption;
                } else {
                    options.selectedFamViewAliOption = '10';
                    fieldConfig.famViewAliOption = '10';
                }
                if (response.response_content.pnViewOption) {
                    options.selectedPnViewOption = response.response_content.pnViewOption;
                    fieldConfig.pnViewOption = response.response_content.pnViewOption;
                } else {
                    options.selectedPnViewOption = '10';
                    fieldConfig.pnViewOption = '10';
                }
                if (response.response_content.ssvOption) {
                    options.selectedSsvOption = response.response_content.ssvOption;
                    fieldConfig.ssvOption = response.response_content.ssvOption;
                } else {
                    options.selectedSsvOption = '10';
                    fieldConfig.ssvOption = '10';
                }
                if (response.response_content.ufsOption) {
                    options.selectedUfsOption = response.response_content.ufsOption;
                    fieldConfig.ufsOption = response.response_content.ufsOption;
                } else {
                    options.selectedUfsOption = '10';
                    fieldConfig.ufsOption = '10';
                }
                if (response.response_content.qsOption) {
                    options.selectedQsOption = response.response_content.qsOption;
                    fieldConfig.qsOption = response.response_content.qsOption;
                } else {
                    options.selectedQsOption = '10';
                    fieldConfig.qsOption = '10';
                }
                if (response.response_content.hspOption) {
                    options.selectedHspOption = response.response_content.hspOption;
                    fieldConfig.hspOption = response.response_content.hspOption;
                } else {
                    options.selectedHspOption = '10';
                    fieldConfig.hspOption = '10';
                }
                if (response.response_content.groupOption) {
                    options.selectedGroupOption = response.response_content.groupOption;
                    fieldConfig.groupOption = response.response_content.groupOption;
                } else {
                    options.selectedGroupOption = '10';
                    fieldConfig.groupOption = '10';
                }
                // Switching grouping from the plain menu used to leave the last group size behind. The groupings
                // the Advanced dialog cannot set never have one of their own, and Patent Family/Number only
                // count it when it was saved with its filter rows.
                const staleGroupSize = ['ufs', 'ssv', 'cas', 'flat', 'qs', 'hsp'].includes(fieldConfig.tableDisplayMode)
                    || ((fieldConfig.tableDisplayMode === 'family' || fieldConfig.tableDisplayMode === 'document')
                        && _.isEmpty(response.response_content.groupFilters));
                if (response.response_content.groupSize && !staleGroupSize) {
                    fieldConfig.groupSize = response.response_content.groupSize;
                }
                if (response.response_content.groupSizeOper && !staleGroupSize) {
                    fieldConfig.groupSizeOper = response.response_content.groupSizeOper;
                }
                if (response.response_content.groupFilters) {
                    fieldConfig.groupFilters = response.response_content.groupFilters;
                }
                if (response.response_content.groupFilterType) {
                    fieldConfig.groupFilterType = response.response_content.groupFilterType;
                }
                if (response.response_content.groupFilterMatchType) {
                    fieldConfig.groupFilterMatchType = response.response_content.groupFilterMatchType;
                }
                if (response.response_content.groupFilterValue) {
                    fieldConfig.groupFilterValue = response.response_content.groupFilterValue;
                }
                setViewOptions(options);

                if (!filter.lvaWidgetState) {
                    filter.lvaWidgetState = {};
                }
                if (response.response_content.lvaFilters) {
                    filter.lvaWidgetState.lvaFilters = _.cloneDeep(response.response_content.lvaFilters);
                    for (let key in filter.lvaWidgetState.lvaFilters) {
                        let tmpFilter = filter.lvaWidgetState.lvaFilters[key];
                        if (!tmpFilter.uuid) {
                            tmpFilter.uuid = filter.generateUUID();
                        }
                        if (!tmpFilter.widgetMode) {
                            tmpFilter.widgetMode = 'AND';
                        }
                        //tmpFilter.filterIdx = key;
                        for (let methodIdx in tmpFilter.widgetContent) {
                            tmpFilter.widgetContent[methodIdx].colors = {
                                color: tmpFilter.selectedColor ? tmpFilter.selectedColor : "blue",
                                bgColor: "white"
                            };
                        }
                    }
                    // To refresh the VM filters for GQPowerTools & ResultStatsBar
                    setVmIds({...vmIds});
                }
                if (response.response_content.userTableTemplate) {
                    fieldConfig.userTableTemplate = response.response_content.userTableTemplate;
                    fieldConfig.estimateTableWidth(fieldConfig.userTableTemplate, fieldConfig.tableDisplayMode);
                }
                if (response.response_content.currentView) {
                    fieldConfig.currentView = response.response_content.currentView;
                }
                filter.state.deduplication = false;
                if (response.response_content.deduplication) {
                    setDeduplication(response.response_content.deduplication);
                    filter.state.deduplication = response.response_content.deduplication;
                }
                if (response.response_content.dedDatabasePrefs) {
                    setDedDatabasePrefs(response.response_content.dedDatabasePrefs);
                    filter.state.dedDatabasePrefs = response.response_content.dedDatabasePrefs;
                }
                // Restore CM selections from State
                if (response.response_content.highlightHits !== undefined) {
                    setHighlightHits(response.response_content.highlightHits);
                    filter.state.highlightHits = response.response_content.highlightHits;
                } else {
                    setHighlightHits(true);
                    filter.state.highlightHits = true;
                }
                if (response.response_content.cmColorLevel !== undefined) {
                    setCmColorLevel(response.response_content.cmColorLevel);
                    filter.state.cmColorLevel = response.response_content.cmColorLevel;
                } else {
                    setCmColorLevel(2);
                    filter.state.cmColorLevel = 2;
                }
                if (response.response_content.queryCmCodes !== undefined) {
                    setQueryCmCodes(response.response_content.queryCmCodes);
                    filter.state.queryCmCodes = response.response_content.queryCmCodes;
                } else {
                    setQueryCmCodes([]);
                    filter.state.queryCmCodes = [];
                }

                let sameAsOriginal = true;
                const ALERT_TYPES = ['alert', 'newhits', 'legal', 'extended', 'family'];
                const isFromAlert = alerts && ALERT_TYPES.some(alertType => alerts.startsWith(alertType));

                if (!(singleAlignmentId !== undefined || abExp !== undefined || vmExp !== undefined || reportId !== undefined || alerts !== undefined)) {
                    // || window.notLoadSavedResFilters
                    if (isFtWorkflow && !fieldConfig.currentView) {
                        fieldConfig.tableDisplayMode = 'document';
                        selectedGroupOption = 'document';
                        setSelectedGroupOption('document');
                        fieldConfig.currentView = 'defaultFt';
                        fieldConfig.selectView(fieldConfig, 'defaultFt', filter, editable);
                    } else if (isCmWorkflow && !fieldConfig.currentView) {
                        fieldConfig.tableDisplayMode = 'flat';
                        selectedGroupOption = 'flat';
                        setSelectedGroupOption('flat');
                        fieldConfig.currentView = 'defaultCm';
                        fieldConfig.selectView(fieldConfig, 'defaultCm', filter, editable, isCasCm);
                    }
                    if (response.response_content.alignmentsCollapseAll === false) {
                        alignmentsCollapseAll = false;
                        setAlignmentsCollapseAll(false);
                    } else {
                        alignmentsCollapseAll = true;
                        setAlignmentsCollapseAll(true);
                    }
                    alignmentsCollapse = response.response_content.alignmentsCollapse;
                    if (response.response_content.claimsCollapseAll === false) {
                        claimsCollapseAll = false;
                        setClaimsCollapseAll(false);
                    } else {
                        claimsCollapseAll = true;
                        setClaimsCollapseAll(true);
                    }
                    claimsCollapse = response.response_content.claimsCollapse;
                    detailPageCollapseAllLevelOne = response.response_content.detailPageCollapseAllLevelOne;
                    detailPageCollapseAllLevelTwo = response.response_content.detailPageCollapseAllLevelTwo;
                    detailPageCollapseAllLevelThree = response.response_content.detailPageCollapseAllLevelThree;

                    if (JSON.stringify(originalState['publicationNumberList']) !== JSON.stringify(filter.state['publicationNumberList'])
                        || JSON.stringify(originalState['databaseNames']) !== JSON.stringify(filter.state['databaseNames'])) {
                        sameAsOriginal = false;
                    }

                    if (sameAsOriginal) {
                        for (let key in originalState) {
                            if (key === 'annot') {
                                if (filter.state[key]) {
                                    if (filter.state.annot.checkboxes) {
                                        for (let anKey in filter.state.annot.checkboxes) {
                                            if (filter.state.annot.checkboxes[anKey] === true) {
                                                sameAsOriginal = false;
                                                break;
                                            }
                                        }
                                    }
                                    if (filter.state.annot.colors) {
                                        for (let anKey in filter.state.annot.colors) {
                                            if (filter.state.annot.colors[anKey] === true) {
                                                sameAsOriginal = false;
                                                break;
                                            }
                                        }
                                    }
                                    if (filter.state.annot.stars) {
                                        for (let anKey in filter.state.annot.stars) {
                                            if (filter.state.annot.stars[anKey] === true) {
                                                sameAsOriginal = false;
                                                break;
                                            }
                                        }
                                    }
                                    if (filter.state.annot.noteList) {
                                        sameAsOriginal = false;
                                        break;
                                    }
                                    if (filter.state.annot.notesCheckboxes) {
                                        for (let anKey in filter.state.annot.notesCheckboxes) {
                                            if (filter.state.annot.notesCheckboxes[anKey] === true) {
                                                sameAsOriginal = false;
                                                break;
                                            }
                                        }
                                    }
                                }
                            } else if (key === 'customFilterCheckboxes' || key === 'cmFilterCheckboxes' || key === 'lvaFilterCheckboxes'
                                || key === 'SUBJECT_PN' || key === 'SUBJECT_PG' || key === 'SUBJECT_PS'
                                || key === 'querySeqDbs' || key === 'queryCmCodes') {
                                if (filter.state[key] && _.size(filter.state[key]) > 0) {
                                    for (let cbKey in filter.state[key]) {
                                        if (filter.state[key][cbKey] === true) {
                                            sameAsOriginal = false;
                                            break;
                                        }
                                    }
                                }
                            } else if (key === 'smartTextFilter') {
                                if (Object.keys(filter.state.smartTextFilter).length > 0) {
                                    for (let typeFilter in filter.state.smartTextFilter) {
                                        for (let tff in filter.state.smartTextFilter[typeFilter]) {
                                            //console.log(filter.state.smartTextFilter[typeFilter][tff].value);
                                            if (filter.state.smartTextFilter[typeFilter][tff].value === true) {
                                                sameAsOriginal = false;
                                                break;
                                            }
                                        }
                                    }
                                }
                            } else if (key === 'smartHighlightFilter') {
                                if (filter.state.smartHighlightFilter && Object.keys(filter.state.smartHighlightFilter).length > 0) {
                                    for (let typeFilter in filter.state.smartHighlightFilter) {
                                        for (let tff in filter.state.smartHighlightFilter[typeFilter]) {
                                            //console.log(filter.state.smartHighlightFilter[typeFilter][tff].value);
                                            if (filter.state.smartHighlightFilter[typeFilter][tff].value === true) {
                                                sameAsOriginal = false;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (filter.state.deduplication) {
                        sameAsOriginal = false;
                    }

                    if (!sameAsOriginal) {
                        setShowLoader(false);

                        if (_.isEmpty(window.reportFilters)) {
                            if (!isFromAlert) {
                                let msg = 'Welcome back to ' + resInfo.title + ' results. ' +
                                    'You can continue to work on your results, or you can clear all filters, groupings and annotations.';
                                setContinueMsg(msg);
                                setShowContinueAlert(true);
                            } else {
                                // Skip the continue modal and load results directly
                                closeContinueModal(resInfo);
                            }
                        } else {
                            // Set the grouping for AB linkouts in advance
                            if (window.reportFilters.groupBy) {
                                fieldConfig.tableDisplayMode = window.reportFilters.groupBy;
                                selectedGroupOption = window.reportFilters.groupBy;
                                setSelectedGroupOption(window.reportFilters.groupBy);
                            }
                            fieldConfig.currentView = 'default';
                            // Don't call below to avoid saving state for AB links
                            //fieldConfig.selectView(fieldConfig, 'default', filter);
                            closeContinueModal(resInfo);
                        }
                    }
                }

                if (singleAlignmentId !== undefined) {
                    //resetAllFitlers(fieldConfig, filter);
                    filter.state.singleAlignmentId = singleAlignmentId;
                } else if (abExp !== undefined) {
                    //resetAllFitlers(fieldConfig, filter);
                    filter.state.abExp = abExp;
                } else if (vmExp !== undefined) {
                    //resetAllFitlers(fieldConfig, filter);
                    //clearCustomFilter(filter, 'lvaFilterCheckboxes');
                    filter.state.vmExp = vmExp;
                    filter.state.vmQueryId = vmQueryId;
                    if (reportId !== undefined) {
                        filter.state.reportId = reportId;
                    }
                } else if (reportId !== undefined) {
                    filter.state.reportId = reportId;
                } else if (alerts !== undefined) {
                    // TODO, Clear all selections???
                    //resetAllFitlers(fieldConfig, filter);

                    // Clear alert parameters first
                    filter.state.familyId = undefined;
                    filter.state.docNum = undefined;
                    filter.state.docType = undefined;
                    // Clear the selected custom filters to avoid no results & it won't be saved
                    clearCustomFilter(filter, 'customFilterCheckboxes');

                    const hashQuery = window.location.hash.split('?')[1];
                    const urlParams = new URLSearchParams(hashQuery || '');
                    const docNum = urlParams.get('doc');
                    const docType = urlParams.get('type');
                    const familyId = urlParams.get('familyid');

                    if (familyId || alerts === 'family') {
                        if (familyId) {
                            filter.state.familyId = familyId;
                        }
                        if (docNum) {
                            filter.state.docNum = docNum;
                            filter.state.docType = 'PN';
                        }

                        fieldConfig.tableDisplayMode = 'family';
                        selectedGroupOption = 'family';
                        setSelectedGroupOption('family');
                        //fieldConfig.currentView = 'defaultFt';
                    } else if (docNum && docType) {
                        filter.state.docNum = docNum;
                        filter.state.docType = docType;

                        if (docType === 'PN') {
                            fieldConfig.tableDisplayMode = 'document';
                            selectedGroupOption = 'document';
                            setSelectedGroupOption('document');
                        } else {
                            fieldConfig.tableDisplayMode = 'flat';
                            selectedGroupOption = 'flat';
                            setSelectedGroupOption('flat');
                        }
                    } else if (alerts === 'legal' || alerts === 'extended') {
                        fieldConfig.tableDisplayMode = 'document';
                        selectedGroupOption = 'document';
                        setSelectedGroupOption('document');
                    }

                }

                Object.assign(filterState, filter.state);
                setFilterState({...filterState});

                if (reportId !== undefined) {
                    setShowLoader(false);
                    // Show report dialog
                    let msg = 'Welcome back to ' + resInfo.title + ' results. ' +
                        'You can continue to view your Read Only subset, or you can go back to the Editable report.';
                    setContinueMsg(msg);
                    setShowReportAlert(true);
                } else if (sameAsOriginal || isFromAlert) {
                    // Load data
                    fetchResultsNow();
                    loadStatistic(resInfo);
                }
            }

            let localAbRepFilters = _.cloneDeep(window.reportFilters)
            console.log("Is from AB Module:" + !_.isEmpty(localAbRepFilters));
            if (!_.isEmpty(localAbRepFilters)) {

                if (localAbRepFilters.groupBy) {
                    fieldConfig.tableDisplayMode = localAbRepFilters.groupBy;
                    selectedGroupOption = localAbRepFilters.groupBy;
                    setSelectedGroupOption(localAbRepFilters.groupBy);
                }
                setAbFiltersDesc(getAbFiltersDesc());

                // if(localAbRepFilters.reportName!== undefined && localAbRepFilters.reportName!== null &&localAbRepFilters.reportName!== ""){
                //     let data = {
                //         abReportName: localAbRepFilters.reportName,
                //         userId: window.$javaCall.data.userId,
                //         workflowId: resid.match(/\d+/)[0],
                //     }
                //     const results = await DiscoverService.loadAbReport(data, window.$javaCall.data.gqApiKey)
                //     setFiltersFromAb(results.filters, filter)
                // }

            }

    }

    // useEffect to auto-open side panel when data loads and autoOpen parameter is true
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const autoOpenParam = urlParams.get('autoOpen');

        // Only proceed if autoOpen is true, we have data, and we haven't already auto-opened
        if (autoOpenParam === 'true' &&
            searchResultData &&
            searchResultData.data &&
            Object.keys(searchResultData.data).length > 0 &&
            !autoOpenedRef.current) {

            console.log('DEBUG: Data loaded, triggering auto-open');
            console.log('DEBUG: searchResultData keys:', Object.keys(searchResultData.data).length);
            //console.log('DEBUG: showContinueAlert modal is:', showContinueAlert);
            //console.log('DEBUG: autoOpenedRef.current:', autoOpenedRef.current);

            // Only auto-open if the continue alert modal is NOT showing
            // If modal is showing, wait for it to be dismissed
            if (!showContinueAlert) {
                // Wait a bit for the ResultTable to fully render
                setTimeout(() => {
                    if (resultTableRef.current && resultTableRef.current.openFirstRow) {
                        //console.log('DEBUG: Calling openFirstRow via ref');
                        resultTableRef.current.openFirstRow();
                        autoOpenedRef.current = true; // Mark as auto-opened
                        console.log('DEBUG: Set autoOpenedRef to true');
                    } else {
                        console.log('DEBUG: resultTableRef not ready', {
                            current: !!resultTableRef.current,
                            openFirstRow: resultTableRef.current ? !!resultTableRef.current.openFirstRow : false
                        });
                    }
                }, 500);
            } else {
                console.log('DEBUG: Continue alert modal is showing, waiting for it to be dismissed before auto-opening');
            }
        }
    }, [searchResultData, location.search, showContinueAlert]);

    const closeReportModal = (resInfo) => {
        setEditable(false);
        setShowReportAlert(false);
        fetchResultsNow();
        loadStatistic(resInfo);
    }

    const startOverReport  = (filter, filterState, resInfo, fieldConfig) => {
        // Remove reportId to work with the current results
        history.push(location.pathname.replace(reportId, ''));
    }

    const closeContinueModal = (resInfo) => {
        setShowContinueAlert(false);
        fetchResultsNow();
        loadStatistic(resInfo);
    }

    const startOver = async(filter, filterState, resInfo, fieldConfig) => {
        let tmpSmartHighlightFilter = filter.state.smartHighlightFilter;
        if (tmpSmartHighlightFilter && Object.keys(tmpSmartHighlightFilter).length > 0) {
            for (let typeFilter in tmpSmartHighlightFilter) {
                for (let filter in tmpSmartHighlightFilter[typeFilter]) {
                    if (tmpSmartHighlightFilter[typeFilter][filter].value === true) {
                        tmpSmartHighlightFilter[typeFilter][filter].value = false;
                    }
                }
            }
        }
        resetAllFitlers(fieldConfig, filter);
        // Set to default grouping
        if (isFtWorkflow) {
            fieldConfig.tableDisplayMode = 'document';
            selectedGroupOption = 'document';
            setSelectedGroupOption('document');
            fieldConfig.currentView = 'defaultFt';
            fieldConfig.selectView(fieldConfig, 'defaultFt', filter, editable);
        } else if (isCmWorkflow) {
            fieldConfig.tableDisplayMode = 'flat';
            selectedGroupOption = 'flat';
            setSelectedGroupOption('flat');
            fieldConfig.currentView = 'defaultCm';
            fieldConfig.selectView(fieldConfig, 'defaultCm', filter, editable, isCasCm);
        } else {
            fieldConfig.tableDisplayMode = 'flat';
            selectedGroupOption = 'flat';
            setSelectedGroupOption('flat');
            fieldConfig.currentView = 'default';
            fieldConfig.selectView(fieldConfig, 'default', filter, editable);
        }
        if (editable === true) {
            saveResultState(filter, fieldConfig);
        }

        // while the backend is preparing results we show the user a spinner animation
        setShowLoader(true);
        // Clear Annatation
        let call = {
            workflowId: resid.match(/\d+/)[0],
            userId: window.$javaCall.data.userId
        };
        const response = await DiscoverService.clearAnnotation(call, window.$javaCall.data.gqApiKey, history);
        if (response && response.status === 'success') { // Waiting for the response to avoid fetching old annotations
            closeContinueModal(resInfo);
        }
    }

    async function getStats(statsApi, algorithm, withGroupSize = true) {
        let javaCall = {
            data: {
                workflowId: resid.match(/\d+/)[0],
                userId: window.$javaCall.data.userId,
                algorithm: algorithm
            }
        };
        applyFilterForJava(javaCall);
        // Group size rows narrow the collection the table shows, so the counts, charts and facets follow
        // them. They belong to a grouping, which the backend groups by.
        if (withGroupSize && hasGroupSizeFilter(fieldConfig)) {
            Object.assign(javaCall.data, {
                groupCriteria: groupCriteriaFor(fieldConfig.tableDisplayMode),
                groupSize: fieldConfig.groupSize,
                groupSizeOper: fieldConfig.groupSizeOper,
                groupFilters: sizeRowsOf(fieldConfig),
            });
        }
        return await DiscoverService.getStats(statsApi, javaCall.data, window.$javaCall.data.gqApiKey);
    }

    let drawCharts = 0;
    async function loadStatistic(resInfo) {
        facetInfo = {};
        const sizeFiltered = hasGroupSizeFilter(fieldConfig);
        // The facet statistics follow a Group size filter, so the dropdown's query IDs come from the whole
        // result: fetched once per result while a filter is applied, unless already known
        const needWholeQueryIds = sizeFiltered && queryIdOptionsResid.current !== resid;
        // Run in parallel to improve the performance
        const [groupStats, resultCharts, facetStats, multiQuerySeq, wholeGroupStats, wholeFacetStats] = await Promise.all(
            [getStats('groupViewStats', resInfo.algorithm),
                getStats('resultCharts', resInfo.algorithm),
                getStats('facetStats', resInfo.algorithm),
                getStats('multiQuerySeqV3', resInfo.algorithm),
                // The other groupings in the menu count the whole result, since picking one clears the filter
                sizeFiltered ? getStats('groupViewStats', resInfo.algorithm, false) : undefined,
                needWholeQueryIds ? getStats('facetStats', resInfo.algorithm, false) : undefined]
        );
        const wholeQueryInfo = sizeFiltered ? wholeFacetStats?.queryInfo : facetStats?.queryInfo;
        if (wholeQueryInfo) {
            setQueryIdOptions(Object.values(wholeQueryInfo).map(query => query.id));
            queryIdOptionsResid.current = resid;
        } else if (queryIdOptionsResid.current !== resid && facetStats?.queryInfo) {
            // Without the whole list, offer this result's narrowed one rather than another result's
            setQueryIdOptions(Object.values(facetStats.queryInfo).map(query => query.id));
        }

        if (groupStats) {
            const groupCountsFrom = (stats) => ({
                RESULT_ID: stats.alignmentCount.replace("\n", ""),
                SUBJECT_PB: stats.familyCount.replace("\n", ""),
                SUBJECT_PJ: stats.ufsCount.replace("\n", ""),
                SUBJECT_PN: stats.patentNumCount.replace("\n", ""),
                SUBJECT_ID: stats.ssvNumCount.replace("\n", ""),
                SUBJECT_RG: stats.casRegNumCount.replace("\n", ""),
                QUERY_ID: stats.qsNumCount ? stats.qsNumCount.replace("\n", "") : undefined,
                HSP: stats.hspNumCount ? stats.hspNumCount.replace("\n", "") : undefined,
            });
            // Falls back to the filtered counts if the whole-result request failed
            const wholeCounts = wholeGroupStats && wholeGroupStats.alignmentCount ? wholeGroupStats : undefined;
            let newGroupCount = groupCountsFrom(wholeCounts || groupStats);
            // The current grouping counts what the table shows
            const currentKey = {family: 'SUBJECT_PB', document: 'SUBJECT_PN'}[fieldConfig.tableDisplayMode];
            if (wholeCounts && currentKey) {
                newGroupCount[currentKey] = groupCountsFrom(groupStats)[currentKey];
            }

            let stat = {};
            stat["count"] = newGroupCount;
            setStats(stat);
            if (data === undefined) {
                data = {};
            }
            if (data.stats === undefined || !data.stats) {
                data.stats = [];
            }
            data.stats.count = newGroupCount;
            setViewCount(newGroupCount);
        }

        if (resultCharts) {
            let res = fieldConfig.resultChartsConverter(resultCharts);
            Object.keys(res).forEach(function (key) {
                facetInfo[key] = res[key];
            });

            drawCharts++;

            if (drawCharts === 2) {
                setFacetInfo({...facetInfo});
                ChartService.facet = _.cloneDeep(facetInfo);
                //$timeout(function () {
                    ChartService.drawNow(facetInfo);
               // }, 100);
                drawCharts = 0;
            }
        }


        if (facetStats) {
            resInfo = {...resInfo};
            resInfo["databases"] = facetStats.databases;
            setResInfo(resInfo);
            setDatabases(prepDatabases(resInfo));

            // console.log(response);
            let res = fieldConfig.facetConverter(facetStats);
            Object.keys(res).forEach(function (key) {
                facetInfo[key] = res[key];
            });
            setQuerySeqIds(facetStats.queryInfo);
            setQuerySeqIdsCount(Object.keys(facetStats.queryInfo).length);

            const detectedQspSeqType = qspModSeqTypeRef.current || inferQspSeqTypeFromQueryInfo(facetStats.queryInfo);
            if (detectedQspSeqType) {
                setQspResultSeqType(detectedQspSeqType);
            }

            // Initialize Query Sequence IDs in smartHighlightFilter with default checked state and colors
            // Start from filter.state, not the smartHighlightFilter React state: when called right after loadResultState()
            // that state is still the stale value from this closure, which dropped the saved highlights
            let updatedSmartHighlightFilter = {...filter.state.smartHighlightFilter};
            if (!updatedSmartHighlightFilter['QUERY_ID']) {
                updatedSmartHighlightFilter['QUERY_ID'] = [];
            }

            const queryKeys = Object.keys(facetStats.queryInfo);

            // Check if user has explicitly cleared QUERY_ID highlights - if so, don't re-add them
            const userClearedHighlights = filter.state.queryIdHighlightsCleared === true;

            // If more than 8 entries or CM workflow, don't auto-add Query Sequence Id by default
            // BUT preserve any manually-added QUERY_ID filters (those with source !== 'querySeqId')
            // Also skip auto-adding if user has explicitly cleared the highlights
            if (queryKeys.length > 8 || isCmWorkflow || userClearedHighlights) {
                // Keep only manually-added QUERY_ID filters (user-created highlights)
                const manuallyAddedFilters = updatedSmartHighlightFilter['QUERY_ID'].filter(
                    item => item.source !== 'querySeqId'
                );
                updatedSmartHighlightFilter['QUERY_ID'] = manuallyAddedFilters;
            } else {
                // If any auto-generated entry isn't one of this result's query IDs, the entries were carried over
                // from a previously viewed result (e.g. SEQ_1 when this result's query is seq?): drop them all so
                // this result's own IDs get added below
                const currentSeqIds = queryKeys.map(key => facetStats.queryInfo[key].id.toUpperCase());
                const hasStaleAutoGenerated = updatedSmartHighlightFilter['QUERY_ID'].some(
                    item => item.source === 'querySeqId' && !currentSeqIds.includes(item.text)
                );
                if (queryKeys.length > 0 && hasStaleAutoGenerated) {
                    updatedSmartHighlightFilter['QUERY_ID'] = updatedSmartHighlightFilter['QUERY_ID'].filter(
                        item => item.source !== 'querySeqId'
                    );
                }

                // Check if there are any existing auto-generated entries - if so, preserve them as-is
                // This ensures user's checkbox changes (unchecking) are remembered
                const existingAutoGenerated = updatedSmartHighlightFilter['QUERY_ID'].filter(
                    item => item.source === 'querySeqId'
                );
                
                // Only auto-populate if there are NO existing auto-generated entries
                // This means it's a fresh load or user reset all filters
                if (existingAutoGenerated.length === 0) {
                    // Process all entries when 8 or fewer and add auto-generated ones
                    for (let i = 0; i < queryKeys.length; i++) {
                        const key = queryKeys[i];
                        const seqId = facetStats.queryInfo[key].id;
                        // Check if this sequence ID already exists in the filter (manual or auto)
                        const existingEntry = _.find(updatedSmartHighlightFilter['QUERY_ID'], obj => obj.text === seqId.toUpperCase());

                        if (!existingEntry) {
                            // Assign specific colors to specific QUERY_IDs
                            const colorIndex = getQueryIdColor(
                                seqId, updatedSmartHighlightFilter['QUERY_ID'].map(item => item.color), currentSeqIds
                            );

                            updatedSmartHighlightFilter['QUERY_ID'].push({
                                text: seqId.toUpperCase(),
                                value: true, // Default to checked
                                negate: false,
                                color: colorIndex, // Assign specific or default color from palette
                                match: [seqId.toUpperCase()],
                                source: 'querySeqId'
                            });
                        }
                    }
                }
                // If existingAutoGenerated.length > 0, keep them as-is (preserve user's checkbox states)
            }

            filter.state.smartHighlightFilter = updatedSmartHighlightFilter;
            setSmartHighlightFilter(updatedSmartHighlightFilter);

            // Log the QUERY_IDs that are displayed (auto-generated and manually-added)
            const autoGeneratedQueryIds = updatedSmartHighlightFilter['QUERY_ID'].filter(item => item.source === 'querySeqId');
            const manuallyAddedQueryIds = updatedSmartHighlightFilter['QUERY_ID'].filter(item => item.source !== 'querySeqId');

            if (queryKeys.length <= 8) {
                console.log('QUERY_IDs auto-displayed by default:', autoGeneratedQueryIds.map(item => ({
                    queryId: item.text,
                    colorIndex: item.color,
                    colorValue: highlightColors[item.color]
                })));
            } else {
                console.log(`Too many QUERY_IDs (${queryKeys.length} > 8), auto-display disabled`);
            }

            if (manuallyAddedQueryIds.length > 0) {
                console.log('Manually-added QUERY_ID filters preserved:', manuallyAddedQueryIds.map(item => ({
                    queryId: item.text,
                    colorIndex: item.color,
                    colorValue: highlightColors[item.color],
                    source: item.source
                })));
            }

            for (let qi in facetStats.queryInfo) {
                // Disable the UFS/CAS group options for FT workflows
                if (facetStats.queryInfo[qi]['seq'] === 'A') {
                    setGroupOptions(['family', 'document', 'flat']);
                    break;
                }
            }
            drawCharts++;

            if (drawCharts === 2) {
                setFacetInfo({...facetInfo});
                ChartService.facet = _.cloneDeep(facetInfo);
                //$timeout(function () {
                    ChartService.drawNow(facetInfo);
               // }, 100);
                drawCharts = 0;
            }

            filter.state.querySeqMap = {};
            let sequenceId = {};
            Object.keys(facetStats.queryInfo).forEach(function (key) {
                sequenceId[key] = facetStats.queryInfo[key].id;
                filter.state.querySeqMap[facetStats.queryInfo[key].id] = key;
            });
            querydb["SEQUENCE_ID"] = sequenceId;
            querydb["SEQUENCE_ID_COUNT"] = facetStats.queryInfo;
            querydb["count"] = Object.keys(facetStats.queryInfo).length;
            setQuerydb(querydb);
            // $scope.querySeqIdsCount = Object.keys(response.queryDb).length;
            if (hasLvaAccess) {
                let lvaQueries = {};
                let maxLen = 0;
                const seqCount = Object.keys(facetStats.queryInfo).length;
                Object.keys(facetStats.queryInfo).forEach(function (key) {
                    let lvaQuery = {};
                    lvaQuery["QUERY_ID"] = facetStats.queryInfo[key].id;
                    lvaQuery["QUERY_L"] = facetStats.queryInfo[key].queryLen;
                    lvaQuery["QUERY_N"] = facetStats.queryInfo[key].queryN;
                    lvaQuery["RESULTS"] = facetStats.queryInfo[key].count;
                    lvaQuery["RESULT_NFQ"] = facetStats.queryInfo[key].resultNfq;
                    lvaQuery["SUBJECT_T"] = facetStats.queryInfo[key].subjectType;
                    lvaQueries[seqCount > 1 ? (parseInt(key) + 1) : key] = lvaQuery;
                    if (facetStats.queryInfo[key].queryLen > maxLen) {
                        maxLen = facetStats.queryInfo[key].queryLen;
                    }
                });
                //console.log(lvaQueries);
                filter.lvaQueries = lvaQueries;
                if (seqCount === 1) {
                    filter.defaultLvaQuery = filter.lvaQueries[Object.keys(filter.lvaQueries)[0]];
                } else {
                    filter.defaultLvaQuery = null;

                    // Add "All" to be the first one
                    let lvaQuery = {};
                    lvaQuery["QUERY_ID"] = "All Queries";
                    lvaQuery["QUERY_L"] = maxLen;
                    lvaQueries[1] = lvaQuery;
                    filter.lvaQueries = lvaQueries;
                }
                setVmIds(lvaQueries);
                loadingLvaTables = false;
            }
        }

        if (multiQuerySeq) {
            setQueryDbStats(multiQuerySeq.queryDbStats);
            if (hasLvaAccess) {
                setLvaLoadingReady(true);
                if (multiQuerySeq.error !== null) {
                    // Important check to see if it is a VM workflow
                    setLvaLoadingReady(false);
                }
            }  else {
                // No LVA access
                filter.lvaQueries = {};
                filter.defaultLvaQuery = null;
                setLvaLoadingReady(true);
                loadingLvaTables = false;
            }
        }
    }

    async function fetchResultsNow(applied) {
        if (!showLoader) {
            setShowLoader(true);
        }
        data = {};
        let groupCriteria;
        let pnsPerPage = '';
        let alignmentsPerPage = '';
        let workflowId = resid.match(/\d+/)[0];
        switch (fieldConfig.tableDisplayMode) {
            case 'family':
                groupCriteria = 'fam';
                pnsPerPage = fieldConfig.famViewOption;
                alignmentsPerPage = fieldConfig.famViewAliOption;
                break;
            case 'document':
                groupCriteria = 'patent';
                alignmentsPerPage = fieldConfig.pnViewOption;
                break;
            case 'flat':
                groupCriteria = 'alignment';
                break;
            case 'ufs':
                groupCriteria = 'ufs';
                alignmentsPerPage = fieldConfig.ufsOption;
                break;
            case 'cas':
                groupCriteria = 'cas';
                break;
            case 'ssv':
                groupCriteria = 'ssv';
                alignmentsPerPage = fieldConfig.ssvOption;
                break;
            case 'qs':
                groupCriteria = 'qs';
                alignmentsPerPage = fieldConfig.qsOption;
                break;
            case 'hsp':
                groupCriteria = 'hsp';
                alignmentsPerPage = fieldConfig.hspOption;
                break;
            case 'ali':
            case 'gname':
            case 'gqid' :
            case 'extpf':
            case 'org':
            case 'npa':
            case 'aipa':
            case 'sid':
                groupCriteria = fieldConfig.tableDisplayMode;
                alignmentsPerPage = fieldConfig.groupOption;
                break;
            default:
                break;
        }

        let call = {
            data: {
                workflowId: workflowId,
                userId: userdir ? userdir : window.$javaCall.data.userId,
                groupCriteria: groupCriteria,
                pnsPerPage: pnsPerPage,
                alignmentsPerPage: alignmentsPerPage,
                sortCriteria: filter.state.sort,
                sortCriterias: fieldConfig.populateSortCriterias(filter.state.sort),
                pageNum: state.currentPage,
                groupSize: fieldConfig.groupSize,
                groupSizeOper: fieldConfig.groupSizeOper,
                groupFilters: fieldConfig.groupFilters,
                // Read path for states saved before groupFilters existed
                groupFilterType: fieldConfig.groupFilterType,
                groupFilterMatchType: fieldConfig.groupFilterMatchType,
                groupFilterValue: fieldConfig.groupFilterValue,
                // Auto-include subjectSeq when Extended GenomeQuest Alignment column is displayed or swap icon is toggled
                includeSubjectSeq: includeSubjectSeq || Object.values(fieldConfig.userTableTemplate).flat().includes('RESULT_EXTENDED_ALI'),
           }
        };

        applyFilterForJava(call, applied);
        setAbFilters(previewABReport());
        setResultReportFilters(call.data);

        //let response = summy
        let response = await DiscoverService.getSummary(call.data, window.$javaCall.data.gqApiKey);
        if (response) {
            let newData = fieldConfig.javaObjectConverter(response, groupCriteria, querydb.SEQUENCE_ID, fieldConfig, cmMap, cmColorMap, filter.state.cmColorLevel);
            data.data = newData.data;
            if (!data.stats) {
                data.stats = [];
            }
            data.stats.nav = newData.stats.nav;
            if (!data.facet) {
                data.facet = {};
            }

            state.showAll = false; // first render only the first 3 members of last group level
            //self.table_key = response.table_key; // record the hash key that tells when to refresh the cache

            // restores checkboxes, colors, stars
            annotState.checkboxes = {};
            annotState.notesCheckboxes = {};
            annotState.colors = {};
            annotState.stars = {};
            annotState.notes = {};
            annotState.dbkeys = {};
            annotState.showColorBoxes = {};
            annotState.dbkeysMap = {};
            if (newData.checkboxes) {
                annotState.checkboxes = newData.checkboxes;
            }
            if (newData.colors) {
                annotState.colors = newData.colors;
            }
            if (newData.stars) {
                annotState.stars = newData.stars;
            }
            if (newData.notes) {
                annotState.notes = newData.notes;
            }
            if (newData.notesCheckboxes) {
                annotState.notesCheckboxes = newData.notesCheckboxes;
            }

            if (data.data !== undefined && data.data !== null) {
                prepClaimsCollapse(data, fieldConfig.tableDisplayMode, claimsCollapseAll);
                prepAlignmentsCollapse(data, fieldConfig.tableDisplayMode, alignmentsCollapseAll);
                prepDetailPageCollapse(data, fieldConfig.tableDisplayMode, detailPageCollapseAllLevelOne,
                    detailPageCollapseAllLevelTwo, detailPageCollapseAllLevelThree, annotState);
            }

            // Populate dbkeys
            if (fieldConfig.tableDisplayMode === 'family' || fieldConfig.tableDisplayMode === 'ufs') {
                for (let idx in data.data) {
                    annotState.dbkeysMap[data.data[idx]["dbkey"]] = [];
                    for (let sub in data.data[idx]["nodes"]) {
                        for (let subIdx in data.data[idx]["nodes"][sub]["nodes"]) {
                            annotState.dbkeys[data.data[idx]["nodes"][sub]["nodes"][subIdx]["dbkey"]] = data.data[idx]["nodes"][sub]["nodes"][subIdx]["RESULT_ID"];
                            annotState.dbkeysMap[data.data[idx]["dbkey"]].push(data.data[idx]["nodes"][sub]["nodes"][subIdx]["RESULT_ID"]);
                        }
                    }
                }
            } else if (fieldConfig.tableDisplayMode === 'document' || fieldConfig.tableDisplayMode === 'cas' || fieldConfig.tableDisplayMode === 'ssv'
                || fieldConfig.tableDisplayMode === 'qs' || fieldConfig.tableDisplayMode === 'hsp'
                || fieldConfig.tableDisplayMode === 'ali' || fieldConfig.tableDisplayMode === 'npa' || fieldConfig.tableDisplayMode === 'aipa'
                || fieldConfig.tableDisplayMode === 'gname' || fieldConfig.tableDisplayMode === 'gqid' ||
                fieldConfig.tableDisplayMode === 'extpf' || fieldConfig.tableDisplayMode === 'org' || fieldConfig.tableDisplayMode === 'sid') {
                for (let idx in data.data) {
                    annotState.dbkeysMap[data.data[idx]["dbkey"]] = [];
                    for (let sub in data.data[idx]["nodes"]) {
                        annotState.dbkeys[data.data[idx]["nodes"][sub]['dbkey']] = data.data[idx]["nodes"][sub]["RESULT_ID"];
                        annotState.dbkeysMap[data.data[idx]["dbkey"]].push(data.data[idx]["nodes"][sub]["RESULT_ID"]);
                    }
                }
            } else {
                for (var idx  in data.data) {
                    annotState.dbkeys[data.data[idx]['dbkey']] = data.data[idx]["RESULT_ID"];
                }
            }

            // find out which display modes are supported for this data set by analyzing which subject databases there are
            setSupportedDisplayModes(getSupportedDisplayModes(resInfo));
            //setalgorithm(resInfo.algorithm);
            // copy the current display mode here, so the UI knows what to display
            //$scope.table.setTableDisplayMode(fieldConfig.tableDisplayMode);
            if (!state.title) {
                state.title = resInfo.title; // set the title for the result set
            }
            state.fileName = _.replace(state.title, new RegExp('/[^\-_a-zA-Z0-9\.]+/', 'g'), '_');
            state.userdir = call.data.userId;

            //self.prepNavBar(); // prepare the result pagination bar
            //$scope.table.prepRowIdxToRow($scope.data.data); // link objects (table rows) displayed to a simple index (0,1,2, ... N) so that the UI can link a table row number to a specific object (PN, family, alignment, UFS, ...)
            //$scope.table.selectFirstRow(); // select the first item displayed

            if (filter.widgetState.defaultFilterAdded === null || filter.widgetState.defaultFilterAdded !== true
                || (isAbWorkflow && filter.widgetState.defaultCustomFilters.length <= 3)) {
                filter.addDefaultCustomFilters(filter, fieldConfig);
            }
            setWidgetState(filter.widgetState);

            appliedCmPatternStateRef.current = {
                cmFilters: Array.isArray(filter.state.cmFilters)
                    ? _.cloneDeep(filter.state.cmFilters)
                    : [],
                cmFilterCheckboxes: Array.isArray(filter.state.cmFilterCheckboxes)
                    ? _.cloneDeep(filter.state.cmFilterCheckboxes)
                    : []
            };

            gqAlignments = [];
            gqAlignmentsNoSumm = [];
            gqAlignmentsStrNoSumm = [];
            gqAlignmentsSumm = [];
            gqAlignmentsVariation = [];
            let gqAlignmentsStrFlanking = [];
            populateGqAlignments(filter, data.data, gqAlignments, gqAlignmentsNoSumm, gqAlignmentsStrNoSumm, gqAlignmentsSumm, gqAlignmentsVariation, gqAlignmentsStrFlanking);

            // For the table display
            setTotalPage(response.lastPage);
            data.columns = fieldConfig.userTableTemplate['flat'];
            data.displayMode = fieldConfig.tableDisplayMode;
            data.tableWidth = fieldConfig.estimateTableWidth(fieldConfig.userTableTemplate, fieldConfig.tableDisplayMode);
            annotState.claimsCollapse = claimsCollapse;
            annotState.claimsCollapseLess = {};
            annotState.alignmentsCollapse = alignmentsCollapse;
            data.annotState = annotState;
            data.gqAlignments = gqAlignments;
            data.gqAlignmentsNoSumm = gqAlignmentsNoSumm;
            data.gqAlignmentsStrNoSumm = gqAlignmentsStrNoSumm;
            data.gqAlignmentsStrFlanking = gqAlignmentsStrFlanking;
            data.gqAlignmentsSumm = gqAlignmentsSumm;
            data.gqAlignmentsVariation = gqAlignmentsVariation;
            data.docItems = docItems;
            data.docItemsSelected = docItemsSelected;
            data.algorithm = resInfo.algorithm;
            setAnnotState({...annotState});
            setSearchResultData(data);
            window.scrollTo({top: 0});
            setShowLoader(false);

            //$scope.firstTimeInitial = 0;

            // we're done reacting stop waiting for results animation
            //$scope.showSpinner = false;

            // after rendering initial 3 results in the last group level, show them all
            //$timeout(function () {
                state.showAll = true;
            //}, 100);
            //self.startTour();
        }
    }

    function applyFilterForJava(javaCall, applied) {
        let query;
        if (applied) {
            query = filter.returnQuery();
        } else {
            Object.assign(filterState, filter.state);
            let fs = {...filterState};
            query = filter.getQuery(fs, filter);
        }
        let filterTextsTrue = {};
        let filterTextsFalse = {};

        // Check if we have a BFQL filter (resid filter from email link)
        // If we have BFQL, do NOT set fromLegal/fromAlert flags because:
        // - The resid is relative to results.res, not the collection
        // - We want to filter from results.res directly using the BFQL
        const hasBfqlFilter = filter.state.bfql !== undefined && filter.state.bfql !== null && filter.state.bfql !== '';
        
        // Set fromLegal/fromAlert/etc flags for alert types
        // These flags tell the backend which collection to use
        // BUT only if we don't have a BFQL filter
        if (!hasBfqlFilter && alerts && (alerts.startsWith('alert')
            || alerts.startsWith('alertChanged') || alerts.startsWith('legal')
            || alerts.startsWith('extended') || alerts.startsWith('family'))) {
            console.log('Setting collection flag for alert type:', alerts);
            if (alerts.startsWith('alert')) {
                javaCall.data["fromAlert"] = true;
            } else if (alerts.startsWith('alertChanged')) {
                javaCall.data["fromAlertChanged"] = true;
            } else if (alerts.startsWith('legal')) {
                javaCall.data["fromLegal"] = true;
            } else if (alerts.startsWith('extended')) {
                javaCall.data["fromExtended"] = true;
            } else if (alerts.startsWith('family')) {
                javaCall.data["fromFamily"] = true;
            }

            if (filter.state.docNum !== undefined && filter.state.docNum !== null) {
                javaCall.data["docNumber"] = filter.state.docNum;
                javaCall.data["docType"] = filter.state.docType;
            }
            if (filter.state.familyId !== undefined && filter.state.familyId !== null) {
                javaCall.data["familyId"] = filter.state.familyId;
            }
            
            // If filterResids is set, pass it to backend to filter within the collection
            if (filter.state.filterResids !== undefined && filter.state.filterResids !== null && filter.state.filterResids !== '') {
                console.log('Passing filterResids to backend:', filter.state.filterResids);
                javaCall.data["filterResids"] = filter.state.filterResids;
            }
        } else if (hasBfqlFilter) {
            console.log('BFQL filter detected - NOT setting fromLegal/fromAlert flags to use results.res directly');
        } else if (filter.state.vmExp !== undefined && filter.state.vmExp !== null) {
            javaCall.data["vmExp"] = vmExp;
            javaCall.data["vmQueryId"] = vmQueryId;

            // Pass below param to avoid splitting VM ranges in backend
            javaCall.data["isAbWorkflow"] = isAbWorkflow;
        }

        javaCall.data["gqUserId"] = userInfo.current_user?.gq_user_id;

        // Pass BFQL filter from email link to backend
        if (filter.state.bfql !== undefined && filter.state.bfql !== null && filter.state.bfql !== '') {
            console.log('Passing BFQL to backend:', filter.state.bfql);
            javaCall.data["bfql"] = filter.state.bfql;
        }

        if (filter.state.reportId !== undefined && filter.state.reportId !== null) {
            javaCall.data["oldCollName"] = reportId;
        }

        if (filter.state.singleAlignmentId !== undefined && filter.state.singleAlignmentId !== null) {
            javaCall.data["singleAlignmentId"] = filter.state.singleAlignmentId;
            console.log('Passing singleAlignmentId to backend:', filter.state.singleAlignmentId);
        } else if (filter.state.abExp !== undefined && filter.state.abExp !== null) {
            javaCall.data["abExp"] = query.abExp;
        } else {
            Object.keys(query).forEach(function (key) {
                if (key === "SUBJECT_PG" && query[key].length > 0) {
                    javaCall.data["legalStatuses"] = query[key];
                } else if (key === "SUBJECT_PN" && query[key].length > 0) {
                    let authorities = [];
                    query[key].forEach(function (auth) {
                        if (auth === "_empty_") {
                            authorities.push("");
                        } else {
                            authorities.push(auth);
                        }
                    });
                    javaCall.data["authorities"] = authorities;
                } else if (key === "databaseNames" && query[key].length > 0) {
                    let databases = [];
                    Object.keys(query[key]).forEach(function (key) {
                        databases.push(key);
                    });
                    javaCall.data["databases"] = databases;
                } else if (key === "SUBJECT_PS" && query[key].length > 0) {
                    javaCall.data["seqLocations"] = query[key];
                } else if (key === "querySeqDbs" && Object.keys(query[key]).length > 0) {
                    javaCall.data["querySeqDbs"] = Object.keys(query[key]);
                    javaCall.data["queryNums"] = [];
                } else if (key === "queryCmCodes" && Object.keys(query[key]).length > 0) {
                    //javaCall.data["queryCmCodes"] = Object.keys(query[key]);
                    let codes = [];
                    Object.keys(query[key]).forEach(function (key) {
                        /*let obj = cmCodes.find(f => f.label === key);
                        for (let code in obj.codes) {
                            if (!codes.includes(obj.codes[code])) {
                                codes.push(obj.codes[code]);
                            }
                        }*/
                        codes.push(key);
                    });
                    javaCall.data["queryCmCodes"] = codes;
                } else if (key === "databaseNames" && Object.keys(query[key]).length > 0) {
                    javaCall.data["databases"] = Object.keys(query[key]);
                } else if (key === "publicationNumberList" && query[key].length > 0) {
                    javaCall.data["publicationNumbers"] = query[key];
                } else if (key === "customFilters" && query[key].length > 0) {
                    let newFilters = [];
                    let customFilters = query[key];
                    for (let i in customFilters) {
                        let newFilter = {};
                        let filter = customFilters[i];
                        newFilter["filterName"] = filter.customFilterName;
                        newFilter["filterMode"] = filter.widgetMode;
                        newFilter["filterCustomQuery"] = filter.widgetCustomQuery;
                        let widgetContent = filter["widgetContent"];
                        let criterias = [];
                        for (let j in widgetContent) {
                            let content = widgetContent[j];
                            let newContent = {};
                            newContent["fieldName"] = content.field;
                            newContent["fieldType"] = content.field_type;
                            newContent["fieldOperator"] = content.operator;
                            newContent["fieldValue"] = content.value;
                            newContent["fieldSecondValue"] = content.second_value;
                            criterias.push(newContent);
                        }
                        newFilter["fieldCriterias"] = criterias;
                        newFilters.push(newFilter);
                    }
                    javaCall.data["customFilters"] = newFilters;
                } else if (key === "cmFilters" && query[key].length > 0) {
                    javaCall.data["cmFilters"] = _.cloneDeep(query[key]);
                    javaCall.data["cm_filters"] = JSON.stringify(query[key]);
                } else if (key === "lvaFilters" && query[key].length > 0) {
                    //console.log(query[key]);
                    let newVmFilters = [];
                    let vmFilters = query[key];
                    for (let i in vmFilters) {
                        let newFilter = {};
                        let filter = vmFilters[i];
                        let lvaQuery = filter.lvaQuery;
                        let widget = filter.widgetContent;
                        newFilter["filterName"] = filter.lvaFilterName;
                        newFilter["queryId"] = lvaQuery.QUERY_ID;
                        let vmCriteria = [];
                        for (let j in widget) {
                            let newCriteria = {};
                            let criteria = widget[j];
                            // when start === stop, don't pass as exactPosition to avoid backend logic issue
                            if (criteria.start !== undefined && criteria.start !== "" &&
                                criteria.stop !== undefined && criteria.stop !== "" && criteria.start === criteria.stop) {
                                newCriteria["exactPosition"] = criteria.start;
                                newCriteria["residue"] = [""];
                            } else {
                                if (criteria.start !== undefined && criteria.start !== "") {
                                    newCriteria["rangeStart"] = criteria.start;
                                }
                                if (criteria.stop !== undefined && criteria.stop !== "") {
                                    newCriteria["rangeEnd"] = criteria.stop;
                                }
                            }
                            let newEventType = [];
                            let events = criteria.events;
                            if (events.length > 0) {
                                for (let k in events) {
                                    newEventType.push(events[k].event);
                                }
                            } else {
                                if (criteria.method === "replacements") {
                                    newEventType.push("R");
                                    newCriteria["residue"] = criteria.replacements.toUpperCase().replace(/ /g, '').replace(/,/g, "\n").replace(/;/g, "\n").split('\n');
                                } else if (criteria.method === "specinserts") {
                                    newEventType.push("I");
                                    newCriteria["residue"] = criteria.inserts.toUpperCase().replace(/ /g, '').replace(/,/g, "\n").replace(/;/g, "\n").split('\n');
                                } else if (criteria.method === "anyinsert") {
                                    newEventType.push("I");
                                    newCriteria["residue"] = [""];
                                } else if (criteria.method === "deletions" && criteria.text_label === "Deletion present beginning at") {
                                    newEventType.push("D");
                                    newCriteria["minResidueLength"] = criteria.mindel ? criteria.mindel : 1;
                                    newCriteria["residueLength"] = criteria.maxdel;
                                    newCriteria["exactPosition"] = criteria.start;
                                    delete newCriteria["rangeStart"];
                                    delete newCriteria["rangeEnd"];
                                } else if (criteria.method === "deletions" && criteria.text_label === "No deletion beginning at") {
                                    newEventType.push("D");
                                    newCriteria["minResidueLength"] = criteria.mindel ? criteria.mindel : 1;
                                    newCriteria["residueLength"] = criteria.maxdel;
                                    newCriteria["exactPosition"] = criteria.start;
                                    delete newCriteria["rangeStart"];
                                    delete newCriteria["rangeEnd"];
                                } else if (criteria.method === "percIdentity") {
                                    newEventType.push("M");
                                } else if (criteria.method === "maxDiff" || criteria.method === "minDiff") {
                                    newEventType.push("M");
                                }
                            }
                            if (criteria.method === "percIdentity") {
                                newCriteria["percIdentity"] = criteria.percIdentity;
                            } else if (criteria.method === "maxDiff") {
                                newCriteria["maxDiffLength"] = criteria.maxDiff;
                            } else if (criteria.method === "minDiff") {
                                newCriteria["minDiffLength"] = criteria.minDiff;
                            }
                            newCriteria["eventType"] = newEventType;
                            if (criteria.text_label.includes("absent") || criteria.text_label === "No insertion" || criteria.text_label === "No deletion" || criteria.text_label === "No deletion beginning at") {
                                newCriteria["eventMatch"] = "absent";
                            } else if (criteria.text_label.includes("present") || criteria.method === "percIdentity" || criteria.method === "maxDiff" || criteria.method === "minDiff") {
                                newCriteria["eventMatch"] = "present";
                            }
                            vmCriteria.push(newCriteria);
                        }
                        newFilter["vmCriteria"] = vmCriteria;
                        newFilter["filterMode"] = filter.widgetMode;
                        newFilter["filterCustomQuery"] = filter.widgetCustomQuery;
                        newVmFilters.push(newFilter);
                    }
                    //console.log(newVmFilters);
                    javaCall.data["vmFilters"] = newVmFilters;

                    // Pass below param to avoid splitting VM ranges in backend
                    javaCall.data["isAbWorkflow"] = isAbWorkflow;
                } else if (key === "annot" && query[key] && Object.keys(query[key]).length > 0) {
                    let i;
                    let checkboxes = [];
                    for (i in query[key].checkboxes) {
                        if (query[key].checkboxes[i]) {
                            if (i === "checked") {
                                checkboxes.push("1");
                            } else if (i === "unchecked") {
                                checkboxes.push("0");
                            }
                        }
                    }

                    let stars = [];
                    for (i in query[key].stars) {
                        if (query[key].stars[i]) {
                            stars.push(i);
                        }
                    }

                    let colors = [];
                    for (i in query[key].colors) {
                        if (query[key].colors[i]) {
                            colors.push(i);
                        }
                    }

                    for (i in query[key].notesCheckboxes) {
                        if (query[key].notesCheckboxes[i]) {
                            if (i === "empty") {
                                javaCall.data["notesEmpty"] = true;
                            } else if (i === "notEmpty") {
                                javaCall.data["notes"] = query.annot?.notes;
                            }
                        }
                    }

                    javaCall.data["checkboxes"] = checkboxes;
                    javaCall.data["stars"] = stars;
                    javaCall.data["colors"] = colors;
                    //javaCall.data["notes"] = query.annot?.notes;
                } else if (key === "smartText" && Object.keys(query[key]).length > 0) {
                    filterTextsTrue = query[key];
                } else if (key === "smartTextNegate" && Object.keys(query[key]).length > 0) {
                    filterTextsFalse = query[key];
                } else if (key === "ftsInline" && query[key]) {
                    // Handle FullText search - add it to filterTextsTrue under SUBJECT_FTS field
                    if (!filterTextsTrue.SUBJECT_FTS) {
                        filterTextsTrue.SUBJECT_FTS = [];
                    }
                    const searchText = query[key].value || query[key].fieldDisplayValue;
                    if (searchText) {
                        filterTextsTrue.SUBJECT_FTS.push(searchText);
                    }
                }
            });
            javaCall.data["deduplication"] = filter.state.deduplication;
            javaCall.data["filterTextsTrue"] = filterTextsTrue;
            javaCall.data["filterTextsFalse"] = filterTextsFalse;

            if (filter.state.deduplication) {
                javaCall.data["dedDbPrefs"] = dedDatabasePrefs;
            }

            if (groupQuery && groupQuery.GROUP_BY) {
                javaCall.data["analysisBy"] = groupQuery.GROUP_BY;
                javaCall.data["analysisNum"] = groupQuery.NBVALS;
                javaCall.data["analysisTotal"] = querydb.count;
            }
        }

        if(!_.isEmpty(window.reportFilters)) {
            let reportABFilters = window.reportFilters;
            if (reportABFilters !== undefined && reportABFilters !== null && reportABFilters !='') {
                javaCall.data = extend(javaCall.data, reportABFilters);
            }
        }
    }

    function previewABReport() {

        var filters = {
            data: getCurrentPageFilters()
        };

        applyFilterForJava(filters);

        return filters;
    }


    function getCurrentPageFilters() {
        let groupCriteria;
        let pnsPerPage = '';
        let alignmentsPerPage = '';
        let workflowId = resid.match(/\d+/)[0];
        switch (fieldConfig.tableDisplayMode) {
            case 'family':
                groupCriteria = 'fam';
                if (fieldConfig.applyEsf) {
                    pnsPerPage = fieldConfig.famViewOption;
                    alignmentsPerPage = fieldConfig.famViewAliOption;
                }
                break;
            case 'document':
                groupCriteria = 'patent';
                if (fieldConfig.applyEsf) {
                    alignmentsPerPage = fieldConfig.pnViewOption;
                }
                break;
            case 'flat':
                groupCriteria = 'alignment';
                break;
            case 'ufs':
                groupCriteria = 'ufs';
                alignmentsPerPage = fieldConfig.ufsOption;
                break;
            case 'cas':
                groupCriteria = 'cas';
                break;
            case 'ssv':
                groupCriteria = 'ssv';
                if (fieldConfig.applyEsf) {
                    alignmentsPerPage = fieldConfig.ssvOption;
                }
                break;
        }

        let data = {
            workflowId: workflowId, // database ID ("GQ-classic" compatible)
            userId: userdir ? userdir : window.$javaCall.data.userId,
            groupCriteria: groupCriteria,
            pnsPerPage: pnsPerPage,
            alignmentsPerPage: alignmentsPerPage,
            sortCriteria: filter.state.sort,
            sortCriterias: fieldConfig.populateSortCriterias(filter.state.sort),
            pageNum: currentPage
        };

        return data;

    }

    async function callGQApi() {
        let api = await DiscoverService.getApi(resid, history);
        if (api && api.response_content) {
            if (api.response_content.type === 'GQEXCEPTION') {
                alert(api.response_content.message);
                return;
            }

            window.$javaCall.data.gqApiKey = api.response_content.gqApiKey;
            setGqApiKey(api.response_content.gqApiKey);
        }
    }

    function popupInfoMsg(msg) {
        if (msg) {
            setInfoMsg(msg);
            setShowInfoMsg(true);
        }
    }

    function dismissInfoMsg() {
        setInfoMsg('');
        setShowInfoMsg(false);
    }

    /**
     * Handles a click on del: checks first, asks second.
     *
     * A view an alert reports its new results with cannot be deleted at all - the alert
     * stores it by name, so removing it would leave that alert pointing at a view that
     * no longer exists. That case says so and stops here, rather than asking the user to
     * confirm something that is about to be refused. Everything else opens the
     * confirmation popup, as the advanced filters do; the deletion itself is in
     * deleteViewConfirmed.
     */
    async function askDeleteView(viewName) {
        pendingDeleteView.current = viewName;
        // alertViewUsage reports failure through `checked` and does not reject, so there
        // is nothing to catch here; a wrapper would only hide a future refactor's errors.
        const usage = await alertViews.alertViewUsage(viewName);

        // Another del click overtook this one: that view is the one the user is waiting
        // on, so say nothing and open nothing for this one.
        if (pendingDeleteView.current !== viewName) {
            return;
        }

        if (!usage.checked) {
            // Deleting a view cannot be undone and an alert may depend on it, so refuse
            // rather than guess. Being asked to retry costs the user nothing.
            popupInfoMsg('Could not check whether an alert uses "' + viewName + '".'
                + ' The view has not been deleted - please try again.');
            return;
        }

        if (usage.inUse) {
            const many = usage.alerts.length > 1;
            // The backend derives in_use from the list, so a name is normally present;
            // if one is missing, say so plainly instead of naming nothing.
            const named = usage.alerts.length
                ? ' (' + usage.alerts.join(', ') + ')'
                : '';
            const which = usage.alerts.length
                ? (many ? 'those alerts' : 'that alert')
                : 'the alert that uses it';
            popupInfoMsg('"' + viewName + '" cannot be deleted because '
                + (many ? 'alerts use' : 'an alert uses')
                + ' it to report new results' + named
                + '. Change the Export Template on ' + which
                + ' first, then delete this view.');
            return;
        }

        setDeleteViewName(viewName);
        setDeleteViewPopup(true);
    }

    const closeDeleteViewModal = () => {
        pendingDeleteView.current = null;
        setDeleteViewPopup(false);
        setDeleteViewName('');
    }

    async function deleteViewConfirmed(viewName) {
        // deleteView reports whether the save landed - it puts the view back when it did
        // not - so the sidebar has to be re-read either way.
        let result = { saved: false, unshareFailed: false };
        try {
            result = await fieldConfig.deleteView(fieldConfig, viewName, filter) || result;
        } catch (error) {
            console.log('could not delete view ' + viewName, error);
        }
        setViewKeys([...fieldConfig.viewKeys]);
        if (!result.saved) {
            popupInfoMsg('Could not delete "' + viewName + '" - your saved views have not'
                + ' been changed. Please try again.');
        } else if (result.unshareFailed) {
            // The owner is the only one who can warn the recipients, so do not leave
            // this in the console: their lists still show a view that no longer exists.
            popupInfoMsg('"' + viewName + '" has been deleted, but it could not be taken'
                + ' off the Shared Views list of the people you shared it with. They may'
                + ' still see it - please let support know if it does not clear.');
        }
    }

    function extend(dest, src) {
        for (let key in src) {
            dest[key] = src[key];
        }
        return dest;
    }

    function prepClaimsCollapse(data, tableDisplayMode, collapse) {
        let currentValue;
        if (claimsCollapse === undefined) {
            claimsCollapse = {};
        }
        if (collapse !== undefined) {
            currentValue = collapse;
        } else {
            currentValue = claimsCollapseAll ? false : true;
        }
        claimsCollapseAll = currentValue;
        if (tableDisplayMode === 'family' || tableDisplayMode === 'cas' || tableDisplayMode === 'ssv'
            || tableDisplayMode === 'qs' || tableDisplayMode === 'hsp' || tableDisplayMode === 'org'
            || tableDisplayMode === 'ali' || tableDisplayMode === 'npa' || tableDisplayMode === 'aipa' || tableDisplayMode === 'gname'|| tableDisplayMode === 'gqid' || tableDisplayMode === 'extpf' || tableDisplayMode === 'sid') {
            // Special handling for CAS display mode here, it is in the alginment level, so treat it same as family mode
            for (let idx in data.data) {
                for (let sub in data.data[idx]["nodes"]) {
                    if (data.data[idx]["nodes"][sub]['dbkey'] && claimsCollapse[data.data[idx]["nodes"][sub]['dbkey']] === undefined) {
                        claimsCollapse[data.data[idx]["nodes"][sub]['dbkey']] = currentValue;
                    }
                }
            }
        } else if (tableDisplayMode === 'ufs') {
            for (let idx in data.data) {
                for (let sub in data.data[idx]["nodes"]) {
                    for (let subIdx in data.data[idx]["nodes"][sub]["nodes"]) {
                        if (data.data[idx]["nodes"][sub]["nodes"][subIdx]["dbkey"]
                            && claimsCollapse[data.data[idx]["nodes"][sub]["nodes"][subIdx]['dbkey']] === undefined) {
                            claimsCollapse[data.data[idx]["nodes"][sub]["nodes"][subIdx]["dbkey"]] = currentValue;
                        }
                    }
                }
            }
        } else {
            for (let idx  in data.data) {
                let item = data.data[idx];
                //if (item.SUBJECT_CT !== undefined && item.SUBJECT_CT !== null && item.SUBJECT_CT.length > 0) {
                if (claimsCollapse[item['dbkey']] === undefined) {
                    // _.set(claimsCollapse, item['dbkey'], currentValue);
                    claimsCollapse[item['dbkey']] = currentValue;
                }
                //}
            }
        }
    }

    function prepAlignmentsCollapse(data, tableDisplayMode, collapse) {
        var currentValue = false;
        if (alignmentsCollapse === undefined) {
            alignmentsCollapse = {};
        }
        if (collapse !== undefined) {
            currentValue = collapse;
        } else if (alignmentsCollapseAll !== undefined) {
            currentValue = alignmentsCollapseAll ? false : true;
        }
        alignmentsCollapseAll = currentValue;
        if (tableDisplayMode === 'family' || tableDisplayMode === 'ufs') {
            for (let idx in data.data) {
                for (let sub in data.data[idx]["nodes"]) {
                    for (let subIdx in data.data[idx]["nodes"][sub]["nodes"]) {
                        if (data.data[idx]["nodes"][sub]["nodes"][subIdx]["dbkey"]
                            && alignmentsCollapse[data.data[idx]["nodes"][sub]["nodes"][subIdx]["dbkey"]] === undefined) {
                            alignmentsCollapse[data.data[idx]["nodes"][sub]["nodes"][subIdx]["dbkey"]] = currentValue;
                        }
                    }
                }
            }
        } else if (tableDisplayMode === 'document' || tableDisplayMode === 'cas' || tableDisplayMode === 'ssv'
            || tableDisplayMode === 'qs' || tableDisplayMode === 'hsp' || tableDisplayMode === 'org'
            || tableDisplayMode === 'ali' || tableDisplayMode === 'npa' || tableDisplayMode === 'aipa' || tableDisplayMode === 'gname' || tableDisplayMode === 'gqid' || tableDisplayMode === 'extpf' || tableDisplayMode === 'sid') {
            for (let idx in data.data) {
                for (let sub in data.data[idx]["nodes"]) {
                    if (data.data[idx]["nodes"][sub]['dbkey'] && alignmentsCollapse[data.data[idx]["nodes"][sub]['dbkey']] === undefined) {
                        alignmentsCollapse[data.data[idx]["nodes"][sub]['dbkey']] = currentValue;
                    }
                }
            }
        } else {
            for (let idx in data.data) {
                let item = data.data[idx];
                if (item.RESULT_FALI_FORMATTED !== undefined && item.RESULT_FALI_FORMATTED !== null && item.RESULT_FALI_FORMATTED.length > 0) {
                    if (alignmentsCollapse[item['dbkey']] === undefined) {
                        alignmentsCollapse[item['dbkey']] = currentValue;
                    }
                }
            }
        }
    }

    function prepDetailPageCollapse(data, tableDisplayMode, collapseLevelOne, collapseLevelTwo, collapseLevelThree, anState) {
        let currentValueLevelOne;
        let currentValueLevelTwo;
        let currentValueLevelThree;
        if (collapseLevelOne !== undefined) {
            currentValueLevelOne = collapseLevelOne;
        } else {
            currentValueLevelOne = detailPageCollapseAllLevelOne ? true : false;
        }
        if (collapseLevelTwo !== undefined) {
            currentValueLevelTwo = collapseLevelTwo;
        } else {
            currentValueLevelTwo = detailPageCollapseAllLevelTwo ? true : false;
        }
        if (collapseLevelThree !== undefined) {
            currentValueLevelThree = collapseLevelThree;
        } else {
            currentValueLevelThree = detailPageCollapseAllLevelThree ? true : false;
        }
        anState.fullRecordExpand = {};
        detailPageCollapseAllLevelOne = currentValueLevelOne;
        detailPageCollapseAllLevelTwo = currentValueLevelTwo;
        detailPageCollapseAllLevelThree = currentValueLevelThree;

        if (tableDisplayMode === 'family' || tableDisplayMode === 'ufs') {
            for (let idx in data.data) {
                if (data.data[idx]['dbkey']) {
                    _.set(anState.fullRecordExpand, data.data[idx]['dbkey'], currentValueLevelOne);
                }
                for (var sub in data.data[idx]["nodes"]) {
                    if (data.data[idx]["nodes"][sub]['dbkey']) {
                        _.set(anState.fullRecordExpand, data.data[idx]["nodes"][sub]['dbkey'], currentValueLevelTwo);
                    }
                    for (var sub2 in data.data[idx]["nodes"][sub]['nodes']) {
                        if (data.data[idx]["nodes"][sub]['nodes'][sub2]['dbkey']) {
                            _.set(anState.fullRecordExpand, data.data[idx]["nodes"][sub]['nodes'][sub2]['dbkey'], currentValueLevelThree);
                        }
                    }
                }
            }
        } else if (tableDisplayMode === 'document' || tableDisplayMode === 'cas' || tableDisplayMode === 'ssv'
            || tableDisplayMode === 'qs' || tableDisplayMode === 'hsp' || tableDisplayMode === 'org'
            || tableDisplayMode === 'ali' || tableDisplayMode === 'npa' || tableDisplayMode === 'aipa' || tableDisplayMode === 'gname' || tableDisplayMode === 'gqid' || tableDisplayMode === 'extpf' || tableDisplayMode === 'sid') {
            for (let idx in data.data) {
                if (data.data[idx]['dbkey']) {
                    _.set(anState.fullRecordExpand, data.data[idx]['dbkey'], currentValueLevelOne);
                }
                for (let sub in data.data[idx]["nodes"]) {
                    if (data.data[idx]["nodes"][sub]['dbkey']) {
                        _.set(anState.fullRecordExpand, data.data[idx]["nodes"][sub]['dbkey'], currentValueLevelTwo);
                    }
                }
            }
        } else {
            for (let idx in data.data) {
                _.set(anState.fullRecordExpand, data.data[idx]['dbkey'], currentValueLevelOne);
            }
        }
    }

    function getSupportedDisplayModes(resInfo) {
        let isGqPat = false,
            isGeneSeq = false,
            isOther = false,
            i, hasGqPat = false,
            hasGeneSeq = false,
            hasOther = false,
            supported;
        if (resInfo && resInfo.databases) {
            for (i = 0; resInfo.databases && i < resInfo.databases.length; i++) {
                isGqPat = resInfo.databases[i].indexOf("GQPAT") === 0;
                isGeneSeq = resInfo.databases[i].indexOf("GEAA") === 0 || resInfo.databases[i].indexOf("GENA") === 0;
                isOther = !(isGqPat || isGeneSeq);
                hasGqPat = hasGqPat || isGqPat;
                hasGeneSeq = hasGeneSeq || isGeneSeq;
                hasOther = hasOther || isOther;
            }
        }
        if (hasGqPat && !hasGeneSeq && !hasOther) {
            // every database is a GQ-Pat database
            supported = {family: true, document: true, ufs: true, flat: true, cas: true, default: 'document'};
        } else if ((hasGqPat || hasGeneSeq) && !hasOther) {
            // this is either a mix of only GeneSeq and GQ-Pat or is only GeneSeq
            supported = {family: true, document: true, ufs: true, flat: true, cas: true, default: 'document'};
        } else {
            // there is at least one non patent database in the mix
            // Bug 132986, changed to all ture for virtual databases
            // supported = {family: false, document: false, ufs: false, flat: false, default: 'flat'};
            supported = {family: true, document: true, ufs: true, flat: true, cas: true, default: 'flat'};
        }
        return supported;
    }

    function populateGqAlignments(filter, data, gqAlignments, gqAlignmentsNoSumm, gqAlignmentsStrNoSumm, gqAlignmentsSumm, gqAlignmentsVariation, gqAlignmentsStrFlanking) {
        const pushFlanking = (item) => {
            if (!gqAlignmentsStrFlanking || !item.RESULT_NFALI_FORMATTED) return;
            const lvaFlagMaps = getExtendedLvaFlagMaps(item);
            const html = buildFullSubjectAlignment(item, isCmNoSeq, buildExtendedCmTracks, lvaFlagMaps);
            if (html != null) {
                const obj = {};
                obj[item['dbkey']] = html.replace(/'/g, '"').replace(/&nbsp;/g, '&#8254;');
                gqAlignmentsStrFlanking.push(obj);
            }
        };

        let rowIdx, item, node0, node1;
        for (rowIdx in data) {
            item = data[rowIdx];
            initDocItems(item);

            if (item.hasOwnProperty('RESULT_FALI_FORMATTED')) {
                gqAlignments[item['dbkey']] = colorAlignment(filter, item['RESULT_FALI_FORMATTED'], filter.extractLvaHintInfo(item), item, gqAlignmentsNoSumm, gqAlignmentsStrNoSumm, gqAlignmentsSumm, gqAlignmentsVariation);
                pushFlanking(item);
            } else {
                for (let nodeIdx in item.nodes) {
                    node0 = item.nodes[nodeIdx];
                    initDocItems(node0);
                    if (node0.hasOwnProperty('RESULT_FALI_FORMATTED')) {
                        gqAlignments[node0['dbkey']] = colorAlignment(filter, node0['RESULT_FALI_FORMATTED'], filter.extractLvaHintInfo(node0), node0, gqAlignmentsNoSumm, gqAlignmentsStrNoSumm, gqAlignmentsSumm, gqAlignmentsVariation);
                        pushFlanking(node0);
                    } else {
                        for (let nodeIdx1 in node0.nodes) {
                            node1 = node0.nodes[nodeIdx1];
                            initDocItems(node1);
                            if (node1.hasOwnProperty('RESULT_FALI_FORMATTED')) {
                                gqAlignments[node1['dbkey']] = colorAlignment(filter, node1['RESULT_FALI_FORMATTED'], filter.extractLvaHintInfo(node1), node1, gqAlignmentsNoSumm, gqAlignmentsStrNoSumm, gqAlignmentsSumm, gqAlignmentsVariation);
                                pushFlanking(node1);
                            }
                        }
                    }
                }
            }
        }
    }

    function normalizeCmCodeKey(code) {
        const strippedCode = _.trim(String(code)).replace(/^"+|"+$/g, '');
        if (strippedCode === '') {
            return null;
        }

        const normalizedCode = !isNaN(strippedCode)
            ? parseInt(strippedCode, 10)
            : strippedCode;
        return Number.isNaN(normalizedCode) ? null : normalizedCode;
    }

    function addCmCodeToMap(markerMap, rawPosition, code) {
        const position = parseInt(rawPosition);
        if (Number.isNaN(position) || position <= 0) {
            return;
        }

        const normalizedCode = normalizeCmCodeKey(code);
        if (normalizedCode === null) {
            return;
        }

        if (!markerMap.has(position)) {
            markerMap.set(position, []);
        }

        const codesAtPosition = markerMap.get(position);
        if (!codesAtPosition.includes(normalizedCode)) {
            codesAtPosition.push(normalizedCode);
        }
    }

    function buildCmChunkEntries(qChunk, sChunk, qLeft, sLeft, sRight, qOrdinalOffset = 0, sOrdinalOffset = 0) {
        const entries = [];
        const isForward = sLeft <= sRight;
        let qCount = 0;
        let sCount = 0;

        for (let chunkIndex = 0; chunkIndex < sChunk.length; chunkIndex++) {
            const qChar = qChunk.charAt(chunkIndex);
            const sChar = sChunk.charAt(chunkIndex);
            let qPos = null;
            let sPos = null;
            let qOrdinal = null;
            let sOrdinal = null;

            if (qChar !== '-') {
                qPos = qLeft + qCount;
                qOrdinal = qOrdinalOffset + qCount + 1;
                qCount++;
            }
            if (sChar !== '-') {
                sPos = isForward ? (sLeft + sCount) : (sLeft - sCount);
                sOrdinal = sOrdinalOffset + sCount + 1;
                sCount++;
            }

            entries.push({
                qChar,
                sChar,
                qPos,
                sPos,
                qOrdinal,
                sOrdinal
            });
        }

        return entries;
    }

    function buildProjectedQueryCmMarkerMap(subjectMarkerMap, entries) {
        const projectedMarkerMap = new Map();
        if (!(subjectMarkerMap instanceof Map) || !Array.isArray(entries) || entries.length === 0) {
            return projectedMarkerMap;
        }

        for (let entryIndex = 0; entryIndex < entries.length; entryIndex++) {
            const entry = entries[entryIndex];
            if (!Number.isFinite(entry?.sPos) || !Number.isFinite(entry?.qPos) || !subjectMarkerMap.has(entry.sPos)) {
                continue;
            }

            const codesAtSubjectPos = subjectMarkerMap.get(entry.sPos) || [];
            for (let codeIndex = 0; codeIndex < codesAtSubjectPos.length; codeIndex++) {
                addCmCodeToMap(projectedMarkerMap, entry.qPos, codesAtSubjectPos[codeIndex]);
            }
        }

        return projectedMarkerMap;
    }

    function parseAlignmentSequenceLine(rawLine, prefix) {
        const match = rawLine.match(new RegExp('^(\\s*' + prefix + ':\\s*\\d+\\s+)(\\S.*?)(\\s+\\d+\\s*)$'));
        if (!match) {
            return null;
        }

        return {
            prefixLength: match[1].length,
            sequence: match[2]
        };
    }

    function getCmAlignmentResidueCounts(lines) {
        const counts = {
            query: 0,
            subject: 0
        };

        if (!Array.isArray(lines)) {
            return counts;
        }

        for (let index = 0; index < lines.length; index++) {
            const queryLineInfo = parseAlignmentSequenceLine(lines[index], 'Q');
            if (queryLineInfo) {
                counts.query += queryLineInfo.sequence.replace(/-/g, '').length;
                continue;
            }

            const subjectLineInfo = parseAlignmentSequenceLine(lines[index], 'S');
            if (subjectLineInfo) {
                counts.subject += subjectLineInfo.sequence.replace(/-/g, '').length;
            }
        }

        return counts;
    }

    function appendCmChunkRange(chunkRanges, start, end, desc) {
        if (!Number.isFinite(start) || !Number.isFinite(end)) {
            return;
        }

        chunkRanges.push({
            start: Math.min(start, end),
            end: Math.max(start, end),
            desc
        });
    }

    function buildSubjectCmChunkRanges(entries, positions) {
        const chunkRanges = [];

        for (let index = 0; index < positions.length; index++) {
            const pos = positions[index];
            const segments = getCmPatternSegments(pos);
            for (let segmentIndex = 0; segmentIndex < segments.length; segmentIndex++) {
                const segment = segments[segmentIndex];
                const rangeStart = segment.start;
                const rangeEnd = segment.end;
                let currentRangeStart = null;
                let currentRangeEnd = null;

                for (let entryIndex = 0; entryIndex < entries.length; entryIndex++) {
                    const entry = entries[entryIndex];
                    const patternPos =  entry.sPos; // pos.alignmentRelative === true ? entry.sOrdinal : entry.sPos;

                    if (entry.sPos === null || patternPos === null) {
                        appendCmChunkRange(chunkRanges, currentRangeStart, currentRangeEnd, pos.desc);
                        currentRangeStart = null;
                        currentRangeEnd = null;
                        continue;
                    }

                    const inRange = patternPos >= rangeStart && patternPos <= rangeEnd;
                    if (!inRange) {
                        appendCmChunkRange(chunkRanges, currentRangeStart, currentRangeEnd, pos.desc);
                        currentRangeStart = null;
                        currentRangeEnd = null;
                        continue;
                    }

                    if (currentRangeStart === null) {
                        currentRangeStart = entry.sPos;
                    }

                    currentRangeEnd = entry.sPos;
                }

                appendCmChunkRange(chunkRanges, currentRangeStart, currentRangeEnd, pos.desc);
            }
        }

        return chunkRanges;
    }

    function buildQueryCmChunkRanges(entries, positions) {
        const chunkRanges = [];

        for (let index = 0; index < positions.length; index++) {
            const pos = positions[index];
            const segments = getCmPatternSegments(pos);
            for (let segmentIndex = 0; segmentIndex < segments.length; segmentIndex++) {
                const segment = segments[segmentIndex];
                const rangeStart = segment.start;
                const rangeEnd = segment.end;
                let currentRangeStart = null;
                let previousQPos = null;

                for (let entryIndex = 0; entryIndex < entries.length; entryIndex++) {
                    const entry = entries[entryIndex];
                    if (entry.qPos === null || entry.sPos === null) {
                        appendCmChunkRange(chunkRanges, currentRangeStart, previousQPos, pos.desc);
                        currentRangeStart = null;
                        previousQPos = null;
                        continue;
                    }

                    const patternPos = pos.alignmentRelative === true ? entry.sOrdinal : entry.sPos;
                    const inRange = patternPos !== null && patternPos >= rangeStart && patternPos <= rangeEnd;
                    if (!inRange) {
                        appendCmChunkRange(chunkRanges, currentRangeStart, previousQPos, pos.desc);
                        currentRangeStart = null;
                        previousQPos = null;
                        continue;
                    }

                    if (currentRangeStart === null) {
                        currentRangeStart = entry.qPos;
                    } else if (previousQPos !== null && entry.qPos !== previousQPos + 1) {
                        appendCmChunkRange(chunkRanges, currentRangeStart, previousQPos, pos.desc);
                        currentRangeStart = entry.qPos;
                    }

                    previousQPos = entry.qPos;
                }

                appendCmChunkRange(chunkRanges, currentRangeStart, previousQPos, pos.desc);
            }
        }

        return chunkRanges;
    }

    function normalizeCmQueryPatternPosition(rawPos, queryLength) {
        if (!rawPos || typeof rawPos !== 'object' || Array.isArray(rawPos)) {
            return null;
        }

        const parsePositiveInt = (value) => {
            const parsed = parseInt(value, 10);
            return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
        };

        const rawAlignmentRelative = rawPos.alignmentRelative === true;

        const parseLinkedSegments = (linkedValue, sequenceLength) => {
            if (typeof linkedValue !== 'string' || linkedValue.trim() === '') {
                return {
                    segments: [],
                    alignmentRelative: false
                };
            }

            const normalizedSequenceLength = Number.isFinite(sequenceLength) && sequenceLength > 0 ? sequenceLength : null;
            const parts = linkedValue.split('^');
            const segments = [];
            let alignmentRelative = false;

            for (let index = 0; index < parts.length; index++) {
                const rawPart = parts[index].trim().toLowerCase();
                const part = rawPart.replace(/\bstart\b/g, '1');
                if (part === '') {
                    continue;
                }

                if (rawPart.includes('start') || rawPart.includes('end') || rawPart.startsWith('..') || rawPart.endsWith('..')) {
                    alignmentRelative = true;
                }

                if (part.includes('..')) {
                    const rangeParts = part.split('..');
                    const startToken = rangeParts[0] ? rangeParts[0].trim() : '';
                    const endToken = rangeParts[1] ? rangeParts[1].trim() : '';
                    const segmentStart = startToken === '' ? 1 : parsePositiveInt(startToken);
                    const segmentEnd = (endToken === '' || endToken === 'end')
                        ? normalizedSequenceLength
                        : parsePositiveInt(endToken);

                    if (segmentStart === null || segmentEnd === null) {
                        return {
                            segments: [],
                            alignmentRelative: false
                        };
                    }

                    segments.push({
                        start: Math.min(segmentStart, segmentEnd),
                        end: Math.max(segmentStart, segmentEnd)
                    });
                    continue;
                }

                if (part === 'end') {
                    if (normalizedSequenceLength === null) {
                        return {
                            segments: [],
                            alignmentRelative: false
                        };
                    }

                    segments.push({
                        start: normalizedSequenceLength,
                        end: normalizedSequenceLength
                    });
                    continue;
                }

                const exactSegment = parsePositiveInt(part);
                if (exactSegment === null) {
                    return {
                        segments: [],
                        alignmentRelative: false
                    };
                }

                segments.push({
                    start: exactSegment,
                    end: exactSegment
                });
            }

            return {
                segments,
                alignmentRelative
            };
        };

        const getPositionBounds = (segments) => {
            if (!Array.isArray(segments) || segments.length === 0) {
                return null;
            }

            let minStart = segments[0].start;
            let maxEnd = segments[0].end;
            for (let index = 1; index < segments.length; index++) {
                minStart = Math.min(minStart, segments[index].start);
                maxEnd = Math.max(maxEnd, segments[index].end);
            }

            return {
                start: minStart,
                end: maxEnd,
                segments
            };
        };

        const normalizedQueryLength = Number.isFinite(queryLength) && queryLength > 0 ? queryLength : null;
        const exact = parsePositiveInt(rawPos.exact);
        const start = parsePositiveInt(rawPos.start);
        const end = parsePositiveInt(rawPos.end);
        const first = parsePositiveInt(rawPos.first);
        const last = parsePositiveInt(rawPos.last);
        const linkedSegments = parseLinkedSegments(rawPos.linked, normalizedQueryLength);

        if (linkedSegments.segments.length > 0) {
            return {
                ...getPositionBounds(linkedSegments.segments),
                linked: true,
                alignmentRelative: rawAlignmentRelative || linkedSegments.alignmentRelative === true
            };
        }

        if (exact !== null) {
            return {
                start: exact,
                end: exact,
                alignmentRelative: rawAlignmentRelative
            };
        }

        if (first !== null) {
            return {
                start: 1,
                end: normalizedQueryLength !== null ? Math.min(first, normalizedQueryLength) : first,
                alignmentRelative: true
            };
        }

        if (last !== null) {
            if (normalizedQueryLength === null) {
                return null;
            }

            return {
                start: Math.max(1, normalizedQueryLength - last + 1),
                end: normalizedQueryLength,
                alignmentRelative: true
            };
        }

        if (start !== null && end !== null) {
            return {
                start: Math.min(start, end),
                end: Math.max(start, end),
                alignmentRelative: rawAlignmentRelative
            };
        }

        if (start !== null) {
            return {
                start: start,
                end: normalizedQueryLength !== null ? normalizedQueryLength : start,
                alignmentRelative: rawAlignmentRelative
            };
        }

        if (end !== null) {
            return {
                start: 1,
                end: end,
                alignmentRelative: rawAlignmentRelative
            };
        }

        return null;
    }

    function getCmPatternSegments(position) {
        if (!position || typeof position !== 'object') {
            return [];
        }

        if (Array.isArray(position.segments) && position.segments.length > 0) {
            return position.segments
                .filter(segment => segment && Number.isFinite(segment.start) && Number.isFinite(segment.end))
                .map(segment => ({
                    start: Math.min(segment.start, segment.end),
                    end: Math.max(segment.start, segment.end)
                }));
        }

        if (Number.isFinite(position.start) && Number.isFinite(position.end)) {
            return [{
                start: Math.min(position.start, position.end),
                end: Math.max(position.start, position.end)
            }];
        }

        return [];
    }

    function isLinkedCmPatternPosition(position) {
        return Boolean(position && position.linked === true);
    }

    function isBridgeOrLinkCmCode(code) {
        const normalizedCode = normalizeCmCodeKey(code);
        if (normalizedCode === null || !cmMap.has(normalizedCode)) {
            return false;
        }

        const feature = String(cmMap.get(normalizedCode).feature || '').toLowerCase();
        return feature.includes('bridge') || feature.includes('link');
    }

    function getCmBridgePairKey(posA, posB) {
        return Math.min(posA, posB) + ':' + Math.max(posA, posB);
    }

    function buildCmBridgePairSet(summaryHtml) {
        const bridgePairs = new Set();
        if (typeof summaryHtml !== 'string' || summaryHtml.trim() === '') {
            return bridgePairs;
        }

        const entries = summaryHtml.split(/<br\s*\/?\s*>/i);
        for (let index = 0; index < entries.length; index++) {
            const plainEntry = entries[index].replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
            if (!/(bridge|link)/i.test(plainEntry)) {
                continue;
            }

            const linkedPositions = [...plainEntry.matchAll(/-(\d+)\b/g)]
                .map(match => parseInt(match[1], 10))
                .filter(position => Number.isFinite(position) && position > 0);

            if (linkedPositions.length < 2) {
                continue;
            }

            bridgePairs.add(getCmBridgePairKey(linkedPositions[0], linkedPositions[1]));
        }

        return bridgePairs;
    }

    function buildQueryBridgePairSet(entries, subjectBridgePairs) {
        const queryBridgePairs = new Set();
        if (!(subjectBridgePairs instanceof Set) || subjectBridgePairs.size === 0 || !Array.isArray(entries) || entries.length === 0) {
            return queryBridgePairs;
        }

        const queryPositionBySubject = new Map();
        for (let entryIndex = 0; entryIndex < entries.length; entryIndex++) {
            const entry = entries[entryIndex];
            if (!Number.isFinite(entry?.qPos) || !Number.isFinite(entry?.sPos)) {
                continue;
            }

            queryPositionBySubject.set(entry.sPos, entry.qPos);
        }

        subjectBridgePairs.forEach((pairKey) => {
            const [subjectPosA, subjectPosB] = String(pairKey)
                .split(':')
                .map(value => parseInt(value, 10));

            if (!Number.isFinite(subjectPosA) || !Number.isFinite(subjectPosB)) {
                return;
            }

            if (!queryPositionBySubject.has(subjectPosA) || !queryPositionBySubject.has(subjectPosB)) {
                return;
            }

            queryBridgePairs.add(getCmBridgePairKey(
                queryPositionBySubject.get(subjectPosA),
                queryPositionBySubject.get(subjectPosB)
            ));
        });

        return queryBridgePairs;
    }

    function hasBridgePairBetweenSegments(bridgePairs, segments) {
        if (!(bridgePairs instanceof Set) || bridgePairs.size === 0 || !Array.isArray(segments) || segments.length < 2) {
            return false;
        }

        for (let segmentIndex = 0; segmentIndex < segments.length - 1; segmentIndex++) {
            const sourceSegment = segments[segmentIndex];
            const targetSegment = segments[segmentIndex + 1];
            let foundBridge = false;

            for (let sourcePos = sourceSegment.start; sourcePos <= sourceSegment.end && !foundBridge; sourcePos++) {
                for (let targetPos = targetSegment.start; targetPos <= targetSegment.end; targetPos++) {
                    if (bridgePairs.has(getCmBridgePairKey(sourcePos, targetPos))) {
                        foundBridge = true;
                        break;
                    }
                }
            }

            if (!foundBridge) {
                return false;
            }
        }

        return true;
    }

    function getSharedLinkedCmCodes(markerMap, segments) {
        if (!(markerMap instanceof Map) || !Array.isArray(segments) || segments.length < 2) {
            return new Set();
        }

        const segmentCodeSets = [];
        for (let segmentIndex = 0; segmentIndex < segments.length; segmentIndex++) {
            const segment = segments[segmentIndex];
            const segmentCodes = new Set();

            for (let position = segment.start; position <= segment.end; position++) {
                const codesAtPosition = markerMap.get(position) || [];
                for (let codeIndex = 0; codeIndex < codesAtPosition.length; codeIndex++) {
                    const code = normalizeCmCodeKey(codesAtPosition[codeIndex]);
                    if (code !== null && isBridgeOrLinkCmCode(code)) {
                        segmentCodes.add(code);
                    }
                }
            }

            if (segmentCodes.size === 0) {
                return new Set();
            }

            segmentCodeSets.push(segmentCodes);
        }

        let sharedCodes = new Set(segmentCodeSets[0]);
        for (let setIndex = 1; setIndex < segmentCodeSets.length; setIndex++) {
            sharedCodes = new Set([...sharedCodes].filter(code => segmentCodeSets[setIndex].has(code)));
            if (sharedCodes.size === 0) {
                return sharedCodes;
            }
        }

        return sharedCodes;
    }

    function filterCmMarkerMapByLinkedPatterns(markerMap, positions, bridgePairs) {
        if (!(markerMap instanceof Map) || !Array.isArray(positions) || positions.length === 0) {
            return markerMap;
        }

        const linkedPositions = new Set();
        const allowedCodesByPosition = new Map();

        for (let index = 0; index < positions.length; index++) {
            const position = positions[index];
            if (!isLinkedCmPatternPosition(position)) {
                continue;
            }

            const segments = getCmPatternSegments(position);
            if (segments.length < 2) {
                continue;
            }

            if (bridgePairs instanceof Set && bridgePairs.size > 0 && !hasBridgePairBetweenSegments(bridgePairs, segments)) {
                continue;
            }

            const sharedCodes = getSharedLinkedCmCodes(markerMap, segments);
            for (let segmentIndex = 0; segmentIndex < segments.length; segmentIndex++) {
                const segment = segments[segmentIndex];
                for (let currentPos = segment.start; currentPos <= segment.end; currentPos++) {
                    linkedPositions.add(currentPos);
                    if (!allowedCodesByPosition.has(currentPos)) {
                        allowedCodesByPosition.set(currentPos, new Set());
                    }

                    const allowedCodes = allowedCodesByPosition.get(currentPos);
                    sharedCodes.forEach(code => allowedCodes.add(code));
                }
            }
        }

        if (linkedPositions.size === 0) {
            return markerMap;
        }

        const filteredMarkerMap = new Map(markerMap);
        linkedPositions.forEach(position => {
            const codesAtPosition = markerMap.get(position);
            if (!Array.isArray(codesAtPosition) || codesAtPosition.length === 0) {
                filteredMarkerMap.delete(position);
                return;
            }

            const allowedCodes = allowedCodesByPosition.get(position);
            if (!allowedCodes || allowedCodes.size === 0) {
                filteredMarkerMap.delete(position);
                return;
            }

            const filteredCodes = [];
            for (let codeIndex = 0; codeIndex < codesAtPosition.length; codeIndex++) {
                const normalizedCode = normalizeCmCodeKey(codesAtPosition[codeIndex]);
                if (normalizedCode !== null && allowedCodes.has(normalizedCode) && !filteredCodes.includes(normalizedCode)) {
                    filteredCodes.push(normalizedCode);
                }
            }

            if (filteredCodes.length > 0) {
                filteredMarkerMap.set(position, filteredCodes);
            } else {
                filteredMarkerMap.delete(position);
            }
        });

        return filteredMarkerMap;
    }

    function getActiveCmQueryPatternPositions(filter, queryLength) {
        if (!Array.isArray(filter.state?.cmFilters) || !Array.isArray(filter.state?.cmFilterCheckboxes)) {
            return [];
        }

        const positions = [];

        for (let filterIndex = 0; filterIndex < filter.state.cmFilters.length; filterIndex++) {
            if (filter.state.cmFilterCheckboxes[filterIndex] !== true) {
                continue;
            }

            const cmFilter = filter.state.cmFilters[filterIndex];
            if (!cmFilter || typeof cmFilter !== 'object' || Array.isArray(cmFilter)) {
                continue;
            }

            const patterns = Array.isArray(cmFilter.patterns) ? cmFilter.patterns : [];
            for (let patternIndex = 0; patternIndex < patterns.length; patternIndex++) {
                const pattern = patterns[patternIndex];
                if (!pattern || typeof pattern !== 'object' || Array.isArray(pattern) || pattern.type !== 'EPR') {
                    continue;
                }

                const criteriaList = Array.isArray(pattern.cmCriteria) ? pattern.cmCriteria : [];
                const patternLabel = typeof pattern.filterName === 'string' && pattern.filterName.trim() !== ''
                    ? pattern.filterName.trim()
                    : 'query pattern ' + (patternIndex + 1);

                for (let criteriaIndex = 0; criteriaIndex < criteriaList.length; criteriaIndex++) {
                    const criteria = criteriaList[criteriaIndex];
                    const posList = Array.isArray(criteria?.posList) ? criteria.posList : [];
                    const modType = typeof criteria?.modType === 'string' ? criteria.modType.toUpperCase() : 'AMOD';
                    const selectedCodes = normalizeCmCriteriaCodes(criteria?.codes)
                        .map((code) => normalizeCmCodeKey(code))
                        .filter((code) => code !== null);

                    for (let posIndex = 0; posIndex < posList.length; posIndex++) {
                        const normalizedPos = normalizeCmQueryPatternPosition(posList[posIndex], queryLength);
                        if (!normalizedPos) {
                            continue;
                        }

                        positions.push({
                            start: normalizedPos.start,
                            end: normalizedPos.end,
                            segments: normalizedPos.segments,
                            linked: normalizedPos.linked === true,
                            alignmentRelative: normalizedPos.alignmentRelative === true,
                            modType,
                            selectedCodes,
                            desc: patternLabel
                        });
                    }
                }
            }
        }

        return positions;
    }

    function filterQueryPatternMarkersByModType(markerMap, positions) {
        const filteredMarkerMap = new Map();
        if (!(markerMap instanceof Map) || !Array.isArray(positions) || positions.length === 0) {
            return filteredMarkerMap;
        }

        const addCodesAtPosition = (position, codes) => {
            if (!Number.isFinite(position) || !Array.isArray(codes) || codes.length === 0) {
                return;
            }

            if (!filteredMarkerMap.has(position)) {
                filteredMarkerMap.set(position, []);
            }

            const existingCodes = filteredMarkerMap.get(position);
            for (let codeIndex = 0; codeIndex < codes.length; codeIndex++) {
                if (!existingCodes.includes(codes[codeIndex])) {
                    existingCodes.push(codes[codeIndex]);
                }
            }
        };

        for (let positionIndex = 0; positionIndex < positions.length; positionIndex++) {
            const positionRule = positions[positionIndex];
            const modType = typeof positionRule?.modType === 'string' ? positionRule.modType : 'AMOD';
            const selectedCodeSet = new Set(
                Array.isArray(positionRule?.selectedCodes) ? positionRule.selectedCodes : []
            );

            const segments = getCmPatternSegments(positionRule);
            for (let segmentIndex = 0; segmentIndex < segments.length; segmentIndex++) {
                const segment = segments[segmentIndex];
                for (let currentPos = segment.start; currentPos <= segment.end; currentPos++) {
                    if (!markerMap.has(currentPos)) {
                        continue;
                    }

                    const codesAtPos = markerMap.get(currentPos) || [];
                    if (!Array.isArray(codesAtPos) || codesAtPos.length === 0) {
                        continue;
                    }

                    if (modType === 'AMOD' || selectedCodeSet.size === 0) {
                        addCodesAtPosition(currentPos, codesAtPos);
                        continue;
                    }
                    const selectedCodesAtPos = codesAtPos.filter((code) => selectedCodeSet.has(code));
                    if (modType === 'SMOD') {
                        addCodesAtPosition(currentPos, selectedCodesAtPos);
                        continue;
                    }
                    if (modType === 'OSMOD') {
                        const hasOnlySelectedCodes = codesAtPos.every((code) => selectedCodeSet.has(code));
                        if (hasOnlySelectedCodes) {
                            addCodesAtPosition(currentPos, selectedCodesAtPos);
                        }
                    }
                }
            }
        }

        return filteredMarkerMap;
    }

    function getActiveCmQueryOccurrencePatterns(filter) {
        if (!Array.isArray(filter.state?.cmFilters) || !Array.isArray(filter.state?.cmFilterCheckboxes)) {
            return [];
        }

        const patterns = [];
        for (let filterIndex = 0; filterIndex < filter.state.cmFilters.length; filterIndex++) {
            if (filter.state.cmFilterCheckboxes[filterIndex] !== true) {
                continue;
            }

            const cmFilter = filter.state.cmFilters[filterIndex];
            if (!cmFilter || typeof cmFilter !== 'object' || Array.isArray(cmFilter)) {
                continue;
            }

            const patternList = Array.isArray(cmFilter.patterns) ? cmFilter.patterns : [];
            for (let patternIndex = 0; patternIndex < patternList.length; patternIndex++) {
                const pattern = patternList[patternIndex];
                if (!pattern || typeof pattern !== 'object' || Array.isArray(pattern) || pattern.type !== 'OC') {
                    continue;
                }

                const criteriaList = Array.isArray(pattern.cmCriteria) ? _.cloneDeep(pattern.cmCriteria) : [];
                if (criteriaList.length === 0) {
                    continue;
                }

                patterns.push({
                    criteria: criteriaList,
                    desc: typeof pattern.filterName === 'string' && pattern.filterName.trim() !== ''
                        ? pattern.filterName.trim()
                        : 'query occurrence pattern ' + (patternIndex + 1)
                });
            }
        }

        return patterns;
    }

    function mergeCmMarkerMaps(baseMap, incomingMap) {
        const mergedMap = baseMap instanceof Map ? new Map(baseMap) : new Map();
        if (!(incomingMap instanceof Map)) {
            return mergedMap;
        }

        incomingMap.forEach((codes, position) => {
            if (!Number.isFinite(position) || !Array.isArray(codes) || codes.length === 0) {
                return;
            }

            if (!mergedMap.has(position)) {
                mergedMap.set(position, []);
            }

            const existingCodes = mergedMap.get(position);
            for (let codeIndex = 0; codeIndex < codes.length; codeIndex++) {
                const normalizedCode = normalizeCmCodeKey(codes[codeIndex]);
                if (normalizedCode !== null && !existingCodes.includes(normalizedCode)) {
                    existingCodes.push(normalizedCode);
                }
            }
        });

        return mergedMap;
    }

    function evaluateQueryOccurrenceCondition(criteria, matchCount, queryLength) {
        if (matchCount <= 0) {
            return false;
        }

        const threshold = parseFloat(criteria?.count);
        const normalizedThreshold = Number.isFinite(threshold) && threshold > 0 ? threshold : 1;
        const countType = typeof criteria?.countType === 'string' ? criteria.countType.toUpperCase() : 'MIN';
        const metricType = typeof criteria?.type === 'string' ? criteria.type.toUpperCase() : 'NUM';

        let valueToCompare = matchCount;
        if (metricType === 'PERC') {
            const normalizedLength = Number.isFinite(queryLength) && queryLength > 0 ? queryLength : 0;
            if (normalizedLength <= 0) {
                return false;
            }
            valueToCompare = (matchCount / normalizedLength) * 100;
        }

        if (countType === 'EXACT') {
            return Math.abs(valueToCompare - normalizedThreshold) < 0.000000001;
        }
        if (countType === 'MAX') {
            return valueToCompare <= normalizedThreshold;
        }

        return valueToCompare >= normalizedThreshold;
    }

    function getQueryOccurrenceCriterionMatches(criteria, queryMarkerMap, queryLength) {
        const criterionMatches = new Map();
        if (!(queryMarkerMap instanceof Map)) {
            return criterionMatches;
        }

        const modType = typeof criteria?.modType === 'string' ? criteria.modType.toUpperCase() : 'AMOD';
        const selectedCodes = normalizeCmCriteriaCodes(criteria?.codes);
        const selectedCodeSet = new Set(selectedCodes.map((code) => normalizeCmCodeKey(code)).filter(code => code !== null));
        const codePositionMap = new Map();

        queryMarkerMap.forEach((codes, position) => {
            if (!Number.isFinite(position) || !Array.isArray(codes) || codes.length === 0) {
                return;
            }

            const normalizedCodes = codes
                .map((code) => normalizeCmCodeKey(code))
                .filter((code) => code !== null);
            if (normalizedCodes.length === 0) {
                return;
            }

            let matchedCodes = [];
            if (modType === 'AMOD') {
                matchedCodes = normalizedCodes;
            } else if (modType === 'SMOD') {
                if (selectedCodeSet.size === 0) {
                    return;
                }
                matchedCodes = normalizedCodes.filter((code) => selectedCodeSet.has(code));
            } else if (modType === 'OSMOD') {
                if (selectedCodeSet.size === 0) {
                    return;
                }
                const anySelected = normalizedCodes.some((code) => selectedCodeSet.has(code));
                const allSelected = normalizedCodes.every((code) => selectedCodeSet.has(code));
                if (anySelected && allSelected) {
                    matchedCodes = normalizedCodes;
                }
            } else {
                matchedCodes = normalizedCodes;
            }

            if (matchedCodes.length > 0) {
                const uniqueMatchedCodes = [...new Set(matchedCodes)];
                for (let codeIndex = 0; codeIndex < uniqueMatchedCodes.length; codeIndex++) {
                    const code = uniqueMatchedCodes[codeIndex];
                    if (!codePositionMap.has(code)) {
                        codePositionMap.set(code, new Set());
                    }
                    codePositionMap.get(code).add(position);
                }
            }
        });

        if (codePositionMap.size === 0) {
            return criterionMatches;
        }

        const qualifyingCodeSet = new Set();
        codePositionMap.forEach((positionsForCode, code) => {
            const occurrenceCount = positionsForCode.size;
            if (evaluateQueryOccurrenceCondition(criteria, occurrenceCount, queryLength)) {
                qualifyingCodeSet.add(code);
            }
        });

        if (qualifyingCodeSet.size === 0) {
            return criterionMatches;
        }

        qualifyingCodeSet.forEach((code) => {
            const matchedPositions = codePositionMap.get(code);
            if (!(matchedPositions instanceof Set)) {
                return;
            }

            matchedPositions.forEach((position) => {
                if (!criterionMatches.has(position)) {
                    criterionMatches.set(position, []);
                }

                const codesAtPosition = criterionMatches.get(position);
                if (!codesAtPosition.includes(code)) {
                    codesAtPosition.push(code);
                }
            });
        });

        return criterionMatches;
    }

    function buildQueryOccurrenceMatches(queryMarkerMap, occurrencePatterns, queryLength) {
        const markerMap = new Map();
        const chunkRanges = [];

        if (!(queryMarkerMap instanceof Map) || !Array.isArray(occurrencePatterns) || occurrencePatterns.length === 0) {
            return {
                markerMap,
                chunkRanges
            };
        }

        for (let patternIndex = 0; patternIndex < occurrencePatterns.length; patternIndex++) {
            const occurrencePattern = occurrencePatterns[patternIndex];
            const criteriaList = Array.isArray(occurrencePattern?.criteria) ? occurrencePattern.criteria : [];
            if (criteriaList.length === 0) {
                continue;
            }

            let occurrenceRangeStart = 1;
            let occurrenceRangeEnd = Number.isFinite(queryLength) && queryLength > 0
                ? queryLength
                : 0;

            if (occurrenceRangeEnd <= 0 && queryMarkerMap instanceof Map) {
                queryMarkerMap.forEach((_, position) => {
                    if (!Number.isFinite(position)) {
                        return;
                    }

                    if (occurrenceRangeEnd <= 0) {
                        occurrenceRangeStart = position;
                        occurrenceRangeEnd = position;
                    } else {
                        occurrenceRangeStart = Math.min(occurrenceRangeStart, position);
                        occurrenceRangeEnd = Math.max(occurrenceRangeEnd, position);
                    }
                });
            }

            if (occurrenceRangeEnd <= 0) {
                occurrenceRangeStart = 1;
                occurrenceRangeEnd = 1;
            }

            appendCmChunkRange(chunkRanges, occurrenceRangeStart, occurrenceRangeEnd, occurrencePattern.desc);

            let patternMarkerMap = new Map();
            let patternMatchesAllCriteria = true;

            for (let criteriaIndex = 0; criteriaIndex < criteriaList.length; criteriaIndex++) {
                const criterionMatchMap = getQueryOccurrenceCriterionMatches(criteriaList[criteriaIndex], queryMarkerMap, queryLength);
                if (criterionMatchMap.size === 0) {
                    patternMatchesAllCriteria = false;
                    break;
                }

                patternMarkerMap = mergeCmMarkerMaps(patternMarkerMap, criterionMatchMap);
            }

            if (!patternMatchesAllCriteria || patternMarkerMap.size === 0) {
                continue;
            }

            patternMarkerMap.forEach((codes, position) => {
                if (!markerMap.has(position)) {
                    markerMap.set(position, []);
                }

                const existingCodes = markerMap.get(position);
                for (let codeIndex = 0; codeIndex < codes.length; codeIndex++) {
                    if (!existingCodes.includes(codes[codeIndex])) {
                        existingCodes.push(codes[codeIndex]);
                    }
                }
            });
        }

        return {
            markerMap,
            chunkRanges
        };
    }

    function hasActiveSubjectFloatingCmPattern(filter) {
        if (!Array.isArray(filter.state?.cmFilters) || !Array.isArray(filter.state?.cmFilterCheckboxes)) {
            return false;
        }

        for (let filterIndex = 0; filterIndex < filter.state.cmFilters.length; filterIndex++) {
            if (filter.state.cmFilterCheckboxes[filterIndex] !== true) {
                continue;
            }

            const cmFilter = filter.state.cmFilters[filterIndex];
            if (!cmFilter || typeof cmFilter !== 'object' || Array.isArray(cmFilter)) {
                continue;
            }

            const patterns = Array.isArray(cmFilter.patterns) ? cmFilter.patterns : [];
            for (let patternIndex = 0; patternIndex < patterns.length; patternIndex++) {
                const pattern = patterns[patternIndex];
                if (pattern && typeof pattern === 'object' && !Array.isArray(pattern) && pattern.type === 'FP') {
                    return true;
                }
            }
        }

        return false;
    }

    function buildDirectQueryCmChunkRanges(entries, positions, excludeMap = null) {
        const chunkRanges = [];

        for (let index = 0; index < positions.length; index++) {
            const pos = positions[index];
            const segments = getCmPatternSegments(pos);
            for (let segmentIndex = 0; segmentIndex < segments.length; segmentIndex++) {
                const segment = segments[segmentIndex];
                const rangeStart = segment.start;
                const rangeEnd = segment.end;
                let currentRangeStart = null;
                let previousQPos = null;

                for (let entryIndex = 0; entryIndex < entries.length; entryIndex++) {
                    const entry = entries[entryIndex];
                    if (entry.qPos === null) {
                        appendCmChunkRange(chunkRanges, currentRangeStart, previousQPos, pos.desc);
                        currentRangeStart = null;
                        previousQPos = null;
                        continue;
                    }

                    const patternPos = pos.alignmentRelative === true ? entry.qOrdinal : entry.qPos;
                    const inRange = patternPos !== null && patternPos >= rangeStart && patternPos <= rangeEnd;
                    const excluded = excludeMap instanceof Map && excludeMap.has(entry.qPos);
                    if (!inRange || excluded) {
                        appendCmChunkRange(chunkRanges, currentRangeStart, previousQPos, pos.desc);
                        currentRangeStart = null;
                        previousQPos = null;
                        continue;
                    }

                    if (currentRangeStart === null) {
                        currentRangeStart = entry.qPos;
                    } else if (previousQPos !== null && entry.qPos !== previousQPos + 1) {
                        appendCmChunkRange(chunkRanges, currentRangeStart, previousQPos, pos.desc);
                        currentRangeStart = entry.qPos;
                    }

                    previousQPos = entry.qPos;
                }

                appendCmChunkRange(chunkRanges, currentRangeStart, previousQPos, pos.desc);
            }
        }

        return chunkRanges;
    }

    function filterCmMarkerMapByRanges(markerMap, chunkRanges) {
        const filteredMarkerMap = new Map();
        if (!(markerMap instanceof Map) || !Array.isArray(chunkRanges) || chunkRanges.length === 0) {
            return filteredMarkerMap;
        }

        for (const [position, codes] of markerMap.entries()) {
            for (let rangeIndex = 0; rangeIndex < chunkRanges.length; rangeIndex++) {
                const range = chunkRanges[rangeIndex];
                if (range.start <= position && position <= range.end) {
                    filteredMarkerMap.set(position, codes);
                    break;
                }
            }
        }

        return filteredMarkerMap;
    }

    function buildCmTrackLine({
        prefixLength,
        entries,
        displayMarkerMap,
        hitMarkerMap,
        chunkRanges,
        positionKey,
        sequenceCharKey,
        cmColorLevel,
        flipAlignment,
        allowStandaloneMarkers = true,
        trackClassName = '',
        hitsOnly = false,
        treatDisplayMarkersAsHits = false,
        invertLineLayerPlacement = false
    }) {
        const sortedRanges = _.cloneDeep(chunkRanges).sort((a, b) => {
            if (a.start !== b.start) {
                return a.start - b.start;
            }
            return a.end - b.end;
        });
        const activeRangeLanes = new Map();
        const rangeDescs = [];
        const laneEnds = [];

        for (let index = 0; index < sortedRanges.length; index++) {
            const range = sortedRanges[index];
            let lane = 0;
            while (lane < laneEnds.length && range.start <= laneEnds[lane]) {
                lane++;
            }
            if (lane === laneEnds.length) {
                laneEnds.push(range.end);
            } else {
                laneEnds[lane] = range.end;
            }

            if (!rangeDescs.includes(range.desc)) {
                rangeDescs.push(range.desc);
            }

            for (let position = range.start; position <= range.end; position++) {
                if (!activeRangeLanes.has(position)) {
                    activeRangeLanes.set(position, []);
                }
                activeRangeLanes.get(position).push(lane);
            }
        }

        let hasAnyHits = sortedRanges.length > 0;
        if (!hasAnyHits && allowStandaloneMarkers) {
            for (let index = 0; index < entries.length; index++) {
                const entry = entries[index];
                const currentPos = entry[positionKey];
                if (currentPos !== null && displayMarkerMap.has(currentPos)) {
                    hasAnyHits = true;
                    break;
                }
            }
        }

        if (!hasAnyHits) {
            return null;
        }

        let maxStackSize = 0;
        const maxLineLayerCount = Math.max(1, laneEnds.length);

        for (let index = 0; index < entries.length; index++) {
            const entry = entries[index];
            const currentPos = entry[positionKey];
            if (entry[sequenceCharKey] === '-' || currentPos === null || !displayMarkerMap.has(currentPos)) {
                continue;
            }

            const currentLanes = activeRangeLanes.get(currentPos) || [];
            const codesAtPos = displayMarkerMap.get(currentPos) || [];
            const stackSizeAtPos = codesAtPos.length;
            if (stackSizeAtPos > maxStackSize) {
                maxStackSize = stackSizeAtPos;
            }
        }

        let cmLine = ''.padStart(prefixLength);
        const cmTrackClasses = ['lva-hint', 'lva-bar', 'lva-bg-white'];
        if (trackClassName) {
            cmTrackClasses.push(trackClassName);
        }
        cmLine += "<span class='" + cmTrackClasses.join(' ') + "'>";

        for (let index = 0; index < entries.length; index++) {
            const entry = entries[index];
            const currentPos = entry[positionKey];
            if (entry[sequenceCharKey] === '-' || currentPos === null) {
                cmLine += ' ';
                continue;
            }

            const currentLanes = activeRangeLanes.get(currentPos) || [];
            const hitMultiplicity = currentLanes.length;
            const inPatternRange = hitMultiplicity > 0;
            const hasMarker = displayMarkerMap.has(currentPos);
            const hasEffectiveHit = hitMarkerMap.has(currentPos) || (treatDisplayMarkersAsHits && hasMarker);

            if (!inPatternRange && !hasMarker) {
                cmLine += ' ';
                continue;
            }

            if (!allowStandaloneMarkers && !inPatternRange) {
                cmLine += ' ';
                continue;
            }

            const lineLayers = currentLanes.length > 0
                ? (invertLineLayerPlacement
                    ? currentLanes.map(lane => maxLineLayerCount - 1 - lane)
                    : currentLanes)
                : (hasEffectiveHit ? [0] : []);

            if (hasMarker) {
                cmLine += getCmMarkerHtml(
                    displayMarkerMap.get(currentPos),
                    currentPos,
                    cmColorLevel,
                    hasEffectiveHit,
                    1,
                    maxStackSize,
                    lineLayers,
                    maxLineLayerCount,
                    flipAlignment
                );
            } else {
                cmLine += getCmRegionMarkerHtml(
                    hasEffectiveHit,
                    maxStackSize,
                    lineLayers,
                    maxLineLayerCount,
                    flipAlignment
                );
            }
        }

        cmLine += '</span>';

        return cmLine;
    }

    /**
     * Build the per-item CM prep (posMap, hitsMap, positions, etc.) needed by the extended
     * alignment's CM track builder.  Mirrors the prep block in colorAlignment (lines 4265-4408)
     * but sources the alignment residue counts from item.RESULT_FALI_FORMATTED.
     */

    // WeakMap memo so buildCmItemPrep runs once per item per render rather than once per
    // 60-col window. Safe because buildExtendedCmTracks (and this cache) are closures
    // redefined on every Discover render, so a filter change produces a fresh empty cache.
    const cmItemPrepCache = new WeakMap();
    function getCmItemPrep(item) {
        if (cmItemPrepCache.has(item)) return cmItemPrepCache.get(item);
        const prep = buildCmItemPrep(item);
        cmItemPrepCache.set(item, prep);
        return prep;
    }

    function buildCmItemPrep(item) {
        const alignment = item['RESULT_FALI_FORMATTED'] || '';
        const lines = _.split(alignment, "\n");
        const cmAlignmentResidueCounts = getCmAlignmentResidueCounts(lines);
        const subjectAllHits = Array.isArray(item?.["SUBJECT_M2"]) ? item["SUBJECT_M2"] : [];
        const subjectHitRows = Array.isArray(item?.["SUBJECT_M4"]) ? item["SUBJECT_M4"] : [];
        const queryAllHits = Array.isArray(item?.["SUBJECT_M2"]) ? item["SUBJECT_M2"] : [];
        const subjectBridgeSummary = typeof item?.["SUBJECT_BM"] === 'string' ? item["SUBJECT_BM"] : '';
        const cmPositionValues = typeof cmPos === 'string' ? _.split(cmPos.replaceAll('\n', ''), ';') : [];

        const posMap = new Map();
        const hitsMap = new Map();
        const queryDirectPosMap = new Map();
        const subjectBridgePairs = buildCmBridgePairSet(subjectBridgeSummary);
        let positions = [];

        for (let index in subjectAllHits) {
            addCmCodeToMap(posMap, subjectAllHits[index]["sPos"], subjectAllHits[index]["code"]);
        }
        for (let index in subjectHitRows) {
            addCmCodeToMap(hitsMap, subjectHitRows[index]["sPos"], subjectHitRows[index]["code"]);
        }
        for (let index in queryAllHits) {
            addCmCodeToMap(queryDirectPosMap, parseInt(queryAllHits[index]["qPos"], 10), queryAllHits[index]["code"]);
        }

        const subjectLength = parseInt(item["SUBJECT_L"]);
        const alignedSubjectLength = isCmNoSeq ? (cmAlignmentResidueCounts.subject || subjectLength) : subjectLength;
        const reverse = item['RESULT_NFQ'] >= 3 && item['RESULT_NFQ'] <= 6;

        const values = cmPositionValues;
        const seenSubjectLinkers = new Set();
        for (let i = 0; i < values.length; i++) {
            if (values[i].length > 0) {
                const tmp = _.split(values[i], ',');
                const start = parseInt(tmp[0]);
                const end = parseInt(tmp[1]);
                const exact = parseInt(tmp[2]);
                const first = parseInt(tmp[3]);
                const last = parseInt(tmp[4]);
                const linker = tmp[5];
                const linkedPos = linker ? normalizeCmQueryPatternPosition({linked: linker}, alignedSubjectLength) : null;

                if (linkedPos && Array.isArray(linkedPos.segments) && linkedPos.segments.length > 0) {
                    if (!seenSubjectLinkers.has(linker)) {
                        seenSubjectLinkers.add(linker);
                        positions.push({
                            "start": linkedPos.start, "end": linkedPos.end,
                            "segments": linkedPos.segments, "linked": true,
                            "alignmentRelative": linkedPos.alignmentRelative === true,
                            "desc": "subj. pos " + linker
                        });
                    }
                    continue;
                }

                if (start > 0 && end > 0) {
                    positions.push({"start": start, "end": end, "desc": "subj. pos " + start + "-" + end});
                } else if (exact > 0) {
                    positions.push({"start": exact, "end": exact, "desc": linker ? "subj. pos " + linker : "subj. exact pos " + exact});
                } else if (first > 0) {
                    positions.push({"start": 1, "end": first < alignedSubjectLength ? first : alignedSubjectLength, "alignmentRelative": true, "desc": "subj. first " + first + " pos"});
                } else if (last > 0) {
                    positions.push({"start": last < alignedSubjectLength ? (alignedSubjectLength - last + 1) : 1, "end": alignedSubjectLength, "alignmentRelative": true, "desc": "subj. last " + last + " pos"});
                } else if (start > 0) {
                    positions.push({"start": start, "end": subjectLength, "desc": "subj. pos " + start + "-"});
                } else if (end > 0) {
                    positions.push({"start": 1, "end": end < subjectLength ? end : subjectLength, "desc": "subj. pos " + "-" + end});
                }
            }
        }

        if (hasActiveSubjectFloatingCmPattern(filter)) {
            let posList = hitsMap.keys();
            for (let i of posList) {
                let pos = parseInt(i);
                let found = false;
                for (let j = 0; j < positions.length; j++) {
                    const segments = getCmPatternSegments(positions[j]);
                    for (let segmentIndex = 0; segmentIndex < segments.length; segmentIndex++) {
                        if (segments[segmentIndex].start <= pos && pos <= segments[segmentIndex].end) { found = true; break; }
                    }
                    if (found) break;
                }
                if (!found) positions.push({"start": pos, "end": pos, "desc": "subj. floating hit pos " + pos});
            }
        }

        if (positions.length > 1) {
            positions.sort((a, b) => {
                const aSegments = getCmPatternSegments(a);
                const bSegments = getCmPatternSegments(b);
                const aStart = aSegments.length > 0 ? aSegments[0].start : parseInt(a.start);
                const aEnd = aSegments.length > 0 ? aSegments[aSegments.length - 1].end : parseInt(a.end);
                const bStart = bSegments.length > 0 ? bSegments[0].start : parseInt(b.start);
                const bEnd = bSegments.length > 0 ? bSegments[bSegments.length - 1].end : parseInt(b.end);
                return reverse ? (bEnd - aEnd) : (aStart - bStart);
            });
        }

        const queryLength = parseInt(item['QUERY_L'], 10) || cmAlignmentResidueCounts.query;
        const cmQueryPositionValues = typeof cmQueryPos === 'string' ? _.split(cmQueryPos.replaceAll('\n', ''), ';') : [];
        const queryPositions = [];
        const seenQueryLinkers = new Set();
        for (let i = 0; i < cmQueryPositionValues.length; i++) {
            if (cmQueryPositionValues[i].length > 0) {
                const tmp = _.split(cmQueryPositionValues[i], ',');
                const start = tmp[0] != null ? parseInt(tmp[0]) : 0;
                const end = tmp[1] != null ? parseInt(tmp[1]) : 0;
                const exact = tmp[2] != null ? parseInt(tmp[2]) : 0;
                const first = tmp[3] != null ? parseInt(tmp[3]) : 0;
                const last = tmp[4] != null ? parseInt(tmp[4]) : 0;
                const linker = tmp[5];
                const isNot = tmp[6] === '0';
                const codesRaw = typeof tmp[7] === 'string' ? tmp[7].trim() : '';
                const useSpecificCodes = codesRaw.length > 0;
                const selectedCodes = useSpecificCodes
                    ? codesRaw.split('-').map(c => normalizeCmCodeKey(c.trim())).filter(c => c !== null)
                    : [];
                const modType = useSpecificCodes ? 'SMOD' : 'AMOD';
                const linkedPos = linker ? normalizeCmQueryPatternPosition({linked: linker}, queryLength) : null;
                if (linkedPos && Array.isArray(linkedPos.segments) && linkedPos.segments.length > 0) {
                    if (!seenQueryLinkers.has(linker)) {
                        seenQueryLinkers.add(linker);
                        queryPositions.push({
                            start: linkedPos.start, end: linkedPos.end,
                            segments: linkedPos.segments, linked: true,
                            alignmentRelative: linkedPos.alignmentRelative === true,
                            isNot, modType, selectedCodes,
                            desc: "query pos " + linker
                        });
                    }
                    continue;
                }
                if (start > 0 && end > 0) {
                    queryPositions.push({start, end, isNot, modType, selectedCodes, desc: "query pos " + start + "-" + end});
                } else if (exact > 0) {
                    queryPositions.push({start: exact, end: exact, isNot, modType, selectedCodes, desc: linker ? "query pos " + linker : "query exact pos " + exact});
                } else if (first > 0) {
                    queryPositions.push({start: 1, end: first < queryLength ? first : queryLength, alignmentRelative: true, isNot, modType, selectedCodes, desc: "query first " + first + " pos"});
                } else if (last > 0) {
                    queryPositions.push({start: last < queryLength ? (queryLength - last + 1) : 1, end: queryLength, alignmentRelative: true, isNot, modType, selectedCodes, desc: "query last " + last + " pos"});
                } else if (start > 0) {
                    queryPositions.push({start, end: queryLength, isNot, modType, selectedCodes, desc: "query pos " + start + "-"});
                } else if (end > 0) {
                    queryPositions.push({start: 1, end: end < queryLength ? end : queryLength, isNot, modType, selectedCodes, desc: "query pos " + "-" + end});
                }
            }
        }

        return { posMap, hitsMap, subjectBridgePairs, positions, queryPositions, queryDirectPosMap, cmAlignmentResidueCounts };
    }

    /**
     * Build CM marker track lines (query track + subject track) for one 60-col window of the
     * extended alignment.  Called per window from buildFullSubjectAlignment via the cmTrackBuilder prop.
     * Mirrors the derivation in colorAlignment lines 4524-4574, operating on synthetic entries
     * built from qCoord/sCoord/queryRow/subjectRow instead of buildCmChunkEntries output.
     */
    function buildExtendedCmTracks(item, entries, { queryPrefixLen, subjectPrefixLen }) {
        if (!isCmWorkflow) return { queryTrackLine: null, subjectTrackLine: null };

        const { posMap, hitsMap, subjectBridgePairs, positions, queryPositions, queryDirectPosMap, cmAlignmentResidueCounts } = getCmItemPrep(item);

        const queryLength = cmAlignmentResidueCounts.query || parseInt(item['QUERY_L'], 10);
        const activeQueryPatternPositions   = getActiveCmQueryPatternPositions(filter, queryLength);
        const activeQueryOccurrencePatterns = getActiveCmQueryOccurrencePatterns(filter);
        const useHitsOnly       = Boolean(filter.state.highlightHits);
        const queryBridgePairs  = buildQueryBridgePairSet(entries, subjectBridgePairs);
        const queryPosMap       = buildProjectedQueryCmMarkerMap(posMap, entries);
        const subjectPatternHitMap  = filterCmMarkerMapByLinkedPatterns(posMap, positions, subjectBridgePairs);
        const queryPatternHitMap    = filterCmMarkerMapByLinkedPatterns(queryPosMap, activeQueryPatternPositions, queryBridgePairs);
        const queryEprChunkRanges   = buildDirectQueryCmChunkRanges(entries, activeQueryPatternPositions);
        const queryOccurrenceMatches = buildQueryOccurrenceMatches(queryPosMap, activeQueryOccurrencePatterns, queryLength);
        const subjectChunkRanges     = buildSubjectCmChunkRanges(entries, positions);
        const queryEprMarkerMap         = filterCmMarkerMapByRanges(queryPatternHitMap, queryEprChunkRanges);
        const queryEprMarkerMapFiltered = filterQueryPatternMarkersByModType(queryEprMarkerMap, activeQueryPatternPositions);
        const normalQueryPositions      = queryPositions.filter(p => !p.isNot);
        const notQueryPositions         = queryPositions.filter(p => p.isNot);
        const querySearchChunkRanges    = buildDirectQueryCmChunkRanges(entries, normalQueryPositions);
        const querySearchPatternHitMap  = filterCmMarkerMapByLinkedPatterns(queryDirectPosMap, normalQueryPositions, queryBridgePairs);
        const querySearchRangeFilteredMap = filterCmMarkerMapByRanges(querySearchPatternHitMap, querySearchChunkRanges);
        const querySearchMarkerMap      = filterQueryPatternMarkersByModType(querySearchRangeFilteredMap, normalQueryPositions);
        const queryNotChunkRanges       = buildDirectQueryCmChunkRanges(entries, notQueryPositions, queryDirectPosMap);
        const queryMarkerMap    = mergeCmMarkerMaps(
            mergeCmMarkerMaps(queryEprMarkerMapFiltered, queryOccurrenceMatches.markerMap),
            querySearchMarkerMap
        );
        const queryChunkRanges  = [...queryEprChunkRanges, ...queryOccurrenceMatches.chunkRanges, ...querySearchChunkRanges, ...queryNotChunkRanges];
        const subjectMarkerMap  = useHitsOnly
            ? hitsMap //filterCmMarkerMapByRanges(subjectPatternHitMap, subjectChunkRanges)
            : posMap;
        const subjectHitMarkerMap = filterCmMarkerMapByRanges(subjectPatternHitMap, subjectChunkRanges);

        const showQueryCmTrack = queryChunkRanges.length > 0;
        const queryTrackLine = showQueryCmTrack ? buildCmTrackLine({
            prefixLength: queryPrefixLen, entries,
            displayMarkerMap: queryMarkerMap, hitMarkerMap: queryMarkerMap,
            chunkRanges: queryChunkRanges,
            positionKey: 'qPos', sequenceCharKey: 'qChar',
            cmColorLevel: filter.state.cmColorLevel,
            flipAlignment: false, allowStandaloneMarkers: true,
            trackClassName: 'cm-query-track', hitsOnly: false,
            invertLineLayerPlacement: true
        }) : null;
        const subjectTrackLine = buildCmTrackLine({
            prefixLength: subjectPrefixLen, entries,
            displayMarkerMap: subjectMarkerMap, hitMarkerMap: subjectHitMarkerMap,
            chunkRanges: subjectChunkRanges,
            positionKey: 'sPos', sequenceCharKey: 'sChar',
            cmColorLevel: filter.state.cmColorLevel,
            flipAlignment: true, hitsOnly: useHitsOnly
        });

        return { queryTrackLine, subjectTrackLine };
    }

    /**
     * Return LVA flag maps for use in the extended alignment's character highlighting.
     * Delegates to filter.getLvaFlagMaps which converts chunk-relative hint flags into
     * absolute query/subject position maps.
     */
    function getExtendedLvaFlagMaps(item) {
        if (!hasLvaAccess || isCmWorkflow) return { qFlags: new Map(), sFlags: new Map() };
        return filter.getLvaFlagMaps(filter, item);
    }

    function colorAlignment(filter, alignment, seqData, item, gqAlignmentsNoSumm, gqAlignmentsStrNoSumm, gqAlignmentsSumm, gqAlignmentsVariation) {
        let hints = filter.getLvaAlignmentHints(filter, seqData);

        // break alignment into lines using newline characters
        let i,
            nextLine = false,
            match = false,
            lines = _.split(alignment, "\n"),
            line,
            newAlignment = '',
            spacer,
            //direction = seqData.RESULT_ALI_DIR,
            chunkIdx = 0,
            subjectLine = false;
        const cmAlignmentResidueCounts = isCmWorkflow ? getCmAlignmentResidueCounts(lines) : {query: 0, subject: 0};
        const subjectAllHits = Array.isArray(item?.["SUBJECT_M2"]) ? item["SUBJECT_M2"] : [];
        const subjectHitRows = Array.isArray(item?.["SUBJECT_M4"]) ? item["SUBJECT_M4"] : [];
        const queryAllHits = Array.isArray(item?.["SUBJECT_M2"]) ? item["SUBJECT_M2"] : [];
        const subjectBridgeSummary = typeof item?.["SUBJECT_BM"] === 'string' ? item["SUBJECT_BM"] : '';
        const cmPositionValues = typeof cmPos === 'string' ? _.split(cmPos.replaceAll('\n', ''), ';') : [];

        // For the CM alignment
        const posMap = new Map();
        const hitsMap = new Map();
        const queryDirectPosMap = new Map();
        const subQueryPosMap = new Map(); // To correct the query positions
        let positions = [];
        let queryPositions = [];
        let subjectBridgePairs = new Set();
        if (isCmWorkflow) {
            // All CM codes
            for (let index in subjectAllHits) {
                addCmCodeToMap(posMap, subjectAllHits[index]["sPos"], subjectAllHits[index]["code"]);
            }
            // Only hits
            for (let index in subjectHitRows) {
                addCmCodeToMap(hitsMap, subjectHitRows[index]["sPos"], subjectHitRows[index]["code"]);
            }
            // Query CM modifications
            for (let index in queryAllHits) {
                addCmCodeToMap(queryDirectPosMap, parseInt(queryAllHits[index]["qPos"], 10), queryAllHits[index]["code"]);
            }

            const values = cmPositionValues;
            const subjectLength = parseInt(item["SUBJECT_L"]);
            const alignedSubjectLength = isCmNoSeq ? (cmAlignmentResidueCounts.subject || subjectLength) : subjectLength;
            subjectBridgePairs = buildCmBridgePairSet(subjectBridgeSummary);

            // Convert subject position to query position
            let reverse = false;
            if (item['RESULT_NFQ'] >= 3 && item['RESULT_NFQ'] <= 6) {
                // Reverse
                reverse = true;
            }
            let qStart, qStop;
            const seenSubjectLinkers2 = new Set();
            for (let i = 0; i < values.length; i++) {
                if (values[i].length > 0) {
                    const tmp = _.split(values[i], ',');
                    const start = parseInt(tmp[0]);
                    const end = parseInt(tmp[1]);
                    const exact = parseInt(tmp[2]);
                    const first = parseInt(tmp[3]);
                    const last = parseInt(tmp[4]);
                    const linker = tmp[5];
                    const linkedPos = linker ? normalizeCmQueryPatternPosition({linked: linker}, alignedSubjectLength) : null;

                    if (linkedPos && Array.isArray(linkedPos.segments) && linkedPos.segments.length > 0) {
                        if (!seenSubjectLinkers2.has(linker)) {
                            seenSubjectLinkers2.add(linker);
                            positions.push({
                                "start": linkedPos.start,
                                "end": linkedPos.end,
                                "segments": linkedPos.segments,
                                "linked": true,
                                "alignmentRelative": linkedPos.alignmentRelative === true,
                                "desc": "subj. pos " + linker
                            });
                        }
                        continue;
                    }

                    if (start > 0 && end > 0) {
                        positions.push({
                            "start": start,
                            "end": end,
                            "desc": "subj. pos " + start + "-" + end
                        });
                    } else if (exact > 0) {
                        positions.push({
                            "start": exact,
                            "end": exact,
                            "desc": linker ? "subj. pos " + linker : "subj. exact pos " + exact
                        });
                    } else if (first > 0) {
                        positions.push({
                            "start": 1,
                            "end": first < alignedSubjectLength ? first : alignedSubjectLength,
                            "alignmentRelative": true,
                            "desc": "subj. first " + first + " pos"
                        });
                    } else if (last > 0) {
                        positions.push({
                            "start": last < alignedSubjectLength ? (alignedSubjectLength - last + 1) : 1,
                            "end": alignedSubjectLength,
                            "alignmentRelative": true,
                            "desc": "subj. last " + last + " pos"
                        });
                    } else if (start > 0) {
                        positions.push({
                            "start": start,
                            "end": subjectLength,
                            "desc": "subj. pos " + start + "-"
                        });
                    } else if (end > 0) {
                        positions.push({
                            "start": 1,
                            "end": end < subjectLength ? end : subjectLength,
                            "desc": "subj. pos " + "-" + end
                        });
                    }
                }
            }
            if (hasActiveSubjectFloatingCmPattern(filter)) {
                // Floating CM patterns need hit-driven anchor positions; non-floating patterns should not inherit cmHits positions.
                let posList = hitsMap.keys();
                for (let i of posList) {
                    let pos = parseInt(i);
                    let found = false;
                    for (let j = 0; j < positions.length; j++) {
                        const segments = getCmPatternSegments(positions[j]);
                        for (let segmentIndex = 0; segmentIndex < segments.length; segmentIndex++) {
                            if (segments[segmentIndex].start <= pos && pos <= segments[segmentIndex].end) {
                                found = true;
                                break;
                            }
                        }
                        if (found) {
                            break;
                        }
                    }

                    if (!found) {
                        positions.push({
                            "start": pos,
                            "end": pos,
                            "desc": "subj. floating hit pos " + pos
                        });
                    }
                }
            }

            if (positions.length > 1) {
                // Sort by query position asc
                positions.sort((a, b) => {
                    const aSegments = getCmPatternSegments(a);
                    const bSegments = getCmPatternSegments(b);
                    const aStart = aSegments.length > 0 ? aSegments[0].start : parseInt(a.start);
                    const aEnd = aSegments.length > 0 ? aSegments[aSegments.length - 1].end : parseInt(a.end);
                    const bStart = bSegments.length > 0 ? bSegments[0].start : parseInt(b.start);
                    const bEnd = bSegments.length > 0 ? bSegments[bSegments.length - 1].end : parseInt(b.end);
                    if (reverse) {
                        return bEnd - aEnd;
                    } else {
                        return aStart - bStart;
                    }
                });
            }

            const queryLength0 = parseInt(item['QUERY_L'], 10) || cmAlignmentResidueCounts.query;
            const cmQueryPositionValues = typeof cmQueryPos === 'string' ? _.split(cmQueryPos.replaceAll('\n', ''), ';') : [];
            const seenQueryLinkers2 = new Set();
            for (let i = 0; i < cmQueryPositionValues.length; i++) {
                if (cmQueryPositionValues[i].length > 0) {
                    const tmp = _.split(cmQueryPositionValues[i], ',');
                    const start = tmp[0] != null ? parseInt(tmp[0]) : 0;
                    const end = tmp[1] != null ? parseInt(tmp[1]) : 0;
                    const exact = tmp[2] != null ? parseInt(tmp[2]) : 0;
                    const first = tmp[3] != null ? parseInt(tmp[3]) : 0;
                    const last = tmp[4] != null ? parseInt(tmp[4]) : 0;
                    const linker = tmp[5];
                    const isNot0 = tmp[6] === '0';
                    const codesRaw0 = typeof tmp[7] === 'string' ? tmp[7].trim() : '';
                    const useSpecificCodes0 = codesRaw0.length > 0;
                    const selectedCodes0 = useSpecificCodes0
                        ? codesRaw0.split('-').map(c => normalizeCmCodeKey(c.trim())).filter(c => c !== null)
                        : [];
                    const modType0 = useSpecificCodes0 ? 'SMOD' : 'AMOD';
                    const linkedPos = linker ? normalizeCmQueryPatternPosition({linked: linker}, queryLength0) : null;
                    if (linkedPos && Array.isArray(linkedPos.segments) && linkedPos.segments.length > 0) {
                        if (!seenQueryLinkers2.has(linker)) {
                            seenQueryLinkers2.add(linker);
                            queryPositions.push({
                                start: linkedPos.start, end: linkedPos.end,
                                segments: linkedPos.segments, linked: true,
                                alignmentRelative: linkedPos.alignmentRelative === true,
                                isNot: isNot0, modType: modType0, selectedCodes: selectedCodes0,
                                desc: "query pos " + linker
                            });
                        }
                        continue;
                    }
                    if (start > 0 && end > 0) {
                        queryPositions.push({start, end, isNot: isNot0, modType: modType0, selectedCodes: selectedCodes0, desc: "query pos " + start + "-" + end});
                    } else if (exact > 0) {
                        queryPositions.push({start: exact, end: exact, isNot: isNot0, modType: modType0, selectedCodes: selectedCodes0, desc: linker ? "query pos " + linker : "query exact pos " + exact});
                    } else if (first > 0) {
                        queryPositions.push({start: 1, end: first < queryLength0 ? first : queryLength0, alignmentRelative: true, isNot: isNot0, modType: modType0, selectedCodes: selectedCodes0, desc: "query first " + first + " pos"});
                    } else if (last > 0) {
                        queryPositions.push({start: last < queryLength0 ? (queryLength0 - last + 1) : 1, end: queryLength0, alignmentRelative: true, isNot: isNot0, modType: modType0, selectedCodes: selectedCodes0, desc: "query last " + last + " pos"});
                    } else if (start > 0) {
                        queryPositions.push({start, end: queryLength0, isNot: isNot0, modType: modType0, selectedCodes: selectedCodes0, desc: "query pos " + start + "-"});
                    } else if (end > 0) {
                        queryPositions.push({start: 1, end: end < queryLength0 ? end : queryLength0, isNot: isNot0, modType: modType0, selectedCodes: selectedCodes0, desc: "query pos " + "-" + end});
                    }
                }
            }
        }

        let pendingCmLine = null;
        let qOrdinalOffset = 0;
        let sOrdinalOffset = 0;
        for (i = 0; i < lines.length; i++) {
            line = lines[i];
            if (nextLine && match) {
                // now we're working with the line between query and subject sequence
                spacer = line.substr(0, match); // leading spaces that we don't want to replace

                line = line.substr(match); // the ||||| |||+||||||||||||||||| part of the alignment without leading spaces
                // do the actual replacement of spaces and + signs with colored ones
                line = line.replace(/ +/g, function (hit) {
                    return '<span class="mismatch">' + hit + '</span>'
                });
                line = line.replace(/\++/g, function (hit) {
                    return '<span class="match">' + hit + '</span>'
                });
                // add the leading spaces back in
                line = spacer + line;

                chunkIdx++;
            }
            nextLine = line.indexOf("Q:") === 0; // true when we're on the Query line of the alignment
            if (nextLine) {
                // find out where the query sequence starts
                match = 2 + (/[0-9] /.exec(line)).index;

                // Append the LVA hints before appending the query line
                if (chunkIdx in hints.hintLines) {
                    spacer = "".padStart(match);
                    let lvaLines = "";  //  We need to do them in reverse order, rather than using Array.reverse()

                    // Merge the flags which indicate whether the chunk is replaced/inserted/deleted,
                    // so that we could display extra color/lower case on it
                    let mergedChunkFlags = null;

                    let qChunk = null;
                    for (let level in hints.hintLines[chunkIdx]) {
                        lvaLines = spacer + hints.hintLines[chunkIdx][level].line + "\n" + lvaLines;

                        if (mergedChunkFlags === null) {
                            mergedChunkFlags = hints.hintLines[chunkIdx][level].qChunkFlags;
                        } else {
                            let tmpMergedChunkFlags = null;
                            if (mergedChunkFlags.length >= hints.hintLines[chunkIdx][level].qChunkFlags.length) {
                                tmpMergedChunkFlags = mergedChunkFlags;
                            } else {
                                tmpMergedChunkFlags = hints.hintLines[chunkIdx][level].qChunkFlags;
                            }

                            // Merge the chunk flags from multiple hint lines
                            for (let chunkFlagsIndx in tmpMergedChunkFlags) {
                                let value = tmpMergedChunkFlags[chunkFlagsIndx];
                                let value2 = hints.hintLines[chunkIdx][level].qChunkFlags[chunkFlagsIndx];
                                let value3 = mergedChunkFlags[chunkFlagsIndx];

                                if (value2 && value2 > value) {
                                    tmpMergedChunkFlags[chunkFlagsIndx] = value2;
                                    value = value2;
                                }
                                if (value3 && value3 > value) {
                                    tmpMergedChunkFlags[chunkFlagsIndx] = value3;
                                }
                            }
                            mergedChunkFlags = tmpMergedChunkFlags;
                        }

                        if (qChunk === null) {
                            qChunk = hints.hintLines[chunkIdx][level].qChunk;
                        }
                    }
                    newAlignment += lvaLines;

                    let qAlignmentLine = "";
                    for (let chunkFlagsIndx in mergedChunkFlags) {
                        let value = mergedChunkFlags[chunkFlagsIndx];
                        if (value === 0) {
                            qAlignmentLine += qChunk.charAt(chunkFlagsIndx);
                        } else if (value === 1) {
                            // Background color - gq blue
                            qAlignmentLine += "<span class='lva-marked'>" + qChunk.charAt(chunkFlagsIndx) + "</span>";
                        } else {
                            // Background color - gq blue, and lower case
                            qAlignmentLine += "<span class='lva-marked lva-not-exact-match'>" + qChunk.charAt(chunkFlagsIndx) + "</span>";
                        }
                    }
                    if (mergedChunkFlags.length < qChunk.length) {
                        qAlignmentLine += qChunk.substring(mergedChunkFlags.length, qChunk.length);
                    }
                    line = line.replace(qChunk, qAlignmentLine);
                } else if (isCmWorkflow) { // CM workflow
                    const sLine = lines[i + 2];
                    const queryLineInfo = parseAlignmentSequenceLine(line, 'Q');
                    const subjectLineInfo = parseAlignmentSequenceLine(sLine, 'S');
                    const queryMatchStart = queryLineInfo ? queryLineInfo.prefixLength : 2 + (/[0-9] /.exec(line)).index;
                    const subjectMatchStart = subjectLineInfo ? subjectLineInfo.prefixLength : 2 + (/[0-9] /.exec(sLine)).index;
                    const queryMatchEnd = queryLineInfo ? (queryMatchStart + queryLineInfo.sequence.length) : ((/[^ :] [0-9]/.exec(line)).index + 1);
                    const subjectMatchEnd = subjectLineInfo ? (subjectMatchStart + subjectLineInfo.sequence.length) : ((/[^ :] [0-9]/.exec(sLine)).index + 1);
                    const qLeft = parseInt((/[0-9]+/.exec(line))[0]); // query start
                    const qChunk = queryLineInfo ? queryLineInfo.sequence : line.substring(queryMatchStart, queryMatchEnd);

                    const sChunk = subjectLineInfo ? subjectLineInfo.sequence : sLine.substring(subjectMatchStart, subjectMatchEnd);
                    const sLeft = parseInt((/[0-9]+/.exec(sLine))[0]);
                    const sRight = parseInt((/[0-9]+$/.exec(sLine))[0]);
                    const chunkEntries = buildCmChunkEntries(qChunk, sChunk, qLeft, sLeft, sRight, qOrdinalOffset, sOrdinalOffset);
                    qOrdinalOffset += chunkEntries.filter(entry => entry.qOrdinal !== null).length;
                    sOrdinalOffset += chunkEntries.filter(entry => entry.sOrdinal !== null).length;
                    for (let entryIndex = 0; entryIndex < chunkEntries.length; entryIndex++) {
                        const entry = chunkEntries[entryIndex];
                        if (entry.qPos !== null && entry.sPos !== null) {
                            subQueryPosMap.set(entry.sPos, {"pos": entry.qPos, "base": entry.qChar});
                        }
                    }

                    const queryLength = cmAlignmentResidueCounts.query || parseInt(item['QUERY_L'], 10);
                    const activeQueryPatternPositions = getActiveCmQueryPatternPositions(filter, queryLength);
                    const activeQueryOccurrencePatterns = getActiveCmQueryOccurrencePatterns(filter);
                    const useHitsOnly = Boolean(filter.state.highlightHits);
                    const queryBridgePairs = buildQueryBridgePairSet(chunkEntries, subjectBridgePairs);
                    const queryPosMap = buildProjectedQueryCmMarkerMap(posMap, chunkEntries);
                    const subjectPatternHitMap = filterCmMarkerMapByLinkedPatterns(posMap, positions, subjectBridgePairs);
                    const queryPatternHitMap = filterCmMarkerMapByLinkedPatterns(queryPosMap, activeQueryPatternPositions, queryBridgePairs);
                    const queryEprChunkRanges = buildDirectQueryCmChunkRanges(chunkEntries, activeQueryPatternPositions);
                    const queryOccurrenceMatches = buildQueryOccurrenceMatches(queryPosMap, activeQueryOccurrencePatterns, queryLength);
                    const subjectChunkRanges = buildSubjectCmChunkRanges(chunkEntries, positions);
                    const queryEprMarkerMap = filterCmMarkerMapByRanges(queryPatternHitMap, queryEprChunkRanges);
                    const queryEprMarkerMapFiltered = filterQueryPatternMarkersByModType(queryEprMarkerMap, activeQueryPatternPositions);
                    const normalQueryPositions = queryPositions.filter(p => !p.isNot);
                    const notQueryPositions = queryPositions.filter(p => p.isNot);
                    const querySearchChunkRanges = buildDirectQueryCmChunkRanges(chunkEntries, normalQueryPositions);
                    const querySearchPatternHitMap = filterCmMarkerMapByLinkedPatterns(queryDirectPosMap, normalQueryPositions, queryBridgePairs);
                    const querySearchRangeFilteredMap = filterCmMarkerMapByRanges(querySearchPatternHitMap, querySearchChunkRanges);
                    const querySearchMarkerMap = filterQueryPatternMarkersByModType(querySearchRangeFilteredMap, normalQueryPositions);
                    const queryNotChunkRanges = buildDirectQueryCmChunkRanges(chunkEntries, notQueryPositions, queryDirectPosMap);
                    const queryMarkerMap = mergeCmMarkerMaps(
                        mergeCmMarkerMaps(queryEprMarkerMapFiltered, queryOccurrenceMatches.markerMap),
                        querySearchMarkerMap
                    );
                    const queryChunkRanges = [
                        ...queryEprChunkRanges,
                        ...queryOccurrenceMatches.chunkRanges,
                        ...querySearchChunkRanges,
                        ...queryNotChunkRanges
                    ];
                    const subjectMarkerMap = useHitsOnly
                        ? hitsMap //filterCmMarkerMapByRanges(subjectPatternHitMap, subjectChunkRanges)
                        : posMap;
                    const subjectHitMarkerMap = filterCmMarkerMapByRanges(subjectPatternHitMap, subjectChunkRanges);
                    const queryTrackHitMap = queryMarkerMap;
                    const showQueryCmTrack = queryChunkRanges.length > 0;
                    const queryCmLine = showQueryCmTrack ? buildCmTrackLine({
                        prefixLength: queryMatchStart,
                        entries: chunkEntries,
                        displayMarkerMap: queryMarkerMap,
                        hitMarkerMap: queryTrackHitMap,
                        chunkRanges: queryChunkRanges,
                        positionKey: 'qPos',
                        sequenceCharKey: 'qChar',
                        cmColorLevel: filter.state.cmColorLevel,
                        flipAlignment: false,
                        allowStandaloneMarkers: true,
                        trackClassName: 'cm-query-track',
                        hitsOnly: false,
                        invertLineLayerPlacement: true
                    }) : null;
                    const cmLine = buildCmTrackLine({
                        prefixLength: subjectMatchStart,
                        entries: chunkEntries,
                        displayMarkerMap: subjectMarkerMap,
                        hitMarkerMap: subjectHitMarkerMap,
                        chunkRanges: subjectChunkRanges,
                        positionKey: 'sPos',
                        sequenceCharKey: 'sChar',
                        cmColorLevel: filter.state.cmColorLevel,
                        flipAlignment: true,
                        hitsOnly: useHitsOnly
                    });

                    if (queryCmLine) {
                        newAlignment += queryCmLine + "\n";
                    }
                    pendingCmLine = cmLine;
                }
            }
            subjectLine = line.indexOf("S:") === 0;
            if (subjectLine) { // true when we're on the Subject line of the alignment
                let sChunkIdx = chunkIdx - 1;

                // Merge the flags which indicate whether the chunk is replaced/inserted/deleted,
                // so that we could display extra color/lower case on it
                if (sChunkIdx in hints.hintLines) {
                    let mergedChunkFlags = null;
                    let sChunk = null;
                    for (let level in hints.hintLines[sChunkIdx]) {
                        if (mergedChunkFlags === null) {
                            mergedChunkFlags = hints.hintLines[sChunkIdx][level].sChunkFlags;
                        } else {
                            let tmpMergedChunkFlags = null;
                            if (mergedChunkFlags.length >= hints.hintLines[sChunkIdx][level].sChunkFlags.length) {
                                tmpMergedChunkFlags = mergedChunkFlags;
                            } else {
                                tmpMergedChunkFlags = hints.hintLines[sChunkIdx][level].sChunkFlags;
                            }

                            // Merge the chunk flags from multiple hint lines
                            for (let chunkFlagsIndx in tmpMergedChunkFlags) {
                                let value = tmpMergedChunkFlags[chunkFlagsIndx];
                                let value2 = hints.hintLines[sChunkIdx][level].sChunkFlags[chunkFlagsIndx];
                                let value3 = mergedChunkFlags[chunkFlagsIndx];

                                if (value2 && value2 > value) {
                                    tmpMergedChunkFlags[chunkFlagsIndx] = value2;
                                    value = value2;
                                }
                                if (value3 && value3 > value) {
                                    tmpMergedChunkFlags[chunkFlagsIndx] = value3;
                                }
                            }
                            mergedChunkFlags = tmpMergedChunkFlags;
                        }

                        if (sChunk === null) {
                            sChunk = hints.hintLines[sChunkIdx][level].sChunk;
                        }
                    }

                    let sAlignmentLine = "";
                    for (let chunkFlagsIndx in mergedChunkFlags) {
                        let value = mergedChunkFlags[chunkFlagsIndx];
                        if (value === 0) {
                            sAlignmentLine += sChunk.charAt(chunkFlagsIndx);
                        } else if (value === 1) {
                            // Background color - gq blue
                            sAlignmentLine += "<span class='lva-marked'>" + sChunk.charAt(chunkFlagsIndx) + "</span>";
                        } else {
                            // Background color - gq blue, and lower case
                            sAlignmentLine += "<span class='lva-marked lva-not-exact-match'>" + sChunk.charAt(chunkFlagsIndx) + "</span>";
                        }
                    }
                    if (mergedChunkFlags.length < sChunk.length) {
                        sAlignmentLine += sChunk.substring(mergedChunkFlags.length, sChunk.length);
                    }
                    line = line.replace(sChunk, sAlignmentLine);
                } else if (isCmWorkflow) {
                    // find out where the subject sequence starts
                    const matchStart = 2 + (/[0-9] /.exec(line)).index;
                    const matchEnd = (/[^ :] [0-9]/.exec(line)).index + 1;
                    const sChunk = line.substring(matchStart, matchEnd);
                    const sLeft = parseInt((/[0-9]+/.exec(line))[0]);
                    const sRight = parseInt((/[0-9]+$/.exec(line))[0]);

                    let sAlignmentLine = "";
                    let chunkFlagsIndex = 0;
                    if (sLeft < sRight) {
                        for (let i = sLeft; i <= sRight; i++) {
                            while (sChunk.charAt(chunkFlagsIndex) === "-") {
                                sAlignmentLine += sChunk.charAt(chunkFlagsIndex);
                                chunkFlagsIndex++;
                            }

                            sAlignmentLine += sChunk.charAt(chunkFlagsIndex);

                            chunkFlagsIndex++;
                        }
                    } else { // Reverted case
                        for (let i = sLeft; i >= sRight; i--) {
                            while (sChunk.charAt(chunkFlagsIndex) === "-") {
                                sAlignmentLine += sChunk.charAt(chunkFlagsIndex);
                                chunkFlagsIndex++;
                            }
                            sAlignmentLine += sChunk.charAt(chunkFlagsIndex);
                            chunkFlagsIndex++;
                        }
                    }
                    line = line.replace(sChunk, sAlignmentLine);
                }
            }

            // put the alignment back together
            if (isCmWorkflow && isCmNoSeq) {
                // For CM workflow without query sequences, only display subject sequences
                if (subjectLine) {
                    newAlignment += line + "\n";
                    if (pendingCmLine) {
                        newAlignment += pendingCmLine + "\n";
                        pendingCmLine = null;
                    }
                }
            } else {
                newAlignment += line + "\n";
                if (subjectLine && pendingCmLine) {
                    newAlignment += pendingCmLine + "\n";
                    pendingCmLine = null;
                }
            }
        }
        if (isCmWorkflow && isCmNoSeq) { // Avoid the last query position wrongly truncated
            newAlignment += "\n";
        }

        // Remove the last "\n", and store it into $scope.gqAlignmentsNoSumm without the Variation Summary Table
        gqAlignmentsNoSumm[item['dbkey']] = newAlignment.substr(0, newAlignment.length - 2); //$sce.trustAsHtml(newAlignment.substr(0, newAlignment.length - 2));
        let obj = {};
        obj[item['dbkey']] = newAlignment.substr(0, newAlignment.length - 2)
            .replace(/<\/?span class='singletooltiptext'.[^>]*>/g, "").replace(/<\/?span class='tooltiptext'.[^>]*>/g, "")
            .replace(/'/g, '"').replace(/&nbsp;/g, "&#8254;");
        //.replace(/lva-hint/g, '').replace(/lva-bar/g, '').replace(/lva-left-end/g, '').replace(/lva-right-end/g, '').replace(/lva-no-ends/g, '').replace(/lva-bg-white/g, '');
        gqAlignmentsStrNoSumm.push(obj);

        const csvSeparator = ['',''].toLocaleString(); // -> ',' for US locale, ';' for some EU regions
        // For the CM Summary Table
        if (isCmWorkflow) {
            let gqAlignmentsSummArray = [];
            let alignmentTable = "<div class='clearfix lvm-summary-row'>";
            alignmentTable += createLVMSummCol("Subj. Pos.", true, true, true);
            if (!isCmNoSeq) {
                alignmentTable += createLVMSummCol("Query Pos.", true, true, true);
            }
            alignmentTable += createLVMSummCol("Orig. Base", true, true, true);
            alignmentTable += createLVMSummCol("Modification", true, true, false);
            alignmentTable += createLVMSummCol("Description", true, true, false);
            alignmentTable += createLVMSummCol("Modification type", true, true, false);
            alignmentTable += "</div>";
            let alignmentTableCsvString = "\"Subject position\"" + csvSeparator;
            if (!isCmNoSeq) {
                alignmentTableCsvString += "\"Query position\"" + csvSeparator;
            }
            alignmentTableCsvString += "\"Original Base\"" + csvSeparator + "Modification" + csvSeparator + "Description" + csvSeparator + "\"Modification type\"";
            let origBase, codeIntValue, colorKey, color, qPos;
            const subjectAllHitsForSummary = subjectAllHits.slice();
            if (subjectAllHitsForSummary.length > 1) {
                // Sort by query position asc
                subjectAllHitsForSummary.sort((a, b) => {
                    return parseInt(a.sPos) - parseInt(b.sPos);
                });
            }

            for (let index in subjectAllHitsForSummary) {
                alignmentTable += "<div class='clearfix lvm-summary-row'>";
                alignmentTable += createLVMSummCol(subjectAllHitsForSummary[index].sPos, false, true, true);
                if (!isCmNoSeq) {
                    qPos = subQueryPosMap.get(parseInt(subjectAllHitsForSummary[index].sPos)) ? subQueryPosMap.get(parseInt(subjectAllHitsForSummary[index].sPos)).pos : "-";
                    subjectAllHitsForSummary[index].qPos = qPos;
                    alignmentTable += createLVMSummCol(qPos, false, true, true);
                }
                /*if (!isNaN(item["SUBJECT_M2"][index].code)) {
                    codeIntValue = parseInt(item["SUBJECT_M2"][index].code);
                    colorKey = cmMap.has(codeIntValue) ? (getCmDisplay(cmMap, codeIntValue, filter.state.cmColorLevel)) : item["SUBJECT_M2"][index].base;
                } else {
                    codeIntValue = item["SUBJECT_M2"][index].sPos;
                    colorKey = item["SUBJECT_M2"][index].code;
                }*/
                if (subQueryPosMap.get(parseInt(subjectAllHitsForSummary[index].sPos))) {
                    color = getCmColor(cmMap, subjectAllHitsForSummary[index].code, cmColorMap, filter.state.cmColorLevel, subjectAllHitsForSummary[index].sPos);
                } else {
                    color = "";
                }
                origBase = '<span class="highlight-' + color + '">' + (subQueryPosMap.get(parseInt(subjectAllHitsForSummary[index].sPos)) ? subQueryPosMap.get(parseInt(subjectAllHitsForSummary[index].sPos)).base : "-") + "</span>";
                subjectAllHitsForSummary[index].origBase = subQueryPosMap.get(parseInt(subjectAllHitsForSummary[index].sPos)) ? subQueryPosMap.get(parseInt(subjectAllHitsForSummary[index].sPos)).base : "-";
                alignmentTable += createLVMSummCol(origBase, false, true, true); // Position sequence
                alignmentTable += createLVMSummCol(subjectAllHitsForSummary[index].base, false, true, false);
                alignmentTable += createLVMSummCol(subjectAllHitsForSummary[index].desc, false, true, false);
                alignmentTable += createLVMSummCol(subjectAllHitsForSummary[index].type, false, true, false);
                alignmentTable += "</div>";

                alignmentTableCsvString += "\r\n";
                alignmentTableCsvString += subjectAllHitsForSummary[index].sPos
                    + (isCmNoSeq ? "" : (csvSeparator + (subQueryPosMap.get(parseInt(subjectAllHitsForSummary[index].sPos)) ? subQueryPosMap.get(parseInt(subjectAllHitsForSummary[index].sPos)).pos : "-")))
                    + csvSeparator + (subQueryPosMap.get(parseInt(subjectAllHitsForSummary[index].sPos)) ? subQueryPosMap.get(parseInt(subjectAllHitsForSummary[index].sPos)).base : "-")
                    + csvSeparator + "\"" + subjectAllHitsForSummary[index].base + "\""
                    + csvSeparator + "\"" + subjectAllHitsForSummary[index].desc + "\""
                    + csvSeparator + "\"" + subjectAllHitsForSummary[index].type + "\"";

                gqAlignmentsSummArray.push(subjectAllHitsForSummary[index]);
            }
            let blob = new Blob([alignmentTableCsvString], {type: "text/csv;charset=utf-8;"});
            let fileURL = URL.createObjectURL(blob);
            //let fileName = state.fileName + ".csv";
            let fileName = item["SUBJECT_PN"] + (item["SUBJECT_SI"] ? "-" + item["SUBJECT_SI"].padStart(4, '0') : "") + "_Chemical Modifications" + ".csv";

            newAlignment += "<div class='lvm-summary-header-row'><div class='lvm-summary-link'><a download='" + fileName + "' href=\"" + fileURL + "\">" +
                "<span class='lvm-summary-link-label'>Download this table</span></a></div><div class='lvm-summary-header-label'>Chemical Modifications Summary Table</div></div>";
            newAlignment += alignmentTable;

            obj = {};
            obj[item['dbkey']] = gqAlignmentsSummArray;
            gqAlignmentsSumm.push(obj);
        }

        // For the Variation Summary Table
        if (hasLvaAccess && !isCmWorkflow) { // && !hasCrossSearch
            // Populates the alignment variations for current hints
            var hintIdx, markerIdx, markersSumm = [], markersSummIdx, duplicateMarker = false;
            for (hintIdx in hints.hints) {
                for (markerIdx in hints.hints[hintIdx].markersSumm) {
                    // Merge the marker summary and filter out the duplicate one
                    duplicateMarker = false;
                    for (markersSummIdx in markersSumm) {
                        if (markersSumm[markersSummIdx].description === hints.hints[hintIdx].markersSumm[markerIdx].description) {
                            duplicateMarker = true;
                            break;
                        }
                    }
                    if (!duplicateMarker) {
                        markersSumm.push(hints.hints[hintIdx].markersSumm[markerIdx]);
                    }
                }
            }
            let gqAlignmentsSummArray = [];
            if (markersSumm.length > 0) {
                // Sort the markersSumm by position
                markersSumm.sort(filter.compareMarkersSummPos);
                for (markersSummIdx in markersSumm) {
                    gqAlignmentsSummArray.push(markersSumm[markersSummIdx]);
                }
            }
            obj = {};
            obj[item['dbkey']] = gqAlignmentsSummArray;
            gqAlignmentsVariation.push(obj);

            // Gets the hints again and populates the alignment summary
            hints = filter.getAlignmentSummary(seqData);
            markersSumm = [];
            for (hintIdx in hints.hints) {
                for (markerIdx in hints.hints[hintIdx].markersSumm) {
                    // Merge the marker summary and filter out the duplicate one
                    duplicateMarker = false;
                    for (markersSummIdx in markersSumm) {
                        if (markersSumm[markersSummIdx].description === hints.hints[hintIdx].markersSumm[markerIdx].description) {
                            duplicateMarker = true;
                            break;
                        }
                    }
                    if (!duplicateMarker) {
                        markersSumm.push(hints.hints[hintIdx].markersSumm[markerIdx]);
                    }
                }
            }
            // Sort the markersSumm by position
            markersSumm.sort(filter.compareMarkersSummPos);
            gqAlignmentsSummArray = [];
            // Add the Variation Summary Table
            if (markersSumm.length > 0) {
                let alignmentTable = "<div class='clearfix lvm-summary-row'>";
                alignmentTable += createLVMSummCol("Query position", true);
                alignmentTable += createLVMSummCol("Variation type", true);
                alignmentTable += createLVMSummCol("Query", true);
                alignmentTable += createLVMSummCol("Subject", true);
                alignmentTable += createLVMSummCol("Description", true);
                alignmentTable += "</div>";
                let alignmentTableCsvString = "\"Query identifier: \"" + csvSeparator + "\"" + item['QUERY_ID'] + "\"";
                alignmentTableCsvString += "\r\n";
                alignmentTableCsvString += "\"Subject identifier: \"" + csvSeparator + "\"" + item['SUBJECT_ID'] + "\"";
                alignmentTableCsvString += "\r\n";
                alignmentTableCsvString += "\"Subject orientation: \"" + csvSeparator + ((item['RESULT_NFQ'] >= 3 && item['RESULT_NFQ'] <= 6) ? "Reverse" : "Forward");
                alignmentTableCsvString += "\r\n";
                alignmentTableCsvString += "\r\n";
                alignmentTableCsvString += "\"Variation Summary Table: \"";
                alignmentTableCsvString += "\r\n";
                alignmentTableCsvString += "\"Query position\"" + csvSeparator + "\"Variation type\"" + csvSeparator + "Query" + csvSeparator + "Subject" + csvSeparator + "Description";

                // Variation hits
                let vmHits = '';
                for (markersSummIdx in markersSumm) {
                    if (vmHits !== '') {
                        vmHits += ', ';
                    }
                    let vmLink = process.env.REACT_APP_URL + 'discover/' + resid + '/variation/'
                        + item['QUERY_ID'] + '/' + markersSumm[markersSummIdx].description + '(1)';
                    markersSumm[markersSummIdx].vmHits = '<a target="_blank" rel="noreferrer" href="' + vmLink + '">' + markersSumm[markersSummIdx].description + '</a>';
                    vmHits += markersSumm[markersSummIdx].vmHits;

                        //alignmentTable += "\n";
                    alignmentTable += "<div class='clearfix lvm-summary-row'>";
                    alignmentTable += createLVMSummCol(markersSumm[markersSummIdx].pos, false);
                    alignmentTable += createLVMSummCol(markersSumm[markersSummIdx].type, false);
                    alignmentTable += createLVMSummCol(markersSumm[markersSummIdx].qChunk, false);
                    alignmentTable += createLVMSummCol(markersSumm[markersSummIdx].sChunk, false);
                    alignmentTable += createLVMSummCol(markersSumm[markersSummIdx].description, false);
                    alignmentTable += "</div>";

                    alignmentTableCsvString += "\r\n";
                    alignmentTableCsvString += markersSumm[markersSummIdx].pos
                        + csvSeparator + markersSumm[markersSummIdx].type
                        + csvSeparator + markersSumm[markersSummIdx].qChunk
                        + csvSeparator + markersSumm[markersSummIdx].sChunk
                        + csvSeparator + "\"" + markersSumm[markersSummIdx].description + "\"";

                    gqAlignmentsSummArray.push(markersSumm[markersSummIdx]);
                }
                item['RESULT_VMH'] = vmHits;

                let blob = new Blob([alignmentTableCsvString], {type: "text/csv;charset=utf-8;"});
                let fileURL = URL.createObjectURL(blob);
                let fileName = state.fileName + ".csv";

                // <img src="img/download.png">
                newAlignment += "<div class='lvm-summary-header-row'><div class='lvm-summary-link'><a download='" + fileName + "' href=\"" + fileURL + "\"><span class='lvm-summary-link-label'>Download this table</span></a></div><div class='lvm-summary-header-label'>Variation Summary Table</div></div>";
                newAlignment += alignmentTable;
            } else {
                // Remove the last "\n"
                newAlignment = newAlignment.substr(0, newAlignment.length - 2);
            }

            obj = {};
            obj[item['dbkey']] = gqAlignmentsSummArray;
            gqAlignmentsSumm.push(obj);

        }

        // return colored alignment
        return newAlignment;
    }

    function getCmMarkerHtml(codes, position, cmColorLevel, hasHit, repeatCount = 1, stackSize = 0, lineLayers = [], maxLineLayerCount = 1, flipAlignment = flipCmAlign) {
        const markerClass = flipAlignment ? "cm-mod-marker cm-mod-marker-flipped" : "cm-mod-marker";
        const arrowGlyph = flipAlignment ? "&#9660;" : "&#9650;";
        let marker = "<span class='" + markerClass + "'>";

        const multiplicity = repeatCount > 0 ? repeatCount : 1;
        const codeList = Array.isArray(codes) ? codes : [];
        const squareHtml = [];
        for (let m = 0; m < multiplicity; m++) {
            for (let idx in codeList) {
                const code = codeList[idx];
                const color = getCmColor(cmMap, code, cmColorMap, cmColorLevel, position);
                const fullDisplay = !isNaN(code)
                    ? getCmDisplay(cmMap, parseInt(code, 10), 4)
                    : code;
                const tooltipAttr = fullDisplay ? " data-cm-tooltip='" + _.escape(fullDisplay) + "'" : "";
                squareHtml.push("<span class='cm-mod-square highlight-" + color + "'" + tooltipAttr + "></span>");
            }
        }

        const renderedSquares = squareHtml.length;
        const spacerCount = Math.max(0, stackSize - renderedSquares);
        const totalLineLayers = Math.max(1, maxLineLayerCount);
        const visibleLayers = new Set(Array.isArray(lineLayers) ? lineLayers : []);
        if (hasHit && visibleLayers.size === 0) {
            visibleLayers.add(0);
        }

        const appendLineLayers = () => {
            for (let layerIndex = 0; layerIndex < totalLineLayers; layerIndex++) {
                const layer = flipAlignment ? (totalLineLayers - 1 - layerIndex) : layerIndex;
                const showLayer = visibleLayers.has(layer);
                const arrowClass = hasHit && showLayer
                    ? 'cm-mod-arrow'
                    : 'cm-mod-arrow cm-mod-arrow-spacer';
                const barClass = showLayer
                    ? 'cm-mod-bottom-bar'
                    : 'cm-mod-bottom-bar cm-mod-bottom-bar-spacer';
                marker += "<span class='" + arrowClass + "'>" + arrowGlyph + "</span>";
                marker += "<span class='" + barClass + "'></span>";
            }
        };

        if (flipAlignment) {
            // With column-reverse, put spacers first and reverse square insertion so
            // visual order starts directly below arrows and fills downward first-to-last.
            for (let s = 0; s < spacerCount; s++) {
                marker += "<span class='cm-mod-square cm-mod-square-spacer'></span>";
            }
            for (let sq = squareHtml.length - 1; sq >= 0; sq--) {
                marker += squareHtml[sq];
            }
        } else {
            for (let s = 0; s < spacerCount; s++) {
                marker += "<span class='cm-mod-square cm-mod-square-spacer'></span>";
            }
            for (let sq = 0; sq < squareHtml.length; sq++) {
                marker += squareHtml[sq];
            }
            appendLineLayers();
        }

        if (flipAlignment) {
            appendLineLayers();
        }
        marker += "</span>";
        return marker;
    }

    function getCmRegionMarkerHtml(hasHit, stackSize = 0, lineLayers = [], maxLineLayerCount = 1, flipAlignment = flipCmAlign) {
        const markerClass = flipAlignment ? "cm-mod-marker cm-mod-marker-flipped" : "cm-mod-marker";
        const arrowGlyph = flipAlignment ? "&#9660;" : "&#9650;";
        let marker = "<span class='" + markerClass + "'>";

        const totalLineLayers = Math.max(1, maxLineLayerCount);
        const visibleLayers = new Set(Array.isArray(lineLayers) ? lineLayers : []);
        if (hasHit && visibleLayers.size === 0) {
            visibleLayers.add(0);
        }

        const appendLineLayers = () => {
            for (let layerIndex = 0; layerIndex < totalLineLayers; layerIndex++) {
                const layer = flipAlignment ? (totalLineLayers - 1 - layerIndex) : layerIndex;
                const showLayer = visibleLayers.has(layer);
                const arrowClass = hasHit && showLayer
                    ? 'cm-mod-arrow'
                    : 'cm-mod-arrow cm-mod-arrow-spacer';
                const barClass = showLayer
                    ? 'cm-mod-bottom-bar'
                    : 'cm-mod-bottom-bar cm-mod-bottom-bar-spacer';
                marker += "<span class='" + arrowClass + "'>" + arrowGlyph + "</span>";
                marker += "<span class='" + barClass + "'></span>";
            }
        };

        for (let s = 0; s < stackSize; s++) {
            marker += "<span class='cm-mod-square cm-mod-square-spacer'></span>";
        }

        if (!flipAlignment) {
            appendLineLayers();
        }

        if (flipAlignment) {
            appendLineLayers();
        }
        marker += "</span>";
        return marker;
    }

    function getCmColor(cmMap, cmCode, cmColorMap, cmColorLevel, randomVal) {
        let label, color;

        if (!isNaN(cmCode)) {
            label = getCmDisplay(cmMap, parseInt(cmCode), cmColorLevel);
        } else {
            label = cmCode;
        }
        if (cmColorMap.has(label)) {
            color = cmColorMap.get(label);
        } else if (label === "Fluorination") {
            color = highlightColors[7];
        } else if (label === "2'-O-Methylation") {
            color = highlightColors[6];
        } else {
            if (cmColorMap.has(label)) {
                color = cmColorMap.get(label);
            } else if (!isNaN(cmCode)) {
                color = highlightColors[parseInt(cmCode) % 14];
            } else {
                color = highlightColors[randomVal % 14];
            }
        }
        cmColorMap.set(label, color);
        return color;
    }

    function getCmDisplay(cmMap, code, cmColorLevel, levelOnly) {
        let display = code + "";
        if (!isNaN(code)) {
            const codeIntValue = parseInt(code);
            const cmEntry = cmMap && cmMap.get ? cmMap.get(codeIntValue) : null;
            if (cmEntry) {
                const classification = cmEntry.classification_UI;
                if (!classification || typeof classification !== 'string') {
                    return display;
                }
                const codes = classification.split('/');
                if (cmColorLevel === 1) {
                    display = codes[0];
                } else if (cmColorLevel === 2) {
                    display = (codes.length >=2 && codes[1] !== "") ? (levelOnly ? codes[1] : codes[0] + "/" + codes[1]) : codes[0];
                } else if (cmColorLevel === 3) {
                    if (codes.length >=3 && codes[2] === "") {
                        let tmp = cmEntry.base === "" ? cmEntry.modification : cmEntry.base;
                        display = levelOnly ? tmp : (codes[0] + "/" + codes[1] + "/" + tmp);
                    } else {
                        display = (codes.length >= 3 && codes[2] !== "") ?
                            (levelOnly ? codes[2] : codes[0] + "/" + codes[1] + "/" + codes[2]) :
                            (codes.length >= 2 && codes[1] !== "" ? (levelOnly ? codes[1] : codes[0] + "/" + codes[1]) : codes[0]);
                    }
                } else {
                    display = "";
                    if (cmEntry.base) {
                        display += cmEntry.base + " "
                    }
                    if (cmEntry.modification) {
                        display += cmEntry.modification + " "
                    }
                    if (cmEntry.Abbreviation) {
                        display += "(" + cmEntry.Abbreviation + ")"
                    }
                }
            }
        }
        return display;
    }

    function createLVMSummCol(value, isHeader, isCm = false, isSmaller = false) {
        if (isHeader) {
            if (isCm) {
                if (isSmaller) {
                    return "<div class='cm-summary-gqcol lvm-summary-sub-header cm-summary-gqcol-smaller'><span>" + value + "</span></div>";
                } else {
                    return "<div class='cm-summary-gqcol lvm-summary-sub-header cm-summary-gqcol-larger'><span>" + value + "</span></div>";
                }
            } else {
                return "<div class='lvm-summary-gqcol lvm-summary-sub-header '><span>" + value + "</span></div>";
            }
        } else if (isCm) {
            if (isSmaller) {
                return "<div class='cm-summary-gqcol cm-summary-gqcol-smaller'><div hover-delay='lvm-summary-gqcol-hover'><span>" + value + "</span></div></div>";
            } else {
                return "<div class='cm-summary-gqcol cm-summary-gqcol-larger'><div hover-delay='lvm-summary-gqcol-hover'><span>" + value + "</span></div></div>";
            }
        } else {
            return "<div class='lvm-summary-gqcol'><div hover-delay='lvm-summary-gqcol-hover'><span>" + value + "</span></div></div>";
        }
    }

    function initDocItems(item) {
        if (item.type === 'doc') {
            if (item.databases) {
                let dbId = getDefaultDatabaseId(item.dbkey, item.databases);
                docItems[item.dbkey] = item.databases[dbId];
                docItemsSelected[item.dbkey] = dbId;
            }
        } else {
            docItems[item.dbkey] = item;
        }
        setDocItems(docItems);
        setDocItemsSelected(docItemsSelected);
        // console.log(docItems[item.dbkey]);
    }

    function getDefaultDatabaseId(dbkey, databases) {
        let dbs = Object.keys(databases);
        if (fieldConfig.databasePrefs && fieldConfig.databasePrefs.length > 0) {
            for (let i = 0; i < fieldConfig.databasePrefs.length; i++) {
                for (let j = 0; j < dbs.length; j++) {
                    if (getPrefName(dbs[j]) === fieldConfig.databasePrefs[i]) {
                        return dbs[j];
                    }
                }
            }
        } else {
            // No preference settings, default as GQ-Pat
            const names = ['GQPAT_NUC', 'GQPAT_PRT', 'GQPAT_PREMIUM_PRT', 'GQPAT_PREMIUM_NUC', 'GENBANK_GQPAT_NUC', 'GENBANK_GQPAT_PRT']
            for (let i = 0; i < names.length; i++) {
                if (databases[names[i]]) {
                    return names[i];
                }
            }
        }

        return dbs[0];
    }

    function getPrefName(dbId) {
        let name = fieldConfig.patentDatabases[dbId];
        if (name) {
            return name;
        } else {
            return dbId;
        }
    }

    function prepDatabases(resInfo) {
        //databasesForDed = {};
        let dbId, databases = {};
        _.forEach(
            resInfo.databases,
            function (SUBJECT_GNAME) {
                dbId = _.split(SUBJECT_GNAME, ':')[0];
                databases[dbId] = fieldConfig.getDatabaseBriefName(SUBJECT_GNAME);
                if (fieldConfig.isPatentDatabase(SUBJECT_GNAME)) {
                    let id = getPrefName(dbId);
                    databasesForDed[id] = fieldConfig.getPatentDatabaseLabel(id);
                }

                if (dbId.indexOf("CASNP") === 0 || dbId.indexOf("REGNP") === 0) {
                    //hasRegNp = true;
                    setHasRegNp(true);
                }
            }
        );
        setDataBasesForDed(databasesForDed);
        return databases;
    }

     // prepare group filter (show all PNs that hit at least three different query sequences)
     //groupQuery = {};
     function ApplyGroupQuery(fieldId, nbseqs){
        if (fieldId === 'TOTAL') {
            groupQuery = {};
        } else {
            groupQuery = {
                GROUP_BY: fieldId,
                GROUP_CONCAT: 'RESULT_NQ',
                METHOD: 'NBVALS',
                NBVALS: nbseqs
            };
        }
        setGroupQuery(groupQuery);
        loadResultsFromBackend(true);
     }

    function expandAllDetailPage(displayMode, type, value) {
        if (displayMode === 'family') {
            if (type === 'fam' || type === 'ufs') {
                detailPageCollapseAllLevelOne = value;
                setDetailPageCollapseAllLevelOne(detailPageCollapseAllLevelOne);
            } else if (type === 'doc') {
                detailPageCollapseAllLevelTwo = value;
                setDetailPageCollapseAllLevelTwo(detailPageCollapseAllLevelTwo);
            } else {
                detailPageCollapseAllLevelThree = value;
                setDetailPageCollapseAllLevelThree(detailPageCollapseAllLevelThree);
            }
        } else if (displayMode === 'ufs') {
            if (type === 'ufs') {
                detailPageCollapseAllLevelOne = value;
                setDetailPageCollapseAllLevelOne(detailPageCollapseAllLevelOne);
            } else if (type === 'fam') {
                detailPageCollapseAllLevelTwo = value;
                setDetailPageCollapseAllLevelTwo(detailPageCollapseAllLevelTwo);
            } else {
                detailPageCollapseAllLevelThree = value;
                setDetailPageCollapseAllLevelThree(detailPageCollapseAllLevelThree);
            }
        } else if (displayMode === 'document' || displayMode === 'cas' || displayMode === 'ssv'
            || displayMode === 'qs' || displayMode === 'hsp' || displayMode === 'org'
            || displayMode === 'ali' || displayMode === 'npa' || displayMode === 'aipa' || displayMode === 'gname' || displayMode === 'gqid' || displayMode === 'extpf' || displayMode === 'sid') {
            if (type === 'doc' || type === 'cas' || type === 'ssv' || type === 'qs' || type === 'hsp'
                || type === 'ali' || type === 'npa' || type === 'aipa' || type === 'gname' || type === 'gqid' ||type === 'org' || type === 'extpf' || type === 'sid') {
                detailPageCollapseAllLevelOne = value;
                setDetailPageCollapseAllLevelOne(detailPageCollapseAllLevelOne);
            } else {
                detailPageCollapseAllLevelTwo = value;
                setDetailPageCollapseAllLevelTwo(detailPageCollapseAllLevelTwo);
            }
        } else {
            detailPageCollapseAllLevelOne = value;
            setDetailPageCollapseAllLevelOne(detailPageCollapseAllLevelOne);
        }
    }

    function expandAllClaims(val) {
        claimsCollapseAll = val;
        setClaimsCollapseAll(val);
    }

    function expandAllAlignments(val) {
        alignmentsCollapseAll = val;
        setAlignmentsCollapseAll(val);
    }

    function switchView(viewName, fieldConfig, filter, editable, isCasCm) {
        fieldConfig.selectView(fieldConfig, viewName, filter, editable, isCasCm);
        let displayMode = 'flat';
        if (viewName === 'default') {
            displayMode = fieldConfig.tableDisplayMode;
        } else if (viewName === 'defaultAli' || viewName === 'defaultCm') {
            displayMode = 'flat';
        } else if (viewName === 'defaultFt') {
            displayMode = 'document';
        }  else if (viewName === 'defaultFam') {
            displayMode = 'family';
        } else if (viewName === 'defaultSsv') {
            displayMode = 'ssv';
        } else if (!fieldConfig.views[viewName]) { // For delete case
            return;
        } else if (fieldConfig.views[viewName].hasOwnProperty('tableDisplayMode')) {
            displayMode = fieldConfig.views[viewName].tableDisplayMode;
        }
        if (displayMode !== fieldConfig.tableDisplayMode) {
            // Reload the page because of the change of display mode
            // Will call saveResultState() in loadResultsFromBackend()
            fieldConfig.tableDisplayMode = displayMode;
            selectedGroupOption = displayMode;
            setSelectedGroupOption(displayMode);
            // Auto-enable/disable full subject sequence fetch based on Extended Alignment column in target mode
            const allCols = Object.values(fieldConfig.userTableTemplate).flat();
            const hasExtGQAlignment = allCols.includes('RESULT_EXTENDED_ALI');
            if (hasExtGQAlignment && !includeSubjectSeq) {
                setIncludeSubjectSeq(true);
            } else if (!hasExtGQAlignment && includeSubjectSeq) {
                setIncludeSubjectSeq(false);
            }
            loadResultsFromBackend(false);
        } else {
            if (editable === true) {
                saveResultState(filter, fieldConfig);
            }

            searchResultData.columns = fieldConfig.userTableTemplate['flat'];
            searchResultData.tableWidth = fieldConfig.estimateTableWidth(fieldConfig.userTableTemplate, fieldConfig.tableDisplayMode);
            // Auto-enable/disable full subject sequence fetch based on Extended Alignment column in current mode
            const allCols = Object.values(fieldConfig.userTableTemplate).flat();
            const hasExtGQAlignment = allCols.includes('RESULT_EXTENDED_ALI');
            if (hasExtGQAlignment && !includeSubjectSeq) {
                setIncludeSubjectSeq(true);
            } else if (!hasExtGQAlignment && includeSubjectSeq) {
                setIncludeSubjectSeq(false);
            }
            setSearchResultData({...searchResultData});
        }
        resultTableRef.current.closeSidePanel();
    }

    function loadResultsFromBackend(loadStatisticInfo) {
        if (pnListErr && pnListErr !== '') {
            return;
        }

        UIlog.record(resid, 'APPLY_BUTTON', 'pressed');
        setApplyEnabled(false);
        state.currentPage = 1;
        setCurrentPage(1);
        //self.gqtour.end();
        if (editable === true) {
            saveResultState(filter, fieldConfig);
        }
        if (loadStatisticInfo) {
            loadStatistic(resInfo);
        }
        fetchResultsNow();
        //fieldConfig.estimateTableWidth();

        setAbFilters(previewABReport());
    }

    function showColumnConfigModal(viewName) {
        // yet to set field config attributes for view names
        if (editable !== true) {
            return;
        }

        setTempTemplate(JSON.parse(JSON.stringify(fieldConfig.userTableTemplate)));
        if (viewName !== 'new') {
            fieldConfig.userTableTemplate = fieldConfig.views[viewName];
            fieldConfig.newViewName = viewName;
            // The user can rename in the modal; remember what they started from so a
            // share can follow the rename instead of being stranded on the old name.
            fieldConfig.editingViewName = viewName;
        }
        else {
            fieldConfig.newViewName = "";
            fieldConfig.editingViewName = '';
        }
        setAddDisplayColumnShow(true)
    }
    // Open the "Share <view>" popup for one of the user's own saved views.
    async function showShareViewModal(viewName) {
        if (editable !== true) {
            return;
        }
        setShareViewName(viewName);
        setShareViewUsers([]);
        setShareViewEntityShared(false);
        setShareViewShow(true);
        await loadShareViewRoster(viewName);
    }

    // Views are not tied to a workflow, so this roster is the whole entity - unlike the
    // "Share these Results" one, which hides people the workflow is already shared with.
    // It also marks who already has this view.
    const loadShareViewRoster = async (viewName) => {
        try {
            const results = await sharedViews.shareableUsers(viewName);
            if (results && results.response_status == 0 && results.response_content) {
                setShareViewUsers(results.response_content.users || {});
                setShareViewEntityShared(!!results.response_content.entity_shared);
            }
        } catch (error) {
            console.log("error::", error);
        }
    }

    const removeShareViewRecipient = async (receiverId) => {
        const viewName = shareViewName;
        try {
            await sharedViews.removeRecipient(viewName, receiverId);
        } catch (error) {
            console.log("error::", error);
        }
        await loadShareViewRoster(viewName);
        // Dropping the last recipient deletes the share, so re-read which of our views
        // still have any - saveView/deleteView key off that.
        await fieldConfig.loadSharedByMe(fieldConfig);
    }

    const closeShareViewModal = () => {
        setShareViewShow(false);
        setShareViewName('');
    }

    const shareView = async (shareData) => {
        try {
            const response = await sharedViews.shareView(shareData.viewName,
                                                         fieldConfig.views[shareData.viewName],
                                                         shareData.scope,
                                                         shareData.userIds);
            if (response && response.response_status == 0) {
                toast.success('"' + shareData.viewName + '" shared.');
                // It now has recipients, so later edits must be pushed to them.
                fieldConfig.sharedByMeNames[shareData.viewName] = true;
            } else {
                // Prefer the server's reason ("view name is too long to share", ...)
                // over a generic failure the user cannot act on.
                const reason = response && response.response_content && response.response_content.message;
                toast.error(reason || ('Could not share "' + shareData.viewName + '".'));
            }
        } catch (error) {
            console.log("error::", error);
            toast.error('Could not share "' + shareData.viewName + '".');
        }
        closeShareViewModal();
    }

    const closeFolderModal = () => {
        setAddDisplayColumnShow(false);
    }

    const saveViews = () => {
        fieldConfig.views = {...fieldConfig.views};
        fieldConfig.viewKeys = [...fieldConfig.viewKeys];
        setViewKeys([...fieldConfig.viewKeys]);
        // Saving a view under a name a shared view held moves that shared view to
        // another key, so the Shared Views list has to be re-read too.
        setSharedViewKeys([...fieldConfig.sharedViewKeys]);
    }

    const cancelDispModal = () => {
        fieldConfig.userTableTemplate = tempTemplate;
        searchResultData.columns = fieldConfig.userTableTemplate[fieldConfig.tableDisplayModeFromView];
       

    }
    const handleColumns = () => {
        searchResultData.columns = fieldConfig.userTableTemplate[fieldConfig.tableDisplayModeFromView];
        searchResultData.tableWidth = fieldConfig.estimateTableWidth(fieldConfig.userTableTemplate, fieldConfig.tableDisplayMode);
        // Auto-enable/disable full subject sequence fetch based on Extended Alignment column in current mode
        const allCols = Object.values(fieldConfig.userTableTemplate).flat();
        const hasExtGQAlignment = allCols.includes('RESULT_EXTENDED_ALI');
        if (hasExtGQAlignment && !includeSubjectSeq) {
            setIncludeSubjectSeq(true);
        } else if (!hasExtGQAlignment && includeSubjectSeq) {
            setIncludeSubjectSeq(false);
        }
        setSearchResultData({...searchResultData});
    }

    const smartHighlightGetOptions = (e, filter, text) => {
        setSmartHighlightText(text);
        filter.state.smartHighlight = text;
        if (!hlFilterSearching || hlFilterSearching === _NOT_SEARCHING) {
            smartHighlightGetOptionsBackendBfql(e, filter, text);
        }
    }

    async function smartHighlightGetOptionsBackendBfql(e, filter, val) {
        let text = val;
        if (text && text.length >= minSmartTextLen) {
            let data = {
                workflowId: resid.match(/\d+/)[0],
                userId: userdir ? userdir : window.$javaCall.data.userId,
                searchValue: text
            }
            let response = await DiscoverService.searchText(data, window.$javaCall.data.gqApiKey);
            if (response) {
                //if (text !== smartHighlightText) {
                    //callAgain = true;
                //}
                let highlightOptions = [];
                _.each(response.fields, function (key, val) {
                    highlightOptions.push({
                        key: key,
                        count: 1,
                        text: text
                    });
                });
                
                // Add QUERY_ID only if the search text matches any Query ID in querySeqIds
                const searchTextLower = text.toLowerCase();
                let matchingQueryIds = [];
                
                Object.keys(querySeqIds).forEach(key => {
                    const queryId = querySeqIds[key].id.toLowerCase();
                    if (queryId.includes(searchTextLower)) {
                        matchingQueryIds.push(querySeqIds[key].id);
                    }
                });
                
                if (matchingQueryIds.length > 0 && !_.find(highlightOptions, {key: 'QUERY_ID'})) {
                    highlightOptions.unshift({
                        key: 'QUERY_ID',
                        count: 1,
                        text: text,
                        matchingIds: matchingQueryIds // Store matching IDs for reference
                    });
                }
                
                setSmartHighlightPopup(true);
                setHlFilterSearching(_NOT_SEARCHING);
                if (_.size(highlightOptions) > 0) {
                    setSmartHighlightOptions(highlightOptions);
                } else {
                    setSmartHighlightOptions([]);
                }
                //document.getElementById("hlText").focus();
                //if (callAgain) {
                    //smartHighlightGetOptions(e, filter, text);
                //}
            } else {
                setSmartHighlightPopup(false);
                setSmartHighlightOptions([]);
            }
        } else {
            setSmartHighlightPopup(false);
            setSmartHighlightOptions([]);
        }
    }

    function addSmartHighlight(resultFilter, field) {
        let text, existingEntry, splitted, filter;
        resultFilter.state.smartHighlight = smartHighlightText;
        text = resultFilter.state.smartHighlight;
        filter = {...smartHighlightFilter};
        if (!filter) {
            filter = {};
        }
        if (text.length >= minSmartTextLen) {
            if (!(field in filter)) {
                filter[field] = [];
            }
            // check for redundant entries
            existingEntry = _.find(filter[field], function (obj) {
                return (obj.text === text);
            });
            if (existingEntry !== undefined) {
                // the entry already exists, check the checkbox
                existingEntry.value = true;
            } else {
                // split on whitespace, but respect phrases in single or double quotes
                splitted = text.match(/"([^"]*)"|'([^']*)'|[^\s]+/g);
                // remove quotes from the splitted phrases
                // for (j = 0; j < splitted.length; j++) {
                //     splitted[j] = splitted[j].replace(/["']/g, '');
                // }

                // collect used colors
                const usedColors = new Set();
                Object.keys(filter).forEach(fld => {
                    const highlights = filter[fld];
                    if (Array.isArray(highlights)) {
                        highlights.forEach(item => {
                            if (item && item.color !== undefined) {
                                usedColors.add(item.color);
                            }
                        });
                    } else if (typeof highlights === 'object' && highlights !== null) {
                        Object.values(highlights).forEach(item => {
                            if (item && item.color !== undefined) {
                                usedColors.add(item.color);
                            }
                        });
                    }
                });

                let newColorIndex;
                if (usedColors.size < highlightColors.length) {
                    // still have unused colors → pick the smallest unused index
                    for (let i = 0; i < highlightColors.length; i++) {
                        if (!usedColors.has(i)) {
                            newColorIndex = i;
                            break;
                        }
                    }
                } else {
                    // all colors used → cycle based on total highlights so far
                    const totalHighlights = Object.keys(filter).reduce((count, fld) => {
                        const highlights = filter[fld];
                        return count + (Array.isArray(highlights) ? highlights.length : Object.keys(highlights).length);
                    }, 0);
                    newColorIndex = totalHighlights % highlightColors.length;
                }

                UIlog.record(resid, 'HIGHLIGHT', field);
                filter[field].push({
                    text: text,
                    value: true,
                    negate: false,
                    color: newColorIndex,
                    match: splitted,
                    source: 'highlight'
                });
            }
        }
        resultFilter.state.smartHighlightFilter = filter;
        setSmartHighlightFilter(filter);
        // hide the smart text autocomplete UI
        setSmartHighlightPopup(false);
        // clear the highlight text input
        setSmartHighlightText('');
        if (editable === true) {
            // Pass resultFilter: the local "filter" is only the highlight map, and saving it stored an empty resultFilterState
            saveResultState(resultFilter, fieldConfig); // save changes to highlighting
        }
    }

    function addKeyWordsInContext(resultFilter) {
        let filter = {...resultFilter.state.smartHighlightFilter};

        let fieldRay = [];
        let selected = resultFilter.state.customFilterCheckboxes
        let defaultSize = resultFilter.widgetState.defaultCustomFilters.length;

        for( let i = 0; i < selected.length; i++){

            if(selected[i] !== undefined){
                if(selected[i]){

                    let widgContent = undefined;
                    if(i >= defaultSize){
                        widgContent = resultFilter.widgetState.customFilters[i - defaultSize].widgetContent;
                    }else{
                        widgContent = resultFilter.widgetState.defaultCustomFilters[i].widgetContent;
                    }

                    if(Array.isArray(widgContent)){
                        for( let k = 0; k < widgContent.length; k++){
                            if(widgContent[k].keyWords !== null && widgContent[k].keyWords !== undefined){
                                if(Array.isArray(widgContent[k].keyWords )){
                                    fieldRay = fieldRay.concat(widgContent[k].keyWords);
                                }
                            }
                        }
                    }
                }
            }
        }

        fieldRay = [...new Set(fieldRay)];
        fieldRay = fieldRay.filter(item => item !== null && item !== undefined);
        
        addHighlightsToKW(fieldRay)

        if(Array.isArray(fieldRay)){
            for(let i =0; i< fieldRay.length; i++){
            if(fieldRay[i] != undefined && fieldRay[i] != null){
                let existingEntry, splitted;
                

                if (!filter) {
                    filter = {};
                }
                if (fieldRay[i].length >= minSmartTextLen) {
                    if (!("ALL_TEXT" in filter)) {
                        filter["ALL_TEXT"] = [];
                    }
                    // check for redundant entries
                    existingEntry = _.find(filter["ALL_TEXT"], function (obj) {
                        return (obj.text === fieldRay[i]);
                    });
                    if (existingEntry === undefined) {

                        splitted = fieldRay[i].match(/"([^"]*)"|'([^']*)'|[^\s]+/g);
                        
                        UIlog.record(resid, 'HIGHLIGHT', "ALL_TEXT");
                        filter["ALL_TEXT"].push({
                            text: fieldRay[i],
                            value: true,
                            negate: false,
                            color: 1,
                            match: splitted,
                            source: 'highlight'
                        });
                    }
                }
            }
          }
        }

        resultFilter.state.smartHighlightFilter = filter;
        setSmartHighlightFilter(filter);
        if (editable === true) {
            // Correct the logic for resultFilter & fieldConfig
            saveResultState(resultFilter, fieldConfig);
        }

        setUpdateKWs(!updateKWs)
    }

    const addHighlightsToKW = (keywords) => {

        if(keywords){
            if(Array.isArray(keywords)){
                if(keywords.length > 0){

                    let savedValue = localStorage.getItem("keywords");
                    if(savedValue !== null){
                        savedValue = JSON.parse(savedValue)
                    }else{
                        savedValue = [];
                    }
            
                    for(let i =0; i< keywords.length; i++){
                        
                        let termIsSaved = false;

                        for(let k =0; k< savedValue.length; k++){
                            if(savedValue[k].term == keywords[i]){
                                termIsSaved = true;
                            }
                        } 

                        if(!termIsSaved){ //if not saved
                            let newTerm = {
                                color: "FFA726",
                                synonyms: [],
                                taxonomy: "",
                                term: keywords[i]
                            }

                            savedValue.push(newTerm)

                        }
                    }

                    let keystring = JSON.stringify(savedValue);
                    localStorage.setItem("keywords", keystring)
                }
            }
        }
    }


    const toggleSideMenuDetail = (sideMenuItem) => {
        if (sideMenuDetail) {// Wait for the initialization
            sideMenuDetail[sideMenuItem] = sideMenuDetail[sideMenuItem] ? false : true;
            setSideMenuDetail({...sideMenuDetail});
        }
    }

    function setHighlightCheckbox() {
        setSmartHighlightFilter({...smartHighlightFilter});
        filter.state.smartHighlightFilter = {...smartHighlightFilter};
        filter.state = {...filter.state};
        if (editable === true) {
            saveResultState(filter, fieldConfig); // save changes to highlighting
        }
        enableApplyButton();
    }

    

    function removeSmartHighlight(filter, field, idx) {
        console.log(field + '-' + filter.state.smartHighlightFilter[field]);
        filter.state.smartHighlightFilter[field].splice(idx, 1);
        console.log(smartHighlightFilter[field]);
        //smartHighlightFilter[field].splice(idx, 1);
    }

    const smartHighlightFilterEvent = (index, val) => {
        let finalData = [...smartHighlightFilterHover];
        finalData[index] = val;
        setSmartHighlightFilterHover(finalData);
    }
    const showHighlightColorBox = (index, val) => {
        highlightColorBox[index] = val;
        setHighlightColorBox({...highlightColorBox});
    }

    function selectHighlightColor(index, subIdx, color) {
        // Update the color
        smartHighlightFilter[index][subIdx].color = color;
        setSmartHighlightFilter({...smartHighlightFilter});
        // Close the color selection box
        highlightColorBox[index + '_' + subIdx] = false;
        setHighlightColorBox({...highlightColorBox});
        filter.state.smartHighlightFilter = {...smartHighlightFilter};
        if (editable === true) {
            saveResultState(filter, fieldConfig); // save changes to highlighting
        }
    }

    function clearHighlights() {
        if (editable !== true) {
            return;
        }
        setSmartHighlightText('');
        filter.state.smartHighlight = '';
        smartHighlightFilter= {};
        setSmartHighlightFilter({...smartHighlightFilter});
        filter.state.smartHighlightFilter = {...smartHighlightFilter};
        // Mark that user explicitly cleared QUERY_ID auto-highlights
        filter.state.queryIdHighlightsCleared = true;
        if (editable === true) {
            saveResultState(filter, fieldConfig); // save changes to highlighting
        }
    }

    function handleSideMenu(){
        if(sideMenuCollapse){
        setSideMenuCollapse(false);}
        else{
            setSideMenuCollapse(true);
        }
    }

    function handleMenuwithSidePanelOpen(){
        setSideMenuCollapse(true);
    }

     function handleMenuwithSidePanelClose(){
        setSideMenuCollapse(false);
    }

    function handleDedup(resultFilter){
        setDeduplication(!deduplication);
        filter.state.deduplication = !deduplication;
        if (!dedDatabasePrefs || dedDatabasePrefs.length === 0) {
            let dedDatabasePrefs = [];
            dedDatabasePrefs.push('GQPat'); // Keeps GQPat as the first choice
            resultFilter.dbs.forEach(function (value) {
                let name = getPrefName(value);
                if (dedDatabasePrefs.length === 0 || dedDatabasePrefs.indexOf(name) < 0) {
                    dedDatabasePrefs.push(name);
                }
            });
            setDedDatabasePrefs(dedDatabasePrefs);
            filter.state.dedDatabasePrefs = dedDatabasePrefs;
        }
        loadResultsFromBackend(true);
    }

    function handleChartMenu(){
        setMultiQuerySeqMenu(false);
        if(chartMenu){
            setChartMenu(false);}
        else{
            setChartMenu(true);
        }
    }

    function handleMulti(field,nbseqs){
        ApplyGroupQuery(field,nbseqs);
    }

    function handleMultiQuerySeqMenu(){
        setChartMenu(false);
        if(multiQuerySeqMenu){
            setMultiQuerySeqMenu(false);}
        else{
            setMultiQuerySeqMenu(true);
        }
    }

    const closePopover = () => {
        setAnchorEl(null);
        setSmartHighlightPopup(false);
        setFilterAnchorEl(null);
        setSmartTextPopup(false);
    }

    function saveEsfGrouping(fieldConfig, selectedGroupOption, option1, option2, groupSize, groupSizeOper, groupFilters) {
        const hadGroupSizeFilter = hasGroupSizeFilter(fieldConfig);
        // The plain Grouping menu passes no filters. Re-applying the current grouping from it, to change how
        // many results it shows, keeps the Advanced dialog's filters.
        const keepGroupFilters = groupFilters === undefined && selectedGroupOption === fieldConfig.tableDisplayMode;
        if (!keepGroupFilters) {
            // A group filter belongs to the grouping it was built for. Clear it up front so switching
            // grouping from the plain menu cannot carry a stale filter into a view that would still apply it.
            fieldConfig.groupFilters = undefined;
            fieldConfig.groupFilterType = undefined;
            fieldConfig.groupFilterMatchType = undefined;
            fieldConfig.groupFilterValue = undefined;
        }
        let displayMode = fieldConfig.tableDisplayMode;
        let newMode = selectedGroupOption;
        let viewName = fieldConfig.currentView;
        // Reset the collapse settings
        setDetailPageCollapseAllLevelOne(false);
        setDetailPageCollapseAllLevelTwo(false);
        setDetailPageCollapseAllLevelThree(false);

        // Change the view name to default when switching the grouping
        if (viewName && viewName !== 'default' && newMode !== displayMode) {
            fieldConfig.currentView = 'default';
        }
        if (newMode !== displayMode) {
            if (newMode === 'ssv') {
                // Change the default display column list
                fieldConfig.userTableTemplate["sin"] = ["QUERY_ID", "RESULT_RIQ", "RESULT_RID", "RESULT_RL", "RESULT_RI"];
            } else if (displayMode === 'ssv') {
                // Change back to the default display column list
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_SI", "QUERY_ID", "RESULT_RL", "RESULT_RIQ", "SUBJECT_PS"];
            }

            if (newMode === 'document') {
                fieldConfig.userTableTemplate["doc"] = ["SUBJECT_PN", "SUBJECT_PG", "SUBJECT_D1", "SUBJECT_D4", "SUBJECT_PU", "VT_FT", "SUBJECT_PT"];
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_ID", "QUERY_ID", "RESULT_RIQ", "RESULT_RID", "SUBJECT_PS"];
            } else if (newMode === 'ufs') {
                fieldConfig.userTableTemplate["ufs"] = ['UFS_DISPLAY', 'SUBJECT_PJ'];
                fieldConfig.userTableTemplate["flat"] = ["SUBJECT_ID", "QUERY_ID", "SUBJECT_PN", "SUBJECT_PG", "SUBJECT_PU", "VT_FT", "SUBJECT_PT",
                                                        "RESULT_RIQ", "RESULT_RID", "SUBJECT_PS", "SUBJECT_D1", "SUBJECT_D4"];
            } else if (newMode === 'qs') {
                // Change the default display column list, remove the QUERY_ID since it is in the grouped level
                fieldConfig.userTableTemplate["qs"] = ["QUERY_ID", "QUERY_L"];
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_ID", "QUERY_ID", "SUBJECT_PN", "SUBJECT_PG", "SUBJECT_PU", "VT_FT", "SUBJECT_PT",
                                                        "RESULT_RIQ", "RESULT_RID", "SUBJECT_PS", "SUBJECT_D1", "SUBJECT_D4"];
            } else if (newMode === 'hsp') {
                // Change the default display column list, remove the QUERY_ID since it is in the grouped level
                fieldConfig.userTableTemplate["hsp"] = ["QUERY_ID", "SUBJECT_ID", "QUERY_L"];
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_PA", "SUBJECT_PT", "SUBJECT_PG", "RESULT_COV", "RESULT_RIQ", "RESULT_RID", "RESULT_RL", "RESULT_RI"];
            } else if (newMode === 'gname') {
                fieldConfig.userTableTemplate["gname"] = ["SUBJECT_GNAME"];
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_ID", "QUERY_ID", "SUBJECT_PN", "SUBJECT_PG", "SUBJECT_PU", "VT_FT", "SUBJECT_PT",
                                                        "RESULT_RIQ", "RESULT_RID", "SUBJECT_PS", "SUBJECT_D1", "SUBJECT_D4"];
            } else if (newMode === 'gqid') {
                fieldConfig.userTableTemplate["gqid"] = ["SUBJECT_GX"];
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_ID", "QUERY_ID", "SUBJECT_PN", "SUBJECT_PG", "SUBJECT_PU", "VT_FT", "SUBJECT_PT",
                                                        "RESULT_RIQ", "RESULT_RID", "SUBJECT_PS", "SUBJECT_D1", "SUBJECT_D4"];
            }else if (newMode === 'extpf') {
                fieldConfig.userTableTemplate["extpf"] = ["SUBJECT_XF"];
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_ID", "QUERY_ID", "SUBJECT_PN", "SUBJECT_PG", "SUBJECT_PU", "VT_FT", "SUBJECT_PT",
                                                        "RESULT_RIQ", "RESULT_RID", "SUBJECT_PS", "SUBJECT_D1", "SUBJECT_D4"];
            }else if (newMode === 'npa') {
                fieldConfig.userTableTemplate["npa"] = ["SUBJECT_PU", "SUBJECT_PA"];
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_ID", "QUERY_ID", "SUBJECT_PN", "SUBJECT_PG", "SUBJECT_PU", "VT_FT", "SUBJECT_PT",
                                                        "RESULT_RIQ", "RESULT_RID", "SUBJECT_PS", "SUBJECT_D1", "SUBJECT_D4"];
            } else if (newMode === 'aipa') {
                fieldConfig.userTableTemplate["aipa"] = ["SUBJECT_ZF"];
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_ID", "QUERY_ID", "SUBJECT_PN", "SUBJECT_PG", "SUBJECT_PU", "VT_FT", "SUBJECT_PT",
                                                        "RESULT_RIQ", "RESULT_RID", "SUBJECT_PS", "SUBJECT_D1", "SUBJECT_D4"];
            } else if (newMode === 'org') {
                fieldConfig.userTableTemplate["org"] = ["SUBJECT_OS", "SUBJECT_OO", "SUBJECT_OX", "SUBJECT_OC"];
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_ID", "QUERY_ID", "SUBJECT_PN", "SUBJECT_PG", "SUBJECT_PU", "VT_FT", "SUBJECT_PT",
                                                        "RESULT_RIQ", "RESULT_RID", "SUBJECT_PS", "SUBJECT_D1", "SUBJECT_D4"];
            } else if (newMode === 'ali') {
                fieldConfig.userTableTemplate["ali"] = ["ALIGN_DESC"];
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_ID", "QUERY_ID", "SUBJECT_PN", "SUBJECT_PG", "SUBJECT_PU", "VT_FT", "SUBJECT_PT",
                                                        "RESULT_RIQ", "RESULT_RID", "SUBJECT_PS", "SUBJECT_D1", "SUBJECT_D4"];
            } else if (newMode === 'sid') {
                fieldConfig.userTableTemplate["sid"] = ["SUBJECT_ID"];
                fieldConfig.userTableTemplate["sin"] = ["SUBJECT_ID", "QUERY_ID", "SUBJECT_PN", "SUBJECT_PG", "SUBJECT_PU", "VT_FT", "SUBJECT_PT",
                                                        "RESULT_RIQ", "RESULT_RID", "SUBJECT_PS", "SUBJECT_D1", "SUBJECT_D4"];
            } else if (displayMode === 'qs' || displayMode === 'hsp' || displayMode === 'ali' || displayMode === 'npa' || displayMode === 'aipa'
                        || displayMode === 'gname' || displayMode === 'gqid' || displayMode === 'org' || displayMode === 'extpf' || displayMode === 'sid') {
                // Change back to the default display column list
                fieldConfig.userTableTemplate["sin"] = ["QUERY_ID", "RESULT_RIQ", "RESULT_RID", "RESULT_RL", "RESULT_RI"];
            }
        }

        if (newMode === 'family') {
            fieldConfig.famViewOption = getViewOption(option1);
            fieldConfig.famViewAliOption = getViewOption(option2);
            viewOptions.selectedFamViewOption = getViewOption(option1);
            viewOptions.selectedFamViewAliOption = getViewOption(option2);
        } else if (newMode === 'document') {
            fieldConfig.pnViewOption = getViewOption(option1);
            viewOptions.selectedPnViewOption = getViewOption(option1);
        } else if (newMode === 'ssv') {
            fieldConfig.ssvOption = getViewOption(option1);
            viewOptions.selectedSsvOption = getViewOption(option1);
        } else if (newMode === 'ufs') {
            fieldConfig.ufsOption = getViewOption(option1);
            viewOptions.selectedUfsOption = getViewOption(option1);
        } else if (newMode === 'qs') {
            fieldConfig.qsOption = getViewOption(option1);
            viewOptions.selectedQsOption = getViewOption(option1);
        } else if (newMode === 'hsp') {
            fieldConfig.hspOption = getViewOption(option1);
            viewOptions.selectedHspOption = getViewOption(option1);
        } else if (newMode === 'ali' || newMode === 'npa' || newMode === 'aipa' || newMode === 'gname' || newMode === 'gqid' || newMode === 'org' || newMode === 'extpf' || newMode === 'sid') {
            fieldConfig.groupOption = option1;
            viewOptions.selectedGroupOption = option1;
        }
        if (!keepGroupFilters) {
            // Every grouping can carry the Advanced dialog's filters. The plain menu passes none, so
            // switching from it clears them, the same as the group filter fields cleared above.
            fieldConfig.groupSize = groupSize;
            fieldConfig.groupSizeOper = groupSizeOper;
            fieldConfig.groupFilters = groupFilters;
        }
        setViewOptions({...viewOptions});
        fieldConfig.tableDisplayMode = newMode;
        // Group size rows narrow the collection the statistics count, so refresh them when one is added,
        // changed or dropped
        loadResultsFromBackend(!keepGroupFilters && (hadGroupSizeFilter || hasGroupSizeFilter(fieldConfig)));
    }

    function getViewOption(option) {
        let result = option;
        if (!option) {
            result = '';
        } else if (option.startsWith("All")) {
            result = 'All';
        } else if (option.startsWith("10 ")) {
            result = '10';
        } else if (option.startsWith("5 ")) {
            result = '5';
        } else if (option.startsWith("3 ")) {
            result = '3';
        } else if (option.startsWith("1 ")) {
            result = '1';
        }
        return result;
    }

    const smartTextGetOptions = (e, filter, text) => {
        setSmartText(text);
        filter.state.smartText = text;
        if (!filterSearching || filterSearching === _NOT_SEARCHING) {
            smartTextGetOptionsBackendBfql(e, filter, text);
        }
    }

    async function smartTextGetOptionsBackendBfql(e, filter, val) {
        let text = val;
        if (text && text.length >= minSmartTextLen) {
            let data = {
                workflowId: resid.match(/\d+/)[0],
                userId: userdir ? userdir : window.$javaCall.data.userId,
                searchValue: text
            }
            let response = await DiscoverService.searchText(data, window.$javaCall.data.gqApiKey);
            if (response) {
                //if (text !== smartText) {
                    //callAgain = true;
                //}
                let options = [];
                text = _.replace(text, new RegExp('^!'), 'NOT ');
                _.each(response.fields, function (key, val) {
                    options.push({
                        key: key,
                        count: val,
                        text: text
                    });
                });
                setSmartTextPopup(true);
                setFilterSearching(_NOT_SEARCHING);
                if (_.size(options) > 0) {
                    setSmartTextOptions(options);
                } else {
                    setSmartTextOptions([]);
                }
            } else {
                setSmartTextPopup(false);
                setSmartTextOptions([]);
            }
        } else {
            setSmartTextPopup(false);
            setSmartTextOptions([]);
        }
    }

    function addSmartText(resultFilter, field) {
        enableApplyButton();
        let text, existingEntry, splitted, j, filter, negate;
        resultFilter.state.smartText = smartText;
        text = smartText;
        filter = {...smartTextFilter};
        if (!filter) {
            filter = {};
        }
        negate = false;
        if (text.indexOf("!") === 0) {
            text = _.replace(text, new RegExp('^!'), '');
            negate = true;
        }
        if (text.length >= minSmartTextLen) {
            if (!(field in filter)) {
                filter[field] = [];
            }
            // check for redundant entries
            existingEntry = _.find(filter[field], function (obj) {
                return (obj.text === text && negate === obj.negate);
            });
            if (existingEntry !== undefined) {
                // the entry already exists, check the checkbox
                existingEntry.value = true;
            } else {
                // split on whitespace, but respect phrases in single or double quotes
                splitted = text.match(/"([^"]*)"|'([^']*)'|[^\s]+/g);
                // remove quotes from the splitted phrases
                for (j = 0; j < splitted.length; j++) {
                    splitted[j] = splitted[j].replace(/["']/g, '');
                }
                UIlog.record(resid, 'FILTER_SMARTTEXT', field);
                filter[field].push({
                    text: text,
                    value: true,
                    negate: negate,
                    color: 0,
                    match: splitted,
                    source: 'filter'
                });
            }
        }
        //resultFilter.state.smartTextFilter = filter;
        setSmartTextFilter(filter);
        // hide the smart text autocomplete UI
        setSmartTextPopup(false);
    }

    function removeSmartText(filter, field, idx) {
        let options = {...smartTextFilter};
        let selected = false;
        if (filter.state.smartTextFilter[field] && filter.state.smartTextFilter[field][idx]) {
            selected = filter.state.smartTextFilter[field][idx].value;
            filter.state.smartTextFilter[field].splice(idx, 1);
            if (filter.state.smartTextFilter[field].length === 0) {
                delete filter.state.smartTextFilter[field];
            }
        }
        options[field].splice(idx, 1);
        if (options[field].length === 0) {
            delete options[field];
        }
        setSmartTextFilter(options);

        if (selected) {
            filter.state.smartTextFilter = {...smartTextFilter};
            // When removing one applied filter, refresh the whole page
            Object.assign(filterState, filter.state);
            setFilterState({...filterState});
            loadResultsFromBackend(true);
        }
    }

    const smartTextFilterEvent = (index, val) => {
        let finalData = [...smartTextHover];
        finalData[index] = val;
        setSmartTextHover(finalData);
    }

    function setSmartTextCheckbox() {
        setSmartTextFilter({...smartTextFilter});
        //filter.state.smartTextFilter = {...smartTextFilter};
        //filter.state = {...filter.state};
        enableApplyButton();
    }

    function clearSmartTextFilter(filter) {
        filter.state.smartText = '';
        setSmartText('');
        // Only unselects the checkboxes
        if (Object.keys(smartTextFilter).length > 0) {
            _.forEach(
                smartTextFilter,
                function (val) {
                    _.forEach(
                        val, function (item) {
                            item.value = false;
                        }
                    )
                }
            );
        }
        //smartTextFilter = {};
        setSmartTextFilter({...smartTextFilter});
        filter.state.smartTextFilter = {...smartTextFilter};
    }

    function resetAllFitlers(fieldConfig, filter, options = {}) {
        const {clearSavedCmFilters = false} = options;

        filter.state.singleAlignmentId = undefined;
        filter.state.abExp = undefined;
        filter.state.vmExp = undefined;
        filter.state.vmQueryId = undefined;
        // Clear alert parameters
        filter.state.familyId = undefined;
        filter.state.docNum = undefined;
        filter.state.docType = undefined;
        //fieldConfig.singleAlignment = false;
        //fieldConfig.forRegistry = false;

        // Clear FullText search inline filter FIRST
        setFtsInline({ field: 'SUBJECT_FTS', value: '', fieldDisplayValue: '', tempFieldDisplayValue: '' });
        setFtsResetCounter(prev => prev + 1); // Force FullTextSearchBox to re-render
        filter.state.ftsInline = undefined;

        clearSmartTextFilter(filter);
        clearQuerySeqIdFilter(filter);
        clearPnFilter(filter);
        clearFilter(filter, 'queryCmCodes');
        clearFilter(filter, 'databaseNames');
        clearFilter(filter, 'SUBJECT_PN');
        clearFilter(filter, 'SUBJECT_PG');
        clearFilter(filter, 'SUBJECT_PS');
        clearAnnotationFilter(filter, 'checkboxes');
        clearAnnotationFilter(filter, 'stars');
        clearAnnotationFilter(filter, 'colors');
        // Clear notes
        noteListChanged(filter, '');
        clearAnnotationFilter(filter, 'notesCheckboxes');
        // Clear Custom filters & VM filters
        clearCustomFilter(filter, 'customFilterCheckboxes');
        if (clearSavedCmFilters) {
            filter.state.cmFilters = [];
            filter.state.cmFilterCheckboxes = [];
        } else if (Array.isArray(filter.state.cmFilters)) {
            filter.state.cmFilterCheckboxes = filter.state.cmFilters.map(() => false);
        } else {
            filter.state.cmFilterCheckboxes = [];
        }
        clearCustomFilter(filter, 'lvaFilterCheckboxes');

        // Clear CM selections
        setHighlightHits(true);
        setCmColorLevel(2);
        filter.state.highlightHits = true;
        filter.state.cmColorLevel = 2;
        filter.state.queryCmCodes = [];

        // Reset the queryIdHighlightsCleared flag so auto-highlights can be re-added
        filter.state.queryIdHighlightsCleared = false;
        
        // Clear ALL highlights (including manually-added ones) so only defaults are shown
        smartHighlightFilter = {};
        setSmartHighlightFilter({});
        filter.state.smartHighlightFilter = {};
        setSmartHighlightText('');
        filter.state.smartHighlight = '';

        // Clear AB filter (links from the AB report)
        window.reportFilters = {};

        setDeduplication(false);
        filter.state.deduplication = false;
        filter.state = {...filter.state};
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});

        //$scope.filter.clearABFilters();
        groupQuery = {};

        saveResultState(filter, fieldConfig);
        //clearHighlights(); // This one will call saveState()
    }

    function applyAllFilters(filter) {
        addKeyWordsInContext(filter);
        filter.state.smartTextFilter = {...smartTextFilter};
        
        // Add FullText search data to the filter
        if (ftsInline.value || ftsInline.fieldDisplayValue || ftsInline.tempFieldDisplayValue) {
            if (!filter.state.ftsInline) {
                filter.state.ftsInline = {};
            }
            filter.state.ftsInline = {
                field: ftsInline.field,
                value: ftsInline.value,
                fieldDisplayValue: ftsInline.tempFieldDisplayValue || ftsInline.fieldDisplayValue,
                tempFieldDisplayValue: ftsInline.tempFieldDisplayValue
            };
        }
        
        Object.assign(filterState, filter.state);
    }

    function getAlignmentPatternFilter(filter, useAppliedSnapshot = false) {
        if (!useAppliedSnapshot) {
            return filter;
        }

        const appliedPatternState = appliedCmPatternStateRef.current || {};
        return {
            ...filter,
            state: {
                ...filter.state,
                cmFilters: Array.isArray(appliedPatternState.cmFilters)
                    ? _.cloneDeep(appliedPatternState.cmFilters)
                    : [],
                cmFilterCheckboxes: Array.isArray(appliedPatternState.cmFilterCheckboxes)
                    ? _.cloneDeep(appliedPatternState.cmFilterCheckboxes)
                    : []
            }
        };
    }

    function setQueryCmCodeCheckbox(filter, cmCodes, code) {
        enableApplyButton();
        filter.state.queryCmCodes = {...filterState.queryCmCodes};
        if (code) {
            filter.state.queryCmCodes[code] = !filter.state.queryCmCodes[code];

            if (code.indexOf('1-') === 0) {
                // Batch update the level 1 check boxes
                for (let level1 in cmCodes) {
                    let found = false;
                    if (cmCodes[level1].code === code) {
                        for (let level2 in cmCodes[level1].codes) {
                            for (let level3 in cmCodes[level1].codes[level2].codes) {
                                let cm = cmCodes[level1].codes[level2].codes[level3].code;
                                filter.state.queryCmCodes[cm] = filter.state.queryCmCodes[code];
                            }
                            filter.state.queryCmCodes[cmCodes[level1].codes[level2].code] = filter.state.queryCmCodes[code];
                        }

                        found = true;
                        break;
                    }
                }
            } else if (code.indexOf('2-') === 0) {
                // Batch update the level 2 check boxes
                for (let level1 in cmCodes) {
                    let found = false;
                    for (let level2 in cmCodes[level1].codes) {
                        if (cmCodes[level1].codes[level2].code === code) {
                            // Select all level 3 codes for specific level 2
                            for (let level3 in cmCodes[level1].codes[level2].codes) {
                                let cm = cmCodes[level1].codes[level2].codes[level3].code;
                                filter.state.queryCmCodes[cm] = filter.state.queryCmCodes[code];
                            }

                            found = true;
                            break;
                        }
                    }

                    if (found) break;
                }
            }

            // Check the checkboxes again to auto check/uncheck the parent one
            for (let level1 in cmCodes) {
                let level2Matched = true;
                let level2Count = 0;
                let lastLevel2Checked = false;
                for (let level2 in cmCodes[level1].codes) {
                    let level3Matched = true;
                    let level3Count = 0;
                    let lastLevel3Checked = filter.state.queryCmCodes[cmCodes[level1].codes[level2].code];
                    for (let level3 in cmCodes[level1].codes[level2].codes) {
                        let cm = cmCodes[level1].codes[level2].codes[level3].code;
                        if (level3Count === 0) {
                            lastLevel3Checked = filter.state.queryCmCodes[cm];
                        } else if (filter.state.queryCmCodes[cm] !== lastLevel3Checked) {
                            level3Matched = false;
                            break;
                        }
                        level3Count++;
                    }
                    if (level3Matched) {
                        filter.state.queryCmCodes[cmCodes[level1].codes[level2].code] = lastLevel3Checked;
                    } else {
                        filter.state.queryCmCodes[cmCodes[level1].codes[level2].code] = false;
                        level2Matched = false;
                    }

                    // Go over all level 2, don't break if unmatched
                    if (level2Count === 0) {
                        lastLevel2Checked = filter.state.queryCmCodes[cmCodes[level1].codes[level2].code];
                    } else if (filter.state.queryCmCodes[cmCodes[level1].codes[level2].code] !== lastLevel2Checked) {
                        level2Matched = false;
                    }
                    level2Count++;
                }
                if (level2Matched) {
                    filter.state.queryCmCodes[cmCodes[level1].code] = lastLevel2Checked;
                } else {
                    filter.state.queryCmCodes[cmCodes[level1].code] = false;
                }
            }

            Object.assign(filterState, filter.state);
            setFilterState({...filterState});
            saveResultState(filter, fieldConfig);
        }
    }

    function setQuerySeqCheckbox(filter, seq) {
        enableApplyButton();
        filter.state.querySeqDbs = {...filterState.querySeqDbs};
        filter.state.querySeqDbs[querySeqIds[seq].id] = !filter.state.querySeqDbs[querySeqIds[seq].id];
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
    }

    function clearQuerySeqIdFilter(filter) {
        filter.state.querySeqDbs = {};
        filterState.querySeqDbs = {};
        setFilterState({...filterState});
    }

    function setDatabaseCheckbox(filter, db) {
        if (deduplication) {
            // Show alert
            setSelectedDatabase(db);
            setShowDedAlert(true);
        } else {
            enableApplyButton();
            filter.state.databaseNames = {...filterState.databaseNames};
            filter.state.databaseNames[db] = !filter.state.databaseNames[db];
            Object.assign(filterState, filter.state);
            setFilterState({...filterState});
        }
    }

    const closeDeduplicationModal = () => {
        setShowDedAlert(false);
    }

    const continueDeduplicationModal = (filter, filterState, db) => {
        setShowDedAlert(false);
        enableApplyButton();
        filter.state.databaseNames = {...filterState.databaseNames};
        filter.state.databaseNames[db] = !filter.state.databaseNames[db];
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
    }

    function clearFilter(filter, name) {
        filter.state = {...filter.state};
        filter.state[name] = {};
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
    }

    function clearCustomFilter(filter, name) {
        filter.state = {...filter.state};
        filter.state[name] = [];
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
    }

    function clearPnFilter(filter) {
        filter.state.publicationNumberList = '';
        filterState.publicationNumberList = '';
        setFilterState({...filterState});
    }

    function pnListChanged(filter, text) {
        // count number of entries in the list, and record in the log when PNs have been added / removed
        let prevNbEntries = (filter.state.publicationNumberList || []).length;
        let query = {};
        filter.prepPublicationNumberFilter(filter, query, text);
        if (query.publicationNumberList.length !== prevNbEntries) {
            UIlog.record(resid, 'FILTER_PNLIST', query.publicationNumberList.length + " PNs");
        }
        if (query.publicationNumberList.length > 4000) {
            setPnListErr('Maximum 4,000 patent numbers may be searched at one time');
            setApplyEnabled(false);
        } else {
            setPnListErr('');
            // enable the apply button
            enableApplyButton();
        }
        filter.state.publicationNumberList = text;
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
    }

    function setFacetCheckbox(filter, key, val) {
        enableApplyButton();
        filter.state[key] = {...filterState[key]};
        filter.state[key][val] = !filter.state[key][val];
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
    }

    function setAnnotationCheckbox(filter, key, val) {
        enableApplyButton();
        //filter.state.annot[key] = {...filterState.annot[key]};
        filter.state.annot[key][val] = !filter.state.annot[key][val];
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
    }

    function clearAnnotationFilter(filter, name) {
        filter.state.annot[name] = {}; //_.cloneDeep(originalState.annot[name]);
        filterState.annot[name] = {}; //_.cloneDeep(originalState.annot[name]);
        setFilterState({...filterState});
    }

           /* ====== result sorting ======================================= */

    // called from UI when the user changes the sort order
    function changeSort (sortKey) {
        console.log(filter.state.sort,"filter.state.sort");
        if (sortKey !== filter.state.sort) {
            filter.state.sort = sortKey;
            loadResultsFromBackend(false);
        }
    }

    function checkExportLimit(isCmWorkflow, totalAlignmentNumber, type) {
        let message = '';
        let desc = ' records';
        if (type === 'PN') {
            desc = ' patent numbers';
        } else if (type === 'ALI') {
            desc = ' alignments';
        }
        // Separate limit for CM export
        if (isCmWorkflow && totalAlignmentNumber > parseInt(process.env.REACT_APP_CM_LIMIT, 10)) {
            message = "Maximum data export limit reached. " + Number(process.env.REACT_APP_CM_LIMIT).toLocaleString() + " of " + Number(totalAlignmentNumber).toLocaleString() + desc + " will be downloaded.";
        } else if (totalAlignmentNumber > parseInt(process.env.REACT_APP_EXPORT_LIMIT, 10)) {
            message = "Maximum data export limit reached. " + Number(process.env.REACT_APP_EXPORT_LIMIT).toLocaleString() + " of " + Number(totalAlignmentNumber).toLocaleString() + desc + " will be downloaded.";
        }
        return message;
    }

    const startExportDownload = (format) => {
        if (JSON.stringify(searchResultData.data) === '{}') {
            alert("Cannot export empty result set");
            return;
        }
        setDownloadType(format);
        if (format === "PNL") {
            setDownloadTypeDesc("Publication Number List");
        } else if (format === "PNFIL") {
            setDownloadTypeDesc("Publication Number, Family ID List");
        } else if (format === "Fastafrag" || format === "Fastasub") {
            setDownloadTypeDesc("Fasta");
        } 
        else if (format === "PatentStats") {
            setDownloadTypeDesc("generate Patent Statistics Report")
        }else {
            setDownloadTypeDesc(format);
        }
        let message = '';
        if (format === 'Word' || format === "Word Simple" || format === "HTML"
            || format === 'EXCEL' || format === 'CSV' || format === 'TSV') {
            setTotalAlignmentNumber(searchResultData.stats.nav.total_count);
            setTotalPatentNumber(searchResultData.stats.nav.total_count);
            let totalAlignmentNumber = searchResultData.stats.nav.total_count;
            message = checkExportLimit(isCmWorkflow, totalAlignmentNumber);
            setAlertMessage(message);
            if (format === 'EXCEL') {
                setIncludeResult(true);
                setIncludeAnnotation(true);
                setIncludeSS(false);
                setIncludeQS(false);
                // Default to true when the table is in flanking mode so the extended alignment
                // column is included by default (user can uncheck to get standard only).
                setIncludeFullSeq(includeSubjectSeq);
            } else if (format === 'Word' || format === "HTML") {
                setIncludeAnnotation(false);
                setIncludeSS(true);
                setIncludeQS(true);
                setIncludeFullSeq(true);
            }
            setShowExportAllModal(true);
        } else {
            setTotalAlignmentNumber(viewCount.RESULT_ID);
            setTotalPatentNumber(viewCount.SUBJECT_PN);
            let totalPatentNumber = viewCount.SUBJECT_PN;
            let totalAlignmentNumber = viewCount.RESULT_ID;
            message = checkExportLimit(isCmWorkflow, totalPatentNumber, 'PN');
            if (message === '') {
                message = checkExportLimit(isCmWorkflow, totalAlignmentNumber, 'ALI');
            }
            setAlertMessage(message);

            //checkExportAmount();
            if (format === 'XML' || format === 'BizInt' || format === 'Geneious' || format === 'Fastafrag' || format === 'Fastasub' ||format === 'PatentStats'
                || format === "LifeQuest" || format === "FullText" || format === "Clustal" || format === "SeqDb") {
                if (format === "SeqDb") {
                    setExtractName('Extracted subjects ' + new Date().toString().split(' GMT')[0].replaceAll(':', ''));
                }
                displayExportSelection();
                setCustomTtlCount(searchResultData.stats.nav.total_count);
                let customTtlCount = searchResultData.stats.nav.total_count;
                //let custMessage = checkExportLimit(isCmWorkflow, customTtlCount);
                setSaveAsName("Fulltext search of " + resInfo['title']);
                setCustomAlertMessage(checkExportLimit(isCmWorkflow, customTtlCount));
                countCheckedRecords(format);
            } else {
                setShowExportAllModal(true);
            }
        }
    }

    function displayExportSelection() {
        if (fieldConfig.tableDisplayMode === 'ssv' && viewOptions.selectedSsvOption !== 'All') {
            setDisplayCustomSelection(true);
            setCustomSelectionLabel(ssvOptions[viewOptions.selectedSsvOption]);
        } else if (fieldConfig.tableDisplayMode === 'qs' && viewOptions.selectedQsOption !== 'All') {
            setDisplayCustomSelection(true);
            setCustomSelectionLabel(qsOptions[viewOptions.selectedQsOption]);
        } else if (fieldConfig.tableDisplayMode === 'hsp' && viewOptions.selectedHspOption !== 'All') {
            setDisplayCustomSelection(true);
            setCustomSelectionLabel(hspOptions[viewOptions.selectedHspOption]);
        } else if (fieldConfig.tableDisplayMode === 'document' && viewOptions.selectedPnViewOption !== 'All') {
            setDisplayCustomSelection(true);
            setCustomSelectionLabel(pnViewOptions[viewOptions.selectedPnViewOption]);
        } else if (fieldConfig.tableDisplayMode === 'ufs' && viewOptions.selectedUfsOption !== 'All') {
            setDisplayCustomSelection(true);
            setCustomSelectionLabel(ufsOptions[viewOptions.selectedUfsOption]);
        } else if (fieldConfig.tableDisplayMode === 'family') {
            if (viewOptions.selectedFamViewAliOption === 'All' && viewOptions.selectedFamViewOption === 'All') {
                setDisplayCustomSelection(false);
            } else if (viewOptions.selectedFamViewAliOption !== 'All' && viewOptions.selectedFamViewOption !== 'All') {
                setDisplayCustomSelection(true);
                setCustomSelectionLabel(famViewOptions[viewOptions.selectedFamViewOption] + ', ' + pnViewOptions[viewOptions.selectedFamViewAliOption]);
            } else if (viewOptions.selectedFamViewAliOption === 'All') {
                setDisplayCustomSelection(true);
                setCustomSelectionLabel(famViewOptions[viewOptions.selectedFamViewOption] + ', All Alignments per Patent Number');
            } else if (viewOptions.selectedFamViewOption === 'All') {
                setDisplayCustomSelection(true);
                setCustomSelectionLabel('All Patent Numbers per Family, ' + pnViewOptions[viewOptions.selectedFamViewAliOption]);
            }
        } else if ((fieldConfig.tableDisplayMode === 'ali' || fieldConfig.tableDisplayMode === 'npa' || fieldConfig.tableDisplayMode === 'aipa'
                    || fieldConfig.tableDisplayMode === 'gname' ||  fieldConfig.tableDisplayMode === 'gqid'
                    || fieldConfig.tableDisplayMode === 'org' ||  fieldConfig.tableDisplayMode === 'extpf' || fieldConfig.tableDisplayMode === 'sid')
                    && viewOptions.selectedGroupOption !== 'All') {
            setDisplayCustomSelection(true);
            setCustomSelectionLabel(viewOptions.selectedGroupOption + ' Alignment(s) per ' + fieldConfig.getTypeDescription(fieldConfig.tableDisplayMode));
        }
    }

    const countCheckedRecords = async(format) => {
        let javaCall = {
            data: {
                workflowId: resid.match(/\d+/)[0],
                userId: window.$javaCall.data.userId,
            }
        };
        let response = await DiscoverService.countCheckedRecords(javaCall.data, history, window.$javaCall.data.gqApiKey);
        if (response) {
            let count = parseInt(response.status);
            let msg = checkExportLimit(isCmWorkflow, count);
            setSelectedAlertMessage(msg);
            setSelectedAlignmentsCount(count);
            setSelectedAlignmentsIds(response.selectedIds);

            setShowExportChoicesModal(true);
        }
    }

    const exportToExcel = (fieldConfig, filter, resInfo, format, exportSelection, exportOption, extractType, extractTitle, fileName) => {
        setExportFileName(fileName);
        let columnsToDisplay = fieldConfig.getCurrentDisplayModeFieldInfo(fieldConfig)[0];
        if (hasLvaAccess && columnsToDisplay.includes("RESULT_VMH")
            && (format === "Word" || format === "Word Simple" || format === "HTML"
                || format === "EXCEL" || format === "CSV" || format === "TSV")) {
            setShowExportAllModal(false);
            setShowExportVmModal(true);
        } else if ((format === "Word" || format === "Word Simple" || format === "HTML" || format === 'EXCEL')
            && ((hasLvaAccess && filter.lvaWidgetState && resInfo.options?.includeAli
                    && filter.lvaWidgetState.lvaFilters && filter.lvaWidgetState.lvaFilters.length > 0)
                || (isCmWorkflow && (resInfo.options?.includeAli || columnsToDisplay.includes("RESULT_FALI_FORMATTED") || columnsToDisplay.includes("RESULT_EXTENDED_ALI"))))) {
            setShowExportAllModal(false);
            setShowExportVmModal(true);
        } /*else if (isCmWorkflow && format === "EXCEL"
            && (columnsToDisplay.includes("SUBJECT_M1") || columnsToDisplay.includes("RESULT_FALI_FORMATTED"))) {
            setShowExportAllModal(false);
            setShowExportVmModal(true);
        }*/ else {
            exportVmAlignments(fieldConfig, filter, resInfo, format, false, exportSelection, fileName, exportOption, extractType, extractTitle);
        }
    }

    const exportVmAlignments = async(fieldConfig, filter, resInfo, format, downloadVMGraphics, exportSelection, newTitle, exportOption, extractType, extractTitle) => {
        // The VM-graphics confirmation modal (DiscoverExportVmModal) re-invokes this without the
        // file name, since it only forwards (fieldConfig, filter, resInfo, format, downloadVMGraphics).
        // Fall back to the name captured earlier in exportToExcel so it survives that extra step.
        newTitle = newTitle || exportFileName;
        let groupCriteria = '', pnsPerPage = '', alignmentsPerPage = '';
        switch (fieldConfig.tableDisplayMode) {
            case 'family':
                groupCriteria = 'fam';
                pnsPerPage = fieldConfig.famViewOption;
                alignmentsPerPage = fieldConfig.famViewAliOption;
                break;
            case 'document':
                groupCriteria = 'patent';
                alignmentsPerPage = fieldConfig.pnViewOption;
                break;
            case 'flat':
                groupCriteria = 'alignment';
                break;
            case 'ufs':
                groupCriteria = 'ufs';
                alignmentsPerPage = fieldConfig.ufsOption;
                break;
            case 'cas':
                groupCriteria = 'cas';
                break;
            case 'ssv':
                groupCriteria = 'ssv';
                alignmentsPerPage = fieldConfig.ssvOption;
                break;
            case 'qs':
                groupCriteria = 'qs';
                alignmentsPerPage = fieldConfig.qsOption;
                break;
            case 'hsp':
                groupCriteria = 'hsp';
                alignmentsPerPage = fieldConfig.hspOption;
                break;
            case 'ali':
            case 'npa':
            case 'aipa':
            case 'org':
            case 'gname':
            case 'gqid':
            case 'extpf':
            case 'sid':
                groupCriteria = fieldConfig.tableDisplayMode;
                alignmentsPerPage = fieldConfig.groupOption;
                break;
            default:
                break;
        }
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
        if (downloadVMGraphics) {
            setShowExportVmModal(false);

            let call = {
                data: {
                    workflowId: resid.match(/\d+/)[0],
                    userId: window.$javaCall.data.userId,
                    groupCriteria: groupCriteria,
                    pnsPerPage: pnsPerPage,
                    alignmentsPerPage: alignmentsPerPage,
                    sortCriteria: filter.state.sort,
                    sortCriterias: fieldConfig.populateSortCriterias(filter.state.sort),
                    vmExport: true,
                    pageNum: 1,
                    // Export the groups the table shows
                    ...groupFilterFields(fieldConfig),
                }
            };
            applyFilterForJava(call);
            let response = await DiscoverService.getSummary(call.data, window.$javaCall.data.gqApiKey);
            if (response) {
                console.log("Received VM records at " + new Date().toLocaleString());
                let newData = fieldConfig.javaObjectConverter(response, groupCriteria, querydb.SEQUENCE_ID, fieldConfig, cmMap, cmColorMap, filter.state.cmColorLevel);
                let gqAlignments = [], gqAlignmentsNoSumm = [], gqAlignmentsStrNoSumm = [], gqAlignmentsSumm = [], gqAlignmentsVariation = [], gqAlignmentsStrFlanking = [];
                populateGqAlignments(filter, newData.data, gqAlignments, gqAlignmentsNoSumm, gqAlignmentsStrNoSumm, gqAlignmentsSumm, gqAlignmentsVariation, gqAlignmentsStrFlanking);
                console.log("Finish populating GQ alignments at " + new Date().toLocaleString());
                exportDocs(fieldConfig, filter, filterState, resInfo, format, gqAlignmentsStrNoSumm, gqAlignmentsSumm,
                    gqAlignmentsVariation, downloadVMGraphics, groupCriteria, pnsPerPage, alignmentsPerPage, exportSelection, newTitle, exportOption, extractType, extractTitle, gqAlignmentsStrFlanking);
            }
        } else {
            exportDocs(fieldConfig, filter, filterState, resInfo, format, searchResultData.gqAlignmentsStrNoSumm, searchResultData.gqAlignmentsSumm,
                searchResultData.gqAlignmentsVariation, downloadVMGraphics, groupCriteria, pnsPerPage, alignmentsPerPage, exportSelection, newTitle, exportOption, extractType, extractTitle, searchResultData.gqAlignmentsStrFlanking);
        }
    }

    const EXPORT_JOB_LABELS = {
        EXCEL: 'Export to Excel',
        CSV: 'Export to CSV',
        TSV: 'Export to TSV',
        PNL: 'Export to Publication Number List',
        PNFIL: 'Export to Publication Numbers & Family Members',
        Word: 'Export to Word',
        'Word Simple': 'Export to Word (Simplified)',
        HTML: 'Export to HTML',
        XML: 'Export to XML',
        BizInt: 'Export to BizInt Smart Charts',
        Geneious: 'Export to Geneious',
        Fastafrag: 'Export to Alignment Fragments Fasta',
        Fastasub: 'Export to Subject Sequences Fasta',
        Clustal: 'Export to Clustal Omega',
    };

    const exportDocs = async(fieldConfig, filter, filterState, resInfo, format, gqAlignmentsStrNoSumm, gqAlignmentsSumm, gqAlignmentsVariation,
                             downloadVMGraphics, groupCriteria, pnsPerPage, alignmentsPerPage, exportSelection, newTitle, exportOption, extractType, extractTitle, gqAlignmentsStrFlanking) => {
        let fileType, fileExtension, downloadApi;
        let exportType = format;
        if (format === 'EXCEL') {
            fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            fileExtension = '.xlsx';
            downloadApi = 'exportExcel';
        } else if (format === 'CSV') {
            fileType = 'text/csv;charset=utf-8;';
            fileExtension = '.csv';
            downloadApi = 'exportCsv';
        } else if (format === 'TSV') {
            fileType = 'text/tab-separated-values';
            fileExtension = '.tsv';
            downloadApi = 'exportTsv';
        } else if (format === 'PNL' || format === 'Publication Number List'
            || format === 'PNFIL' || format === 'Publication Number, Family ID List') {
            fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            fileExtension = '.xlsx';
            downloadApi = 'exportPNxlsx';
        } else if (format === 'Word') {
            fileType = 'application/msword';
            fileExtension = '.doc';
            downloadApi = 'exportWord';
        } else if (format === 'Word Simple') {
            fileType = 'application/msword';
            fileExtension = '.doc';
            downloadApi = 'exportWordSimple';
        } else if (format === 'Fastafrag') {
            fileType = 'text/plain';
            fileExtension = '.txt';
            downloadApi = 'exportAlign';
        } else if (format === 'Fastasub' ) {
            fileType = 'text/plain';
            fileExtension = '.txt';
            downloadApi = 'exportSub';
        } else if (format === 'XML') {
            fileType = 'application/xml';
            fileExtension = '.xml';
            downloadApi = 'exportToXml';
        } else if (format === 'BizInt') {
            fileType = 'data/bizint-patent-data';
            fileExtension = '.bpd';
            downloadApi = 'exportToXml';
        } else if (format === 'Geneious') {
            fileType = 'data/geneious';
            fileExtension = '.geneious';
            downloadApi = 'exportToGeneious';
        } else if (format === 'LifeQuest') {
            downloadApi = 'exportToLQ';
        } else if (format === 'FullText' || format === 'Patbase') {
            downloadApi = 'exportToPatbase';
        } else if (format === 'HTML') {
            fileType = 'text/html';
            fileExtension = '.html';
            downloadApi = 'exportWord';
        } else if (format === 'Clustal') {
            fileType = 'text/html';
            fileExtension = '.html';
            downloadApi = 'exportClustalo';
        } else if (format === 'SeqDb') {
            downloadApi = 'extractDatabase';
            exportType = extractType;
        }

        let javaCall = {
            data: {
                workflowId: resid.match(/\d+/)[0],
                userId: window.$javaCall.data.userId,
                groupCriteria: groupCriteria,
                pnsPerPage: pnsPerPage,
                alignmentsPerPage: alignmentsPerPage,
                sortCriteria: filterState.sort,
                sortCriterias: fieldConfig.populateSortCriterias(filterState.sort),
                pageNum: 1,
                title: format === 'SeqDb' ? extractTitle : resInfo.title,
                vmExport: downloadVMGraphics,
                algorithm: resInfo.algorithm,
                exportType: exportType,
                isAbWorkflow: isAbWorkflow,
                newLink: true,
                firstName: userInfo.current_user?.first_name,
                lastName: userInfo.current_user?.last_name,
                loginName: userInfo.current_user?.login_name,
                accountingGroup: userInfo.current_user?.accounting_group_name,
                auditInfo: resInfo.options?.auditInfo,
                auditOnTop: resInfo.options?.auditOnTop,
                overview: resInfo.options?.overview,
                includeResult: resInfo.options?.includeResult,
                includeAli: resInfo.options?.includeAli,
                clipAli: resInfo.options?.clipAli,
                excludeClaim: resInfo.options?.excludeClaim,
                excludeFamilyData: resInfo.options?.excludeFamilyData,
                includeAnnotation: resInfo.options?.includeAnnotation,
                includeSS: resInfo.options?.includeSS,
                includeQS: resInfo.options?.includeQS,
                includeFullSeq : resInfo.options?.includeFullSeq,
                highlightHits: filter.state.highlightHits,
                cmColorLevel: filter.state.cmColorLevel,
                // Export the groups the table shows
                ...groupFilterFields(fieldConfig),
            }
        };
        let contentType;
        if (format === 'EXCEL' || format === 'CSV' || format === 'TSV' || format === 'PNL' || format === 'PNFIL'
            || format === 'Publication Number List' || format === 'Publication Number, Family ID List') {
            javaCall['responseType'] = 'arraybuffer';
            contentType = 'arraybuffer';
        } else if (format === 'XML' || format === 'BizInt') {
            // Save the file as a Blob. The default JSON parse builds one string, and Chrome
            // cannot create a string past ~512MB (a body of about 613,589 kB fails that way).
            contentType = 'blob';
        }
        applyFilterForJava(javaCall);

        if (format === 'Word' || format === "Word Simple" || format === "HTML"
            || format === 'EXCEL' || format === 'CSV' || format === 'TSV') {
            javaCall.data.workflowUrl = process.env.REACT_APP_URL + 'discover/' + resid;
            javaCall.data.columnsToDisplay = fieldConfig.getCurrentDisplayModeFieldInfo(fieldConfig)[0];
            // Align the exported alignment columns with what was requested.
            {
                const cols = [...javaCall.data.columnsToDisplay];
                const hasFali = cols.includes('RESULT_FALI_FORMATTED');
                const hasExt  = cols.includes('RESULT_EXTENDED_ALI');

                if (resInfo.options?.includeFullSeq || hasExt) {
                    // When full-sequence export is requested or extended alignment is already in the
                    // template, keep only RESULT_EXTENDED_ALI and drop RESULT_FALI_FORMATTED.
                    const faliIdx = cols.indexOf('RESULT_FALI_FORMATTED');
                    if (hasFali && !hasExt) {
                        cols.splice(faliIdx, 1, 'RESULT_EXTENDED_ALI');
                    } else if (hasFali) {
                        cols.splice(faliIdx, 1);
                    }
                }

                javaCall.data.columnsToDisplay = cols;
            }
            let columns = fieldConfig.getColumnsInfoForExport(fieldConfig);
            javaCall.data.groupedColumns = columns[0];
            javaCall.data.detailedColumns = columns[1];
            javaCall.data.gqAlignments = {};
            javaCall.data.gqAlignmentSummaries = {};
            javaCall.data.vmHits = {};
            if (downloadVMGraphics) {
                // Use the flanking alignment HTML when the export column is RESULT_EXTENDED_ALI,
                // falling back to the standard alignment when no flanking data was built.
                const useFlanking = javaCall.data.columnsToDisplay.includes('RESULT_EXTENDED_ALI');
                const alignmentSource = (useFlanking && gqAlignmentsStrFlanking && gqAlignmentsStrFlanking.length > 0)
                    ? gqAlignmentsStrFlanking
                    : gqAlignmentsStrNoSumm;
                for (let idx in alignmentSource) {
                    for (let key in alignmentSource[idx]) {
                        javaCall.data.gqAlignments[key] = alignmentSource[idx][key];
                    }
                }
                // Variation or CM hits
                for (let idx in gqAlignmentsSumm) {
                    for (let key in gqAlignmentsSumm[idx]) {
                        javaCall.data.gqAlignmentSummaries[key] = [];
                        let vmHits = '';
                        for (let sIdx in gqAlignmentsSumm[idx][key]) {
                            let obj = {};
                            if (isCmWorkflow) {
                                obj.spos = gqAlignmentsSumm[idx][key][sIdx].sPos;
                                obj.qpos = gqAlignmentsSumm[idx][key][sIdx].qPos;
                                obj.origBase = gqAlignmentsSumm[idx][key][sIdx].origBase;
                                obj.base = gqAlignmentsSumm[idx][key][sIdx].base;
                                obj.type = gqAlignmentsSumm[idx][key][sIdx].type;
                                obj.description = gqAlignmentsSumm[idx][key][sIdx].desc;
                            } else {
                                obj.pos = gqAlignmentsSumm[idx][key][sIdx].pos;
                                obj.type = gqAlignmentsSumm[idx][key][sIdx].type;
                                // No idea why qChunk/sChunk could not be deserilized in backend, so using qchunk/schunk instead
                                obj.qchunk = gqAlignmentsSumm[idx][key][sIdx].qChunk;
                                obj.schunk = gqAlignmentsSumm[idx][key][sIdx].sChunk;
                                obj.description = gqAlignmentsSumm[idx][key][sIdx].description;
                            }
                            javaCall.data.gqAlignmentSummaries[key].push(obj);

                            if (vmHits !== '') {
                                vmHits += ', ';
                            }
                            if (format === 'EXCEL' || format === 'CSV' || format === 'TSV') {
                                vmHits += gqAlignmentsSumm[idx][key][sIdx].description;
                            } else {
                                vmHits += gqAlignmentsSumm[idx][key][sIdx].vmHits;
                            }
                        }
                        javaCall.data.vmHits[key] = vmHits;
                    }
                }
            }
            if (format === 'EXCEL' && Object.keys(filterState['smartHighlightFilter']).length > 0) {
                let highlightFilters = filterState['smartHighlightFilter'];
                javaCall.data.highlightFilters = {};
                let newFilters = {};
                Object.keys(highlightFilters).forEach(field => {
                    let subFilters = highlightFilters[field];
                    newFilters[field] = [];
                    Object.keys(subFilters).forEach(subKey => {
                        let filter = subFilters[subKey];
                        if (filter.value === true) {
                            let newFilter = {};
                            newFilter['text'] = filter.text;
                            newFilter['color'] = highlightColors[filter.color];
                            newFilters[field].push(newFilter);
                        }
                    });
                });
                javaCall.data.highlightFilters = newFilters;
                //console.log(javaCall.data.highlightFilters);
            }
        } else if (format === 'XML' || format === 'BizInt' || format === 'Geneious' || format === 'Fastafrag' || format === 'Fastasub' || format === 'PatentS'
            || format === 'FullText' || format === 'Patbase' || format === 'LifeQuest' || format === 'Clustal'|| format === 'SeqDb') {
            javaCall.data.reachLimit = (exportSelection === 'all' && totalAlignmentNumber > parseInt(process.env.REACT_APP_EXPORT_LIMIT, 10));
            if (exportSelection === 'selected') {
                javaCall.data.selectedIds = selectedAlignmentsIds;
                javaCall.data.exportSelection = 'selected';
            } else if (exportSelection === 'custom') {
                javaCall.data.exportSelection = 'custom';
            }
            else if (exportSelection === 'all') {
                javaCall.data.exportSelection = 'all';
            }
            if (format === 'LifeQuest') {
                javaCall.data.lqAuthKey = lqAuthKey;
                javaCall.data.lqBaseUrl = lqBaseUrl;
                javaCall.data.loginName = loginName;
            } else if (format === 'Clustal') {
                if (exportOption === 'both') {
                    javaCall.data.includeBothSeqs = true;
                } else if (exportOption === 'qs') {
                    javaCall.data.includeQS = true;
                } else if (exportOption === 'ss') {
                    javaCall.data.includeSS = true;
                } else if (exportOption === 'fullseq') {
                    javaCall.data.includeFullSeq = true;
                } else {
                    javaCall.data.includeSubjFragments = true;
                }
            }
        }

        closeExportModal();
        const isTrackedExport = EXPORT_JOB_LABELS.hasOwnProperty(format);
        const exportJobId = crypto.randomUUID();
        const exportAbortController = isTrackedExport ? new AbortController() : null;
        if (isTrackedExport) {
            dispatch(startExportProgress({ id: exportJobId, name: EXPORT_JOB_LABELS[format] }));
            registerExportAbort(exportJobId, exportAbortController);
            registerExportRetry(exportJobId, () => exportDocs(fieldConfig, filter, filterState, resInfo, format,
                gqAlignmentsStrNoSumm, gqAlignmentsSumm, gqAlignmentsVariation, downloadVMGraphics, groupCriteria,
                pnsPerPage, alignmentsPerPage, exportSelection, newTitle, exportOption, extractType, extractTitle,
                gqAlignmentsStrFlanking));
        }
        const onExportProgress = isTrackedExport
            ? (progressEvent) => {
                const totalBytes = progressEvent.total || null;
                const percent = totalBytes ? Math.round((progressEvent.loaded / totalBytes) * 100) : null;
                dispatch(updateExportProgress({ id: exportJobId, percent, loadedBytes: progressEvent.loaded, totalBytes }));
            }
            : undefined;

        let response;
        try {
            if (format === 'Clustal') {
                response = await DiscoverService.exportClustal({data: javaCall.data}, onExportProgress, exportAbortController?.signal);
            } else {
                response = await DiscoverService.exportDocs(javaCall.data, downloadApi, window.$javaCall.data.gqApiKey, contentType, onExportProgress, exportAbortController?.signal);
            }
        } catch (err) {
            // exportDocs() swallows its own axios errors and resolves to undefined rather than
            // rejecting, so this branch mainly covers exportClustal — but handle both shapes.
            const wasCancelled = isTrackedExport && exportAbortController.signal.aborted;
            if (isTrackedExport && !wasCancelled) {
                dispatch(failExportProgress({ id: exportJobId, error: 'The export request failed. Please try again.' }));
            }
            if (!wasCancelled) {
                throw err;
            }
        }
        if (isTrackedExport && exportAbortController.signal.aborted) {
            dispatch(cancelExportProgress({ id: exportJobId }));
            return;
        }
        // XML and BizInt normally arrive as a file Blob. A JSON Blob is the CM-limit
        // error, or a legacy body that still wraps the XML in exportResults.
        if ((format === 'XML' || format === 'BizInt') && response instanceof Blob
                && /json|text\/plain/i.test(response.type || '')) {
            try {
                response = JSON.parse(await response.text());
            } catch (parseErr) {
                if (isTrackedExport) {
                    dispatch(failExportProgress({
                        id: exportJobId,
                        error: 'This export is too large for the browser to save. Export a smaller result set and try again.',
                    }));
                }
                return;
            }
        }
        if (format !== 'SeqDb' && response) {
            if (isCmWorkflow) {
                if (response.status === 'error' || response.byteLength === "CM Export limit reached.".length) {
                    // Handle CM export limit
                    if (isTrackedExport) {
                        dispatch(failExportProgress({ id: exportJobId, error: 'Daily export limit reached for the Chemical Modification Module.' }));
                    }
                    popupInfoMsg("You’ve reached the maximum of 5 daily exports allowed for the Chemical Modification Module. Please try again tomorrow.");
                    return;
                }
            }

            if (format === 'LifeQuest') {
                window.open(process.env.REACT_APP_BASE_URL + 'query?do=gqredirect.lq&lq_ca=patentList/workfileInProgress&id=lq');
                return;
            } else if (format === 'Patbase') {
                console.log("Received PN list at " + new Date().toLocaleString());
                let result = response.exportResults;
                let pns = _.split(result, ",");
                setPatbasePnsStr(result);
                setPatbasePns(pns);
                setTotalPatbasePns(pns.length);
                let countdown = 3;
                pbTimer = setInterval(() => {
                    (async () => {
                        setPbCountdown(countdown--);
                        if (countdown === 0) {
                            closeExportModal();
                        }
                    })();
                }, 1000);
                setShowPatbaseModal(true);
                return;
            } else if (format === 'FullText') {
                console.log("Received PN list at " + new Date().toLocaleString());
                let ftwindow = window.open(process.env.REACT_APP_URL + "fulltextsearch");
                ftwindow.data = {};
                ftwindow.data.exportData = JSON.stringify(response.exportResults).replace(/"/ig, '');
                //await navigator.clipboard.writeText(response.exportResults);
                return;
            } else if (format === 'Clustal') {
                //localStorage.setItem('clustalo_' + response.response_id, response.response_content);
                const url = "#/clustaloreport/" + response.response_id;
                const newWindow = window.open(url, '_blank');
                let clustalError = null;
                if (response.response_content && response.response_content.type === 'GQEXCEPTION') {
                    clustalError = response.response_content.message;
                } else if (response.response_content && response.response_content.type === 'GQSCRIPTGENERALEXCEPTION') {
                    clustalError = "Error: " + response.response_content.message + " Please retry with smaller and fewer sequences.";
                }
                // window.open() can return null if the popup was blocked (common here since it
                // fires after an await, outside the original click's user-activation window) —
                // guard so a blocked popup can't stop us from settling the tracked job below.
                if (newWindow) {
                    newWindow.reportString = response.response_content;
                    if (clustalError) {
                        newWindow.message = clustalError;
                    }
                    newWindow.window.focus();
                }
                if (isTrackedExport) {
                    if (clustalError) {
                        dispatch(failExportProgress({ id: exportJobId, error: clustalError }));
                    } else {
                        const titleForFileName = (newTitle && newTitle.trim().length > 0) ? newTitle.trim() : resInfo.title;
                        dispatch(completeExportProgress({
                            id: exportJobId,
                            fileName: titleForFileName + ' (Clustal Omega Report)',
                            reportUrl: url,
                        }));
                    }
                }
                return;
            }
            let blob;
            if (format === 'EXCEL' || format === 'CSV' || format === 'TSV' || format === 'PNL' || format === 'PNFIL') {
                blob = new Blob([response], {type: fileType});
            } else if (format === 'Clustal') {
                blob = new Blob([(response.response_content)], {type: fileType});
            } else if ((format === 'XML' || format === 'BizInt') && response instanceof Blob) {
                blob = response;
            } else {
                blob = new Blob([(response.exportResults)], {type: fileType});
            }

            let link = document.createElement("a");
            let fileURL = URL.createObjectURL(blob);
            link.setAttribute("href", fileURL);
            let titleForFileName = (newTitle && newTitle.trim().length > 0) ? newTitle.trim() : resInfo.title;
            let fileName = _.replace(titleForFileName, new RegExp('/[^\-_a-zA-Z0-9\.]+/', 'g'), '_');
            link.setAttribute("download", fileName + fileExtension);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            if (isTrackedExport) {
                dispatch(completeExportProgress({
                    id: exportJobId,
                    fileName: fileName + fileExtension,
                    downloadUrl: fileURL,
                    totalBytes: blob.size,
                }));
            }
        } else if (format === 'LifeQuest') {
            window.open(process.env.REACT_APP_BASE_URL + 'query?do=gqredirect.lq&lq_ca=patentList/workfileInProgress&id=lq');
            return;
        } else if (isTrackedExport) {
            dispatch(failExportProgress({ id: exportJobId, error: 'The export failed on the server. Please try again.' }));
        }
    }

    const closeExportModal = () => {
        setShowExportAllModal(false);
        setShowExportChoicesModal(false);
        setShowExportVmModal(false);
        setShowPatbaseModal(false);
        if (pbTimer) {
            if (document.getElementById('pb_pn_list')) {
                document.getElementById('pb_pn_list').submit();
            }
            clearInterval(pbTimer);
        }
    }
    let dedDatabasePrefsForUI = [];
      /* ===== Function to show/hide duplicate records ==== */
      function displayDedpreferences (resultFilter) {
        
        let tmpDedDatabasePrefsForUI = [];
        tmpDedDatabasePrefsForUI.push('GQPat'); // Keeps GQPat as the first choice
        //console.log(resultFilter,"resultFilter")
        
        resultFilter.dbs.forEach(function (value) {
            var name = getPrefName(value);
            if (tmpDedDatabasePrefsForUI.length === 0 || tmpDedDatabasePrefsForUI.indexOf(name) < 0) {
                tmpDedDatabasePrefsForUI.push(name);
            }
        });
        
        if (!dedDatabasePrefs || dedDatabasePrefs.length === 0) {
            // Initialized from the user accessible database list
            setDeduplication(false);
            filter.state.deduplication = false;
            dedDatabasePrefsForUI = _.cloneDeep(tmpDedDatabasePrefsForUI);
        } else {
            if (dedDatabasePrefs.length !== tmpDedDatabasePrefsForUI.length) {
                dedDatabasePrefsForUI = _.cloneDeep(tmpDedDatabasePrefsForUI);
            } else {
                dedDatabasePrefsForUI = _.cloneDeep(dedDatabasePrefs);
            }
        }
        setDedDataBasePrefsForUI(dedDatabasePrefsForUI);
        setDedupModal(true);
    };

    const closeDedupModal = () => {
        setDedupModal(false);
    }

    const saveDedup = (filter, fieldConfig, dedDataBasePrefsForUI) => {
        setDedDatabasePrefs(_.cloneDeep(dedDataBasePrefsForUI));
        filter.state.dedDatabasePrefs = _.cloneDeep(dedDataBasePrefsForUI);
        if (editable) {
            saveResultState(filter, fieldConfig);
        }
        setDedupModal(false);
    }

    const openSaveResultsModal = (open) => {
        if (open) {
            setDownloadType("SaveResultAs");
            setSaveAsName("copy of " + resInfo['title']);
            setShowSaveResultsModal(true);
        } else {
            setShowSaveResultsModal(false);
        }
    }

    /* ====== Functions to manage ESF sorting options ======================================= */
    fieldConfig.customSortingFields.PFD_PA = Authorities.loadAuthorities();
    let saveAndApplySort = false;
    function errorsInSortOption(saveAndApply,sortname) {
        saveAndApplySort = saveAndApply;
        //fieldConfig.addSortOption(sortname);
        filter.state.sort=sortname;
        loadResultsFromBackend(false);
        saveAndApplySort = false;
    };

    function deleteSortOption(fieldConfig, filter){
        if (fieldConfig.sortOptionName === filter.state.sort){
            filter.state.sort = 'high_percid_query';
        }
        fieldConfig.deleteSortOption(fieldConfig, filter);
        if (editable === true) {
            saveResultState(filter, fieldConfig);
        }
        if (fieldConfig.sortOptionName === filter.state.sort){
            loadResultsFromBackend(false);
        }
    };

    function manageSortOptions() {
        setManageSortModal(true);
        saveAndApplySort = false;
        fieldConfig.sortOptionName = '';
        fieldConfig.sortOptions = [];
        fieldConfig.sortOptions[0] = fieldConfig.newSortingAtom();
    }


    function closeManageSortModal() {
        saveAndApplySort = false;
        setManageSortModal(false);
    }

    const saveFilteredResult = async(fieldConfig, filter, resInfo, title, format, choice) => {
        setShowSaveResultsModal(false);
        let javaCall = {
            data: {
                'workflow_type': 'GqWfAlndbCopy',
                'groupCriteria': 'alignment',
                'parent_id': resid.match(/\d+/)[0],
                'ttlAlignments': viewCount.RESULT_ID,
                'createVm': hasLvaAccess && lvaLoadingReady,
                'title': title,
                'firstName': userInfo.current_user?.first_name,
                'lastName': userInfo.current_user?.last_name,
                'loginName': userInfo.current_user?.login_name,
                'accountingGroup': userInfo.current_user?.accounting_group_name,
            }
        };
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
        applyFilterForJava(javaCall);
        let response = await DiscoverService.saveFilteredResult(javaCall.data);
        if (response) {
            let id = response.response_content;
            setSaveFiltedResultMsg(process.env.REACT_APP_URL + 'discover/wf:' + id + '.resdb');
            setShowSaveResultsSucModal(true);
        }
    }


    const saveFilteredResultBundle = async(filter,title,joinedEmails) => {
        let wftitle = 'SharedResult ' + resInfo['title'];

        let domaincheck = await ftAccess.checkDomains(joinedEmails);
        if((domaincheck.response_content[0] == "same" && userInfo.current_user.ppu_type == 0) ||
        userInfo.current_user.ppu_type == 2 ){
            toast.info("Please wait while the workflow is being shared...", {
                autoClose: 5000,  
              });  
            let javaCall = {
                data: {
                    'workflow_type': 'GqWfAlndbCopy',
                    'groupCriteria': 'alignment',
                    'parent_id': resid.match(/\d+/)[0],
                    'ttlAlignments': viewCount.RESULT_ID,
                    'createVm': hasLvaAccess && lvaLoadingReady,
                    'title': wftitle,
                    'firstName': userInfo.current_user?.first_name,
                    'lastName': userInfo.current_user?.last_name,
                    'loginName': userInfo.current_user?.login_name,
                    'accountingGroup': userInfo.current_user?.accounting_group_name,
                }
            };
            Object.assign(filterState, filter.state);
            setFilterState({...filterState});
            applyFilterForJava(javaCall);
            let response = await DiscoverService.saveFilteredResult(javaCall.data);
            if (response) {
                let id = response.response_content;
                let parentId = resid.match(/\d+/)[0];
                const getaddShareResponse = await ftAccess.addSharedEmail(id, parentId, joinedEmails);
                if (getaddShareResponse && getaddShareResponse.response_status == 0) {
                    toast.success('Workflow Shared with the user');

                } else if(getaddShareResponse && getaddShareResponse.response_status == 1) {
                    const myString = getaddShareResponse.response_content.message;

                    if (typeof myString === 'string' && myString.startsWith("Non unique")){
                        toast.error("Email id is not unique, and has multiple GQ accounts");  
                    }
                    else{
                        toast.error(getaddShareResponse.response_content.message);  
                    }
                            
                }
                else{	
                    toast.error('Adding in Error.');
                    }
                
            }
        }
        else{	
            toast.error('Email not in same domain.');
            }
    
}

    const closeSaveResultsSucModal = () => {
        setShowSaveResultsModal(false);
        setShowSaveResultsSucModal(false);
    }

    const displayItemsView = (dbkey1, dbkey2, parentGroup, fieldConfig, filter) => {
        let value1 = '', value2 = '';
        if (dbkey1 && dbkey1 !== '') {
            value1 = dbkey1.substr(dbkey1.indexOf('_') + 1, dbkey1.length);
            if (value1 === 'NULL' || value1 === 'undefined') {
                value1 = '';
            }
            let type = dbkey1.substr(0, dbkey1.indexOf('_'));
            if (type === 'hsp') {
                // Special case for hsp, set value1=qframe_queryId, value2=sframe_subjectId
                let qframe = value1.substr(0, value1.indexOf('_'));
                let sframe = value1.substr(value1.indexOf('_') + 1);
                // parentGroup.RESULT_FQ is a converted string, so use qframe passed from backend instead,
                // same case for parentGroup.RESULT_NFD
                value1 = qframe + "_" + parentGroup.QUERY_ID;
                value2 = sframe + "_" + parentGroup.SUBJECT_ID;
            } else if (type === 'ali') { // for ALI grouping
                // Special case for Alignment grouping, set value1=queryId, value2=FQ_OOBQ_FD_OOBD_S.L_S.D
                value2 = value1;
                value1 = parentGroup.QUERY_ID;
            }
        } else {
            console.log('empty dbkey for more items.');
            return;
        }
        if (dbkey2 && dbkey2 !== '') {
            value2 = dbkey2.substr(dbkey2.indexOf('_') + 1, dbkey2.length);
            if (value2 === 'NULL' || value2 === 'undefined') {
                value2 = '';
            }
        }
        setGroupValue1(value1);
        setGroupValue2(value2);
        fetchItemsNow(fieldConfig, filter, value1, value2, 1);
    }

    const changeItemsPage = async (e, page, fieldConfig, filter, groupValue1, groupValue2) => {
        if (page) {
            fetchItemsNow(fieldConfig, filter, groupValue1, groupValue2, page);
        }
    }

    function createMoreItemsFilter(fieldConfig, groupValue1, groupValue2) {
        let newItemFilter = {};
        newItemFilter["filterMode"] = "AND";
        let criterias = [];
        let newContent = {};
        newContent["fieldType"] = "string";
        newContent["fieldOperator"] = "EQUALS";
        switch (fieldConfig.tableDisplayMode) {
            case 'family':
                newItemFilter["filterName"] = "familyGroupedItems";
                newContent["fieldName"] = "SUBJECT_PB";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                if (groupValue2 && groupValue2 !== '') {
                    newContent = {};
                    newContent["fieldName"] = "SUBJECT_PN";
                    newContent["fieldType"] = "string";
                    newContent["fieldOperator"] = "EQUALS";
                    newContent["fieldValue"] = groupValue2;
                    criterias.push(newContent);
                }
                break;
            case 'document':
                newItemFilter["filterName"] = "docGroupedItems";
                newContent["fieldName"] = "SUBJECT_PN";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                break;
            case 'ufs':
                newItemFilter["filterName"] = "ufsGroupedItems";
                newContent["fieldName"] = "SUBJECT_PJ";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                if (groupValue2 && groupValue2 !== '') {
                    newContent = {};
                    newContent["fieldName"] = "SUBJECT_PB";
                    newContent["fieldType"] = "string";
                    newContent["fieldOperator"] = "EQUALS";
                    newContent["fieldValue"] = groupValue2;
                    criterias.push(newContent);
                }
                break;
            case 'cas':
                newItemFilter["filterName"] = "casGroupedItems";
                newContent["fieldName"] = "SUBJECT_RG";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                break;
            case 'ssv':
                newItemFilter["filterName"] = "ssvGroupedItems";
                newContent["fieldName"] = "SUBJECT_ID";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                break;
            case 'qs':
                newItemFilter["filterName"] = "qsGroupedItems";
                newContent["fieldName"] = "QUERY_ID";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                break;
            case 'npa':
                newItemFilter["filterName"] = "npaGroupedItems";
                newContent["fieldName"] = "SUBJECT_PU";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                break;
            case 'aipa':
                newItemFilter["filterName"] = "aipaGroupedItems";
                newContent["fieldName"] = "SUBJECT_ZF";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                break;
            case 'org':
                newItemFilter["filterName"] = "orgGroupedItems";
                newContent["fieldName"] = "SUBJECT_OS";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                break;
            case 'gname': // only a prefix for Subject database name
                newItemFilter["filterName"] = "gnameGroupedItems";
                newContent["fieldName"] = "SUBJECT_GNAME";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                break;
            case 'gqid': 
                newItemFilter["filterName"] = "gqidGroupedItems";
                newContent["fieldName"] = "SUBJECT_GX";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                break;
             case 'extpf':
                newItemFilter["filterName"] = "extpfGroupedItems";
                newContent["fieldName"] = "SUBJECT_XF";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                break;
            case 'sid':
                newItemFilter["filterName"] = "sidGroupedItems";
                newContent["fieldName"] = "SUBJECT_ID";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);
                break;
            case 'ali':
                newItemFilter["filterName"] = "aliGroupedItems";
                newContent["fieldName"] = "QUERY_ID";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);

                // groupValue2=FQ_OOBQ_FD_OOBD_S.L_RID
                const values = _.split(groupValue2, "_");
                newContent = {};
                newContent["fieldName"] = "RESULT_FQ";
                newContent["fieldType"] = "string";
                newContent["fieldOperator"] = "EQUALS";
                newContent["fieldValue"] = values[0];
                criterias.push(newContent);

                newContent = {};
                newContent["fieldName"] = "RESULT_OOBQ";
                newContent["fieldType"] = "int";
                newContent["fieldOperator"] = "EQUALS";
                newContent["fieldValue"] = values[1];
                criterias.push(newContent);

                newContent = {};
                newContent["fieldName"] = "RESULT_NFD";
                newContent["fieldType"] = "string";
                newContent["fieldOperator"] = "EQUALS";
                newContent["fieldValue"] = values[2];
                criterias.push(newContent);

                newContent = {};
                newContent["fieldName"] = "RESULT_OOBD";
                newContent["fieldType"] = "int";
                newContent["fieldOperator"] = "EQUALS";
                newContent["fieldValue"] = values[3];
                criterias.push(newContent);

                newContent = {};
                newContent["fieldName"] = "SUBJECT_L";
                newContent["fieldType"] = "int";
                newContent["fieldOperator"] = "EQUALS";
                newContent["fieldValue"] = values[4];
                criterias.push(newContent);

                if (values.length > 5 && values[5] && values[5] !== '') {
                    newContent = {};
                    newContent["fieldName"] = "RESULT_SD";
                    newContent["fieldType"] = "string";
                    newContent["fieldOperator"] = "EQUALS";
                    newContent["fieldValue"] = values[5];
                    criterias.push(newContent);
                }
                break;
            case 'hsp':
                let groupValue3 = groupValue1.substr(groupValue1.indexOf('_') + 1);
                groupValue1 = groupValue1.substr(0, groupValue1.indexOf('_'));
                newItemFilter["filterName"] = "hspGroupedItems";
                newContent["fieldName"] = "QUERY_ID";
                newContent["fieldValue"] = groupValue3;
                criterias.push(newContent);

                newContent = {};
                newContent["fieldName"] = "RESULT_FQ";
                newContent["fieldType"] = "string";
                newContent["fieldOperator"] = "EQUALS";
                newContent["fieldValue"] = groupValue1;
                criterias.push(newContent);

                let groupValue4 = groupValue2.substr(groupValue2.indexOf('_') + 1);
                groupValue2 = groupValue2.substr(0, groupValue2.indexOf('_'));
                newContent = {};
                newContent["fieldName"] = "SUBJECT_ID";
                newContent["fieldType"] = "string";
                newContent["fieldOperator"] = "EQUALS";
                newContent["fieldValue"] = groupValue4;
                criterias.push(newContent);

                newContent = {};
                newContent["fieldName"] = "RESULT_NFD";
                newContent["fieldType"] = "string";
                newContent["fieldOperator"] = "EQUALS";
                newContent["fieldValue"] = groupValue2;
                criterias.push(newContent);
                break;
            default:
                break;
        }
        newItemFilter["fieldCriterias"] = criterias;
        return newItemFilter;
    }

    const fetchItemsNow = async(fieldConfig, filter, groupValue1, groupValue2, itemsCurrentPage) => {
        setItemsCurrentPage(itemsCurrentPage);
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});

        let call = {
            data: {
                workflowId: resid.match(/\d+/)[0],
                userId: window.$javaCall.data.userId,
                groupCriteria: 'alignment',
                sortCriteria: filterState.sort,
                sortCriterias: fieldConfig.populateSortCriterias(filterState.sort),
                pageNum: itemsCurrentPage
            }
        };
        applyFilterForJava(call);
        let newItemFilter = createMoreItemsFilter(fieldConfig, groupValue1, groupValue2);
        if (call.data["customFilters"] && Object.keys(call.data["customFilters"]).length > 0) {
            call.data["customFilters"].push(newItemFilter);
        } else {
            call.data["customFilters"] = [];
            call.data["customFilters"].push(newItemFilter);
        }

        let response = await DiscoverService.getItems(call.data, window.$javaCall.data.gqApiKey, history);
        if (response) {
            let newData = fieldConfig.javaObjectConverter(response, 'alignment', querydb.SEQUENCE_ID, fieldConfig, cmMap, cmColorMap, filter.state.cmColorLevel);
            let itemsData = {};
            itemsData.data = newData.data;
            itemsData.itemsStats = newData.stats;
            itemsData.itemsStats.count = [];
            itemsData.itemsStats.count.ali = newData.stats.nav.total_count;

            // restores checkboxes, colors, stars
            itemsAnnotState.checkboxes = {};
            for (let idx in newData.checkboxes) {
                itemsAnnotState.checkboxes[idx] = newData.checkboxes[idx];
            }
            itemsAnnotState.colors = {};
            for (let idx in newData.colors) {
                itemsAnnotState.colors[idx] = newData.colors[idx];
            }
            itemsAnnotState.stars = {};
            for (let idx in newData.stars) {
                itemsAnnotState.stars[idx] = newData.stars[idx];
            }
            itemsAnnotState.notes = {};
            for (let idx in newData.notes) {
                itemsAnnotState.notes[idx] = newData.notes[idx];
            }
            itemsAnnotState.notesCheckboxes = {};
            for (let idx in newData.notesCheckboxes) {
                itemsAnnotState.notesCheckboxes[idx] = newData.notesCheckboxes[idx];
            }
            itemsAnnotState.dbkeys = {};
            for (let idx in newData.data) {
                itemsAnnotState.dbkeys[newData.data[idx]['dbkey']] = newData.data[idx]["RESULT_ID"];
            }

            if (itemsData && itemsData.data) {
                prepClaimsCollapse(itemsData, 'flat', claimsCollapseAll);
                prepAlignmentsCollapse(itemsData, 'flat', alignmentsCollapseAll);
                prepDetailPageCollapse(itemsData, 'flat', detailPageCollapseAllLevelOne, detailPageCollapseAllLevelTwo, detailPageCollapseAllLevelThree, itemsAnnotState);
            }
            itemsAnnotState.claimsCollapse = claimsCollapse;
            itemsAnnotState.claimsCollapseLess = {};
            itemsAnnotState.alignmentsCollapse = alignmentsCollapse;

            let gqAlignments = [], gqAlignmentsNoSumm = [], gqAlignmentsStrNoSumm = [], gqAlignmentsSumm = [], gqAlignmentsVariation = [], gqAlignmentsStrFlanking = [];
            populateGqAlignments(filter, newData.data, gqAlignments, gqAlignmentsNoSumm, gqAlignmentsStrNoSumm, gqAlignmentsSumm, gqAlignmentsVariation, gqAlignmentsStrFlanking);

            // For the table display
            setItemsTotalPage(response.lastPage);
            itemsData.displayMode = 'flat';
            annotState.claimsCollapse = claimsCollapse;
            annotState.claimsCollapseLess = {};
            annotState.alignmentsCollapse = alignmentsCollapse;
            itemsData.annotState = itemsAnnotState;
            itemsData.gqAlignments = gqAlignments;
            itemsData.gqAlignmentsNoSumm = gqAlignmentsNoSumm;
            itemsData.gqAlignmentsStrNoSumm = gqAlignmentsStrNoSumm;
            itemsData.gqAlignmentsStrFlanking = gqAlignmentsStrFlanking;
            itemsData.gqAlignmentsSumm = gqAlignmentsSumm;
            itemsData.gqAlignmentsVariation = gqAlignmentsVariation;
            itemsData.docItems = docItems;
            itemsData.docItemsSelected = docItemsSelected;
            itemsData.algorithm = resInfo.algorithm;

            let itemsViewFields = [];
            if (fieldConfig.tableDisplayMode === 'family') {
                itemsViewFields = fieldConfig.userTableTemplate['fam'].concat(fieldConfig.userTableTemplate['doc']).concat(fieldConfig.userTableTemplate['sin']);
            } else if (fieldConfig.tableDisplayMode === 'document') {
                itemsViewFields = fieldConfig.userTableTemplate['doc'].concat(fieldConfig.userTableTemplate['sin']);
            } else if (fieldConfig.tableDisplayMode === 'ufs') {
                itemsViewFields = fieldConfig.userTableTemplate['ufs'].concat(fieldConfig.userTableTemplate['fam']).concat(fieldConfig.userTableTemplate['flat']);
            } else if (fieldConfig.tableDisplayMode === 'cas') {
                if (fieldConfig.userTableTemplate['cas'] === undefined || fieldConfig.userTableTemplate['cas'] === 'undefined') {
                    itemsViewFields = fieldConfig.defaultUserTableTemplate['cas'].concat(fieldConfig.userTableTemplate['flat']);
                } else {
                    itemsViewFields = fieldConfig.userTableTemplate['cas'].concat(fieldConfig.userTableTemplate['flat']);
                }
            } else if (fieldConfig.tableDisplayMode === 'ssv') {
                if (fieldConfig.userTableTemplate['ssv'] === undefined || fieldConfig.userTableTemplate['ssv'] === 'undefined') {
                    itemsViewFields = fieldConfig.defaultUserTableTemplate['ssv'].concat(fieldConfig.userTableTemplate['sin']);
                } else {
                    itemsViewFields = fieldConfig.userTableTemplate['ssv'].concat(fieldConfig.userTableTemplate['sin']);
                }
            } else if (fieldConfig.tableDisplayMode === 'qs') {
                if (fieldConfig.userTableTemplate['qs'] === undefined || fieldConfig.userTableTemplate['qs'] === 'undefined') {
                    itemsViewFields = fieldConfig.defaultUserTableTemplate['qs'].concat(fieldConfig.userTableTemplate['sin']);
                } else {
                    itemsViewFields = fieldConfig.userTableTemplate['qs'].concat(fieldConfig.userTableTemplate['sin']);
                }
            } else if (fieldConfig.tableDisplayMode === 'hsp') {
                if (fieldConfig.userTableTemplate['hsp'] === undefined || fieldConfig.userTableTemplate['hsp'] === 'undefined') {
                    itemsViewFields = fieldConfig.defaultUserTableTemplate['hsp'].concat(fieldConfig.userTableTemplate['sin']);
                } else {
                    itemsViewFields = fieldConfig.userTableTemplate['hsp'].concat(fieldConfig.userTableTemplate['sin']);
                }
            } else {
                if (fieldConfig.userTableTemplate[fieldConfig.tableDisplayMode] === undefined
                    || fieldConfig.userTableTemplate[fieldConfig.tableDisplayMode] === 'undefined') {
                    itemsViewFields = fieldConfig.defaultUserTableTemplate[fieldConfig.tableDisplayMode].concat(fieldConfig.userTableTemplate['sin']);
                } else {
                    itemsViewFields = fieldConfig.userTableTemplate[fieldConfig.tableDisplayMode].concat(fieldConfig.userTableTemplate['sin']);
                }
            }
            itemsData.columns = itemsViewFields;

            let width = 310;
            itemsViewFields.forEach(function (value) {
                width += parseInt(fieldConfig.fieldConfig[value].colwidth) + 20;
            });
            itemsData.tableWidth = width;

            setItemsAnnotState(itemsAnnotState);
            setItemsData(itemsData);
            setShowItemsModal(true);
        }

    }

    const refreshAnnotState = (notesState) => {
        setAnnotState(notesState);
    }

    const closeItemsModal = () => {
        setAnnotState({...annotState});
        setShowItemsModal(false);
    }

    const closeFilterModal = () => {
        setAddFilterPopup(false);
    }

    const closeDeleteFilterModal = () =>{
        setDeleteFilterPopup(false);
    }

    const saveFilter = (filter, fieldConfig, sideMenuDetail) => {
        // Save the filter into database
        filter.addCustomFilterToList(filter, fieldConfig);
        enableApplyButton();
        setAddFilterPopup(false);
        if (fieldConfig.showAlert) {
            // Show the alert message
            popupInfoMsg(fieldConfig.alertMsg);
        } else {
            UIlog.record(resid, 'CUSTOMFILTER_NEW', filter.widgetState.customFilterName);
            filter.widgetState = {...filter.widgetState};
            filter.state = {...filter.state};

            // Open the filter list when adding a new one
            setWidgetState({...filter.widgetState});
            sideMenuDetail['mycustomfilter'] = true;
            setSideMenuDetail({...sideMenuDetail});

            // TODO, Save the result state?
            //saveResultState(filter, fieldConfig);
        }
    }

    const setFilterCheckbox = (filter, idx) => {
        enableApplyButton();
        if (!filter.state.customFilterCheckboxes) {
            filter.state.customFilterCheckboxes = [];
        }
        filter.state.customFilterCheckboxes[idx] = !filter.state.customFilterCheckboxes[idx];
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
    }

    const setCmFilterCheckbox = (filter, idx) => {
        enableApplyButton();
        if (!Array.isArray(filter.state.cmFilterCheckboxes)) {
            filter.state.cmFilterCheckboxes = [];
        }
        filter.state.cmFilterCheckboxes[idx] = !filter.state.cmFilterCheckboxes[idx];
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
    }

    const startFilteringWidget = (filter, type, idx) => {
        if (type === 'default') {
            // View/Edit default filter
            const df = filter.widgetState?.defaultCustomFilters?.[idx];
            if (!df) return;
            widgetState.widgetContent = _.cloneDeep(df.widgetContent);
            widgetState.widgetMode = df.widgetMode;
            widgetState.widgetCustomQuery = df.widgetCustomQuery;
            widgetState.customFilterName = df.customFilterName;
        } else if (type === 'custom') {
            // View/Edit custom filter
            const cf = filter.widgetState?.customFilters?.[idx];
            if (!cf) return;
            widgetState.widgetContent = _.cloneDeep(cf.widgetContent);
            widgetState.widgetMode = cf.widgetMode;
            widgetState.widgetCustomQuery = cf.widgetCustomQuery;
            widgetState.customFilterName = cf.customFilterName;
        } else {
            // Create new filter
            widgetState.widgetContent = [{field: 'ALL_TEXT', field_type: 'string', operator: 'CONTAINS', value: '', second_value: ''}];
            widgetState.widgetMode = 'AND';
            widgetState.widgetCustomQuery = '';
            widgetState.customFilterName = '';
        }
        setWidgetState({...widgetState});
        setAddFilterPopup(true);
    }

    const removeCustomFilterFromList = (filter, fieldConfig, idx) => {
        filter.lvaWidgetState = {...filter.lvaWidgetState};
        filter.widgetState = {...filter.widgetState}; // When saved as global
        filter.state = {...filter.state};

        setDeleteIdx(idx);
        setDeleteFilterPopup(true);
    }

    const removeCustomFilterFromListAction = async (filter, fieldConfig, idx) => {
        let oldQuery = filter.query;
        let needReload = false;
        let uuid = filter.widgetState.customFilters[idx].uuid;
        for (let key in oldQuery.customFilters) {
            if (uuid === oldQuery.customFilters[key].uuid) {
                needReload = true;
                break;
            }
        }

        let defaultSize = filter.widgetState.defaultCustomFilters.length;
        filter.widgetState.customFilters = filter.widgetState.customFilters.filter((_, i) => i !== idx);
        if (filter.state.customFilterCheckboxes) {
            filter.state.customFilterCheckboxes = filter.state.customFilterCheckboxes.filter((_, i) => i !== idx + defaultSize);
        }
        //filter.widgetState.customFilterDeleted[idx + defaultSize] = true;
        setWidgetState({...filter.widgetState});

        if (singleAlignmentId === undefined && abExp === undefined && vmExp === undefined && reportId === undefined && alerts === undefined) {
            await fieldConfig.saveConfig(fieldConfig, 'default', filter); // save
            saveResultState(filter, fieldConfig);
        }

        if (needReload) {
            loadResultsFromBackend(true);
        }
    }

    const closeMessageModal = (fieldConfig) => {
        fieldConfig.showAlert = false;
        dismissInfoMsg();
    }

    const saveAnnotation = async(type, choice, annotated, dbkey, value,
                            annotState, filter, fieldConfig,
                            fromItemsPage, groupValue1, groupValue2, parentAnnotState) => {
        // Type = checkbox/star/color
        // Choice = single/thisPage/all/thisPageWhole/whole/thisGroup/sameSubject/samePatent
        // annotated = true for Annotated/false for Unanotated
        // dbkey, used for single annotation
        // fromItemsPage, groupValue1, groupValue2, when comes from the 'More Items' page

        let groupCriteria, dbkeyPrefix, pnsPerPage = '', alignmentsPerPage = '';
        if (fromItemsPage) {
            groupCriteria = 'alignment';
            //currentPage = itemsCurrentPage;
        } else {
            switch (fieldConfig.tableDisplayMode) {
                case 'family':
                    groupCriteria = 'fam';
                    dbkeyPrefix = "fam_";
                    pnsPerPage = fieldConfig.famViewOption;
                    alignmentsPerPage = fieldConfig.famViewAliOption;
                    break;
                case 'document':
                    groupCriteria = 'patent';
                    dbkeyPrefix = "doc_";
                    alignmentsPerPage = fieldConfig.pnViewOption;
                    break;
                case 'flat':
                    groupCriteria = 'alignment';
                    dbkeyPrefix = "ali_";
                    break;
                case 'ufs':
                    groupCriteria = 'ufs';
                    dbkeyPrefix = "ufs_";
                    alignmentsPerPage = fieldConfig.ufsOption;
                    break;
                case 'cas':
                    groupCriteria = 'cas';
                    dbkeyPrefix = "cas_";
                    break;
                case 'ssv':
                    groupCriteria = 'ssv';
                    dbkeyPrefix = "ssv_";
                    alignmentsPerPage = fieldConfig.ssvOption;
                    break;
                case 'qs':
                    groupCriteria = 'qs';
                    dbkeyPrefix = "qs_";
                    alignmentsPerPage = fieldConfig.qsOption;
                    break;
                case 'hsp':
                    groupCriteria = 'hsp';
                    dbkeyPrefix = "hsp_";
                    alignmentsPerPage = fieldConfig.hspOption;
                    break;
                case 'flat':
                    groupCriteria = 'ali';
                    dbkeyPrefix = "align_";
                    alignmentsPerPage = fieldConfig.groupOption;
                    break;
                default:
                    groupCriteria = fieldConfig.tableDisplayMode;
                    dbkeyPrefix = fieldConfig.tableDisplayMode + "_";
                    alignmentsPerPage = fieldConfig.groupOption;
                    break;
            }
        }
        let call = {
            data: {
                workflowId: resid.match(/\d+/)[0],
                userId: userdir ? userdir : window.$javaCall.data.userId,
                groupCriteria: groupCriteria,
                pnsPerPage: pnsPerPage,
                alignmentsPerPage: alignmentsPerPage,
                sortCriteria: filter.state.sort,
                sortCriterias: fieldConfig.populateSortCriterias(filter.state.sort),
                //pageNum: state.currentPage
            }
        };
        if (type === 'checkbox') {
            call.data['value'] = value <= 0 ? 1 : 0;
        } else if (type === 'notes') {
            call.data['value'] = 0;
            call.data['comment'] = value;
        } else {
            call.data['value'] = value;
        }
        call.data['annotType'] = type;
        call.data['unannotated'] = !annotated;

        if (choice === 'thisPage' || choice === 'all' || choice === 'thisGroup' || choice === 'sameSubject' || choice === 'samePatent') {
            filter.state = {...filter.state};
            applyFilterForJava(call, false);
        }
        if ((fromItemsPage && choice === 'all') || choice === 'thisGroup') {
            let newItemFilter = createMoreItemsFilter(fieldConfig, groupValue1, groupValue2);
            if (call.data["customFilters"] && Object.keys(call.data["customFilters"]).length > 0) {
                call.data["customFilters"].push(newItemFilter);
            } else {
                call.data["customFilters"] = [];
                call.data["customFilters"].push(newItemFilter);
            }
        }
        if (choice === 'sameSubject' || choice === 'samePatent') {
            let newItemFilter = {};
            newItemFilter["filterMode"] = "AND";
            let criterias = [];
            let newContent = {};
            newContent["fieldType"] = "string";
            newContent["fieldOperator"] = "EQUALS";
            if (choice === 'sameSubject') {
                newItemFilter["filterName"] = "ssvGroupedItems";
                newContent["fieldName"] = "SUBJECT_ID";
                newContent["fieldValue"] = groupValue1;
            } else {
                newItemFilter["filterName"] = "docGroupedItems";
                newContent["fieldName"] = "SUBJECT_PN";
                newContent["fieldValue"] = groupValue1;
            }
            criterias.push(newContent);
            newItemFilter["fieldCriterias"] = criterias;
            if (call.data["customFilters"] && Object.keys(call.data["customFilters"]).length > 0) {
                call.data["customFilters"].push(newItemFilter);
            } else {
                call.data["customFilters"] = [];
                call.data["customFilters"].push(newItemFilter);
            }
        }

        let selectedIds = [];
        if (choice === 'single') {
            if (type === 'checkbox') {
                annotState.checkboxes[dbkey] = Boolean(value <= 0);
                if (fromItemsPage && parentAnnotState.dbkeys[dbkey]) {
                    parentAnnotState.checkboxes[dbkey] = Boolean(value <= 0);
                }
            } else if (type === 'star') {
                annotState.stars[dbkey] = value;
                if (fromItemsPage && parentAnnotState.dbkeys[dbkey]) {
                    parentAnnotState.stars[dbkey] = value;
                }
            } else if (type === 'color') {
                annotState.colors[dbkey] = value;
                if (fromItemsPage && parentAnnotState.dbkeys[dbkey]) {
                    parentAnnotState.colors[dbkey] = value;
                }
            } else if (type === 'notes') {
                annotState.notes[dbkey] = value;
                if (fromItemsPage && parentAnnotState.dbkeys[dbkey]) {
                    parentAnnotState.notes[dbkey] = value;
                }
            }
            call.data['allPages'] = false;
            call.data['unannotated'] = false;
            selectedIds.push(annotState.dbkeys[dbkey]);
            if (fromItemsPage) {
                setItemsAnnotState({...annotState});
                setAnnotState(parentAnnotState);
            } else {
                setAnnotState({...annotState});
            }
        } else {
            if (choice === 'thisPage' || choice === 'thisPageWhole') {
                call.data['allPages'] = false;
                for (let idx in annotState.dbkeys) {
                    selectedIds.push(annotState.dbkeys[idx]);
                }
            } else if (choice === 'thisGroup' || choice === 'sameSubject' || choice === 'samePatent') {
                call.data['allPages'] = false;
            } else {
                call.data['allPages'] = true;
            }

            if (choice !== 'thisGroup' && choice !== 'sameSubject' && choice !== 'samePatent') {
                // Update the values for current page
                for (let idx in annotState.dbkeys) {
                    if (type === 'checkbox') {
                        if (annotated) {
                            annotState.checkboxes[idx] = Boolean(value <= 0);
                            if (fromItemsPage && parentAnnotState.dbkeys[idx]) {
                                parentAnnotState.checkboxes[idx] = Boolean(value <= 0);
                            }
                        } else if (!annotated && !annotState.checkboxes[idx]) {
                            annotState.checkboxes[idx] = Boolean(value <= 0);
                            if (fromItemsPage && parentAnnotState.dbkeys[idx]) {
                                parentAnnotState.checkboxes[idx] = Boolean(value <= 0);
                            }
                        }
                    } else if (type === 'star') {
                        if (annotated) {
                            annotState.stars[idx] = value;
                            if (fromItemsPage && parentAnnotState.dbkeys[idx]) {
                                parentAnnotState.stars[idx] = value;
                            }
                        } else if (!annotated && (!annotState.stars[idx] || annotState.stars[idx] === 0)) {
                            annotState.stars[idx] = value;
                            if (fromItemsPage && parentAnnotState.dbkeys[idx]) {
                                parentAnnotState.stars[idx] = value;
                            }
                        }
                    } else if (type === 'color') {
                        if (annotated) {
                            annotState.colors[idx] = value;
                            if (fromItemsPage && parentAnnotState.dbkeys[idx]) {
                                parentAnnotState.colors[idx] = value;
                            }
                        } else if (!annotated && (!annotState.colors[idx] || annotState.colors[idx] === 0)) {
                            annotState.colors[idx] = value;
                            if (fromItemsPage && parentAnnotState.dbkeys[idx]) {
                                parentAnnotState.colors[idx] = value;
                            }
                        }
                    } else if (type === 'notes') {
                        if (annotated) {
                            annotState.notes[idx] = value;
                            if (fromItemsPage && parentAnnotState.dbkeys[idx]) {
                                parentAnnotState.notes[idx] = value;
                            }
                        } else if (!annotated && (!annotState.notes[idx] || annotState.notes[idx] === '')) {
                            annotState.notes[idx] = value;
                            if (fromItemsPage && parentAnnotState.dbkeys[idx]) {
                                parentAnnotState.notes[idx] = value;
                            }
                        }
                    }
                }
            } else {
                let keys = annotState.dbkeysMap[dbkeyPrefix + groupValue1];
                if (keys) {
                    for (let keyIndex in keys) {
                        let key = keys[keyIndex];
                        if (key) {
                            if (type === 'checkbox') {
                                if (annotated) {
                                    annotState.checkboxes['ali_' + key] = Boolean(value <= 0);
                                } else if (!annotated && !annotState.checkboxes['ali_' + key]) {
                                    annotState.checkboxes['ali_' + key] = Boolean(value <= 0);
                                }
                            } else if (type === 'star') {
                                if (annotated) {
                                    annotState.stars['ali_' + key] = value;
                                } else if (!annotated && (!annotState.stars['ali_' + key] || annotState.stars['ali_' + key] === 0)) {
                                    annotState.stars['ali_' + key] = value;
                                }
                            } else if (type === 'color') {
                                if (annotated) {
                                    annotState.colors['ali_' + key] = value;
                                } else if (!annotated && (!annotState.colors['ali_' + key] || annotState.colors['ali_' + key] === 0)) {
                                    annotState.colors['ali_' + key] = value;
                                }
                            } else if (type === 'notes') {
                                if (annotated) {
                                    annotState.notes['ali_' + key] = value;
                                } else if (!annotated && (!annotState.notes['ali_' + key] || annotState.notes['ali_' + key] === '')) {
                                    annotState.notes['ali_' + key] = value;
                                }
                            }
                        }
                    }
                }
            }

            if (fromItemsPage) {
                if (choice === 'whole') {
                    for (let idx in parentAnnotState.dbkeys) {
                        if (type === 'checkbox') {
                            if (parentAnnotState && parentAnnotState.checkboxes[idx]) {
                                parentAnnotState.checkboxes[idx] = Boolean(value <= 0);
                            } else if (!annotated && !parentAnnotState.checkboxes[idx]) {
                                parentAnnotState.checkboxes[idx] = Boolean(value <= 0);
                            }
                        } else if (type === 'star') {
                            if (annotated && parentAnnotState.stars[idx] && parentAnnotState.stars[idx] > 0) {
                                parentAnnotState.stars[idx] = value;
                            } else if (!annotated && (!parentAnnotState.stars[idx] || parentAnnotState.stars[idx] === 0)) {
                                parentAnnotState.stars[idx] = value;
                            }
                        } else if (type === 'color') {
                            if (annotated && parentAnnotState.colors[idx] && parentAnnotState.colors[idx] > 0) {
                                parentAnnotState.colors[idx] = value;
                            } else if (!annotated && (!parentAnnotState.colors[idx] || parentAnnotState.colors[idx] === 0)) {
                                parentAnnotState.colors[idx] = value;
                            }
                        } else if (type === 'notes') {
                            if (annotated && parentAnnotState.notes[idx] && parentAnnotState.notes[idx] > 0) {
                                parentAnnotState.notes[idx] = value;
                            } else if (!annotated && (!parentAnnotState.notes[idx] || parentAnnotState.notes[idx] === '')) {
                                parentAnnotState.notes[idx] = value;
                            }
                        }
                    }
                }
                setItemsAnnotState({...annotState});
                setAnnotState(parentAnnotState);
            } else {
                setAnnotState({...annotState});
            }
        }
        call.data['selectedIds'] = selectedIds;

        // Save annotation
        const response = await DiscoverService.saveAnnotation(call.data, window.$javaCall.data.gqApiKey);
        if (response && response.selectedIds && (choice === 'thisGroup' || choice === 'sameSubject' || choice === 'samePatent')) {
            // Update the annotState for the group
            for (let id in response.selectedIds) {
                if (type === 'checkbox') {
                    annotState.checkboxes['ali_' + response.selectedIds[id]] = Boolean(value <= 0);
                } else if (type === 'star') {
                    annotState.stars['ali_' + response.selectedIds[id]] = value;
                } else if (type === 'color') {
                    annotState.colors['ali_' + response.selectedIds[id]] = value;
                } else if (type === 'notes') {
                    annotState.notes['ali_' + response.selectedIds[id]] = value;
                }
            }
            setAnnotState({...annotState});
        }
    }

    function getAbFiltersDesc() {
        if (!_.isEmpty(window.reportFilters)) {
            var reportABFiltersData = window.reportFilters;
            var clone = Object.assign({}, reportABFiltersData);
            delete clone.workflowId;
            delete clone.userId;
            var repFilters = Object.keys(clone);
            var filterList = [];
            for (let key of repFilters) {
                if (!_.isEmpty(reportABFiltersData[key]) && key !== 'groupBy' && key !== 'cdrCombinationsString' && key !== 'cdrCombinations' ) {
                    var descr = abFiltersMap[key];
                    if (descr) { // When the key exists, displays as a filter
                        filterList.push(descr + " - " +reportABFiltersData[key]);
                    }
                }
                if (!_.isEmpty(reportABFiltersData[key]) && ( key == 'cdrCombinations' )) {
                    var cdrs = reportABFiltersData['cdrCombinations'];
                    var matchString = reportABFiltersData['cdrCombinationsString'];
                    var matchcdrs = []; var missingcdrs= []; var mismatchcdrs=[];
                    var description = 'Sequences with ';
                    for(var i=0; i<matchString.length;i++) {
                        if (matchString.charAt(i) == 'M') matchcdrs.push(cdrs[i]);
                        else if (matchString.charAt(i) == '-')  missingcdrs.push(cdrs[i]);
                        else if (matchString.charAt(i) == 'X') mismatchcdrs.push(cdrs[i]);
                    }
                    // var descr = "Sequences with ";
                    var descr = [];
                    if (!_.isEmpty(matchcdrs)){
                        descr.push("matching " + matchcdrs.join());
                        //console.log('matches for ' + matchcdrs.join());
                    }
                    if (!_.isEmpty(missingcdrs)) {
                        descr.push("no " + missingcdrs.join());
                        // console.log('missing cdrs for ' + missingcdrs.join());
                    }
                    if (!_.isEmpty(mismatchcdrs)) {
                        descr.push("mismatches for " + mismatchcdrs.join());
                        // console.log('mismatches for ' + mismatchcdrs.join());
                    }
                    filterList.push("Sequences with " + descr.join(", "));
                }
            }
            return filterList;
           /* var repFilters = Object.values(clone);
            var filterList = [];
            for (let value of repFilters) {
                if (!_.isEmpty(value) ) {
                    filterList.push(value);
                }
            }*/
           // return filterList.join(', ');
        }else{
            return [];
        }
    }

    function noteListChanged(filter, text) {
        filter.state.annot.noteList = text;
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
        enableApplyButton();
    }

    function resetNotes(filter){
        if(filter.state.annot.noteList !== null){
            filter.state.annot.noteList = '';
        }
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
        enableApplyButton();
    }

    const saveVmFilter = (filter, fieldConfig, sideMenuDetail) => {
        sideMenuDetail['lvaModules'] = true;
        sideMenuDetail['lvaFilters'] = true;
        setSideMenuDetail({...sideMenuDetail});

        filter.addLvaFilterToList(filter, fieldConfig);
        enableApplyButton();
        UIlog.record(resid, 'VM_CUSTOMFILTER_NEW', filter.lvaWidgetState.customFilterName);
        filter.lvaWidgetState = {...filter.lvaWidgetState};
        filter.widgetState = {...filter.widgetState}; // When saved as global
        filter.state = {...filter.state};
        // Save the filter into database
        if (editable === true) {
            saveResultState(filter, fieldConfig); // Save LVA filters
        }

        setVmIds({...vmIds}); // In order to refresh the VM filter list, especially when adding from the toolbar
    }

    const setLvaFilterCheckbox = (filter, idx) => {
        enableApplyButton();
        if (!filter.state.lvaFilterCheckboxes) {
            filter.state.lvaFilterCheckboxes = [];
        }
        filter.state.lvaFilterCheckboxes[idx] = !filter.state.lvaFilterCheckboxes[idx];
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
    }

    const removeLvaFilterFromList = (filter, fieldConfig, idx) => {
        if (!filter.lvaWidgetState.lvaFilters[idx]) {
            // Already removed
            return;
        }
        let oldQuery = filter.query;
        let needReload = false;
        let uuid = filter.lvaWidgetState.lvaFilters[idx].uuid;
        for (let key in oldQuery.lvaFilters) {
            if (uuid === oldQuery.lvaFilters[key].uuid) {
                needReload = true;
                break;
            }
        }

        //fieldConfig.saveConfig(fieldConfig, 'default', filter); // only needed for global filters

        // Remove the filter from the existing list
        filter.lvaWidgetState.lvaFilters.splice(idx, 1);
        filter.state.lvaFilterCheckboxes?.splice(idx, 1); // remove checkbox state as well
        if (editable === true) {
            saveResultState(filter, fieldConfig);
        }

        if (needReload) {
            // When it is used in the last query, reload the whole page
            loadResultsFromBackend(true);
        } else {
            setVmIds({...vmIds}); // In order to refresh the VM filter list
        }
    }
    
    const enableApplyButton = () => {
        // Won't enable the apply button when coming from reports
        setApplyEnabled(reportId === undefined);
    }

    const handleInlineLucene = (ftsState) => {
        setFtsInline(prev => ({ ...prev, value: ftsState.fieldDisplayValue }));
    };

    const handleInlineEndString = (val) => {
        console.log('[FT endString] visible string:', val);

        setFtsInline(prev => ({
            ...prev,
            fieldDisplayValue: val,
            tempFieldDisplayValue: val,
            value: val
        }));
        setApplyEnabled(true);
        if(val == ''){
            setApplyEnabled(false);
        }
    };

    const handleFTModalSave = (ftsState,ono) => {
        console.log('Saved from FTSearchModal:', ftsState);

        // Extract what to show in the inline box (allow empty strings)
        const nextVal =
            ftsState?.fieldDisplayValue !== undefined
                ? ftsState.fieldDisplayValue
                : (ftsState?.value ?? '');

        // Update inline state (this will set empty when modal sends empty)
        setFtsInline(prev => ({
            ...prev,
            value: ftsState?.value || nextVal, // Use parsed lucene value if available
            fieldDisplayValue: nextVal,
            tempFieldDisplayValue: nextVal
        }));

        // If the text is cleared, increment the reset counter to force re-render
        if (nextVal === '') {
            setFtsResetCounter(prev => prev + 1);
        }

        setApplyEnabled(true);
        if(nextVal === ''){
            setApplyEnabled(false);
        }

        setShowFTModal(false);
    };

    const refreshCmAlign = (val, data, filter, fieldConfig) => {
        // Save flag in State
        setHighlightHits(val);
        filter.state.highlightHits = val;
        refreshCmTable(data, filter, fieldConfig);
    }

    const refreshCmTable = (data, filter, fieldConfig) => {
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
        saveResultState(filter, fieldConfig);

        const alignmentPatternFilter = getAlignmentPatternFilter(filter, true);

        // Refresh the GQ alignments to use the new highlight option
        gqAlignments = [];
        gqAlignmentsNoSumm = [];
        gqAlignmentsStrNoSumm = [];
        gqAlignmentsSumm = [];
        gqAlignmentsVariation = [];
        let gqAlignmentsStrFlankingRefresh = [];
        populateGqAlignments(alignmentPatternFilter, data.data, gqAlignments, gqAlignmentsNoSumm, gqAlignmentsStrNoSumm, gqAlignmentsSumm, gqAlignmentsVariation, gqAlignmentsStrFlankingRefresh);
        data.gqAlignments = gqAlignments;
        data.gqAlignmentsNoSumm = gqAlignmentsNoSumm;
        data.gqAlignmentsStrNoSumm = gqAlignmentsStrNoSumm;
        data.gqAlignmentsStrFlanking = gqAlignmentsStrFlankingRefresh;
        data.gqAlignmentsSumm = gqAlignmentsSumm;
        data.gqAlignmentsVariation = gqAlignmentsVariation;
        setSearchResultData(data);
    }

    const refreshCmColorLevel = (val, data, filter, fieldConfig, cmMap, cmColorLevel) => {
        setCmColorLevel(val);
        filter.state.cmColorLevel = val;
        /*
        if (data.cms !== undefined && data.cms !== "") {
            newData["SUBJECT_M3"] = structureCmType(data.cms, cmMap, cmColorMap, cmColorLevel);
        }
        if (data.cmHits !== undefined && data.cmHits !== "") {
            newData["SUBJECT_M1"] = structureCmType(data.cmHits, cmMap, cmColorMap, cmColorLevel);
            newData["SUBJECT_M4"] = structureCmTable(data.cmHits, cmMap, cmColorLevel);
        }
        if (data.cmAllHits !== undefined && data.cmAllHits !== "") {
            newData["SUBJECT_M2"] = structureCmTable(data.cmAllHits, cmMap, cmColorLevel);
        }*/

        let rowIdx, item, node0, node1;
        for (rowIdx in data.data) {
            item = data.data[rowIdx];
            if (item.hasOwnProperty('cmHits')) {
                item["SUBJECT_M3"] = fieldConfig.structureCmType(item['cms'], cmMap, cmColorMap, val);
                item["SUBJECT_M1"] = fieldConfig.structureCmType(item['cmHits'], cmMap, cmColorMap, val);
                item["SUBJECT_M4"] = fieldConfig.structureCmTable(item['cmHits'], cmMap, val);
                item["SUBJECT_M2"] = fieldConfig.structureCmTable(item['cmAllHits'], cmMap, val);
            } else {
                for (let nodeIdx in item.nodes) {
                    node0 = item.nodes[nodeIdx];
                    if (node0.hasOwnProperty('cmHits')) {
                        node0["SUBJECT_M3"] = fieldConfig.structureCmType(node0['cms'], cmMap, cmColorMap, val);
                        node0["SUBJECT_M1"] = fieldConfig.structureCmType(node0['cmHits'], cmMap, cmColorMap, val);
                        node0["SUBJECT_M4"] = fieldConfig.structureCmTable(node0['cmHits'], cmMap, val);
                        node0["SUBJECT_M2"] = fieldConfig.structureCmTable(node0['cmAllHits'], cmMap, val);
                    } else {
                        for (let nodeIdx1 in node0.nodes) {
                            node1 = node0.nodes[nodeIdx1];
                            if (node1.hasOwnProperty('cmHits')) {
                                node1["SUBJECT_M3"] = fieldConfig.structureCmType(node1['cms'], cmMap, cmColorMap, val);
                                node1["SUBJECT_M1"] = fieldConfig.structureCmType(node1['cmHits'], cmMap, cmColorMap, val);
                                node1["SUBJECT_M4"] = fieldConfig.structureCmTable(node1['cmHits'], cmMap, val);
                                node1["SUBJECT_M2"] = fieldConfig.structureCmTable(node1['cmAllHits'], cmMap, val);
                            }
                        }
                    }
                }
            }
        }
        refreshCmTable(data, filter, fieldConfig);

        // Refresh the colors in CM Filter
        const updatedCmCodes = cmCodes.map(level1 => ({
            ...level1,
            codes: level1.codes.map(level2 => {
                const newLevel2 = {...level2};
                const hasChildren = level2.codes && level2.codes.length > 0;
                if (!hasChildren && !isNaN(level2.code)) {
                    newLevel2.color = getCmColor(cmMap, level2.code, cmColorMap, val, parseInt(level2.code));
                } else if (hasChildren) {
                    const actualCode = parseInt(String(level2.code).replace('2-', ''));
                    if (!isNaN(actualCode)) {
                        newLevel2.color = getCmColor(cmMap, actualCode, cmColorMap, val, actualCode);
                    }
                    newLevel2.codes = level2.codes.map(level3 => ({
                        ...level3,
                        color: !isNaN(level3.code)
                            ? getCmColor(cmMap, level3.code, cmColorMap, val, parseInt(level3.code))
                            : level3.color,
                    }));
                }
                return newLevel2;
            }),
        }));
        setCmCodes(updatedCmCodes);
    }

    const [pfmFilterOpen, setPfmFilterOpen] = useState(false); 
    const [pfmWidgetState, setPfmWidgetState] = useState({});

    const [QSPModalIsOpen, setQSPModalIsOpen] = useState(false);
    const [qspWidgetState, setQspWidgetState] = useState({});
    const [qspResultSeqType, setQspResultSeqType] = useState('protein');

    function inferQspSeqTypeFromModIds(modIds, dictionary) {
        if (!Array.isArray(modIds) || !dictionary || typeof dictionary.get !== 'function') {
            return null;
        }

        for (let index = 0; index < modIds.length; index++) {
            const id = parseInt(modIds[index], 10);
            if (Number.isNaN(id)) {
                continue;
            }
            const entry = dictionary.get(id);
            const baseType = entry && typeof entry.base_type === 'string' ? entry.base_type : '';
            if (baseType === 'NUC') {
                return 'nucleotide';
            }
            if (baseType === 'PRT') {
                return 'protein';
            }
            return null;
        }

        return null;
    }

    function normalizeQspSeqType(type) {
        if (typeof type !== 'string') {
            return null;
        }

        const normalizedType = type.trim().toLowerCase();
        if (!normalizedType) {
            return null;
        }

        if (normalizedType === 'protein' || normalizedType === 'prt' || normalizedType === 'aa' || normalizedType === 'aminoacid' || normalizedType === 'amino_acid') {
            return 'protein';
        }

        if (normalizedType === 'nucleotide' || normalizedType === 'nuc' || normalizedType === 'nt' || normalizedType === 'dna' || normalizedType === 'rna') {
            return 'nucleotide';
        }

        if (normalizedType.includes('protein') || normalizedType.includes('prt') || normalizedType.includes('amino') || normalizedType.includes('aa')) {
            return 'protein';
        }

        if (normalizedType.includes('nucleotide') || normalizedType.includes('nuc') || normalizedType.includes('dna') || normalizedType.includes('rna') || normalizedType.includes('nt')) {
            return 'nucleotide';
        }

        return null;
    }

    function inferQspSeqTypeFromQueryInfo(queryInfo) {
        if (!queryInfo || typeof queryInfo !== 'object') {
            return null;
        }

        const queryEntries = Object.values(queryInfo);
        if (queryEntries.length === 0) {
            return null;
        }

        let proteinVotes = 0;
        let nucleotideVotes = 0;

        for (let index = 0; index < queryEntries.length; index++) {
            const entry = queryEntries[index];
            if (!entry || typeof entry !== 'object') {
                continue;
            }

            const typeCandidates = [entry.qdb_seq_type, entry.queryType, entry.subjectType, entry.type];
            for (let candidateIndex = 0; candidateIndex < typeCandidates.length; candidateIndex++) {
                const normalizedType = normalizeQspSeqType(typeCandidates[candidateIndex]);
                if (normalizedType === 'protein') {
                    proteinVotes += 1;
                } else if (normalizedType === 'nucleotide') {
                    nucleotideVotes += 1;
                }
            }

            if (typeof entry.seq === 'string' && entry.seq.trim() !== '') {
                const cleanedSeq = entry.seq.toUpperCase().replace(/[^A-Z]/g, '');
                if (cleanedSeq.length > 0) {
                    if (/[EFHIJKLMPQRSVWYZ]/.test(cleanedSeq)) {
                        proteinVotes += 1;
                    } else if (/^[ATGCUN]+$/.test(cleanedSeq)) {
                        nucleotideVotes += 1;
                    }
                }
            }
        }

        if (proteinVotes === 0 && nucleotideVotes === 0) {
            return null;
        }

        return proteinVotes >= nucleotideVotes ? 'protein' : 'nucleotide';
    }

    function openQSPFilter(startingFilterState, idx = -1) {
        if (Number(querySeqIdsCount) <= 0) {
            return;
        }

        const hasStartingState = (
            startingFilterState &&
            typeof startingFilterState === 'object' &&
            !Array.isArray(startingFilterState) &&
            Object.keys(startingFilterState).length > 0
        );

        const resultSeqType = qspModSeqTypeRef.current || qspResultSeqType;

        if (hasStartingState) {
            const normalizedStartingType = normalizeQspSeqType(startingFilterState.qdb_seq_type);
            setQspWidgetState({
                searchInfo: {
                    cm_filters: _.cloneDeep(startingFilterState),
                    qdb_seq_type: normalizedStartingType || resultSeqType,
                    idx: idx,
                },
                layout: {
                    errorIdList: [],
                    isRedo: false,
                }
            });
        } else {
            setQspWidgetState({});
        }

        setQSPModalIsOpen(true);
    }

    function closeQSPFilter() {
        setQspWidgetState({});
        setQSPModalIsOpen(false);
    }

    function normalizeCmCriteriaCodes(codes) {
        if (!Array.isArray(codes)) {
            return [];
        }

        const normalizedCodes = [];
        const addCode = (rawCode) => {
            if (rawCode === null || rawCode === undefined) {
                return;
            }

            const code = String(rawCode).trim();
            if (code !== '' && !normalizedCodes.includes(code)) {
                normalizedCodes.push(code);
            }
        };

        for (let index = 0; index < codes.length; index++) {
            const entry = codes[index];

            if (entry === null || entry === undefined) {
                continue;
            }

            if (Array.isArray(entry)) {
                entry.forEach(addCode);
                continue;
            }

            if (typeof entry === 'string') {
                const trimmedEntry = entry.trim();
                if (trimmedEntry.startsWith('{') && trimmedEntry.endsWith('}')) {
                    try {
                        const parsedEntry = JSON.parse(trimmedEntry);
                        if (Array.isArray(parsedEntry?.values)) {
                            parsedEntry.values.forEach(addCode);
                            continue;
                        }
                    } catch (error) {
                        // Keep non-JSON strings as-is.
                    }
                }

                addCode(trimmedEntry);
                continue;
            }

            if (typeof entry === 'object') {
                if (Array.isArray(entry.values)) {
                    entry.values.forEach(addCode);
                    continue;
                }

                if (entry.Mod_ID !== undefined) {
                    addCode(entry.Mod_ID);
                    continue;
                }
            }

            addCode(entry);
        }

        return normalizedCodes;
    }

    function normalizeQspFilterForApply(cmFilter) {
        if (!cmFilter || typeof cmFilter !== 'object' || Array.isArray(cmFilter)) {
            return {};
        }

        const normalizedFilter = _.cloneDeep(cmFilter);
        if (!Array.isArray(normalizedFilter.patterns)) {
            return normalizedFilter;
        }

        normalizedFilter.patterns = normalizedFilter.patterns.map((pattern) => {
            if (!pattern || typeof pattern !== 'object' || Array.isArray(pattern)) {
                return pattern;
            }

            const normalizedPattern = {...pattern};
            if (!Array.isArray(normalizedPattern.cmCriteria)) {
                return normalizedPattern;
            }

            normalizedPattern.cmCriteria = normalizedPattern.cmCriteria.map((criteria) => {
                if (!criteria || typeof criteria !== 'object' || Array.isArray(criteria)) {
                    return criteria;
                }

                const normalizedCriteria = {...criteria};
                if (!Array.isArray(normalizedCriteria.posList)) {
                    normalizedCriteria.posList = [];
                }
                if (Array.isArray(normalizedCriteria.codes)) {
                    normalizedCriteria.codes = normalizeCmCriteriaCodes(normalizedCriteria.codes);
                }

                return normalizedCriteria;
            });

            return normalizedPattern;
        });

        return normalizedFilter;
    }

    function applyQSPFilter(newFilterState) {
        const normalizedFilterState = (
            newFilterState &&
            typeof newFilterState === 'object' &&
            !Array.isArray(newFilterState) &&
            newFilterState.searchInfo &&
            typeof newFilterState.searchInfo === 'object' &&
            !Array.isArray(newFilterState.searchInfo)
        )
            ? normalizeQspFilterForApply(newFilterState.searchInfo.cm_filters || {})
            : {};

        filter.state = {...filter.state};
        const currentCmFilters = Array.isArray(filter.state.cmFilters)
            ? _.cloneDeep(filter.state.cmFilters)
            : [];
        const currentCmFilterCheckboxes = Array.isArray(filter.state.cmFilterCheckboxes)
            ? _.cloneDeep(filter.state.cmFilterCheckboxes)
            : [];
        const normalizedFilterName = typeof normalizedFilterState.filterName === 'string'
            ? normalizedFilterState.filterName.trim()
            : '';
        const idxFromState = Number.isInteger(newFilterState?.searchInfo?.idx)
            ? newFilterState.searchInfo.idx
            : -1;
        let savedFilterIdx = -1;

        const existingFilterIndex = currentCmFilters.findIndex((cmFilter) => (
            cmFilter &&
            typeof cmFilter === 'object' &&
            !Array.isArray(cmFilter) &&
            typeof cmFilter.filterName === 'string' &&
            cmFilter.filterName.trim() === normalizedFilterName
        ));

        if (idxFromState >= 0 && idxFromState < currentCmFilters.length) {
            currentCmFilters[idxFromState] = {...normalizedFilterState};
            savedFilterIdx = idxFromState;
        } else if (existingFilterIndex >= 0) {
            currentCmFilters[existingFilterIndex] = {...normalizedFilterState};
            savedFilterIdx = existingFilterIndex;
        } else {
            currentCmFilters.push({...normalizedFilterState});
            currentCmFilterCheckboxes.push(true);
            savedFilterIdx = currentCmFilters.length - 1;
        }

        if (currentCmFilterCheckboxes.length < currentCmFilters.length) {
            for (let cmIdx = currentCmFilterCheckboxes.length; cmIdx < currentCmFilters.length; cmIdx++) {
                currentCmFilterCheckboxes[cmIdx] = true;
            }
        } else if (currentCmFilterCheckboxes.length > currentCmFilters.length) {
            currentCmFilterCheckboxes.length = currentCmFilters.length;
        }

        if (savedFilterIdx >= 0 && savedFilterIdx < currentCmFilterCheckboxes.length) {
            currentCmFilterCheckboxes[savedFilterIdx] = true;
        }

        filter.state.cmFilters = currentCmFilters;
        filter.state.cmFilterCheckboxes = currentCmFilterCheckboxes;
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
        saveResultState(filter, fieldConfig);

        closeQSPFilter();
        enableApplyButton();

    }

    function deleteQSPFilter(idx) {
        if (!Array.isArray(filter.state?.cmFilters) || idx < 0 || idx >= filter.state.cmFilters.length) {
            return;
        }

        filter.state = {...filter.state};
        const currentCmFilters = _.cloneDeep(filter.state.cmFilters);
        const currentCmFilterCheckboxes = Array.isArray(filter.state.cmFilterCheckboxes)
            ? _.cloneDeep(filter.state.cmFilterCheckboxes)
            : [];

        currentCmFilters.splice(idx, 1);
        currentCmFilterCheckboxes.splice(idx, 1);

        filter.state.cmFilters = currentCmFilters;
        filter.state.cmFilterCheckboxes = currentCmFilterCheckboxes;
        Object.assign(filterState, filter.state);
        setFilterState({...filterState});
        saveResultState(filter, fieldConfig);
        enableApplyButton();
    }
  
    function openPfmFilter(StartingFilterState,  idx = -1) {
        if(StartingFilterState && Object.keys(StartingFilterState).length > 0){
            StartingFilterState.idx = idx;
            setPfmWidgetState(StartingFilterState);
        }else{
            setPfmWidgetState({});
        }
        setPfmFilterOpen(true);
    }

    function applyPfmFilter(newState) {
        let type = newState.type;
        let idx = newState.idx;
        
        if(idx === -1){

        }else {

        }

        closePfmFilter();

    }

    function closePfmFilter(newState) {
        setPfmWidgetState({});
        setPfmFilterOpen(false);
    }

    // The sidebar's view rows are labels and spans with click handlers, so a keyboard
    // user could not switch views at all. Enter and Space on the focused row do what a
    // click does; preventDefault keeps Space from scrolling the sidebar instead.
    const activateOnKey = (action) => (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            action();
        }
    };

    if (accessDeniedMsg) {
        return (
            <div style={{ padding: '40px', maxWidth: '800px', margin: '40px auto' }}>
                <div style={{ backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px', padding: '20px 24px', color: '#856404' }}>
                    <h5 style={{ fontWeight: 'bold', marginBottom: '10px' }}>Access Denied</h5>
                    <p style={{ margin: 0 }}>{accessDeniedMsg}</p>
                </div>
                <div style={{ marginTop: '16px' }}>
                    <a href="#/searchResult" style={{ color: '#337cb7', textDecoration: 'none' }}>← Back to Search Results</a>
                </div>
            </div>
        );
    }

    return (
        <div id = 'tour-start' className={classes.grow}>
            <Row style={{overflowX: 'auto', flexWrap: 'nowrap'}}>
                <div style={sideMenuCollapse? {display: 'none'}:{display: 'block', position: 'relative'}}>
                <Col md="3" sm="3" xs="3" style={{minWidth: '300px', maxWidth: '300px', paddingLeft: '0px', flex: '0 0 300px', position: 'relative'}}>
                    <div className={classes.sideMenuContainer}>
                    <Col md="12" className="appTextColor">
                        <div id="myColumnGroups">
                        <h6><b>My Column Groups</b></h6>
                        <Accordion square expanded={true}>
                            <AccordionSummary aria-controls='panel-content-cols' id='paneld-header-cols' className="subMenuHeading p-0">
                                <p className="subMenuHeading m-0" onClick={(e) => {showColumnConfigModal('new');e.preventDefault();}} style={{paddingLeft: '5px'}}>
                                    <FaRegPlusSquare style={{marginRight: '5px', verticalAlign: 'middle'}} className="fa fa-plus-square"></FaRegPlusSquare>
                                    <span>Select Displayed Columns</span>
                                </p>
                            </AccordionSummary>
                        </Accordion>
                        {sideMenuDetail &&
                        <Accordion square expanded={sideMenuDetail['saved-view']} onChange={() => toggleSideMenuDetail('saved-view')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" className="p-0" styles = {{backgroundColor: '#292929'}}>
                                <p className="m-0 p-0">
                                    {sideMenuDetail['saved-view'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                    {!sideMenuDetail['saved-view'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                    <span className={classes.arrowIconTitle}>Saved Views</span>
                                </p>
                            </AccordionSummary>
                            <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <Col md="12" sm='12' xs='12' className="side-menu-item-view">
                                    <HoverPopout>
                                    <span className="side-menu-item-view-content">
                                        <span className="selected-view-marker" aria-hidden="true">{fieldConfig.currentView === 'default' ? '-' : ''}</span>
                                        <span style={{fontWeight: fieldConfig.currentView === 'default' ? 'bold' : ''}} role="button" tabIndex={0} aria-current={fieldConfig.currentView === 'default' ? 'true' : undefined} onKeyDown={activateOnKey(()=>switchView('default', fieldConfig))} onClick={()=>switchView('default', fieldConfig)}>Default View</span>
                                    </span>
                                    </HoverPopout>
                                </Col>
                                <Col md="12" sm='12' xs='12' className="side-menu-item-view">
                                    <HoverPopout>
                                    <span className="side-menu-item-view-content">
                                        <span className="selected-view-marker" aria-hidden="true">{fieldConfig.currentView === 'defaultAli' ? '-' : ''}</span>
                                        <span style={{fontWeight: fieldConfig.currentView === 'defaultAli' ? 'bold' : ''}} role="button" tabIndex={0} aria-current={fieldConfig.currentView === 'defaultAli' ? 'true' : undefined} onKeyDown={activateOnKey(()=>switchView('defaultAli', fieldConfig, filter, editable))} onClick={()=>switchView('defaultAli', fieldConfig, filter, editable)}>Default Alignment</span>
                                    </span>
                                    </HoverPopout>
                                </Col>
                                <Col md="12" sm='12' xs='12' className="side-menu-item-view">
                                    <HoverPopout>
                                    <span className="side-menu-item-view-content">
                                    <span className="selected-view-marker" aria-hidden="true">{fieldConfig.currentView === 'defaultFam' ? '-' : ''}</span>
                                    <span style={{fontWeight: fieldConfig.currentView === 'defaultFam' ? 'bold' : ''}} role="button" tabIndex={0} aria-current={fieldConfig.currentView === 'defaultFam' ? 'true' : undefined} onKeyDown={activateOnKey(()=>switchView('defaultFam', fieldConfig, filter, editable))} onClick={()=>switchView('defaultFam', fieldConfig, filter, editable)}>Default Patent Family</span>
                                    </span>
                                    </HoverPopout>
                                </Col>
                                <Col md="12" sm='12' xs='12' className="side-menu-item-view">
                                    <HoverPopout>
                                    <span className="side-menu-item-view-content">
                                        <span className="selected-view-marker" aria-hidden="true">{fieldConfig.currentView === 'defaultFt' ? '-' : ''}</span>
                                        <span style={{fontWeight: fieldConfig.currentView === 'defaultFt' ? 'bold' : ''}} role="button" tabIndex={0} aria-current={fieldConfig.currentView === 'defaultFt' ? 'true' : undefined} onKeyDown={activateOnKey(()=>switchView('defaultFt', fieldConfig, filter, editable))} onClick={()=>switchView('defaultFt', fieldConfig, filter, editable)}>Default Full Text</span>
                                    </span>
                                    </HoverPopout>
                                </Col>
                                {isCmWorkflow &&
                                <Col md="12" sm='12' xs='12' className="side-menu-item-view">
                                    <HoverPopout>
                                    <span className="side-menu-item-view-content">
                                        <span className="selected-view-marker" aria-hidden="true">{fieldConfig.currentView === 'defaultCm' ? '-' : ''}</span>
                                        <span style={{fontWeight: fieldConfig.currentView === 'defaultCm' ? 'bold' : ''}} role="button" tabIndex={0} aria-current={fieldConfig.currentView === 'defaultCm' ? 'true' : undefined} onKeyDown={activateOnKey(()=>switchView('defaultCm', fieldConfig, filter, editable, isCasCm))} onClick={()=>switchView('defaultCm', fieldConfig, filter, editable, isCasCm)}>Default Chemical Mod.</span>
                                    </span>
                                    </HoverPopout>
                                </Col>
                                }
                                {viewKeys && Object.keys(viewKeys).length > 0 &&
                                    Object.keys(viewKeys).map(
                                        (viewName) => (
                                            <Col key={'views_' + viewName} md="12" sm='12' xs='12' className="side-menu-item-view">
                                                <HoverPopout>
                                                <span className="side-menu-item-view-content view-name"
                                                      onClick={()=>switchView(viewKeys[viewName], fieldConfig, filter, editable)}><span className="selected-view-marker" aria-hidden="true">{fieldConfig.currentView === viewKeys[viewName] ? '-' : ''}</span><span style={{fontWeight: (fieldConfig.currentView === viewKeys[viewName] ? 'bold' : '')}}
                                                      role="button" tabIndex={0}
                                                      aria-current={fieldConfig.currentView === viewKeys[viewName] ? 'true' : undefined}
                                                      onKeyDown={activateOnKey(()=>switchView(viewKeys[viewName], fieldConfig, filter, editable))}>{viewKeys[viewName]}</span>
                                                <HoverPopout.Actions>
                                                    {editable &&
                                                        <div style={{display: 'inline-block'}}>
                                                            &nbsp;&nbsp;<Tooltip title="Edit" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();showColumnConfigModal(viewKeys[viewName]);}}><FaPencilAlt size={13} style={{color: "#337ab7"}} /></a></Tooltip>
                                                            &nbsp;<Tooltip title="Delete" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();askDeleteView(viewKeys[viewName]).catch((err) => console.log('delete view failed', err));}}><FaTrash size={13} style={{color: "#337ab7"}} /></a></Tooltip>
                                                            &nbsp;<Tooltip title="Share" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();showShareViewModal(viewKeys[viewName]);}}><FaShareAlt size={13} style={{color: "#337ab7"}} /></a></Tooltip>
                                                        </div>
                                                    }
                                                </HoverPopout.Actions>
                                                </span>
                                                </HoverPopout>
                                            </Col>
                                        )
                                    )
                                }
                            </AccordionDetails>
                        </Accordion>
                        }
                        {/* Views colleagues shared with this user, in their own collapsible
                            section alongside Saved Views. Only rendered when there is
                            something in it, so the sidebar gains nothing when unused. */}
                        {sideMenuDetail && sharedViewKeys && sharedViewKeys.length > 0 &&
                        <Accordion square expanded={!!sideMenuDetail['shared-view']} onChange={() => toggleSideMenuDetail('shared-view')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                            <AccordionSummary aria-controls="panel-content-shared" id="panel-header-shared" className="p-0">
                                <p className="m-0 p-0">
                                    {sideMenuDetail['shared-view'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                    {!sideMenuDetail['shared-view'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                    <span className={classes.arrowIconTitle}>Shared Views</span>
                                </p>
                            </AccordionSummary>
                            <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                {sharedViewKeys.map(
                                    (sharedName) => (
                                        <Col key={'shared_views_' + sharedName} md="12" sm='12' xs='12' className="side-menu-item-view">
                                            <HoverPopout>
                                            <span className="side-menu-item-view-content view-name"
                                                  onClick={()=>switchView(sharedName, fieldConfig, filter, editable)}><span className="selected-view-marker" aria-hidden="true">{fieldConfig.currentView === sharedName ? '-' : ''}</span><span style={{fontWeight: (fieldConfig.currentView === sharedName ? 'bold' : '')}}
                                                  role="button" tabIndex={0}
                                                  aria-current={fieldConfig.currentView === sharedName ? 'true' : undefined}
                                                  onKeyDown={activateOnKey(()=>switchView(sharedName, fieldConfig, filter, editable))}>{fieldConfig.sharedViewInfo[sharedName] ? fieldConfig.sharedViewInfo[sharedName].view_name : sharedName}&nbsp;&nbsp;</span>
                                            <HoverPopout.Actions>
                                                {/* Shared views belong to their owner: no edit, delete or re-share. */}
                                                <div style={{display: 'inline-block', opacity: 0.75}}>
                                                    shared by {fieldConfig.sharedViewInfo[sharedName] ? fieldConfig.sharedViewInfo[sharedName].owner_name : ''}
                                                </div>
                                            </HoverPopout.Actions>
                                            </span>
                                            </HoverPopout>
                                        </Col>
                                    )
                                )}
                            </AccordionDetails>
                        </Accordion>
                        }
                        </div>

                        <div id="HighlightText">
                        <h6 className="mt-2"><b>Highlight Text</b> {videoToggle && <Tooltip title="Video Help for Highlight Text" arrow>
                                    <Link href="https://share.vidyard.com/watch/QNgaKh6Jxr8GRxovdLiDJM" target="_blank" rel="noopener noreferrer">
                                    <PlayCircleOutlineIcon  style={{paddingBottom: '3px', color: 'darkorange',marginBottom: '1px'}} /></Link></Tooltip>}</h6>
                        <div id = 'tour-highlight' className="side-menu-block">
                            <div className="invisible-popup sidebar-tour-width"
                                 //tour-step tour-step-order="8"
                                 //tour-step-content="Highlight text by typing here."
                            >
                                <input id="hlText" key="hlText" type="text" className="search-input" placeholder="Highlight all text"
                                       value={smartHighlightText} autoComplete="off" spellCheck="false"
                                       onChange={(e) => {setAnchorEl(e.currentTarget);smartHighlightGetOptions(e, filter, e.target.value);}}
                                       onKeyDown={(e) => {if(e.key==='Enter'){addSmartHighlight(filter, 'ALL_TEXT');};if(e.key==='Escape'){setSmartHighlightPopup(false);};e.stopPropagation();}}
                                       onClick={(e) => {setAnchorEl(e.currentTarget);smartHighlightGetOptions(e, filter, e.target.value);e.stopPropagation()}}
                                       //onBlur={(e) => {setSmartHighlightPopup(false)}}
                                       style={toggle ? {backgroundColor: ''}:{backgroundColor:'#292929', color: 'white'}}
                                />
                                {smartHighlightPopup && smartHighlightText && smartHighlightText.length >= minSmartTextLen &&
                                    <Popover id={"highlight-popover"}
                                             open={smartHighlightPopup}
                                             anchorEl={anchorEl}
                                             onClose={closePopover}
                                             anchorReference="anchorEl"
                                             anchorOrigin={{
                                                 vertical: "bottom",
                                                 horizontal: "left",
                                             }}
                                             transformOrigin={{
                                                 vertical: "top",
                                                 horizontal: "left",
                                             }}
                                             // pass these props to the popover component
                                             disableAutoFocus={true}
                                             disableEnforceFocus={true}
                                    >
                                        <div className="autocomplete-container">
                                            {smartHighlightOptions.length>0 &&
                                                <div>
                                                    <div className="autocomplete-item"
                                                         onClick={() => addSmartHighlight(filter, 'ALL_TEXT')}>
                                                        {smartHighlightOptions[0].text} in <b>Any Text Field</b>
                                                    </div>
                                                    <div className="autocomplete-spacer"></div>
                                                    {smartHighlightOptions.map(
                                                        (option, optIdx) => (
                                                            <div className="autocomplete-item" key={'hloption_' + optIdx}
                                                                 onClick={() => addSmartHighlight(filter, smartHighlightOptions[optIdx].key)}>
                                                                {smartHighlightOptions[optIdx].text} in <b>{
                                                                fieldConfig.getFieldInfo(smartHighlightOptions[optIdx].key).title
                                                            }</b>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            }
                                            {smartHighlightOptions.length <= 0 &&
                                                <div className="autocomplete-item">"{filter.state.smartHighlight}" Not Found
                                                </div>
                                            }
                                        </div>
                                    </Popover>
                                }

                            </div>

                            {/* {smartHighlightFilter &&
                                Object.keys(smartHighlightFilter).map(index => ( */}

                            {smartHighlightFilter &&
                                Object.keys(smartHighlightFilter)
                                .filter(key => Array.isArray(smartHighlightFilter[key]) ? smartHighlightFilter[key].length > 0 : true)
                                .filter(key => {
                                    if (isCmWorkflow && key === 'QUERY_ID') {
                                        // In CM workflow, only show QUERY_ID if it has manually added items
                                        return smartHighlightFilter[key].some(item => !item.source || item.source !== 'querySeqId');
                                    }
                                    return true;
                                })
                                .map(index => (    
                                    <div className="cursor-default" key={'smartHighlightFilter_' + index}>
                                        <div className="side-menu-item-hl">
                                            <span onClick={(e)=> toggleSideMenuDetail('text-'+index)}>
                                                {index === 'QUERY_ID' 
                                                    ? 'Query Sequence ID'
                                                    : ReactHtmlParser(fieldConfig.getFieldName(index))
                                                }</span>
                                        </div>
                                        {sideMenuDetail && !sideMenuDetail['text-'+index] &&
                                        <div className="side-menu-indent">
                                            {smartHighlightFilter[index] &&
                                                Object.keys(smartHighlightFilter[index])
                                                .filter(subIdx => {
                                                    // In CM workflow, only show manually added QUERY_IDs
                                                    if (isCmWorkflow && index === 'QUERY_ID') {
                                                        return !smartHighlightFilter[index][subIdx].source || smartHighlightFilter[index][subIdx].source !== 'querySeqId';
                                                    }
                                                    return true;
                                                })
                                                .map((subIdx,itemIdx) => (
                                                <div className="side-menu-sub-items" key={"smartHighlightFilterSubDiv_" + itemIdx}
                                                     onMouseEnter={(e) => smartHighlightFilterEvent(index + '_' + itemIdx, true)}
                                                     onMouseLeave={(e) => {smartHighlightFilterEvent(index + '_' + itemIdx, false);showHighlightColorBox(index + '_' + itemIdx, false)}}>
                                                    <div className="clearfix">
                                                        <div className="pull-left">
                                                            <input type="checkbox" checked={smartHighlightFilter[index][subIdx].value || false}
                                                                   onChange={(e)=> {smartHighlightFilter[index][subIdx].value = !smartHighlightFilter[index][subIdx].value;setHighlightCheckbox()}}/>
                                                        </div>
                                                        <div className="color-select-div pull-left">
                                                            <div onClick={() => showHighlightColorBox(index + '_' + itemIdx, true)}
                                                                className={'pull-right color-select-highlight highlight-' + highlightColors[smartHighlightFilter[index][subIdx].color]}></div>
                                                            {highlightColorBox[index + '_' + itemIdx] &&
                                                                <div id="highlightcolorbox" className="clearfix color-box-container" onBlur={() => showHighlightColorBox(index + '_' + itemIdx, false)}>
                                                                    {highlightColors.map(
                                                                        (color, colorIdx) => (
                                                                            <div key={'colorbox_' + color} className={'color-box pull-left highlight-' + color} onClick={() => selectHighlightColor(index, itemIdx, colorIdx)}></div>
                                                                        ))
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="pull-left"><span
                                                            onClick={(e) => {smartHighlightFilter[index][subIdx].value = !smartHighlightFilter[index][subIdx].value;setHighlightCheckbox()}}
                                                        >&nbsp;{smartHighlightFilter[index][subIdx].text}</span>
                                                        </div>
                                                        {smartHighlightFilterHover[index + '_' + itemIdx] &&
                                                            <div className="pull-left">
                                                                &nbsp;&nbsp;<Tooltip title="Delete" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();removeSmartHighlight(filter,index,itemIdx); setHighlightCheckbox();}}><FaTrash size={13} style={{color: "#337ab7"}} /></a></Tooltip>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        }
                                    </div>))
                            }
                            {smartHighlightFilter && Object.keys(smartHighlightFilter)
                                .filter(key => {
                                    if (!Array.isArray(smartHighlightFilter[key]) || smartHighlightFilter[key].length === 0) return false;
                                    if (isCmWorkflow && key === 'QUERY_ID') {
                                        return smartHighlightFilter[key].some(item => !item.source || item.source !== 'querySeqId');
                                    }
                                    return true;
                                }).length > 0 &&
                                <div className="side-menu-block">
                                    <div className="clearfix button-div">
                                        <button className="pull-left small-button grey" onClick={() => clearHighlights()}>Clear Highlights</button>
                                    </div>
                                </div>
                            }
                        </div>
                        </div>
                        {/*<div>
                            <h6 id="FullText" className="mt-2"><b>My FullText Filter</b></h6>
                            <div style={{ display: 'flex', width: '100%' }}>
                                <CustomTooltip title="Expand Full Text Search">
                                    <LaunchIcon aria-label="Expand Full Text Search" onClick={() => setShowFTModal(true)} style={{ borderRadius: 4, width: '15px' }} > </LaunchIcon>
                                </CustomTooltip>
                                <div style={{ flex: 1, minWidth: 280, maxWidth: 640 }}>
                                    <div className='discover-page'>
                                        <div data-ft-discover="true">
                                            <FullTextSearchBox
                                                key={`fts-reset-${ftsResetCounter}`}
                                                setSearchLock={() => { }}
                                                starterString={ftsInline.tempFieldDisplayValue || ftsInline.fieldDisplayValue}
                                                setLuceneQueryValue={handleInlineLucene}
                                                endString={handleInlineEndString}
                                                setNodeId={() => ""}
                                                hideOntologies={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>*/}
                        <div>
                        {/* id moved to a tighter wrapper so the tour spotlight covers only the
                            Filter Text heading + search box, not the filter accordions below */}
                        <div id="FilterText">
                        <h6 className="mt-2"><b>Filter Text</b></h6>
                            <div className="invisible-popup sidebar-tour-width"
                                //tour-step tour-step-order="10"
                                //tour-step-content="Filter results by typing text here. For example type the word claim."
                            >
                                <input id="filterText" key="filterText" type="text" className="search-input" placeholder="Search all text"
                                       value={smartText} autoComplete="off" spellCheck="false"
                                       onChange={(e) => {setFilterAnchorEl(e.currentTarget);smartTextGetOptions(e, filter, e.target.value);}}
                                       onKeyDown={(e) => {if(e.key==='Enter'){addSmartText(filter, 'ALL_TEXT');};if(e.key==='Escape'){setSmartTextPopup(false);};e.stopPropagation();}}
                                       onClick={(e) => {setFilterAnchorEl(e.currentTarget);smartTextGetOptions(e, filter, e.target.value);e.stopPropagation()}}
                                       style={toggle ? {backgroundColor: ''}:{backgroundColor:'#292929', color: 'white'}}
                                />
                                {smartTextPopup && smartText && smartText.length >= minSmartTextLen &&
                                    <Popover id={"smarttext-popover"}
                                             open={smartTextPopup}
                                             anchorEl={filterAnchorEl}
                                             onClose={closePopover}
                                             anchorReference="anchorEl"
                                             anchorOrigin={{
                                                 vertical: "bottom",
                                                 horizontal: "left",
                                             }}
                                             transformOrigin={{
                                                 vertical: "top",
                                                 horizontal: "left",
                                             }}
                                             disableAutoFocus={true}
                                             disableEnforceFocus={true}
                                    >
                                        <div className="autocomplete-container">
                                            {smartTextOptions.length>0 &&
                                                <div>
                                                    <div className="autocomplete-item"
                                                         onClick={() => addSmartText(filter, 'ALL_TEXT')}>
                                                        {smartTextOptions[0].text} in <b>Any Text Field</b>
                                                    </div>
                                                    <div className="autocomplete-spacer"></div>
                                                    {smartTextOptions.map(
                                                        (option, optIdx) => (
                                                            <div className="autocomplete-item" key={'ft_option_' + optIdx}
                                                                 onClick={() => addSmartText(filter, smartTextOptions[optIdx].key)}>
                                                                {smartTextOptions[optIdx].text} in <b>{
                                                                fieldConfig.getFieldInfo(smartTextOptions[optIdx].key).title
                                                            }</b>
                                                            </div>
                                                        )
                                                    )}
                                                </div>
                                            }
                                            {smartTextOptions.length <= 0 &&
                                                <div className="autocomplete-item">"{filter.state.smartText}" Not Found
                                                </div>
                                            }
                                        </div>
                                    </Popover>
                                }

                            </div>
                        </div>

                            {smartTextFilter &&
                                Object.keys(smartTextFilter).map(index => (
                                    <div className="cursor-default" key={'smartTextFilter_' + index}>
                                        <div className="side-menu-item-hl">
                                            <span onClick={(e)=> toggleSideMenuDetail('text-'+index)}>
                                                {ReactHtmlParser(fieldConfig.getFieldName(index))}</span>
                                        </div>
                                        {sideMenuDetail && !sideMenuDetail['text-'+index] &&
                                            <div className="side-menu-indent">
                                                {smartTextFilter[index] &&
                                                    Object.keys(smartTextFilter[index]).map(
                                                        (subIdx,itemIdx) => (
                                                            <div className="side-menu-sub-items" key={"smartTextFilterSubDiv_" + itemIdx}
                                                                 onMouseEnter={(e) => smartTextFilterEvent(index + '_' + itemIdx, true)}
                                                                 onMouseLeave={(e) => {smartTextFilterEvent(index + '_' + itemIdx, false);}}>
                                                                <div className="clearfix">
                                                                    <div className="pull-left">
                                                                        <input type="checkbox" checked={smartTextFilter[index][subIdx].value || false}
                                                                               onChange={(e)=> {smartTextFilter[index][subIdx].value = !smartTextFilter[index][subIdx].value;setSmartTextCheckbox()}}/>
                                                                    </div>
                                                                    <div className="pull-left"><span
                                                                        onClick={(e) => {smartTextFilter[index][subIdx].value = !smartTextFilter[index][subIdx].value;setSmartTextCheckbox()}}
                                                                    >
                                                                        {smartTextFilter[index][subIdx].negate &&
                                                                            <span>&nbsp;<b>NOT</b></span>
                                                                        }
                                                                        &nbsp;{smartTextFilter[index][subIdx].text}</span>
                                                                    </div>
                                                                    {smartTextHover[index + '_' + itemIdx] && editable &&
                                                                        <div className="pull-left">
                                                                            &nbsp;&nbsp;<Tooltip title="Delete" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();removeSmartText(filter,index,itemIdx);}}><FaTrash size={13} style={{color: "#337ab7"}} /></a></Tooltip>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        ))}
                                            </div>
                                        }
                                    </div>))
                            }

                        {sideMenuDetail && !(isCmWorkflow && isCmNoSeq) &&
                        <Accordion square expanded={sideMenuDetail['queryseqid']} onChange={() => {toggleSideMenuDetail('queryseqid')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                            <AccordionSummary aria-controls="panelqid-content" id="panelqid-header" className="subMenuHeading p-0">
                                <p className="subMenuHeading m-0">
                                    {sideMenuDetail['queryseqid'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                    {!sideMenuDetail['queryseqid'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                    <span className="mt-4">Query Sequence ID</span>
                                </p>
                            </AccordionSummary>
                            <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                {Object.keys(querySeqIds).map(
                                    (seq, seqIdx) => (
                                    <Col key={'seq_' + seqIdx} md="12" sm='12' xs='12'>
                                        <input type="checkbox" id={'cb_seq_' + seqIdx} key={'cb_seq_' + seqIdx}
                                               style={{verticalAlign: 'middle'}}
                                               checked={(filter.state.querySeqDbs && filter.state.querySeqDbs[querySeqIds[seq].id]) || false}
                                               onChange={(e)=> {setQuerySeqCheckbox(filter, seq)}}/>
                                        <label htmlFor={'cb_seq_' + seqIdx} key={'cb_seq_label_' + seqIdx}>&nbsp;{querySeqIds[seq].id.toUpperCase()}&nbsp;({Number(querySeqIds[seq].count).toLocaleString()})</label>
                                    </Col>
                                ))}
                                {filter.state.querySeqDbs && _.size(filter.state.querySeqDbs) > 0 && reportId === undefined &&
                                    <div className="clearfix button-div button-div-pad">
                                        <button className="pull-left small-button grey"
                                                onClick={() => {clearQuerySeqIdFilter(filter); loadResultsFromBackend(true)}}>
                                            Reset Query Sequence ID Filter
                                        </button>
                                    </div>
                                }
                                {!_.isEmpty(window.reportFilters) &&
                                <div class="paddingletf15 filter-widget-top">
                                    <span className="mt-4 filterABText">Antibody Filters</span>
                                    <div class="clearfix filterABText">
                                        {abFilterDesc != [] && abFilterDesc.map(abfilterItem => {
                                        return(
                                            <span class="pull-left filterABText">{abfilterItem}</span>
                                        );})
                                        }
                                    </div> 
                                </div>
                                }
                            </AccordionDetails>
                        </Accordion>
                        }

                        {sideMenuDetail &&
                        <Accordion square expanded={sideMenuDetail['pubnumbers']} onChange={() => {toggleSideMenuDetail('pubnumbers')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                            <AccordionSummary aria-controls="panelpns-content" id="panelpns-header" className="subMenuHeading p-0">
                                <p className="subMenuHeading m-0">
                                    {sideMenuDetail['pubnumbers'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                    {!sideMenuDetail['pubnumbers'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                    <span className="mt-4">Patent Numbers</span>
                                </p>
                            </AccordionSummary>
                            <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <Col key={'col_pns'} md="12" sm='12' xs='12'>
                                    <div>
                                    <Tooltip title={pnListErr} placement="top" arrow>
                                    <textarea className={'pnlist ' + ((pnListErr && pnListErr !== '')?'input-with-error':'')}
                                              placeholder="Copy & Paste PN list" value={filter.state.publicationNumberList}
                                              onChange={(e) => pnListChanged(filter, e.target.value)}>
                                    </textarea></Tooltip>
                                    </div>
                                    {filter.state.publicationNumberList && filter.state.publicationNumberList !== '' && reportId === undefined &&
                                        <div className="clearfix button-div ">
                                            <button className="pull-left small-button grey"
                                                    onClick={() => {clearPnFilter(filter); loadResultsFromBackend(true)}}>
                                                Reset Patent Number Filter
                                            </button>
                                        </div>
                                    }
                                </Col>
                            </AccordionDetails>
                        </Accordion>
                        }

                        {sideMenuDetail &&
                        <Accordion square expanded={sideMenuDetail['databasenames']} onChange={() => {toggleSideMenuDetail('databasenames')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                            <AccordionSummary aria-controls="paneldbs-content" id="paneldbs-header" className="subMenuHeading p-0">
                                <p className="subMenuHeading m-0">
                                    {sideMenuDetail['databasenames'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                    {!sideMenuDetail['databasenames'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                    <span className="mt-4">Sequence Databases</span>
                                </p>
                            </AccordionSummary>
                            <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                {Object.keys(databases).map(
                                    (db, dbIdx) => (
                                        <Col key={'coldb_' + dbIdx} md="12" sm='12' xs='12'>
                                            <input type="checkbox" id={'cb_db_' + dbIdx} key={'cb_db_' + dbIdx}
                                                   style={{verticalAlign: 'middle'}}
                                                   checked={(filter.state.databaseNames && filter.state.databaseNames[db]) || false}
                                                   onChange={(e)=> {setDatabaseCheckbox(filter, db)}}/>
                                            <label htmlFor={'cb_db_' + dbIdx} key={'cb_db_label_' + dbIdx}>&nbsp;{databases[db]}</label>
                                        </Col>
                                    ))}
                                {filter.state.databaseNames && _.size(filter.state.databaseNames) > 0 && reportId === undefined &&
                                    <div className="clearfix button-div button-div-pad">
                                        <button className="pull-left small-button grey"
                                                onClick={() => {clearFilter(filter, 'databaseNames'); loadResultsFromBackend(true)}}>
                                            Reset Sequence Database Filter
                                        </button>
                                    </div>
                                }
                            </AccordionDetails>
                        </Accordion>
                        }
                        </div>
                        {sideMenuDetail &&
                        <Accordion id="annotationFilter" square expanded={sideMenuDetail['annotation-filters']} onChange={() => toggleSideMenuDetail('annotation-filters')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                            <AccordionSummary aria-controls="panelannot-content" className="subMenuHeading p-0">
                                <p className="subMenuHeading m-0">
                                    {sideMenuDetail['annotation-filters'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                    {!sideMenuDetail['annotation-filters'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                    <span className={classes.arrowIconTitle}>Annotation Filters</span>
                                </p>
                            </AccordionSummary>
                            <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <Col md="12" sm='12' xs='12' className={classes.row1}>
                                    <Accordion square expanded={sideMenuDetail['annotation-checkboxes']} onChange={() => toggleSideMenuDetail('annotation-checkboxes')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                        <AccordionSummary aria-controls="panelcb-content" id="panelcb-header" className="p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                            <p className="m-0">
                                                {sideMenuDetail['annotation-checkboxes'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                {!sideMenuDetail['annotation-checkboxes'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                                <span className={classes.arrowIconTitle}>Checkboxes</span>
                                            </p>
                                        </AccordionSummary>
                                        <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                             <Col md="12" sm='12' xs='12' className={classes.row1}>
                                                 <input type="checkbox" id='annot_cb_unchecked' key='annot_cb_unchecked'
                                                        style={{verticalAlign: 'middle'}}
                                                        checked={filter.state.annot?.checkboxes?.unchecked || false}
                                                        onChange={(e)=> {setAnnotationCheckbox(filter, 'checkboxes', 'unchecked')}}/>
                                                 <label htmlFor='annot_cb_unchecked'>&nbsp;Unchecked</label>
                                            </Col>
                                            <Col md="12" sm='12' xs='12' className={classes.row2}>
                                                <input type="checkbox" id='annot_cb_checked' key='annot_cb_checked'
                                                       style={{verticalAlign: 'middle'}}
                                                       checked={filter.state.annot?.checkboxes?.checked || false}
                                                       onChange={(e)=> {setAnnotationCheckbox(filter, 'checkboxes', 'checked')}}/>
                                                <label htmlFor='annot_cb_checked'>&nbsp;Checked</label>
                                             </Col>
                                        </AccordionDetails>
                                     </Accordion>   
                                     <Accordion square expanded={sideMenuDetail['annotation-stars']} onChange={() => toggleSideMenuDetail('annotation-stars')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                        <AccordionSummary aria-controls="panelst-content" id="panelst-header" className="p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                            <p className="m-0 p-0">
                                                {sideMenuDetail['annotation-stars'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                {!sideMenuDetail['annotation-stars'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                                <span className={classes.arrowIconTitle}>Stars</span>
                                            </p>
                                        </AccordionSummary>
                                        <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                             <Col md="12" sm='12' xs='12' className={classes.row1}>
                                                 <input type="checkbox" id='annot_st_0' key='annot_st_0'
                                                        style={{verticalAlign: 'middle'}}
                                                        checked={(filter.state.annot?.stars && filter.state.annot.stars['0']) || false}
                                                        onChange={(e)=> {setAnnotationCheckbox(filter, 'stars', '0')}}/>
                                                 <label htmlFor='annot_st_0'>&nbsp;
                                                     <FaStar className="fa fa-star-mid" color={'#DDD'}></FaStar>
                                                     <FaStar className="fa fa-star-mid" color={'#DDD'}></FaStar>
                                                     <FaStar className="fa fa-star-mid" color={'#DDD'}></FaStar>
                                                     &nbsp;Zero Stars</label>
                                            </Col>
                                            <Col md="12" sm='12' xs='12' className={classes.row2}>
                                                <input type="checkbox" id='annot_st_1' key='annot_st_1'
                                                       style={{verticalAlign: 'middle'}}
                                                       checked={(filter.state.annot?.stars && filter.state.annot.stars['1']) || false}
                                                       onChange={(e)=> {setAnnotationCheckbox(filter, 'stars', '1')}}/>
                                                <label htmlFor='annot_st_1'>&nbsp;
                                                    <FaStar className="fa fa-star-mid" color={'#999'}></FaStar>
                                                    <FaStar className="fa fa-star-mid" color={'#DDD'}></FaStar>
                                                    <FaStar className="fa fa-star-mid" color={'#DDD'}></FaStar>
                                                    &nbsp;One Star</label>
                                             </Col>
                                             <Col md="12" sm='12' xs='12' className={classes.row2}>
                                                 <input type="checkbox" id='annot_st_2' key='annot_st_2'
                                                        style={{verticalAlign: 'middle'}}
                                                        checked={(filter.state.annot?.stars && filter.state.annot.stars['2']) || false}
                                                        onChange={(e)=> {setAnnotationCheckbox(filter, 'stars', '2')}}/>
                                                 <label htmlFor='annot_st_2'>&nbsp;
                                                     <FaStar className="fa fa-star-mid" color={'#999'}></FaStar>
                                                     <FaStar className="fa fa-star-mid" color={'#999'}></FaStar>
                                                     <FaStar className="fa fa-star-mid" color={'#DDD'}></FaStar>
                                                     &nbsp;Two Stars</label>
                                             </Col>
                                             <Col md="12" sm='12' xs='12' className={classes.row2}>
                                                 <input type="checkbox" id='annot_st_3' key='annot_st_3'
                                                        style={{verticalAlign: 'middle'}}
                                                        checked={(filter.state.annot?.stars && filter.state.annot.stars['3']) || false}
                                                        onChange={(e)=> {setAnnotationCheckbox(filter, 'stars', '3')}}/>
                                                 <label htmlFor='annot_st_3'>&nbsp;
                                                     <FaStar className="fa fa-star-mid" color={'#999'}></FaStar>
                                                     <FaStar className="fa fa-star-mid" color={'#999'}></FaStar>
                                                     <FaStar className="fa fa-star-mid" color={'#999'}></FaStar>
                                                     &nbsp;Three Stars</label>
                                             </Col>
                                        </AccordionDetails>
                                     </Accordion> 
                                     <Accordion square expanded={sideMenuDetail['annotation-colors']} onChange={() => toggleSideMenuDetail('annotation-colors')}>
                                        <AccordionSummary aria-controls="panelco-content" id="panelco-header" className="p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                            <p className="m-0 p-0">
                                                {sideMenuDetail['annotation-colors'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                {!sideMenuDetail['annotation-colors'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                                <span className={classes.arrowIconTitle}>Colors</span>
                                            </p>
                                        </AccordionSummary>
                                        <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                            {colors.map(
                                                (col, idx) => (
                                                    <Col key={'colco_' + idx} md="12" sm='12' xs='12'>
                                                        <input type="checkbox" id={'annot_co_' + idx}
                                                               style={{verticalAlign: 'middle'}}
                                                               checked={(filter.state.annot?.colors && filter.state.annot.colors[idx]) || false}
                                                               onChange={(e)=> {setAnnotationCheckbox(filter, 'colors', idx)}}/>
                                                        <label htmlFor={'annot_co_' + idx}>&nbsp;<div className={'color-example pull-left color-' + idx}></div>
                                                            {col}</label>
                                                    </Col>
                                                ))}
                                        </AccordionDetails>
                                     </Accordion>
                                    <Accordion square expanded={sideMenuDetail['annotation-notes']} onChange={() => {toggleSideMenuDetail('annotation-notes')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                        <AccordionSummary aria-controls="paneltn-content" id="paneltn-header" className="p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}> 
                                            <p className="p-0 m-0">
                                                {sideMenuDetail['annotation-notes'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                {!sideMenuDetail['annotation-notes'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                                <span className="mt-4">Notes</span>
                                            </p>
                                        </AccordionSummary>
                                        <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                            <Col md="12" sm='12' xs='12' className={classes.row1}>
                                                <input type="checkbox" id='annot_notes_emp' key='annot_notes_emp'
                                                       style={{verticalAlign: 'middle'}}
                                                       checked={filter.state.annot?.notesCheckboxes?.empty || false}
                                                       onChange={(e)=> {setAnnotationCheckbox(filter, 'notesCheckboxes', 'empty')}}/>
                                                <label htmlFor='annot_notes_emp'>&nbsp;Notes are empty</label>
                                            </Col>
                                            <Col md="12" sm='12' xs='12' className={classes.row2}>
                                                <input type="checkbox" id='annot_notes_sel' key='annot_notes_sel'
                                                       style={{verticalAlign: 'middle'}}
                                                       checked={filter.state.annot?.notesCheckboxes?.notEmpty || false}
                                                       onChange={(e)=> {setAnnotationCheckbox(filter, 'notesCheckboxes', 'notEmpty')}}/>
                                                <label htmlFor='annot_notes_sel'>&nbsp;Notes contain</label>
                                                <div>
                                                    <textarea className={'pnlist'} disabled={!filter.state.annot?.notesCheckboxes?.notEmpty}
                                                              placeholder="Search by your notes here" value={filter.state.annot?.noteList}
                                                              onChange={(e) => noteListChanged(filter, e.target.value)}
                                                    >
                                                    </textarea>
                                                    {filter.state.annot?.noteList && reportId === undefined &&
                                                        <button className="pull-left small-button grey" onClick={(e) => resetNotes(filter)}>Reset Notes</button>
                                                    }
                                                </div>
                                            </Col>
                                        </AccordionDetails>
                                    </Accordion>
                                 </Col>
                            </AccordionDetails>
                            </Accordion>
                        }

                        {sideMenuDetail &&
                            <Accordion square expanded={sideMenuDetail['SUBJECT_PN']} onChange={() => {toggleSideMenuDetail('SUBJECT_PN')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls='panel-content-SUBJECT_PN' id='paneld-header-SUBJECT_PN' className="subMenuHeading p-0">
                                    <p className="subMenuHeading m-0">
                                        {sideMenuDetail['SUBJECT_PN'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['SUBJECT_PN'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className="mt-4">Patent Authorities
                                        {videoToggle && <Tooltip title="Video Help for Standard Filters" arrow>
                                    <Link href="https://share.vidyard.com/watch/8GZHKypKwyG8564ReFpZFL" target="_blank" rel="noopener noreferrer">
                                    <PlayCircleOutlineIcon  style={{paddingBottom: '3px', color: 'darkorange',marginBottom: '1px'}} /></Link></Tooltip>}</span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                    {facetInfo && facetInfo['SUBJECT_PN'] && Object.keys(facetInfo['SUBJECT_PN']).length > 0
                                        && Object.keys(facetInfo['SUBJECT_PN']).map(
                                            (db, dbIdx) => (
                                                <Col key={'col_' + db + "_" + dbIdx} md="12" sm='12' xs='12'>
                                                    <input type="checkbox" id={'cb_facet_SUBJECT_PN_' + dbIdx}
                                                           style={{verticalAlign: 'middle'}}
                                                           checked={filter.state['SUBJECT_PN'][db] || false}
                                                           onChange={(e)=> {setFacetCheckbox(filter, 'SUBJECT_PN', db)}}/>
                                                    <label htmlFor={'cb_facet_SUBJECT_PN_' + dbIdx}>
                                                        &nbsp;<span className={'flag-icon flag-icon-' + facetInfo['SUBJECT_PN'][db].desc.toLowerCase()}></span>
                                                        &nbsp;{facetInfo['SUBJECT_PN'][db].desc} ({Number(facetInfo['SUBJECT_PN'][db].count).toLocaleString()})</label>
                                                </Col>
                                            ))}
                                    {_.size(filter.state['SUBJECT_PN']) > 0 && reportId === undefined &&
                                        <div className="clearfix button-div button-div-pad">
                                            <button className="pull-left small-button grey"
                                                    onClick={() => {clearFilter(filter, 'SUBJECT_PN'); loadResultsFromBackend(true)}}>
                                                Reset Patent Authorities Filter
                                            </button>
                                        </div>
                                    }
                                </AccordionDetails>
                            </Accordion>
                        }
                        <span id="advFilterScroll"></span>
                        {sideMenuDetail &&
                            <Accordion square expanded={sideMenuDetail['SUBJECT_PG']} onChange={() => {toggleSideMenuDetail('SUBJECT_PG')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls='panel-content-SUBJECT_PG' id='paneld-header-SUBJECT_PG' className="subMenuHeading p-0">
                                    <p className="subMenuHeading m-0">
                                        {sideMenuDetail['SUBJECT_PG'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['SUBJECT_PG'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className="mt-4">Extended Legal Status</span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                    {facetInfo && facetInfo['SUBJECT_PG'] && Object.keys(facetInfo['SUBJECT_PG']).length > 0
                                        && Object.keys(facetInfo['SUBJECT_PG']).map(
                                            (db, dbIdx) => (
                                                <Col key={'col_' + db + "_" + dbIdx} md="12" sm='12' xs='12'>
                                                    <input type="checkbox" id={'cb_facet_SUBJECT_PG_' + dbIdx}
                                                           style={{verticalAlign: 'middle'}}
                                                           checked={filter.state['SUBJECT_PG'][db] || false}
                                                           onChange={(e)=> {setFacetCheckbox(filter, 'SUBJECT_PG', db)}}/>
                                                    <label htmlFor={'cb_facet_SUBJECT_PG_' + dbIdx}>&nbsp;{facetInfo['SUBJECT_PG'][db].desc} ({Number(facetInfo['SUBJECT_PG'][db].count).toLocaleString()})</label>
                                                </Col>
                                            ))}
                                    {_.size(filter.state['SUBJECT_PG']) > 0 && reportId === undefined &&
                                        <div className="clearfix button-div button-div-pad">
                                            <button className="pull-left small-button grey"
                                                    onClick={() => {clearFilter(filter, 'SUBJECT_PG'); loadResultsFromBackend(true)}}>
                                                Reset Extended Legal Status Filter
                                            </button>
                                        </div>
                                    }
                                </AccordionDetails>
                            </Accordion>
                        }
                        {sideMenuDetail &&
                            <Accordion square expanded={sideMenuDetail['SUBJECT_PS']} onChange={() => {toggleSideMenuDetail('SUBJECT_PS')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls='panel-content-SUBJECT_PS' id='paneld-header-SUBJECT_PS' className="subMenuHeading p-0">
                                    <p className="subMenuHeading m-0">
                                        {sideMenuDetail['SUBJECT_PS'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['SUBJECT_PS'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className="mt-4">Patent Sequence Location</span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                    {facetInfo && facetInfo['SUBJECT_PS'] && Object.keys(facetInfo['SUBJECT_PS']).length > 0
                                        && Object.keys(facetInfo['SUBJECT_PS']).map(
                                            (db, dbIdx) => (
                                                <Col key={'col_' + db + "_" + dbIdx} md="12" sm='12' xs='12'>
                                                    <input type="checkbox" id={'cb_facet_SUBJECT_PS_' + dbIdx}
                                                           style={{verticalAlign: 'middle'}}
                                                           checked={filter.state['SUBJECT_PS'][db] || false}
                                                           onChange={(e)=> {setFacetCheckbox(filter, 'SUBJECT_PS', db)}}/>
                                                    <label htmlFor={'cb_facet_SUBJECT_PS_' + dbIdx}>&nbsp;{facetInfo['SUBJECT_PS'][db].desc} ({Number(facetInfo['SUBJECT_PS'][db].count).toLocaleString()})</label>
                                                </Col>
                                            ))}
                                    {_.size(filter.state['SUBJECT_PS']) > 0 && reportId === undefined &&
                                        <div className="clearfix button-div button-div-pad">
                                            <button className="pull-left small-button grey"
                                                    onClick={() => {clearFilter(filter, 'SUBJECT_PS'); loadResultsFromBackend(true)}}>
                                                Reset Patent Seq. Location Filter
                                            </button>
                                        </div>
                                    }
                                </AccordionDetails>
                            </Accordion>
                        }

                        {/* <span id="fpf"></span>
                        {sideMenuDetail &&
                            <Accordion square expanded={sideMenuDetail['prefamember']} onChange={() => {toggleSideMenuDetail('prefamember')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls='panel-content-customfilter' id='paneld-header-customfilter' className="subMenuHeading p-0">
                                    <p className="subMenuHeading m-0">
                                        {sideMenuDetail['prefamember'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['prefamember'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className="mt-4">Preferred Family Members
                                        {videoToggle && <Tooltip title="Video Help for creating New Filters" arrow>
                                    <Link href="https://share.vidyard.com/watch/nSGYvm1paiCgpBra81C8WM" target="_blank" rel="noopener noreferrer">
                                    <PlayCircleOutlineIcon  style={{paddingBottom: '3px', color: 'darkorange',marginBottom: '1px'}} /></Link></Tooltip>}
                                        </span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                    <Col md="12" sm='12' xs='12' style={{paddingLeft: '5px'}}>
                                        <Accordion square expanded={true}>
                                            <AccordionSummary aria-controls='panel-content-samcustomfilter' id='paneld-header-samcustomfilter' className="subMenuHeading p-0">
                                                <p className="subMenuHeading m-0" onClick={() => {if (editable === true) {openPfmFilter({}, "custom");}}} style={{paddingLeft: '5px'}}>
                                                    <FaRegPlusSquare style={{marginRight: '5px', verticalAlign: 'middle'}} className="fa fa-plus-square"></FaRegPlusSquare>
                                                    <span>Create New Filter</span>
                                                </p>
                                            </AccordionSummary>
                                        </Accordion>
                                        <Accordion square expanded={sideMenuDetail['sampleprefamember']}
                                                   onChange={() => {toggleSideMenuDetail('sampleprefamember')}}>
                                            <AccordionSummary aria-controls='panel-content-samcustomfilter' id='paneld-header-samcustomfilter' className="subMenuHeading p-0">
                                                <p className="subMenuHeading m-0">
                                                    {sideMenuDetail['sampleprefamember'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                    {!sideMenuDetail['sampleprefamember'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                                    <span className="mt-4">Sample Filters</span>
                                                </p>
                                            </AccordionSummary>
                                            <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                {filter.widgetState && filter.widgetState.defaultPfmFilters
                                                    && Object.keys(filter.widgetState.defaultPfmFilters).length > 0 &&
                                                    filter.widgetState.defaultPfmFilters.map(
                                                        (pfmFilter, idx) => (
                                                                <Col key={'defaultPfmFilters' + idx} style={{paddingLeft: '10px', whiteSpace: 'nowrap'}}>
                                                                    <HoverPopout>
                                                                    <div className="custom-filter-no-wrap">
                                                                    <input type="checkbox" id={'cb_defaultPfmFilter_' + idx} style={{verticalAlign: 'middle'}}
                                                                           checked={filter.state?.defaultPfmFilterCheckboxes ? filter.state?.defaultPfmFilterCheckboxes[idx] || false : false}
                                                                           onChange={(e)=> {setFilterCheckbox(filter, idx)}}
                                                                    />
                                                                    <label htmlFor={'cb_defaultPfmFilter_' + idx}>&nbsp;{filter.widgetState.defaultPfmFilters[idx].customFilterName}</label>
                                                                    <CustomTooltip arrow title={defaultCustomFiltersHelpMessage[idx]} placement="top">
                                                                        <span><FaInfoCircle/>&nbsp;&nbsp;</span>
                                                                    </CustomTooltip>
                                                                    <HoverPopout.Actions>
                                                                        {editable &&
                                                                            <>&nbsp;&nbsp;<Tooltip title="Edit" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();openPfmFilter(filter, idx);}}><FaPencilAlt size={13} style={{color: "#337ab7"}} /></a></Tooltip></>
                                                                        }
                                                                    </HoverPopout.Actions>
                                                                </div>
                                                                </HoverPopout>
                                                            </Col>
                                                        )
                                                    )
                                                }
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion square expanded={sideMenuDetail['mycustomfilter']} onChange={() => {toggleSideMenuDetail('mycustomfilter')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                            <AccordionSummary aria-controls='panel-content-mycustomfilter' id='paneld-header-mycustomfilter' className="subMenuHeading p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                <p className="subMenuHeading m-0">
                                                    {sideMenuDetail['mycustomfilter'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                    {!sideMenuDetail['mycustomfilter'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                                    <span className="mt-4">My Filters</span>
                                                </p>
                                            </AccordionSummary>
                                            <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                {filter.widgetState && filter.widgetState.pfmFilters
                                                    && Object.keys(filter.widgetState.pfmFilters).length > 0 &&
                                                    filter.widgetState.pfmFilters.map(
                                                        (pfmFilter, idx) => (
                                                                <Col key={'pfmFilters' + idx} style={{paddingLeft: '10px', whiteSpace: 'nowrap'}}>
                                                                    <HoverPopout>
                                                                    <div className="custom-filter-no-wrap">
                                                                    <input type="checkbox" id={'cb_defaultPfmFilter_' + idx} style={{verticalAlign: 'middle'}}
                                                                           checked={filter.state?.pfmFilterCheckboxes ? filter.state?.pfmFilterCheckboxes[idx] || false : false}
                                                                           onChange={(e)=> {setFilterCheckbox(filter, idx)}}
                                                                    />
                                                                    <label htmlFor={'cb_defaultPfmFilter_' + idx}>&nbsp;{filter.widgetState.defaultPfmFilters[idx].customFilterName}</label>
                                                                    <CustomTooltip arrow title={defaultCustomFiltersHelpMessage[idx]} placement="top">
                                                                        <span><FaInfoCircle/>&nbsp;&nbsp;</span>
                                                                    </CustomTooltip>
                                                                    <HoverPopout.Actions>
                                                                        {editable &&
                                                                            <>&nbsp;&nbsp;<Tooltip title="Edit" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();startFilteringWidget(filter, 'default', idx);}}><FaPencilAlt size={13} style={{color: "#337ab7"}} /></a></Tooltip></>
                                                                        }
                                                                    </HoverPopout.Actions>
                                                                </div>
                                                                </HoverPopout>
                                                            </Col>
                                                        )
                                                    )
                                                }
                                            </AccordionDetails>
                                        </Accordion>
                                    </Col>
                                </AccordionDetails>
                            </Accordion>
                        } */}
                        {sideMenuDetail &&
                            <Accordion id="advFilter" square expanded={sideMenuDetail['customfilter']} onChange={() => {toggleSideMenuDetail('customfilter')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls='panel-content-customfilter' className="subMenuHeading p-0">
                                    <p className="subMenuHeading m-0">
                                        {sideMenuDetail['customfilter'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['customfilter'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className="mt-4">Advanced Filters
                                        {videoToggle && <Tooltip title="Video Help for creating New Filters" arrow>
                                    <Link href="https://share.vidyard.com/watch/nSGYvm1paiCgpBra81C8WM" target="_blank" rel="noopener noreferrer">
                                    <PlayCircleOutlineIcon  style={{paddingBottom: '3px', color: 'darkorange',marginBottom: '1px'}} /></Link></Tooltip>}
                                        </span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                    <Col md="12" sm='12' xs='12' style={{paddingLeft: '5px'}}>
                                        <Accordion square expanded={true}>
                                            <AccordionSummary aria-controls='panel-content-samcustomfilter' id='paneld-header-samcustomfilter' className="subMenuHeading p-0">
                                                <p className="subMenuHeading m-0" onClick={() => {if (editable === true) {startFilteringWidget(filter, '', '');}}} style={{paddingLeft: '5px'}}>
                                                    <FaRegPlusSquare style={{marginRight: '5px', verticalAlign: 'middle'}} className="fa fa-plus-square"></FaRegPlusSquare>
                                                    <span>Create New Filter</span>
                                                </p>
                                            </AccordionSummary>
                                        </Accordion>
                                        <Accordion square expanded={sideMenuDetail['samplecustomfilter']}
                                                   onChange={() => {toggleSideMenuDetail('samplecustomfilter')}}>
                                            <AccordionSummary aria-controls='panel-content-samcustomfilter' id='paneld-header-samcustomfilter' className="subMenuHeading p-0">
                                                <p className="subMenuHeading m-0">
                                                    {sideMenuDetail['samplecustomfilter'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                    {!sideMenuDetail['samplecustomfilter'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                                    <span className="mt-4">Sample Filters</span>
                                                </p>
                                            </AccordionSummary>
                                            <AccordionDetails className="appTextColor" style={{paddingBottom: "5px", backgroundColor: toggle ? '' : '#292929'}}>
                                                {filter.widgetState && filter.widgetState.defaultCustomFilters
                                                    && Object.keys(filter.widgetState.defaultCustomFilters).length > 0 &&
                                                    filter.widgetState.defaultCustomFilters.map(
                                                        (defaultFilter, idx) => (
                                                                <Col key={'defaultFilter_' + idx} style={{paddingLeft: '10px', height: "30px", whiteSpace: 'nowrap'}}>
                                                                <HoverPopout>
                                                                    <div className="custom-filter-no-wrap">
                                                                    <input type="checkbox" id={'cb_defaultFilter_' + idx} style={{verticalAlign: 'middle'}}
                                                                           checked={filter.state?.customFilterCheckboxes ? filter.state?.customFilterCheckboxes[idx] || false : false}
                                                                           onChange={(e)=> {setFilterCheckbox(filter, idx)}}
                                                                    />
                                                                    <label style={{marginTop: "8px"}} htmlFor={'cb_defaultFilter_' + idx}>&nbsp;{filter.widgetState.defaultCustomFilters[idx].customFilterName}</label>
                                                                    <CustomTooltip arrow title={defaultCustomFiltersHelpMessage[idx]} placement="top">
                                                                        <span><FaInfoCircle/>&nbsp;&nbsp;</span>
                                                                    </CustomTooltip>
                                                                    <HoverPopout.Actions>
                                                                        {editable &&
                                                                            <Tooltip title="Edit" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();startFilteringWidget(filter, 'default', idx);}}><FaPencilAlt size={13} style={{color: "#337ab7"}} /></a></Tooltip>
                                                                        }
                                                                    </HoverPopout.Actions>
                                                                </div>
                                                                </HoverPopout>
                                                            </Col>
                                                        )
                                                    )
                                                }
                                            </AccordionDetails>
                                        </Accordion>
                                        <Accordion square expanded={sideMenuDetail['mycustomfilter']} onChange={() => {toggleSideMenuDetail('mycustomfilter')}} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                            <AccordionSummary aria-controls='panel-content-mycustomfilter' id='paneld-header-mycustomfilter' className="subMenuHeading p-0" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                <p className="subMenuHeading m-0">
                                                    {sideMenuDetail['mycustomfilter'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                                    {!sideMenuDetail['mycustomfilter'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                                    <span className="mt-4">My Filters</span>
                                                </p>
                                            </AccordionSummary>
                                            <AccordionDetails className="appTextColor" style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                                {filter.widgetState && filter.widgetState.customFilters && Object.keys(filter.widgetState.customFilters).length > 0 &&
                                                    filter.widgetState.customFilters.map(
                                                        (customFilter, idx) => (
                                                            <Col key={'customFilter_' + idx} style={{paddingLeft: '10px'}}>
                                                                <HoverPopout>
                                                                <div className="custom-filter-no-wrap view-name">
                                                                    <input type="checkbox" id={'cb_customFilter_' + idx} style={{verticalAlign: 'middle'}}
                                                                           checked={(filter.state?.customFilterCheckboxes && filter.state?.customFilterCheckboxes[idx + filter.widgetState.defaultCustomFilters.length]) || false}
                                                                           onChange={(e)=> {setFilterCheckbox(filter, idx + filter.widgetState.defaultCustomFilters.length)}}
                                                                    />
                                                                    <span htmlFor={'cb_customFilter_' + idx} className={'custom-filter-label'}>
                                                                        &nbsp;{filter.widgetState.customFilters[idx].customFilterName}</span>
                                                                    <HoverPopout.Actions>
                                                                        {editable &&
                                                                            <div style={{display: 'inline-block'}}>
                                                                                &nbsp;&nbsp;<Tooltip title="Edit" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();startFilteringWidget(filter, 'custom', idx);}}><FaPencilAlt size={13} style={{color: "#337ab7"}} /></a></Tooltip>
                                                                                &nbsp;<Tooltip title="Delete" placement="top" arrow><a href="#" onClick={(e) => {e.stopPropagation();e.preventDefault();removeCustomFilterFromList(filter, fieldConfig, idx);}}><FaTrash size={13} style={{color: "#337ab7"}} /></a></Tooltip>
                                                                            </div>
                                                                        }
                                                                    </HoverPopout.Actions>
                                                                </div>
                                                                    </HoverPopout>
                                                            </Col>
                                                        )
                                                    )
                                                }
                                            </AccordionDetails>
                                        </Accordion>
                                    </Col>
                                </AccordionDetails>
                            </Accordion>
                        }

                        <h6 id="ExportResultsScroll" className="mt-4"><b>GQ Power Tools</b></h6>
                        <div id= 'GQPowerTools' className="form-group">
                            {sideMenuDetail && searchResultData && <GQPowerTools
                                AB={isAbWorkflow}
                                VM={hasLvaAccess}
                                CM={isCmWorkflow}
                                apiKey={gqApiKey}
                                //previewABReport = {previewABReport}
                                abFilters={abFilters}
                                //AbReportNames={abReportNames}
                                vmIds={vmIds}
                                userdir={userdir}
                                widgetState={widgetState}
                                filter={filter}
                                fieldConfig={fieldConfig}
                                applyFilterForJava={applyFilterForJava}
                                saveResultState={saveVmFilter}
                                setLvaFilterCheckbox={setLvaFilterCheckbox}
                                removeLvaFilterFromList={removeLvaFilterFromList}
                                sideMenuDetail={sideMenuDetail}
                                lvaLoadingReady={lvaLoadingReady}
                                reportId={reportId}
                                reportFilters={resultReportFilters}
                                editable={editable}
                                updateKWs = { updateKWs }
                                ftWindowsToOpen={ftWindowsToOpen}
                                setFtWindowsToOpen ={(value)=>{setFtWindowsToOpen(value)}}
                                cmColorLevel={cmColorLevel}
                                refreshCmColorLevel={refreshCmColorLevel}
                                highlightHits={highlightHits}
                                refreshCmAlign={refreshCmAlign}
                                toggle={toggle}
                                data={searchResultData}
                                    querySeqIdsCount={querySeqIdsCount}
                                toggleSideMenuDetail={toggleSideMenuDetail}
                                cmMap={cmMap}
                                cmColorMap={cmColorMap}
                                setQueryCmCodeCheckbox={setQueryCmCodeCheckbox}
                                setCmFilterCheckbox={setCmFilterCheckbox}
                                cmCodes={cmCodes}
                                openCmCodeModal={(startingFilterState, idx = -1) => openQSPFilter(startingFilterState, idx)}
                                deleteCmFilter={(idx) => deleteQSPFilter(idx)}
                            ></GQPowerTools>}
                        </div>

                        <div className='floating-action-button-block'>
                            <div id="applyButtonBlock" className="clearfix button-div sidebar-tour-width"
                            >
                                {reportId === undefined &&
                                <button id="floatApply"  className="pull-left small-button grey"
                                         onClick={() => {
                                            resetAllFitlers(fieldConfig, filter);
                                            loadResultsFromBackend(true);
                                            if (resultTableRef.current && resultTableRef.current.closeSidePanel) {
                                                resultTableRef.current.closeSidePanel();
                                            }
                                        }}>Reset All Filters
                                </button>
                                }
                                {reportId !== undefined &&
                                    <button id="floatApply" disabled className="pull-left small-button grey">Reset All Filters</button>
                                }
                                {applyEnabled &&
                                    <button className="pull-left small-button gqblue-alert" style={{color: 'black'}}
                                            onClick={() => {applyAllFilters(filter); loadResultsFromBackend(true);
                                            if (resultTableRef.current && resultTableRef.current.closeSidePanel) {
                                                resultTableRef.current.closeSidePanel();
                                            }
                                        }}
                                    >Apply</button>
                                }
                                {!applyEnabled &&
                                    <button disabled className="pull-left small-button gqblue-disabled" style={{color: 'black'}}>Apply</button>
                                }
                            </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-between mt-4" style={{ gap: 12 }}>
                            <h6 id="ExportResults" className="m-0"><b>Export Results</b></h6>
                            <DownloadsIndicator />
                        </div>
                        {sideMenuDetail &&
                            <Accordion square expanded={sideMenuDetail['exportspreadsheet']} onChange={() => toggleSideMenuDetail('exportspreadsheet')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls="panelexcel-content" id="panelexcel-header" className="subMenuHeading p-0">
                                    <p className="subMenuHeading m-0">
                                        {sideMenuDetail['exportspreadsheet'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['exportspreadsheet'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className={classes.arrowIconTitle}>Spreadsheet</span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor">
                                    <div className="side-menu-item">
                                        <span onClick={(e) => startExportDownload('EXCEL')} className="side-menu-span">- Microsoft Excel</span>
                                    </div>
                                    <div className="side-menu-item">
                                        <span onClick={(e) => startExportDownload('CSV')} className="side-menu-span">- Comma Separated (CSV)</span>
                                    </div>
                                    <div className="side-menu-item">
                                        <span onClick={(e) => startExportDownload('TSV')} className="side-menu-span">- Tab Separated (TSV)</span>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        }

                        {sideMenuDetail &&
                            <Accordion square expanded={sideMenuDetail['exportpnlist']} onChange={() => toggleSideMenuDetail('exportpnlist')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls="panelpn-content" id="panelpn-header" className="subMenuHeading p-0">
                                    <p className="subMenuHeading m-0">
                                        {sideMenuDetail['exportpnlist'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['exportpnlist'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className={classes.arrowIconTitle}>Publication Numbers</span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor">
                                    <div className="side-menu-item">
                                        <span onClick={(e) => startExportDownload('PNL')} className="side-menu-span">- Publication Number Only</span>
                                    </div>
                                    <div className="side-menu-item">
                                        <span onClick={(e) => startExportDownload('PNFIL')} className="side-menu-span">- Publication Number and Family Members</span>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        }

                        {sideMenuDetail &&
                            <Accordion square expanded={sideMenuDetail['exportdocument']} onChange={() => toggleSideMenuDetail('exportdocument')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls="paneldoc-content" id="paneldoc-header" className="subMenuHeading p-0">
                                    <p className="subMenuHeading m-0">
                                        {sideMenuDetail['exportdocument'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['exportdocument'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className={classes.arrowIconTitle}>Document</span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor">
                                    <div className="side-menu-item">
                                        <span onClick={() => {startExportDownload('Word')}} className="side-menu-span">- Microsoft Word</span>
                                    </div>
                                    <div className="side-menu-item">
                                        <span onClick={() => {startExportDownload('Word Simple')}} className="side-menu-span">- Microsoft Word (Simplified)</span>
                                    </div>
                                    <div className="side-menu-item">
                                        <span onClick={() => {startExportDownload('XML')}} className="side-menu-span">- XML Document</span>
                                    </div>
                                    <div className="side-menu-item">
                                        <span onClick={() => {startExportDownload('HTML')}} className="side-menu-span">- HTML Document</span>
                                    </div>
                                    {/*<div className="side-menu-item">
                                        <span className="side-menu-span" style={{color: 'rgb(148 147 141 / 68%)'}}>- PDF Document</span>
                                    </div>*/}
                                </AccordionDetails>
                            </Accordion>
                        }

                        {sideMenuDetail &&
                            <Accordion square expanded={sideMenuDetail['exportother']} onChange={() => toggleSideMenuDetail('exportother')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls="paneloth-content" id="paneloth-header" className="subMenuHeading p-0">
                                    <p className="subMenuHeading m-0">
                                        {sideMenuDetail['exportother'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['exportother'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className={classes.arrowIconTitle}>Connectors</span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor">
                                    <div className="side-menu-item">
                                        <span onClick={() => {startExportDownload('LifeQuest')}} className="side-menu-span">- Export to LifeQuest</span>
                                    </div>
                                    {hasftAccess &&
                                        <div className="side-menu-item">
                                            <span onClick={() => {startExportDownload('FullText')}} className="side-menu-span">- Export to GQ Full Text</span>
                                        </div>
                                    }
                                    {!hasftAccess &&
                                        <div className="side-menu-item">
                                            <span className="side-menu-span" style={{color: 'rgb(148 147 141 / 68%)'}}>- Export to GQ Full Text</span>
                                        </div>
                                    }
                                    <div className="side-menu-item">
                                        <span onClick={() => {startExportDownload('BizInt')}} className="side-menu-span">- BizInt Smart Charts</span>
                                    </div>
                                    <div className="side-menu-item">
                                        <span onClick={() => {startExportDownload('Geneious')}} className="side-menu-span">- Geneious</span>
                                    </div>
                                    {/*<div className="side-menu-item">
                                        <span className="side-menu-span" style={{color: 'rgb(148 147 141 / 68%)'}}>- Questel Orbit</span>
                                    </div>*/}
                                    <div className="side-menu-item">
                                        <span onClick={() => {startExportDownload('Patbase')}} className="side-menu-span">- Export to PatBase</span>
                                    </div>
                                    <div className="side-menu-item">
                                        <span onClick={() => {openSaveResultsModal(true)}} className="side-menu-span">- Save Result As</span>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        }

                        {sideMenuDetail &&
                            <Accordion square expanded={sideMenuDetail['exportsequences']} onChange={() => toggleSideMenuDetail('exportsequences')} style={toggle? {backgroundColor: ''}:{backgroundColor: '#292929'}}>
                                <AccordionSummary aria-controls="panelseq-content" id="panelseq-header" className="subMenuHeading p-0">
                                    <p className="subMenuHeading m-0">
                                        {sideMenuDetail['exportsequences'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['exportsequences'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className={classes.arrowIconTitle}>Sequences</span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor">
                                    <div className="side-menu-item">
                                        <span onClick={() => {startExportDownload('Fastasub')}} className="side-menu-span">- Subject Sequences Fasta</span>
                                    </div>
                                    <div className="side-menu-item">
                                        <span onClick={() => {startExportDownload('Fastafrag')}} className="side-menu-span">- Alignment Fragments Fasta</span>
                                    </div>
                                    {workflowType && workflowType !== "GqWfMerge" &&
                                    <div className="side-menu-item">
                                        <span onClick={() => {startExportDownload('SeqDb')}} className="side-menu-span">- Extract Sequence Database</span>
                                    </div>
                                    }
                                </AccordionDetails>
                            </Accordion>
                        }

                        <Accordion square expanded={false}>
                            <AccordionSummary aria-controls="panelclu-content" id="panelclu-header" className="subMenuHeading p-0">
                                <p className="subMenuHeading m-0">
                                    <ArrowRightIcon/>
                                    <span className={classes.arrowIconTitle} onClick={() => {startExportDownload('Clustal')}}>Clustal Omega</span>
                                </p>
                            </AccordionSummary>
                        </Accordion>

                        {sideMenuDetail &&
                            <Accordion square expanded={sideMenuDetail['patentStatistics']} onChange={() => toggleSideMenuDetail('patentStatistics')} style={toggle ? { backgroundColor: '' } : { backgroundColor: '#292929' }}>
                                <AccordionSummary aria-controls="panelseq-content" id="panelseq-header" className="subMenuHeading p-0">
                                    <p className="subMenuHeading m-0">
                                        {sideMenuDetail['patentStatistics'] && <ArrowDropDownIcon className={classes.arrowIcon} />}
                                        {!sideMenuDetail['patentStatistics'] && <ArrowRightIcon className={classes.arrowIcon} />}
                                        <span className={classes.arrowIconTitle}>Patent Statistics</span>
                                    </p>
                                </AccordionSummary>
                                <AccordionDetails className="appTextColor" style={toggle ? {} : { backgroundColor: '#292929' }}>
                                    <Col md="12" sm="12" xs="12" style={{ paddingLeft: '5px' }}>

                                        {/* Create New Patent Statistics */}
                                        <Accordion square expanded={true}>
                                            <AccordionSummary className="subMenuHeading p-0">
                                                <p className="subMenuHeading m-0"
                                                    onClick={() => {startExportDownload('PatentStats')}}
                                                    style={{ paddingLeft: '11px', cursor: 'pointer' }}>
                                                    {/* <FaRegPlusSquare style={{ marginRight: '5px', verticalAlign: 'middle' }} /> */}
                                                    <span>- Create New Patent Statistics</span>
                                                </p>
                                            </AccordionSummary>
                                        </Accordion>
                                    </Col>
                                </AccordionDetails>
                            </Accordion>
                        }
                        {/* Placeholder so that the siode menu is visible over the Reset/Apply float buttons */}
                         <Accordion square expanded={false}>
                            <AccordionSummary aria-controls="panelclu-content" id="panelclu-header" className="subMenuHeading p-0">
                                <p className="subMenuHeading m-0">
                                    <br></br>
                                    <span></span>
                                </p>
                            </AccordionSummary>
                        </Accordion>
                    </Col>
                    </div>
                </Col>
                </div>
                <Col md="9" sm="9" xs="9" style={{flex: '1 1 auto', minWidth: '600px', position: 'relative', zIndex: 1}}>
                    {viewOptions && searchResultData.displayMode && (!hasLvaAccess || vmIds) && searchResultData.stats &&
                     <ResultStatsBar
                        tableDisplayMode={searchResultData.displayMode}
                        handleMenuCollapse={handleSideMenu}
                        sideMenuCollapse={sideMenuCollapse}
                        handleChartMenu={handleChartMenu}
                        viewCount={viewCount}
                        totalCount={searchResultData.stats.nav.total_groups}
                        // This result's query sequence IDs, for the Advanced Group Options dropdown
                        queryIds={queryIdOptions}
                        fieldConfig={fieldConfig}
                        saveEsfGrouping={saveEsfGrouping}
                        viewOptions={viewOptions}
                        querySeqIdsCount ={querySeqIdsCount}
                        handleMultiQuerySeqMenu={handleMultiQuerySeqMenu}
                        deduplication={deduplication}
                        setDedDuplication={() => handleDedup(filter)}
                        databasesForDed={dataBasesForDed}
                        dedupModal={() => displayDedpreferences(filter)}
                        filter={filter}
                        handleSorting={changeSort}
                        handleManageSort={manageSortOptions}
                        groupOptions={groupOptions}
                        hasLvaAccess={hasLvaAccess}
                        lvaLoadingReady={lvaLoadingReady}
                        saveResultState={saveVmFilter}
                        vmIds={vmIds}
                        sideMenuDetail={sideMenuDetail}
                        editable={editable}
                        workflowId={resid.match(/\d+/)[0]}
                        userInfo={userInfo}
                        actionModal={saveFilteredResultBundle}
                        showMqsa={!isCmWorkflow}
                    />}

                    { (multiQuerySeqMenu || chartMenu) &&
                        <TabUnderTool
                            chartobj={ChartService.chartObjects}
                            chart={chartMenu}
                            multiQuery={queryDbStats && Object.keys(queryDbStats).length > 0 && multiQuerySeqMenu}
                            queryDbStats={queryDbStats}
                            querydb={querydb}
                            supportedDisplayModes={supportedDisplayModes}
                            handleMulti={handleMulti}
                        />
                    }

                    <div id="result-container" style={{
                        height: '70vh', 
                        width: sideMenuCollapse ? '140%' : '110%',
                        position: 'relative',
                        zIndex: 1,
                        overflowY: 'auto', 
                        overflowX: 'auto',
                        marginTop: '10px',
                        scrollbarColor: 'green',
                    }} 
                    className={ toggle ? {}: classes.scrollStyleChangeDark}>
                    <ResultTable
                        ref={resultTableRef}
                        columns={searchResultData.columns}
                        data={searchResultData}
                        viewCount={viewCount}
                        handleMenuCollapse={handleMenuwithSidePanelOpen}
                        handleMenuOpen={handleMenuwithSidePanelClose}
                        displayMode={searchResultData.displayMode}
                        tableWidth={searchResultData.tableWidth}
                        fieldConfig={fieldConfig}
                        annotState={annotState}
                        filter={filter}
                        expandAllDetailPage={expandAllDetailPage}
                        expandAllClaims={expandAllClaims}
                        expandAllAlignments={expandAllAlignments}
                        openItemsView={displayItemsView}
                        saveAnnotation={saveAnnotation}
                        refreshAnnotState={refreshAnnotState}
                        algorithm={resInfo.algorithm}
                        isAbWorkflow={isAbWorkflow}
                        editable={editable}
                        setFtWindowsToOpen ={(value)=>{setFtWindowsToOpen(value)}}
                        isCmNoSeq={isCmNoSeq}
                        buildExtendedCmTracks={buildExtendedCmTracks}
                        getExtendedLvaFlagMaps={getExtendedLvaFlagMaps}
                        includeSubjectSeq={includeSubjectSeq}
                        onToggleFullSubject={(val) => { setIncludeSubjectSeq(val); }}
                    />
                    </div>

                    <Col className={'d-flex justify-content-center' + ((searchResultData.data && Object.keys(searchResultData.data).length) > 0 ? ' d-block' : ' d-none')} md="12">
                        <CustomPagination className={"float-right mt-2 floating-action-pagination-block"} count={10} changePage={changePage} recordPerPage={pageCount} showFirstButton showLastButton defaultPage={1} page={currentPage} totalPages={totalPage} />
                    </Col>

                </Col>
                <SortingWidgetModal showModal={manageSortModal} 
                                   closeModal={closeManageSortModal} 
                                   fieldConfig={fieldConfig} filter={filter}
                                   sortOptions={fieldConfig.sortOptions}
                                   algorithm={resInfo.algorithm}
                                   regAccess={hasRegAccess}
                                   errorsInSortOption={errorsInSortOption}
                                   deleteSortOption={deleteSortOption}
                                    />
                <DisplayColumnModal fieldConfig={fieldConfig} showModal={addDisplayColumnShow} filter={filter} saveViews={saveViews}
                regNP={hasRegNp} regAccess={hasRegAccess} closeModal={closeFolderModal} columns={handleColumns} cancelModal={cancelDispModal} isAbWorkflow={isAbWorkflow} algorithm={resInfo.algorithm}/>
                <ShareViewModal show={shareViewShow} viewName={shareViewName} data={shareViewUsers}
                                entityShared={shareViewEntityShared}
                                removeRecipient={removeShareViewRecipient}
                                removeEntityShare={() => removeShareViewRecipient('entity')}
                                onHide={closeShareViewModal} shareView={shareView}/>
                <DiscoverContinueModal showModal={showDedAlert} closeButton={'Cancel'} actionButton={'Continue'}
                                       message={'This filter applies to the entire dataset, not just the deduplicated dataset.'}
                                       closeModal={closeDeduplicationModal} actionModal={continueDeduplicationModal}
                                       filter={filter} filterState={filterState} db={selectedDatabase} />
                <DiscoverContinueModal showModal={showContinueAlert} closeButton={'Continue'} actionButton={'Start Over'}
                                       message={continueMsg} closeModal={closeContinueModal} actionModal={startOver}
                                       filter={filter} filterState={filterState} db={resInfo} fieldConfig={fieldConfig}/>
                <DiscoverContinueModal showModal={showReportAlert} closeButton={'Read Only Report'} actionButton={'Editable Report'}
                                       message={continueMsg} closeModal={closeReportModal} actionModal={startOverReport}
                                       filter={filter} filterState={filterState} db={resInfo} fieldConfig={fieldConfig}/>
                <DiscoverMessageModal showModal={showInfoMsg} message={infoMsg}
                                      closeModal={closeMessageModal} fieldConfig={fieldConfig}/>
                <DiscoverExportAllModal showModal={showExportAllModal} closeModal={closeExportModal} actionModal={exportToExcel}
                                        totalAlignmentNumber={totalAlignmentNumber} totalPatentNumber={totalPatentNumber}
                                        downloadType={downloadType} downloadTypeDesc={downloadTypeDesc} alertMessage={alertMessage}
                                        filter={filter} fieldConfig={fieldConfig} resInfo={resInfo} isCmNoSeq={isCmNoSeq}
                                        displayedColumns={searchResultData.columns}
                                        includeAnnotation={includeAnnotation} includeSS={includeSS} includeQS={includeQS} includeFullSeq={includeFullSeq}/>
                <DedupPrefModal showModal={dedupModal} closeModal={closeDedupModal} saveModal={saveDedup} prefsForUI={dedDataBasePrefsForUI}
                                fieldConfig={fieldConfig} filter={filter} />
                <DiscoverExportChoicesModal showModal={showExportChoicesModal} closeModal={closeExportModal} actionModal={exportToExcel}
                                        totalAlignmentNumber={totalAlignmentNumber} customTtlCount={customTtlCount} displayCustomSelection={displayCustomSelection}
                                        downloadType={downloadType} downloadTypeDesc={downloadTypeDesc} workflowId={resid.match(/\d+/)[0]}
                                        selectedAlignmentsCount={selectedAlignmentsCount} customSelectionLabel={customSelectionLabel}
                                        alertMessage={alertMessage} selectedAlertMessage={selectedAlertMessage} customAlertMessage={customAlertMessage}
                                        filter={filter} fieldConfig={fieldConfig} resInfo={resInfo} queryNohits={queriesNoHits} defaultTitle={extractName}/>
                <DiscoverPatbaseModal showModal={showPatbaseModal} closeModal={closeExportModal} patbasePnsStr={patbasePnsStr}
                                      totalPatbasePns={totalPatbasePns} pbCountdown={pbCountdown} patbasePns={patbasePns} />
                <DiscoverExportVmModal showModal={showExportVmModal} closeModal={closeExportModal} actionModal={exportVmAlignments} isCmWorkflow={isCmWorkflow}
                                       downloadType={downloadType} filter={filter} fieldConfig={fieldConfig} resInfo={resInfo} />
                <DiscoverSaveResultsModal showModal={showSaveResultsModal} closeModal={closeSaveResultsSucModal} actionModal={saveFilteredResult}
                                          filter={filter} fieldConfig={fieldConfig} resInfo={resInfo} defaultTitle={saveAsName} downloadType={downloadType}
                                          selectedAlignmentsCount={selectedAlignmentsCount} customSelectionLabel={customSelectionLabel}
                                          totalAlignmentNumber={totalAlignmentNumber} customTtlCount={customTtlCount} displayCustomSelection={displayCustomSelection}/>
                <DiscoverSaveResultsSucModal showModal={showSaveResultsSucModal} closeModal={closeSaveResultsSucModal}
                                             saveFiltedResultMsg={saveFiltedResultMsg} downloadType={downloadType} />
                <DiscoverMoreItemsModal showModal={showItemsModal} closeModal={closeItemsModal} filter={filter}
                                        currentPage={itemsCurrentPage} totalPage={itemsTotalPage} changePage={changeItemsPage}
                                        searchResultData={itemsData} fieldConfig={fieldConfig} expandAllClaims={expandAllClaims}
                                        expandAllDetailPage={expandAllDetailPage} expandAllAlignments={expandAllAlignments}
                                        groupValue1={groupValue1} groupValue2={groupValue2} annotState={itemsAnnotState}
                                        saveAnnotation={saveAnnotation} parentAnnotState={annotState} refreshAnnotState={refreshAnnotState}
                                        algorithm={resInfo.algorithm} isAbWorkflow={isAbWorkflow}
                                        setFtWindowsToOpen={(val) => setFtWindowsToOpen(val)}/>
                {addFilterPopup &&
                    <DiscoverFilterModal showModal={addFilterPopup} closeModal={closeFilterModal} callback={saveFilter}
                                         widgetState={widgetState} filter={filter} fieldConfig={fieldConfig} sideMenuDetail={sideMenuDetail}
                                         displayRegFields={hasRegAccess} hasRegNP={hasRegNp} isAbWorkflow={isAbWorkflow} algorithm={resInfo.algorithm}
                                         />}
                {deleteFilterPopup &&
                    <DiscoverFilterDeleteModal showModal={deleteFilterPopup} closeModal={closeDeleteFilterModal}
                                               filter={filter} fieldConfig={fieldConfig} deleteIdx={deleteIdx}
                                               removeCustomFilterFromListAction={removeCustomFilterFromListAction} />
                }
                {deleteViewPopup &&
                    <DiscoverViewDeleteModal showModal={deleteViewPopup} closeModal={closeDeleteViewModal}
                                             viewName={deleteViewName}
                                             isShared={Boolean(fieldConfig.sharedByMeNames[deleteViewName])}
                                             deleteViewAction={deleteViewConfirmed} />
                }
                {showFTModal &&
                    <FTSearchModal
                        show={showFTModal}
                        closeModal={() => setShowFTModal(false)}
                        callback={handleFTModalSave}
                        discoverFTSValue={ftsInline.tempFieldDisplayValue || ftsInline.fieldDisplayValue || ''}
                    />
                }
                {pfmFilterOpen &&
                    <PfmFilterModal
                         start={pfmWidgetState} 
                         apply={(data)=>{applyPfmFilter(data)}} 
                         cancel={() => closePfmFilter(false)} 
                         isOpen={pfmFilterOpen}
                    />
                }
                {QSPModalIsOpen &&
                    <QuerySequencePatterns
                         hideFormat={['FP']}
                         start={qspWidgetState}
                         apply={(data)=>{applyQSPFilter(data)}}
                         cancel={() => closeQSPFilter(false)}
                         existingCmFilters={Array.isArray(filter.state?.cmFilters) ? filter.state.cmFilters : []}
                         resultSetSeqType={qspModSeqTypeRef.current || qspResultSeqType}
                         isOpen={QSPModalIsOpen}
                         availableModCodes={resultSetModCodes}
                    />
                }
            </Row>
            {showLoader &&
                <div className={classes.loader}>
                    <div className={classes.loaderPosition}>
                        <div className="spinner-container">
                            <div className="spinner-socket">
                                <div className="spinner-hex spinner-tile-1">
                                    <div className="spinner-brick rotate-0"></div>
                                    <div className="spinner-brick rotate-1"></div>
                                    <div className="spinner-brick rotate-2"></div>
                                </div>
                                <div className="spinner-hex spinner-tile-2">
                                    <div className="spinner-brick rotate-0"></div>
                                    <div className="spinner-brick rotate-1"></div>
                                    <div className="spinner-brick rotate-2"></div>
                                </div>
                                <div className="spinner-hex spinner-tile-3 spinner-row-2">
                                    <div className="spinner-brick rotate-0"></div>
                                    <div className="spinner-brick rotate-1"></div>
                                    <div className="spinner-brick rotate-2"></div>
                                </div>
                                <div className="spinner-hex spinner-tile-4 spinner-row-2">
                                    <div className="spinner-brick rotate-0"></div>
                                    <div className="spinner-brick rotate-1"></div>
                                    <div className="spinner-brick rotate-2"></div>
                                </div>
                                <div className="spinner-hex spinner-tile-5 spinner-row-2">
                                    <div className="spinner-brick rotate-0"></div>
                                    <div className="spinner-brick rotate-1"></div>
                                    <div className="spinner-brick rotate-2"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}
export default Discover;
